var K3 = Object.defineProperty;
var X3 = (e, n, t) => n in e ? K3(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var re = (e, n, t) => X3(e, typeof n != "symbol" ? n + "" : n, t);
import Z3, { jsxs as Ve, jsx as ee, Fragment as Ku } from "react/jsx-runtime";
import { useNavigate as Q3 } from "react-router-dom";
import * as Lo from "react";
import X, { useId as J3, createContext as Vr, useContext as Dt, useLayoutEffect as e9, useEffect as St, useState as Sa, useRef as Wr, useCallback as ca, useMemo as Kl, forwardRef as o0, createElement as t9, useImperativeHandle as n9, Fragment as s0, use as u0 } from "react";
import "react-dom";
import { u as r9 } from "./useClickAway-B02nPhI9.js";
function l0(e) {
  var n, t, a = "";
  if (typeof e == "string" || typeof e == "number") a += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (n = 0; n < o; n++) e[n] && (t = l0(e[n])) && (a && (a += " "), a += t);
  } else for (t in e) e[t] && (a && (a += " "), a += t);
  return a;
}
function fn() {
  for (var e, n, t = 0, a = "", o = arguments.length; t < o; t++) (e = arguments[t]) && (n = l0(e)) && (a && (a += " "), a += n);
  return a;
}
var fa = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function c0(e) {
  if (e.__esModule) return e;
  var n = e.default;
  if (typeof n == "function") {
    var t = function a() {
      return this instanceof a ? Reflect.construct(n, arguments, this.constructor) : n.apply(this, arguments);
    };
    t.prototype = n.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(e).forEach(function(a) {
    var o = Object.getOwnPropertyDescriptor(e, a);
    Object.defineProperty(t, a, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[a];
      }
    });
  }), t;
}
var Fo = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Fo.exports;
(function(e, n) {
  (function() {
    var t, a = "4.17.21", o = 200, s = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", l = "Expected a function", c = "Invalid `variable` option passed into `_.template`", d = "__lodash_hash_undefined__", h = 500, p = "__lodash_placeholder__", v = 1, w = 2, b = 4, _ = 1, D = 2, C = 1, N = 2, $ = 4, A = 8, k = 16, R = 32, ie = 64, Y = 128, z = 256, oe = 512, xe = 30, Ne = "...", Ae = 800, Te = 16, ke = 1, et = 2, He = 3, Pe = 1 / 0, qe = 9007199254740991, lt = 17976931348623157e292, U = NaN, Z = 4294967295, V = Z - 1, I = Z >>> 1, M = [
      ["ary", Y],
      ["bind", C],
      ["bindKey", N],
      ["curry", A],
      ["curryRight", k],
      ["flip", oe],
      ["partial", R],
      ["partialRight", ie],
      ["rearg", z]
    ], S = "[object Arguments]", F = "[object Array]", G = "[object AsyncFunction]", K = "[object Boolean]", Q = "[object Date]", te = "[object DOMException]", ce = "[object Error]", j = "[object Function]", me = "[object GeneratorFunction]", ve = "[object Map]", Ge = "[object Number]", wt = "[object Null]", at = "[object Object]", Kn = "[object Promise]", Mi = "[object Proxy]", Xn = "[object RegExp]", Rt = "[object Set]", Pn = "[object String]", zr = "[object Symbol]", Kc = "[object Undefined]", yr = "[object WeakMap]", mg = "[object WeakSet]", Pa = "[object ArrayBuffer]", qr = "[object DataView]", Ps = "[object Float32Array]", Ts = "[object Float64Array]", Es = "[object Int8Array]", Rs = "[object Int16Array]", As = "[object Int32Array]", Is = "[object Uint8Array]", Ls = "[object Uint8ClampedArray]", Fs = "[object Uint16Array]", Ns = "[object Uint32Array]", vg = /\b__p \+= '';/g, gg = /\b(__p \+=) '' \+/g, yg = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Xc = /&(?:amp|lt|gt|quot|#39);/g, Zc = /[&<>"']/g, wg = RegExp(Xc.source), bg = RegExp(Zc.source), _g = /<%-([\s\S]+?)%>/g, xg = /<%([\s\S]+?)%>/g, Qc = /<%=([\s\S]+?)%>/g, Dg = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Sg = /^\w*$/, Og = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ks = /[\\^$.*+?()[\]{}|]/g, Mg = RegExp(ks.source), Ws = /^\s+/, Cg = /\s/, Pg = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Tg = /\{\n\/\* \[wrapped with (.+)\] \*/, Eg = /,? & /, Rg = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Ag = /[()=,{}\[\]\/\s]/, Ig = /\\(\\)?/g, Lg = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Jc = /\w*$/, Fg = /^[-+]0x[0-9a-f]+$/i, Ng = /^0b[01]+$/i, kg = /^\[object .+?Constructor\]$/, Wg = /^0o[0-7]+$/i, Vg = /^(?:0|[1-9]\d*)$/, $g = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Ci = /($^)/, Yg = /['\n\r\u2028\u2029\\]/g, Pi = "\\ud800-\\udfff", Bg = "\\u0300-\\u036f", Hg = "\\ufe20-\\ufe2f", Ug = "\\u20d0-\\u20ff", ef = Bg + Hg + Ug, tf = "\\u2700-\\u27bf", nf = "a-z\\xdf-\\xf6\\xf8-\\xff", jg = "\\xac\\xb1\\xd7\\xf7", zg = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", qg = "\\u2000-\\u206f", Gg = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rf = "A-Z\\xc0-\\xd6\\xd8-\\xde", af = "\\ufe0e\\ufe0f", of = jg + zg + qg + Gg, Vs = "['’]", Kg = "[" + Pi + "]", sf = "[" + of + "]", Ti = "[" + ef + "]", uf = "\\d+", Xg = "[" + tf + "]", lf = "[" + nf + "]", cf = "[^" + Pi + of + uf + tf + nf + rf + "]", $s = "\\ud83c[\\udffb-\\udfff]", Zg = "(?:" + Ti + "|" + $s + ")", ff = "[^" + Pi + "]", Ys = "(?:\\ud83c[\\udde6-\\uddff]){2}", Bs = "[\\ud800-\\udbff][\\udc00-\\udfff]", Gr = "[" + rf + "]", df = "\\u200d", hf = "(?:" + lf + "|" + cf + ")", Qg = "(?:" + Gr + "|" + cf + ")", pf = "(?:" + Vs + "(?:d|ll|m|re|s|t|ve))?", mf = "(?:" + Vs + "(?:D|LL|M|RE|S|T|VE))?", vf = Zg + "?", gf = "[" + af + "]?", Jg = "(?:" + df + "(?:" + [ff, Ys, Bs].join("|") + ")" + gf + vf + ")*", e1 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", t1 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", yf = gf + vf + Jg, n1 = "(?:" + [Xg, Ys, Bs].join("|") + ")" + yf, r1 = "(?:" + [ff + Ti + "?", Ti, Ys, Bs, Kg].join("|") + ")", a1 = RegExp(Vs, "g"), i1 = RegExp(Ti, "g"), Hs = RegExp($s + "(?=" + $s + ")|" + r1 + yf, "g"), o1 = RegExp([
      Gr + "?" + lf + "+" + pf + "(?=" + [sf, Gr, "$"].join("|") + ")",
      Qg + "+" + mf + "(?=" + [sf, Gr + hf, "$"].join("|") + ")",
      Gr + "?" + hf + "+" + pf,
      Gr + "+" + mf,
      t1,
      e1,
      uf,
      n1
    ].join("|"), "g"), s1 = RegExp("[" + df + Pi + ef + af + "]"), u1 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, l1 = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], c1 = -1, Ke = {};
    Ke[Ps] = Ke[Ts] = Ke[Es] = Ke[Rs] = Ke[As] = Ke[Is] = Ke[Ls] = Ke[Fs] = Ke[Ns] = !0, Ke[S] = Ke[F] = Ke[Pa] = Ke[K] = Ke[qr] = Ke[Q] = Ke[ce] = Ke[j] = Ke[ve] = Ke[Ge] = Ke[at] = Ke[Xn] = Ke[Rt] = Ke[Pn] = Ke[yr] = !1;
    var Ue = {};
    Ue[S] = Ue[F] = Ue[Pa] = Ue[qr] = Ue[K] = Ue[Q] = Ue[Ps] = Ue[Ts] = Ue[Es] = Ue[Rs] = Ue[As] = Ue[ve] = Ue[Ge] = Ue[at] = Ue[Xn] = Ue[Rt] = Ue[Pn] = Ue[zr] = Ue[Is] = Ue[Ls] = Ue[Fs] = Ue[Ns] = !0, Ue[ce] = Ue[j] = Ue[yr] = !1;
    var f1 = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, d1 = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, h1 = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, p1 = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, m1 = parseFloat, v1 = parseInt, wf = typeof fa == "object" && fa && fa.Object === Object && fa, g1 = typeof self == "object" && self && self.Object === Object && self, vt = wf || g1 || Function("return this")(), Us = n && !n.nodeType && n, wr = Us && !0 && e && !e.nodeType && e, bf = wr && wr.exports === Us, js = bf && wf.process, zt = function() {
      try {
        var P = wr && wr.require && wr.require("util").types;
        return P || js && js.binding && js.binding("util");
      } catch {
      }
    }(), _f = zt && zt.isArrayBuffer, xf = zt && zt.isDate, Df = zt && zt.isMap, Sf = zt && zt.isRegExp, Of = zt && zt.isSet, Mf = zt && zt.isTypedArray;
    function Vt(P, W, L) {
      switch (L.length) {
        case 0:
          return P.call(W);
        case 1:
          return P.call(W, L[0]);
        case 2:
          return P.call(W, L[0], L[1]);
        case 3:
          return P.call(W, L[0], L[1], L[2]);
      }
      return P.apply(W, L);
    }
    function y1(P, W, L, ae) {
      for (var ge = -1, Ee = P == null ? 0 : P.length; ++ge < Ee; ) {
        var ft = P[ge];
        W(ae, ft, L(ft), P);
      }
      return ae;
    }
    function qt(P, W) {
      for (var L = -1, ae = P == null ? 0 : P.length; ++L < ae && W(P[L], L, P) !== !1; )
        ;
      return P;
    }
    function w1(P, W) {
      for (var L = P == null ? 0 : P.length; L-- && W(P[L], L, P) !== !1; )
        ;
      return P;
    }
    function Cf(P, W) {
      for (var L = -1, ae = P == null ? 0 : P.length; ++L < ae; )
        if (!W(P[L], L, P))
          return !1;
      return !0;
    }
    function Zn(P, W) {
      for (var L = -1, ae = P == null ? 0 : P.length, ge = 0, Ee = []; ++L < ae; ) {
        var ft = P[L];
        W(ft, L, P) && (Ee[ge++] = ft);
      }
      return Ee;
    }
    function Ei(P, W) {
      var L = P == null ? 0 : P.length;
      return !!L && Kr(P, W, 0) > -1;
    }
    function zs(P, W, L) {
      for (var ae = -1, ge = P == null ? 0 : P.length; ++ae < ge; )
        if (L(W, P[ae]))
          return !0;
      return !1;
    }
    function Ze(P, W) {
      for (var L = -1, ae = P == null ? 0 : P.length, ge = Array(ae); ++L < ae; )
        ge[L] = W(P[L], L, P);
      return ge;
    }
    function Qn(P, W) {
      for (var L = -1, ae = W.length, ge = P.length; ++L < ae; )
        P[ge + L] = W[L];
      return P;
    }
    function qs(P, W, L, ae) {
      var ge = -1, Ee = P == null ? 0 : P.length;
      for (ae && Ee && (L = P[++ge]); ++ge < Ee; )
        L = W(L, P[ge], ge, P);
      return L;
    }
    function b1(P, W, L, ae) {
      var ge = P == null ? 0 : P.length;
      for (ae && ge && (L = P[--ge]); ge--; )
        L = W(L, P[ge], ge, P);
      return L;
    }
    function Gs(P, W) {
      for (var L = -1, ae = P == null ? 0 : P.length; ++L < ae; )
        if (W(P[L], L, P))
          return !0;
      return !1;
    }
    var _1 = Ks("length");
    function x1(P) {
      return P.split("");
    }
    function D1(P) {
      return P.match(Rg) || [];
    }
    function Pf(P, W, L) {
      var ae;
      return L(P, function(ge, Ee, ft) {
        if (W(ge, Ee, ft))
          return ae = Ee, !1;
      }), ae;
    }
    function Ri(P, W, L, ae) {
      for (var ge = P.length, Ee = L + (ae ? 1 : -1); ae ? Ee-- : ++Ee < ge; )
        if (W(P[Ee], Ee, P))
          return Ee;
      return -1;
    }
    function Kr(P, W, L) {
      return W === W ? F1(P, W, L) : Ri(P, Tf, L);
    }
    function S1(P, W, L, ae) {
      for (var ge = L - 1, Ee = P.length; ++ge < Ee; )
        if (ae(P[ge], W))
          return ge;
      return -1;
    }
    function Tf(P) {
      return P !== P;
    }
    function Ef(P, W) {
      var L = P == null ? 0 : P.length;
      return L ? Zs(P, W) / L : U;
    }
    function Ks(P) {
      return function(W) {
        return W == null ? t : W[P];
      };
    }
    function Xs(P) {
      return function(W) {
        return P == null ? t : P[W];
      };
    }
    function Rf(P, W, L, ae, ge) {
      return ge(P, function(Ee, ft, Ye) {
        L = ae ? (ae = !1, Ee) : W(L, Ee, ft, Ye);
      }), L;
    }
    function O1(P, W) {
      var L = P.length;
      for (P.sort(W); L--; )
        P[L] = P[L].value;
      return P;
    }
    function Zs(P, W) {
      for (var L, ae = -1, ge = P.length; ++ae < ge; ) {
        var Ee = W(P[ae]);
        Ee !== t && (L = L === t ? Ee : L + Ee);
      }
      return L;
    }
    function Qs(P, W) {
      for (var L = -1, ae = Array(P); ++L < P; )
        ae[L] = W(L);
      return ae;
    }
    function M1(P, W) {
      return Ze(W, function(L) {
        return [L, P[L]];
      });
    }
    function Af(P) {
      return P && P.slice(0, Nf(P) + 1).replace(Ws, "");
    }
    function $t(P) {
      return function(W) {
        return P(W);
      };
    }
    function Js(P, W) {
      return Ze(W, function(L) {
        return P[L];
      });
    }
    function Ta(P, W) {
      return P.has(W);
    }
    function If(P, W) {
      for (var L = -1, ae = P.length; ++L < ae && Kr(W, P[L], 0) > -1; )
        ;
      return L;
    }
    function Lf(P, W) {
      for (var L = P.length; L-- && Kr(W, P[L], 0) > -1; )
        ;
      return L;
    }
    function C1(P, W) {
      for (var L = P.length, ae = 0; L--; )
        P[L] === W && ++ae;
      return ae;
    }
    var P1 = Xs(f1), T1 = Xs(d1);
    function E1(P) {
      return "\\" + p1[P];
    }
    function R1(P, W) {
      return P == null ? t : P[W];
    }
    function Xr(P) {
      return s1.test(P);
    }
    function A1(P) {
      return u1.test(P);
    }
    function I1(P) {
      for (var W, L = []; !(W = P.next()).done; )
        L.push(W.value);
      return L;
    }
    function eu(P) {
      var W = -1, L = Array(P.size);
      return P.forEach(function(ae, ge) {
        L[++W] = [ge, ae];
      }), L;
    }
    function Ff(P, W) {
      return function(L) {
        return P(W(L));
      };
    }
    function Jn(P, W) {
      for (var L = -1, ae = P.length, ge = 0, Ee = []; ++L < ae; ) {
        var ft = P[L];
        (ft === W || ft === p) && (P[L] = p, Ee[ge++] = L);
      }
      return Ee;
    }
    function Ai(P) {
      var W = -1, L = Array(P.size);
      return P.forEach(function(ae) {
        L[++W] = ae;
      }), L;
    }
    function L1(P) {
      var W = -1, L = Array(P.size);
      return P.forEach(function(ae) {
        L[++W] = [ae, ae];
      }), L;
    }
    function F1(P, W, L) {
      for (var ae = L - 1, ge = P.length; ++ae < ge; )
        if (P[ae] === W)
          return ae;
      return -1;
    }
    function N1(P, W, L) {
      for (var ae = L + 1; ae--; )
        if (P[ae] === W)
          return ae;
      return ae;
    }
    function Zr(P) {
      return Xr(P) ? W1(P) : _1(P);
    }
    function rn(P) {
      return Xr(P) ? V1(P) : x1(P);
    }
    function Nf(P) {
      for (var W = P.length; W-- && Cg.test(P.charAt(W)); )
        ;
      return W;
    }
    var k1 = Xs(h1);
    function W1(P) {
      for (var W = Hs.lastIndex = 0; Hs.test(P); )
        ++W;
      return W;
    }
    function V1(P) {
      return P.match(Hs) || [];
    }
    function $1(P) {
      return P.match(o1) || [];
    }
    var Y1 = function P(W) {
      W = W == null ? vt : Qr.defaults(vt.Object(), W, Qr.pick(vt, l1));
      var L = W.Array, ae = W.Date, ge = W.Error, Ee = W.Function, ft = W.Math, Ye = W.Object, tu = W.RegExp, B1 = W.String, Gt = W.TypeError, Ii = L.prototype, H1 = Ee.prototype, Jr = Ye.prototype, Li = W["__core-js_shared__"], Fi = H1.toString, We = Jr.hasOwnProperty, U1 = 0, kf = function() {
        var r = /[^.]+$/.exec(Li && Li.keys && Li.keys.IE_PROTO || "");
        return r ? "Symbol(src)_1." + r : "";
      }(), Ni = Jr.toString, j1 = Fi.call(Ye), z1 = vt._, q1 = tu(
        "^" + Fi.call(We).replace(ks, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), ki = bf ? W.Buffer : t, er = W.Symbol, Wi = W.Uint8Array, Wf = ki ? ki.allocUnsafe : t, Vi = Ff(Ye.getPrototypeOf, Ye), Vf = Ye.create, $f = Jr.propertyIsEnumerable, $i = Ii.splice, Yf = er ? er.isConcatSpreadable : t, Ea = er ? er.iterator : t, br = er ? er.toStringTag : t, Yi = function() {
        try {
          var r = Or(Ye, "defineProperty");
          return r({}, "", {}), r;
        } catch {
        }
      }(), G1 = W.clearTimeout !== vt.clearTimeout && W.clearTimeout, K1 = ae && ae.now !== vt.Date.now && ae.now, X1 = W.setTimeout !== vt.setTimeout && W.setTimeout, Bi = ft.ceil, Hi = ft.floor, nu = Ye.getOwnPropertySymbols, Z1 = ki ? ki.isBuffer : t, Bf = W.isFinite, Q1 = Ii.join, J1 = Ff(Ye.keys, Ye), dt = ft.max, bt = ft.min, ey = ae.now, ty = W.parseInt, Hf = ft.random, ny = Ii.reverse, ru = Or(W, "DataView"), Ra = Or(W, "Map"), au = Or(W, "Promise"), ea = Or(W, "Set"), Aa = Or(W, "WeakMap"), Ia = Or(Ye, "create"), Ui = Aa && new Aa(), ta = {}, ry = Mr(ru), ay = Mr(Ra), iy = Mr(au), oy = Mr(ea), sy = Mr(Aa), ji = er ? er.prototype : t, La = ji ? ji.valueOf : t, Uf = ji ? ji.toString : t;
      function g(r) {
        if (tt(r) && !we(r) && !(r instanceof Oe)) {
          if (r instanceof Kt)
            return r;
          if (We.call(r, "__wrapped__"))
            return jd(r);
        }
        return new Kt(r);
      }
      var na = /* @__PURE__ */ function() {
        function r() {
        }
        return function(i) {
          if (!Qe(i))
            return {};
          if (Vf)
            return Vf(i);
          r.prototype = i;
          var u = new r();
          return r.prototype = t, u;
        };
      }();
      function zi() {
      }
      function Kt(r, i) {
        this.__wrapped__ = r, this.__actions__ = [], this.__chain__ = !!i, this.__index__ = 0, this.__values__ = t;
      }
      g.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: _g,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: xg,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Qc,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: g
        }
      }, g.prototype = zi.prototype, g.prototype.constructor = g, Kt.prototype = na(zi.prototype), Kt.prototype.constructor = Kt;
      function Oe(r) {
        this.__wrapped__ = r, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Z, this.__views__ = [];
      }
      function uy() {
        var r = new Oe(this.__wrapped__);
        return r.__actions__ = At(this.__actions__), r.__dir__ = this.__dir__, r.__filtered__ = this.__filtered__, r.__iteratees__ = At(this.__iteratees__), r.__takeCount__ = this.__takeCount__, r.__views__ = At(this.__views__), r;
      }
      function ly() {
        if (this.__filtered__) {
          var r = new Oe(this);
          r.__dir__ = -1, r.__filtered__ = !0;
        } else
          r = this.clone(), r.__dir__ *= -1;
        return r;
      }
      function cy() {
        var r = this.__wrapped__.value(), i = this.__dir__, u = we(r), f = i < 0, m = u ? r.length : 0, y = x2(0, m, this.__views__), x = y.start, O = y.end, E = O - x, B = f ? O : x - 1, H = this.__iteratees__, q = H.length, ne = 0, se = bt(E, this.__takeCount__);
        if (!u || !f && m == E && se == E)
          return pd(r, this.__actions__);
        var de = [];
        e:
          for (; E-- && ne < se; ) {
            B += i;
            for (var _e = -1, he = r[B]; ++_e < q; ) {
              var Se = H[_e], Me = Se.iteratee, Ht = Se.type, Ct = Me(he);
              if (Ht == et)
                he = Ct;
              else if (!Ct) {
                if (Ht == ke)
                  continue e;
                break e;
              }
            }
            de[ne++] = he;
          }
        return de;
      }
      Oe.prototype = na(zi.prototype), Oe.prototype.constructor = Oe;
      function _r(r) {
        var i = -1, u = r == null ? 0 : r.length;
        for (this.clear(); ++i < u; ) {
          var f = r[i];
          this.set(f[0], f[1]);
        }
      }
      function fy() {
        this.__data__ = Ia ? Ia(null) : {}, this.size = 0;
      }
      function dy(r) {
        var i = this.has(r) && delete this.__data__[r];
        return this.size -= i ? 1 : 0, i;
      }
      function hy(r) {
        var i = this.__data__;
        if (Ia) {
          var u = i[r];
          return u === d ? t : u;
        }
        return We.call(i, r) ? i[r] : t;
      }
      function py(r) {
        var i = this.__data__;
        return Ia ? i[r] !== t : We.call(i, r);
      }
      function my(r, i) {
        var u = this.__data__;
        return this.size += this.has(r) ? 0 : 1, u[r] = Ia && i === t ? d : i, this;
      }
      _r.prototype.clear = fy, _r.prototype.delete = dy, _r.prototype.get = hy, _r.prototype.has = py, _r.prototype.set = my;
      function Tn(r) {
        var i = -1, u = r == null ? 0 : r.length;
        for (this.clear(); ++i < u; ) {
          var f = r[i];
          this.set(f[0], f[1]);
        }
      }
      function vy() {
        this.__data__ = [], this.size = 0;
      }
      function gy(r) {
        var i = this.__data__, u = qi(i, r);
        if (u < 0)
          return !1;
        var f = i.length - 1;
        return u == f ? i.pop() : $i.call(i, u, 1), --this.size, !0;
      }
      function yy(r) {
        var i = this.__data__, u = qi(i, r);
        return u < 0 ? t : i[u][1];
      }
      function wy(r) {
        return qi(this.__data__, r) > -1;
      }
      function by(r, i) {
        var u = this.__data__, f = qi(u, r);
        return f < 0 ? (++this.size, u.push([r, i])) : u[f][1] = i, this;
      }
      Tn.prototype.clear = vy, Tn.prototype.delete = gy, Tn.prototype.get = yy, Tn.prototype.has = wy, Tn.prototype.set = by;
      function En(r) {
        var i = -1, u = r == null ? 0 : r.length;
        for (this.clear(); ++i < u; ) {
          var f = r[i];
          this.set(f[0], f[1]);
        }
      }
      function _y() {
        this.size = 0, this.__data__ = {
          hash: new _r(),
          map: new (Ra || Tn)(),
          string: new _r()
        };
      }
      function xy(r) {
        var i = io(this, r).delete(r);
        return this.size -= i ? 1 : 0, i;
      }
      function Dy(r) {
        return io(this, r).get(r);
      }
      function Sy(r) {
        return io(this, r).has(r);
      }
      function Oy(r, i) {
        var u = io(this, r), f = u.size;
        return u.set(r, i), this.size += u.size == f ? 0 : 1, this;
      }
      En.prototype.clear = _y, En.prototype.delete = xy, En.prototype.get = Dy, En.prototype.has = Sy, En.prototype.set = Oy;
      function xr(r) {
        var i = -1, u = r == null ? 0 : r.length;
        for (this.__data__ = new En(); ++i < u; )
          this.add(r[i]);
      }
      function My(r) {
        return this.__data__.set(r, d), this;
      }
      function Cy(r) {
        return this.__data__.has(r);
      }
      xr.prototype.add = xr.prototype.push = My, xr.prototype.has = Cy;
      function an(r) {
        var i = this.__data__ = new Tn(r);
        this.size = i.size;
      }
      function Py() {
        this.__data__ = new Tn(), this.size = 0;
      }
      function Ty(r) {
        var i = this.__data__, u = i.delete(r);
        return this.size = i.size, u;
      }
      function Ey(r) {
        return this.__data__.get(r);
      }
      function Ry(r) {
        return this.__data__.has(r);
      }
      function Ay(r, i) {
        var u = this.__data__;
        if (u instanceof Tn) {
          var f = u.__data__;
          if (!Ra || f.length < o - 1)
            return f.push([r, i]), this.size = ++u.size, this;
          u = this.__data__ = new En(f);
        }
        return u.set(r, i), this.size = u.size, this;
      }
      an.prototype.clear = Py, an.prototype.delete = Ty, an.prototype.get = Ey, an.prototype.has = Ry, an.prototype.set = Ay;
      function jf(r, i) {
        var u = we(r), f = !u && Cr(r), m = !u && !f && ir(r), y = !u && !f && !m && oa(r), x = u || f || m || y, O = x ? Qs(r.length, B1) : [], E = O.length;
        for (var B in r)
          (i || We.call(r, B)) && !(x && // Safari 9 has enumerable `arguments.length` in strict mode.
          (B == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          m && (B == "offset" || B == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          y && (B == "buffer" || B == "byteLength" || B == "byteOffset") || // Skip index properties.
          Ln(B, E))) && O.push(B);
        return O;
      }
      function zf(r) {
        var i = r.length;
        return i ? r[mu(0, i - 1)] : t;
      }
      function Iy(r, i) {
        return oo(At(r), Dr(i, 0, r.length));
      }
      function Ly(r) {
        return oo(At(r));
      }
      function iu(r, i, u) {
        (u !== t && !on(r[i], u) || u === t && !(i in r)) && Rn(r, i, u);
      }
      function Fa(r, i, u) {
        var f = r[i];
        (!(We.call(r, i) && on(f, u)) || u === t && !(i in r)) && Rn(r, i, u);
      }
      function qi(r, i) {
        for (var u = r.length; u--; )
          if (on(r[u][0], i))
            return u;
        return -1;
      }
      function Fy(r, i, u, f) {
        return tr(r, function(m, y, x) {
          i(f, m, u(m), x);
        }), f;
      }
      function qf(r, i) {
        return r && pn(i, pt(i), r);
      }
      function Ny(r, i) {
        return r && pn(i, Lt(i), r);
      }
      function Rn(r, i, u) {
        i == "__proto__" && Yi ? Yi(r, i, {
          configurable: !0,
          enumerable: !0,
          value: u,
          writable: !0
        }) : r[i] = u;
      }
      function ou(r, i) {
        for (var u = -1, f = i.length, m = L(f), y = r == null; ++u < f; )
          m[u] = y ? t : $u(r, i[u]);
        return m;
      }
      function Dr(r, i, u) {
        return r === r && (u !== t && (r = r <= u ? r : u), i !== t && (r = r >= i ? r : i)), r;
      }
      function Xt(r, i, u, f, m, y) {
        var x, O = i & v, E = i & w, B = i & b;
        if (u && (x = m ? u(r, f, m, y) : u(r)), x !== t)
          return x;
        if (!Qe(r))
          return r;
        var H = we(r);
        if (H) {
          if (x = S2(r), !O)
            return At(r, x);
        } else {
          var q = _t(r), ne = q == j || q == me;
          if (ir(r))
            return gd(r, O);
          if (q == at || q == S || ne && !m) {
            if (x = E || ne ? {} : Nd(r), !O)
              return E ? h2(r, Ny(x, r)) : d2(r, qf(x, r));
          } else {
            if (!Ue[q])
              return m ? r : {};
            x = O2(r, q, O);
          }
        }
        y || (y = new an());
        var se = y.get(r);
        if (se)
          return se;
        y.set(r, x), fh(r) ? r.forEach(function(he) {
          x.add(Xt(he, i, u, he, r, y));
        }) : lh(r) && r.forEach(function(he, Se) {
          x.set(Se, Xt(he, i, u, Se, r, y));
        });
        var de = B ? E ? Mu : Ou : E ? Lt : pt, _e = H ? t : de(r);
        return qt(_e || r, function(he, Se) {
          _e && (Se = he, he = r[Se]), Fa(x, Se, Xt(he, i, u, Se, r, y));
        }), x;
      }
      function ky(r) {
        var i = pt(r);
        return function(u) {
          return Gf(u, r, i);
        };
      }
      function Gf(r, i, u) {
        var f = u.length;
        if (r == null)
          return !f;
        for (r = Ye(r); f--; ) {
          var m = u[f], y = i[m], x = r[m];
          if (x === t && !(m in r) || !y(x))
            return !1;
        }
        return !0;
      }
      function Kf(r, i, u) {
        if (typeof r != "function")
          throw new Gt(l);
        return Ba(function() {
          r.apply(t, u);
        }, i);
      }
      function Na(r, i, u, f) {
        var m = -1, y = Ei, x = !0, O = r.length, E = [], B = i.length;
        if (!O)
          return E;
        u && (i = Ze(i, $t(u))), f ? (y = zs, x = !1) : i.length >= o && (y = Ta, x = !1, i = new xr(i));
        e:
          for (; ++m < O; ) {
            var H = r[m], q = u == null ? H : u(H);
            if (H = f || H !== 0 ? H : 0, x && q === q) {
              for (var ne = B; ne--; )
                if (i[ne] === q)
                  continue e;
              E.push(H);
            } else y(i, q, f) || E.push(H);
          }
        return E;
      }
      var tr = xd(hn), Xf = xd(uu, !0);
      function Wy(r, i) {
        var u = !0;
        return tr(r, function(f, m, y) {
          return u = !!i(f, m, y), u;
        }), u;
      }
      function Gi(r, i, u) {
        for (var f = -1, m = r.length; ++f < m; ) {
          var y = r[f], x = i(y);
          if (x != null && (O === t ? x === x && !Bt(x) : u(x, O)))
            var O = x, E = y;
        }
        return E;
      }
      function Vy(r, i, u, f) {
        var m = r.length;
        for (u = be(u), u < 0 && (u = -u > m ? 0 : m + u), f = f === t || f > m ? m : be(f), f < 0 && (f += m), f = u > f ? 0 : hh(f); u < f; )
          r[u++] = i;
        return r;
      }
      function Zf(r, i) {
        var u = [];
        return tr(r, function(f, m, y) {
          i(f, m, y) && u.push(f);
        }), u;
      }
      function gt(r, i, u, f, m) {
        var y = -1, x = r.length;
        for (u || (u = C2), m || (m = []); ++y < x; ) {
          var O = r[y];
          i > 0 && u(O) ? i > 1 ? gt(O, i - 1, u, f, m) : Qn(m, O) : f || (m[m.length] = O);
        }
        return m;
      }
      var su = Dd(), Qf = Dd(!0);
      function hn(r, i) {
        return r && su(r, i, pt);
      }
      function uu(r, i) {
        return r && Qf(r, i, pt);
      }
      function Ki(r, i) {
        return Zn(i, function(u) {
          return Fn(r[u]);
        });
      }
      function Sr(r, i) {
        i = rr(i, r);
        for (var u = 0, f = i.length; r != null && u < f; )
          r = r[mn(i[u++])];
        return u && u == f ? r : t;
      }
      function Jf(r, i, u) {
        var f = i(r);
        return we(r) ? f : Qn(f, u(r));
      }
      function Ot(r) {
        return r == null ? r === t ? Kc : wt : br && br in Ye(r) ? _2(r) : L2(r);
      }
      function lu(r, i) {
        return r > i;
      }
      function $y(r, i) {
        return r != null && We.call(r, i);
      }
      function Yy(r, i) {
        return r != null && i in Ye(r);
      }
      function By(r, i, u) {
        return r >= bt(i, u) && r < dt(i, u);
      }
      function cu(r, i, u) {
        for (var f = u ? zs : Ei, m = r[0].length, y = r.length, x = y, O = L(y), E = 1 / 0, B = []; x--; ) {
          var H = r[x];
          x && i && (H = Ze(H, $t(i))), E = bt(H.length, E), O[x] = !u && (i || m >= 120 && H.length >= 120) ? new xr(x && H) : t;
        }
        H = r[0];
        var q = -1, ne = O[0];
        e:
          for (; ++q < m && B.length < E; ) {
            var se = H[q], de = i ? i(se) : se;
            if (se = u || se !== 0 ? se : 0, !(ne ? Ta(ne, de) : f(B, de, u))) {
              for (x = y; --x; ) {
                var _e = O[x];
                if (!(_e ? Ta(_e, de) : f(r[x], de, u)))
                  continue e;
              }
              ne && ne.push(de), B.push(se);
            }
          }
        return B;
      }
      function Hy(r, i, u, f) {
        return hn(r, function(m, y, x) {
          i(f, u(m), y, x);
        }), f;
      }
      function ka(r, i, u) {
        i = rr(i, r), r = $d(r, i);
        var f = r == null ? r : r[mn(Qt(i))];
        return f == null ? t : Vt(f, r, u);
      }
      function ed(r) {
        return tt(r) && Ot(r) == S;
      }
      function Uy(r) {
        return tt(r) && Ot(r) == Pa;
      }
      function jy(r) {
        return tt(r) && Ot(r) == Q;
      }
      function Wa(r, i, u, f, m) {
        return r === i ? !0 : r == null || i == null || !tt(r) && !tt(i) ? r !== r && i !== i : zy(r, i, u, f, Wa, m);
      }
      function zy(r, i, u, f, m, y) {
        var x = we(r), O = we(i), E = x ? F : _t(r), B = O ? F : _t(i);
        E = E == S ? at : E, B = B == S ? at : B;
        var H = E == at, q = B == at, ne = E == B;
        if (ne && ir(r)) {
          if (!ir(i))
            return !1;
          x = !0, H = !1;
        }
        if (ne && !H)
          return y || (y = new an()), x || oa(r) ? Id(r, i, u, f, m, y) : w2(r, i, E, u, f, m, y);
        if (!(u & _)) {
          var se = H && We.call(r, "__wrapped__"), de = q && We.call(i, "__wrapped__");
          if (se || de) {
            var _e = se ? r.value() : r, he = de ? i.value() : i;
            return y || (y = new an()), m(_e, he, u, f, y);
          }
        }
        return ne ? (y || (y = new an()), b2(r, i, u, f, m, y)) : !1;
      }
      function qy(r) {
        return tt(r) && _t(r) == ve;
      }
      function fu(r, i, u, f) {
        var m = u.length, y = m, x = !f;
        if (r == null)
          return !y;
        for (r = Ye(r); m--; ) {
          var O = u[m];
          if (x && O[2] ? O[1] !== r[O[0]] : !(O[0] in r))
            return !1;
        }
        for (; ++m < y; ) {
          O = u[m];
          var E = O[0], B = r[E], H = O[1];
          if (x && O[2]) {
            if (B === t && !(E in r))
              return !1;
          } else {
            var q = new an();
            if (f)
              var ne = f(B, H, E, r, i, q);
            if (!(ne === t ? Wa(H, B, _ | D, f, q) : ne))
              return !1;
          }
        }
        return !0;
      }
      function td(r) {
        if (!Qe(r) || T2(r))
          return !1;
        var i = Fn(r) ? q1 : kg;
        return i.test(Mr(r));
      }
      function Gy(r) {
        return tt(r) && Ot(r) == Xn;
      }
      function Ky(r) {
        return tt(r) && _t(r) == Rt;
      }
      function Xy(r) {
        return tt(r) && ho(r.length) && !!Ke[Ot(r)];
      }
      function nd(r) {
        return typeof r == "function" ? r : r == null ? Ft : typeof r == "object" ? we(r) ? id(r[0], r[1]) : ad(r) : Sh(r);
      }
      function du(r) {
        if (!Ya(r))
          return J1(r);
        var i = [];
        for (var u in Ye(r))
          We.call(r, u) && u != "constructor" && i.push(u);
        return i;
      }
      function Zy(r) {
        if (!Qe(r))
          return I2(r);
        var i = Ya(r), u = [];
        for (var f in r)
          f == "constructor" && (i || !We.call(r, f)) || u.push(f);
        return u;
      }
      function hu(r, i) {
        return r < i;
      }
      function rd(r, i) {
        var u = -1, f = It(r) ? L(r.length) : [];
        return tr(r, function(m, y, x) {
          f[++u] = i(m, y, x);
        }), f;
      }
      function ad(r) {
        var i = Pu(r);
        return i.length == 1 && i[0][2] ? Wd(i[0][0], i[0][1]) : function(u) {
          return u === r || fu(u, r, i);
        };
      }
      function id(r, i) {
        return Eu(r) && kd(i) ? Wd(mn(r), i) : function(u) {
          var f = $u(u, r);
          return f === t && f === i ? Yu(u, r) : Wa(i, f, _ | D);
        };
      }
      function Xi(r, i, u, f, m) {
        r !== i && su(i, function(y, x) {
          if (m || (m = new an()), Qe(y))
            Qy(r, i, x, u, Xi, f, m);
          else {
            var O = f ? f(Au(r, x), y, x + "", r, i, m) : t;
            O === t && (O = y), iu(r, x, O);
          }
        }, Lt);
      }
      function Qy(r, i, u, f, m, y, x) {
        var O = Au(r, u), E = Au(i, u), B = x.get(E);
        if (B) {
          iu(r, u, B);
          return;
        }
        var H = y ? y(O, E, u + "", r, i, x) : t, q = H === t;
        if (q) {
          var ne = we(E), se = !ne && ir(E), de = !ne && !se && oa(E);
          H = E, ne || se || de ? we(O) ? H = O : it(O) ? H = At(O) : se ? (q = !1, H = gd(E, !0)) : de ? (q = !1, H = yd(E, !0)) : H = [] : Ha(E) || Cr(E) ? (H = O, Cr(O) ? H = ph(O) : (!Qe(O) || Fn(O)) && (H = Nd(E))) : q = !1;
        }
        q && (x.set(E, H), m(H, E, f, y, x), x.delete(E)), iu(r, u, H);
      }
      function od(r, i) {
        var u = r.length;
        if (u)
          return i += i < 0 ? u : 0, Ln(i, u) ? r[i] : t;
      }
      function sd(r, i, u) {
        i.length ? i = Ze(i, function(y) {
          return we(y) ? function(x) {
            return Sr(x, y.length === 1 ? y[0] : y);
          } : y;
        }) : i = [Ft];
        var f = -1;
        i = Ze(i, $t(fe()));
        var m = rd(r, function(y, x, O) {
          var E = Ze(i, function(B) {
            return B(y);
          });
          return { criteria: E, index: ++f, value: y };
        });
        return O1(m, function(y, x) {
          return f2(y, x, u);
        });
      }
      function Jy(r, i) {
        return ud(r, i, function(u, f) {
          return Yu(r, f);
        });
      }
      function ud(r, i, u) {
        for (var f = -1, m = i.length, y = {}; ++f < m; ) {
          var x = i[f], O = Sr(r, x);
          u(O, x) && Va(y, rr(x, r), O);
        }
        return y;
      }
      function e2(r) {
        return function(i) {
          return Sr(i, r);
        };
      }
      function pu(r, i, u, f) {
        var m = f ? S1 : Kr, y = -1, x = i.length, O = r;
        for (r === i && (i = At(i)), u && (O = Ze(r, $t(u))); ++y < x; )
          for (var E = 0, B = i[y], H = u ? u(B) : B; (E = m(O, H, E, f)) > -1; )
            O !== r && $i.call(O, E, 1), $i.call(r, E, 1);
        return r;
      }
      function ld(r, i) {
        for (var u = r ? i.length : 0, f = u - 1; u--; ) {
          var m = i[u];
          if (u == f || m !== y) {
            var y = m;
            Ln(m) ? $i.call(r, m, 1) : yu(r, m);
          }
        }
        return r;
      }
      function mu(r, i) {
        return r + Hi(Hf() * (i - r + 1));
      }
      function t2(r, i, u, f) {
        for (var m = -1, y = dt(Bi((i - r) / (u || 1)), 0), x = L(y); y--; )
          x[f ? y : ++m] = r, r += u;
        return x;
      }
      function vu(r, i) {
        var u = "";
        if (!r || i < 1 || i > qe)
          return u;
        do
          i % 2 && (u += r), i = Hi(i / 2), i && (r += r);
        while (i);
        return u;
      }
      function De(r, i) {
        return Iu(Vd(r, i, Ft), r + "");
      }
      function n2(r) {
        return zf(sa(r));
      }
      function r2(r, i) {
        var u = sa(r);
        return oo(u, Dr(i, 0, u.length));
      }
      function Va(r, i, u, f) {
        if (!Qe(r))
          return r;
        i = rr(i, r);
        for (var m = -1, y = i.length, x = y - 1, O = r; O != null && ++m < y; ) {
          var E = mn(i[m]), B = u;
          if (E === "__proto__" || E === "constructor" || E === "prototype")
            return r;
          if (m != x) {
            var H = O[E];
            B = f ? f(H, E, O) : t, B === t && (B = Qe(H) ? H : Ln(i[m + 1]) ? [] : {});
          }
          Fa(O, E, B), O = O[E];
        }
        return r;
      }
      var cd = Ui ? function(r, i) {
        return Ui.set(r, i), r;
      } : Ft, a2 = Yi ? function(r, i) {
        return Yi(r, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Hu(i),
          writable: !0
        });
      } : Ft;
      function i2(r) {
        return oo(sa(r));
      }
      function Zt(r, i, u) {
        var f = -1, m = r.length;
        i < 0 && (i = -i > m ? 0 : m + i), u = u > m ? m : u, u < 0 && (u += m), m = i > u ? 0 : u - i >>> 0, i >>>= 0;
        for (var y = L(m); ++f < m; )
          y[f] = r[f + i];
        return y;
      }
      function o2(r, i) {
        var u;
        return tr(r, function(f, m, y) {
          return u = i(f, m, y), !u;
        }), !!u;
      }
      function Zi(r, i, u) {
        var f = 0, m = r == null ? f : r.length;
        if (typeof i == "number" && i === i && m <= I) {
          for (; f < m; ) {
            var y = f + m >>> 1, x = r[y];
            x !== null && !Bt(x) && (u ? x <= i : x < i) ? f = y + 1 : m = y;
          }
          return m;
        }
        return gu(r, i, Ft, u);
      }
      function gu(r, i, u, f) {
        var m = 0, y = r == null ? 0 : r.length;
        if (y === 0)
          return 0;
        i = u(i);
        for (var x = i !== i, O = i === null, E = Bt(i), B = i === t; m < y; ) {
          var H = Hi((m + y) / 2), q = u(r[H]), ne = q !== t, se = q === null, de = q === q, _e = Bt(q);
          if (x)
            var he = f || de;
          else B ? he = de && (f || ne) : O ? he = de && ne && (f || !se) : E ? he = de && ne && !se && (f || !_e) : se || _e ? he = !1 : he = f ? q <= i : q < i;
          he ? m = H + 1 : y = H;
        }
        return bt(y, V);
      }
      function fd(r, i) {
        for (var u = -1, f = r.length, m = 0, y = []; ++u < f; ) {
          var x = r[u], O = i ? i(x) : x;
          if (!u || !on(O, E)) {
            var E = O;
            y[m++] = x === 0 ? 0 : x;
          }
        }
        return y;
      }
      function dd(r) {
        return typeof r == "number" ? r : Bt(r) ? U : +r;
      }
      function Yt(r) {
        if (typeof r == "string")
          return r;
        if (we(r))
          return Ze(r, Yt) + "";
        if (Bt(r))
          return Uf ? Uf.call(r) : "";
        var i = r + "";
        return i == "0" && 1 / r == -Pe ? "-0" : i;
      }
      function nr(r, i, u) {
        var f = -1, m = Ei, y = r.length, x = !0, O = [], E = O;
        if (u)
          x = !1, m = zs;
        else if (y >= o) {
          var B = i ? null : g2(r);
          if (B)
            return Ai(B);
          x = !1, m = Ta, E = new xr();
        } else
          E = i ? [] : O;
        e:
          for (; ++f < y; ) {
            var H = r[f], q = i ? i(H) : H;
            if (H = u || H !== 0 ? H : 0, x && q === q) {
              for (var ne = E.length; ne--; )
                if (E[ne] === q)
                  continue e;
              i && E.push(q), O.push(H);
            } else m(E, q, u) || (E !== O && E.push(q), O.push(H));
          }
        return O;
      }
      function yu(r, i) {
        return i = rr(i, r), r = $d(r, i), r == null || delete r[mn(Qt(i))];
      }
      function hd(r, i, u, f) {
        return Va(r, i, u(Sr(r, i)), f);
      }
      function Qi(r, i, u, f) {
        for (var m = r.length, y = f ? m : -1; (f ? y-- : ++y < m) && i(r[y], y, r); )
          ;
        return u ? Zt(r, f ? 0 : y, f ? y + 1 : m) : Zt(r, f ? y + 1 : 0, f ? m : y);
      }
      function pd(r, i) {
        var u = r;
        return u instanceof Oe && (u = u.value()), qs(i, function(f, m) {
          return m.func.apply(m.thisArg, Qn([f], m.args));
        }, u);
      }
      function wu(r, i, u) {
        var f = r.length;
        if (f < 2)
          return f ? nr(r[0]) : [];
        for (var m = -1, y = L(f); ++m < f; )
          for (var x = r[m], O = -1; ++O < f; )
            O != m && (y[m] = Na(y[m] || x, r[O], i, u));
        return nr(gt(y, 1), i, u);
      }
      function md(r, i, u) {
        for (var f = -1, m = r.length, y = i.length, x = {}; ++f < m; ) {
          var O = f < y ? i[f] : t;
          u(x, r[f], O);
        }
        return x;
      }
      function bu(r) {
        return it(r) ? r : [];
      }
      function _u(r) {
        return typeof r == "function" ? r : Ft;
      }
      function rr(r, i) {
        return we(r) ? r : Eu(r, i) ? [r] : Ud(Ie(r));
      }
      var s2 = De;
      function ar(r, i, u) {
        var f = r.length;
        return u = u === t ? f : u, !i && u >= f ? r : Zt(r, i, u);
      }
      var vd = G1 || function(r) {
        return vt.clearTimeout(r);
      };
      function gd(r, i) {
        if (i)
          return r.slice();
        var u = r.length, f = Wf ? Wf(u) : new r.constructor(u);
        return r.copy(f), f;
      }
      function xu(r) {
        var i = new r.constructor(r.byteLength);
        return new Wi(i).set(new Wi(r)), i;
      }
      function u2(r, i) {
        var u = i ? xu(r.buffer) : r.buffer;
        return new r.constructor(u, r.byteOffset, r.byteLength);
      }
      function l2(r) {
        var i = new r.constructor(r.source, Jc.exec(r));
        return i.lastIndex = r.lastIndex, i;
      }
      function c2(r) {
        return La ? Ye(La.call(r)) : {};
      }
      function yd(r, i) {
        var u = i ? xu(r.buffer) : r.buffer;
        return new r.constructor(u, r.byteOffset, r.length);
      }
      function wd(r, i) {
        if (r !== i) {
          var u = r !== t, f = r === null, m = r === r, y = Bt(r), x = i !== t, O = i === null, E = i === i, B = Bt(i);
          if (!O && !B && !y && r > i || y && x && E && !O && !B || f && x && E || !u && E || !m)
            return 1;
          if (!f && !y && !B && r < i || B && u && m && !f && !y || O && u && m || !x && m || !E)
            return -1;
        }
        return 0;
      }
      function f2(r, i, u) {
        for (var f = -1, m = r.criteria, y = i.criteria, x = m.length, O = u.length; ++f < x; ) {
          var E = wd(m[f], y[f]);
          if (E) {
            if (f >= O)
              return E;
            var B = u[f];
            return E * (B == "desc" ? -1 : 1);
          }
        }
        return r.index - i.index;
      }
      function bd(r, i, u, f) {
        for (var m = -1, y = r.length, x = u.length, O = -1, E = i.length, B = dt(y - x, 0), H = L(E + B), q = !f; ++O < E; )
          H[O] = i[O];
        for (; ++m < x; )
          (q || m < y) && (H[u[m]] = r[m]);
        for (; B--; )
          H[O++] = r[m++];
        return H;
      }
      function _d(r, i, u, f) {
        for (var m = -1, y = r.length, x = -1, O = u.length, E = -1, B = i.length, H = dt(y - O, 0), q = L(H + B), ne = !f; ++m < H; )
          q[m] = r[m];
        for (var se = m; ++E < B; )
          q[se + E] = i[E];
        for (; ++x < O; )
          (ne || m < y) && (q[se + u[x]] = r[m++]);
        return q;
      }
      function At(r, i) {
        var u = -1, f = r.length;
        for (i || (i = L(f)); ++u < f; )
          i[u] = r[u];
        return i;
      }
      function pn(r, i, u, f) {
        var m = !u;
        u || (u = {});
        for (var y = -1, x = i.length; ++y < x; ) {
          var O = i[y], E = f ? f(u[O], r[O], O, u, r) : t;
          E === t && (E = r[O]), m ? Rn(u, O, E) : Fa(u, O, E);
        }
        return u;
      }
      function d2(r, i) {
        return pn(r, Tu(r), i);
      }
      function h2(r, i) {
        return pn(r, Ld(r), i);
      }
      function Ji(r, i) {
        return function(u, f) {
          var m = we(u) ? y1 : Fy, y = i ? i() : {};
          return m(u, r, fe(f, 2), y);
        };
      }
      function ra(r) {
        return De(function(i, u) {
          var f = -1, m = u.length, y = m > 1 ? u[m - 1] : t, x = m > 2 ? u[2] : t;
          for (y = r.length > 3 && typeof y == "function" ? (m--, y) : t, x && Mt(u[0], u[1], x) && (y = m < 3 ? t : y, m = 1), i = Ye(i); ++f < m; ) {
            var O = u[f];
            O && r(i, O, f, y);
          }
          return i;
        });
      }
      function xd(r, i) {
        return function(u, f) {
          if (u == null)
            return u;
          if (!It(u))
            return r(u, f);
          for (var m = u.length, y = i ? m : -1, x = Ye(u); (i ? y-- : ++y < m) && f(x[y], y, x) !== !1; )
            ;
          return u;
        };
      }
      function Dd(r) {
        return function(i, u, f) {
          for (var m = -1, y = Ye(i), x = f(i), O = x.length; O--; ) {
            var E = x[r ? O : ++m];
            if (u(y[E], E, y) === !1)
              break;
          }
          return i;
        };
      }
      function p2(r, i, u) {
        var f = i & C, m = $a(r);
        function y() {
          var x = this && this !== vt && this instanceof y ? m : r;
          return x.apply(f ? u : this, arguments);
        }
        return y;
      }
      function Sd(r) {
        return function(i) {
          i = Ie(i);
          var u = Xr(i) ? rn(i) : t, f = u ? u[0] : i.charAt(0), m = u ? ar(u, 1).join("") : i.slice(1);
          return f[r]() + m;
        };
      }
      function aa(r) {
        return function(i) {
          return qs(xh(_h(i).replace(a1, "")), r, "");
        };
      }
      function $a(r) {
        return function() {
          var i = arguments;
          switch (i.length) {
            case 0:
              return new r();
            case 1:
              return new r(i[0]);
            case 2:
              return new r(i[0], i[1]);
            case 3:
              return new r(i[0], i[1], i[2]);
            case 4:
              return new r(i[0], i[1], i[2], i[3]);
            case 5:
              return new r(i[0], i[1], i[2], i[3], i[4]);
            case 6:
              return new r(i[0], i[1], i[2], i[3], i[4], i[5]);
            case 7:
              return new r(i[0], i[1], i[2], i[3], i[4], i[5], i[6]);
          }
          var u = na(r.prototype), f = r.apply(u, i);
          return Qe(f) ? f : u;
        };
      }
      function m2(r, i, u) {
        var f = $a(r);
        function m() {
          for (var y = arguments.length, x = L(y), O = y, E = ia(m); O--; )
            x[O] = arguments[O];
          var B = y < 3 && x[0] !== E && x[y - 1] !== E ? [] : Jn(x, E);
          if (y -= B.length, y < u)
            return Td(
              r,
              i,
              eo,
              m.placeholder,
              t,
              x,
              B,
              t,
              t,
              u - y
            );
          var H = this && this !== vt && this instanceof m ? f : r;
          return Vt(H, this, x);
        }
        return m;
      }
      function Od(r) {
        return function(i, u, f) {
          var m = Ye(i);
          if (!It(i)) {
            var y = fe(u, 3);
            i = pt(i), u = function(O) {
              return y(m[O], O, m);
            };
          }
          var x = r(i, u, f);
          return x > -1 ? m[y ? i[x] : x] : t;
        };
      }
      function Md(r) {
        return In(function(i) {
          var u = i.length, f = u, m = Kt.prototype.thru;
          for (r && i.reverse(); f--; ) {
            var y = i[f];
            if (typeof y != "function")
              throw new Gt(l);
            if (m && !x && ao(y) == "wrapper")
              var x = new Kt([], !0);
          }
          for (f = x ? f : u; ++f < u; ) {
            y = i[f];
            var O = ao(y), E = O == "wrapper" ? Cu(y) : t;
            E && Ru(E[0]) && E[1] == (Y | A | R | z) && !E[4].length && E[9] == 1 ? x = x[ao(E[0])].apply(x, E[3]) : x = y.length == 1 && Ru(y) ? x[O]() : x.thru(y);
          }
          return function() {
            var B = arguments, H = B[0];
            if (x && B.length == 1 && we(H))
              return x.plant(H).value();
            for (var q = 0, ne = u ? i[q].apply(this, B) : H; ++q < u; )
              ne = i[q].call(this, ne);
            return ne;
          };
        });
      }
      function eo(r, i, u, f, m, y, x, O, E, B) {
        var H = i & Y, q = i & C, ne = i & N, se = i & (A | k), de = i & oe, _e = ne ? t : $a(r);
        function he() {
          for (var Se = arguments.length, Me = L(Se), Ht = Se; Ht--; )
            Me[Ht] = arguments[Ht];
          if (se)
            var Ct = ia(he), Ut = C1(Me, Ct);
          if (f && (Me = bd(Me, f, m, se)), y && (Me = _d(Me, y, x, se)), Se -= Ut, se && Se < B) {
            var ot = Jn(Me, Ct);
            return Td(
              r,
              i,
              eo,
              he.placeholder,
              u,
              Me,
              ot,
              O,
              E,
              B - Se
            );
          }
          var sn = q ? u : this, kn = ne ? sn[r] : r;
          return Se = Me.length, O ? Me = F2(Me, O) : de && Se > 1 && Me.reverse(), H && E < Se && (Me.length = E), this && this !== vt && this instanceof he && (kn = _e || $a(kn)), kn.apply(sn, Me);
        }
        return he;
      }
      function Cd(r, i) {
        return function(u, f) {
          return Hy(u, r, i(f), {});
        };
      }
      function to(r, i) {
        return function(u, f) {
          var m;
          if (u === t && f === t)
            return i;
          if (u !== t && (m = u), f !== t) {
            if (m === t)
              return f;
            typeof u == "string" || typeof f == "string" ? (u = Yt(u), f = Yt(f)) : (u = dd(u), f = dd(f)), m = r(u, f);
          }
          return m;
        };
      }
      function Du(r) {
        return In(function(i) {
          return i = Ze(i, $t(fe())), De(function(u) {
            var f = this;
            return r(i, function(m) {
              return Vt(m, f, u);
            });
          });
        });
      }
      function no(r, i) {
        i = i === t ? " " : Yt(i);
        var u = i.length;
        if (u < 2)
          return u ? vu(i, r) : i;
        var f = vu(i, Bi(r / Zr(i)));
        return Xr(i) ? ar(rn(f), 0, r).join("") : f.slice(0, r);
      }
      function v2(r, i, u, f) {
        var m = i & C, y = $a(r);
        function x() {
          for (var O = -1, E = arguments.length, B = -1, H = f.length, q = L(H + E), ne = this && this !== vt && this instanceof x ? y : r; ++B < H; )
            q[B] = f[B];
          for (; E--; )
            q[B++] = arguments[++O];
          return Vt(ne, m ? u : this, q);
        }
        return x;
      }
      function Pd(r) {
        return function(i, u, f) {
          return f && typeof f != "number" && Mt(i, u, f) && (u = f = t), i = Nn(i), u === t ? (u = i, i = 0) : u = Nn(u), f = f === t ? i < u ? 1 : -1 : Nn(f), t2(i, u, f, r);
        };
      }
      function ro(r) {
        return function(i, u) {
          return typeof i == "string" && typeof u == "string" || (i = Jt(i), u = Jt(u)), r(i, u);
        };
      }
      function Td(r, i, u, f, m, y, x, O, E, B) {
        var H = i & A, q = H ? x : t, ne = H ? t : x, se = H ? y : t, de = H ? t : y;
        i |= H ? R : ie, i &= ~(H ? ie : R), i & $ || (i &= -4);
        var _e = [
          r,
          i,
          m,
          se,
          q,
          de,
          ne,
          O,
          E,
          B
        ], he = u.apply(t, _e);
        return Ru(r) && Yd(he, _e), he.placeholder = f, Bd(he, r, i);
      }
      function Su(r) {
        var i = ft[r];
        return function(u, f) {
          if (u = Jt(u), f = f == null ? 0 : bt(be(f), 292), f && Bf(u)) {
            var m = (Ie(u) + "e").split("e"), y = i(m[0] + "e" + (+m[1] + f));
            return m = (Ie(y) + "e").split("e"), +(m[0] + "e" + (+m[1] - f));
          }
          return i(u);
        };
      }
      var g2 = ea && 1 / Ai(new ea([, -0]))[1] == Pe ? function(r) {
        return new ea(r);
      } : zu;
      function Ed(r) {
        return function(i) {
          var u = _t(i);
          return u == ve ? eu(i) : u == Rt ? L1(i) : M1(i, r(i));
        };
      }
      function An(r, i, u, f, m, y, x, O) {
        var E = i & N;
        if (!E && typeof r != "function")
          throw new Gt(l);
        var B = f ? f.length : 0;
        if (B || (i &= -97, f = m = t), x = x === t ? x : dt(be(x), 0), O = O === t ? O : be(O), B -= m ? m.length : 0, i & ie) {
          var H = f, q = m;
          f = m = t;
        }
        var ne = E ? t : Cu(r), se = [
          r,
          i,
          u,
          f,
          m,
          H,
          q,
          y,
          x,
          O
        ];
        if (ne && A2(se, ne), r = se[0], i = se[1], u = se[2], f = se[3], m = se[4], O = se[9] = se[9] === t ? E ? 0 : r.length : dt(se[9] - B, 0), !O && i & (A | k) && (i &= -25), !i || i == C)
          var de = p2(r, i, u);
        else i == A || i == k ? de = m2(r, i, O) : (i == R || i == (C | R)) && !m.length ? de = v2(r, i, u, f) : de = eo.apply(t, se);
        var _e = ne ? cd : Yd;
        return Bd(_e(de, se), r, i);
      }
      function Rd(r, i, u, f) {
        return r === t || on(r, Jr[u]) && !We.call(f, u) ? i : r;
      }
      function Ad(r, i, u, f, m, y) {
        return Qe(r) && Qe(i) && (y.set(i, r), Xi(r, i, t, Ad, y), y.delete(i)), r;
      }
      function y2(r) {
        return Ha(r) ? t : r;
      }
      function Id(r, i, u, f, m, y) {
        var x = u & _, O = r.length, E = i.length;
        if (O != E && !(x && E > O))
          return !1;
        var B = y.get(r), H = y.get(i);
        if (B && H)
          return B == i && H == r;
        var q = -1, ne = !0, se = u & D ? new xr() : t;
        for (y.set(r, i), y.set(i, r); ++q < O; ) {
          var de = r[q], _e = i[q];
          if (f)
            var he = x ? f(_e, de, q, i, r, y) : f(de, _e, q, r, i, y);
          if (he !== t) {
            if (he)
              continue;
            ne = !1;
            break;
          }
          if (se) {
            if (!Gs(i, function(Se, Me) {
              if (!Ta(se, Me) && (de === Se || m(de, Se, u, f, y)))
                return se.push(Me);
            })) {
              ne = !1;
              break;
            }
          } else if (!(de === _e || m(de, _e, u, f, y))) {
            ne = !1;
            break;
          }
        }
        return y.delete(r), y.delete(i), ne;
      }
      function w2(r, i, u, f, m, y, x) {
        switch (u) {
          case qr:
            if (r.byteLength != i.byteLength || r.byteOffset != i.byteOffset)
              return !1;
            r = r.buffer, i = i.buffer;
          case Pa:
            return !(r.byteLength != i.byteLength || !y(new Wi(r), new Wi(i)));
          case K:
          case Q:
          case Ge:
            return on(+r, +i);
          case ce:
            return r.name == i.name && r.message == i.message;
          case Xn:
          case Pn:
            return r == i + "";
          case ve:
            var O = eu;
          case Rt:
            var E = f & _;
            if (O || (O = Ai), r.size != i.size && !E)
              return !1;
            var B = x.get(r);
            if (B)
              return B == i;
            f |= D, x.set(r, i);
            var H = Id(O(r), O(i), f, m, y, x);
            return x.delete(r), H;
          case zr:
            if (La)
              return La.call(r) == La.call(i);
        }
        return !1;
      }
      function b2(r, i, u, f, m, y) {
        var x = u & _, O = Ou(r), E = O.length, B = Ou(i), H = B.length;
        if (E != H && !x)
          return !1;
        for (var q = E; q--; ) {
          var ne = O[q];
          if (!(x ? ne in i : We.call(i, ne)))
            return !1;
        }
        var se = y.get(r), de = y.get(i);
        if (se && de)
          return se == i && de == r;
        var _e = !0;
        y.set(r, i), y.set(i, r);
        for (var he = x; ++q < E; ) {
          ne = O[q];
          var Se = r[ne], Me = i[ne];
          if (f)
            var Ht = x ? f(Me, Se, ne, i, r, y) : f(Se, Me, ne, r, i, y);
          if (!(Ht === t ? Se === Me || m(Se, Me, u, f, y) : Ht)) {
            _e = !1;
            break;
          }
          he || (he = ne == "constructor");
        }
        if (_e && !he) {
          var Ct = r.constructor, Ut = i.constructor;
          Ct != Ut && "constructor" in r && "constructor" in i && !(typeof Ct == "function" && Ct instanceof Ct && typeof Ut == "function" && Ut instanceof Ut) && (_e = !1);
        }
        return y.delete(r), y.delete(i), _e;
      }
      function In(r) {
        return Iu(Vd(r, t, Gd), r + "");
      }
      function Ou(r) {
        return Jf(r, pt, Tu);
      }
      function Mu(r) {
        return Jf(r, Lt, Ld);
      }
      var Cu = Ui ? function(r) {
        return Ui.get(r);
      } : zu;
      function ao(r) {
        for (var i = r.name + "", u = ta[i], f = We.call(ta, i) ? u.length : 0; f--; ) {
          var m = u[f], y = m.func;
          if (y == null || y == r)
            return m.name;
        }
        return i;
      }
      function ia(r) {
        var i = We.call(g, "placeholder") ? g : r;
        return i.placeholder;
      }
      function fe() {
        var r = g.iteratee || Uu;
        return r = r === Uu ? nd : r, arguments.length ? r(arguments[0], arguments[1]) : r;
      }
      function io(r, i) {
        var u = r.__data__;
        return P2(i) ? u[typeof i == "string" ? "string" : "hash"] : u.map;
      }
      function Pu(r) {
        for (var i = pt(r), u = i.length; u--; ) {
          var f = i[u], m = r[f];
          i[u] = [f, m, kd(m)];
        }
        return i;
      }
      function Or(r, i) {
        var u = R1(r, i);
        return td(u) ? u : t;
      }
      function _2(r) {
        var i = We.call(r, br), u = r[br];
        try {
          r[br] = t;
          var f = !0;
        } catch {
        }
        var m = Ni.call(r);
        return f && (i ? r[br] = u : delete r[br]), m;
      }
      var Tu = nu ? function(r) {
        return r == null ? [] : (r = Ye(r), Zn(nu(r), function(i) {
          return $f.call(r, i);
        }));
      } : qu, Ld = nu ? function(r) {
        for (var i = []; r; )
          Qn(i, Tu(r)), r = Vi(r);
        return i;
      } : qu, _t = Ot;
      (ru && _t(new ru(new ArrayBuffer(1))) != qr || Ra && _t(new Ra()) != ve || au && _t(au.resolve()) != Kn || ea && _t(new ea()) != Rt || Aa && _t(new Aa()) != yr) && (_t = function(r) {
        var i = Ot(r), u = i == at ? r.constructor : t, f = u ? Mr(u) : "";
        if (f)
          switch (f) {
            case ry:
              return qr;
            case ay:
              return ve;
            case iy:
              return Kn;
            case oy:
              return Rt;
            case sy:
              return yr;
          }
        return i;
      });
      function x2(r, i, u) {
        for (var f = -1, m = u.length; ++f < m; ) {
          var y = u[f], x = y.size;
          switch (y.type) {
            case "drop":
              r += x;
              break;
            case "dropRight":
              i -= x;
              break;
            case "take":
              i = bt(i, r + x);
              break;
            case "takeRight":
              r = dt(r, i - x);
              break;
          }
        }
        return { start: r, end: i };
      }
      function D2(r) {
        var i = r.match(Tg);
        return i ? i[1].split(Eg) : [];
      }
      function Fd(r, i, u) {
        i = rr(i, r);
        for (var f = -1, m = i.length, y = !1; ++f < m; ) {
          var x = mn(i[f]);
          if (!(y = r != null && u(r, x)))
            break;
          r = r[x];
        }
        return y || ++f != m ? y : (m = r == null ? 0 : r.length, !!m && ho(m) && Ln(x, m) && (we(r) || Cr(r)));
      }
      function S2(r) {
        var i = r.length, u = new r.constructor(i);
        return i && typeof r[0] == "string" && We.call(r, "index") && (u.index = r.index, u.input = r.input), u;
      }
      function Nd(r) {
        return typeof r.constructor == "function" && !Ya(r) ? na(Vi(r)) : {};
      }
      function O2(r, i, u) {
        var f = r.constructor;
        switch (i) {
          case Pa:
            return xu(r);
          case K:
          case Q:
            return new f(+r);
          case qr:
            return u2(r, u);
          case Ps:
          case Ts:
          case Es:
          case Rs:
          case As:
          case Is:
          case Ls:
          case Fs:
          case Ns:
            return yd(r, u);
          case ve:
            return new f();
          case Ge:
          case Pn:
            return new f(r);
          case Xn:
            return l2(r);
          case Rt:
            return new f();
          case zr:
            return c2(r);
        }
      }
      function M2(r, i) {
        var u = i.length;
        if (!u)
          return r;
        var f = u - 1;
        return i[f] = (u > 1 ? "& " : "") + i[f], i = i.join(u > 2 ? ", " : " "), r.replace(Pg, `{
/* [wrapped with ` + i + `] */
`);
      }
      function C2(r) {
        return we(r) || Cr(r) || !!(Yf && r && r[Yf]);
      }
      function Ln(r, i) {
        var u = typeof r;
        return i = i ?? qe, !!i && (u == "number" || u != "symbol" && Vg.test(r)) && r > -1 && r % 1 == 0 && r < i;
      }
      function Mt(r, i, u) {
        if (!Qe(u))
          return !1;
        var f = typeof i;
        return (f == "number" ? It(u) && Ln(i, u.length) : f == "string" && i in u) ? on(u[i], r) : !1;
      }
      function Eu(r, i) {
        if (we(r))
          return !1;
        var u = typeof r;
        return u == "number" || u == "symbol" || u == "boolean" || r == null || Bt(r) ? !0 : Sg.test(r) || !Dg.test(r) || i != null && r in Ye(i);
      }
      function P2(r) {
        var i = typeof r;
        return i == "string" || i == "number" || i == "symbol" || i == "boolean" ? r !== "__proto__" : r === null;
      }
      function Ru(r) {
        var i = ao(r), u = g[i];
        if (typeof u != "function" || !(i in Oe.prototype))
          return !1;
        if (r === u)
          return !0;
        var f = Cu(u);
        return !!f && r === f[0];
      }
      function T2(r) {
        return !!kf && kf in r;
      }
      var E2 = Li ? Fn : Gu;
      function Ya(r) {
        var i = r && r.constructor, u = typeof i == "function" && i.prototype || Jr;
        return r === u;
      }
      function kd(r) {
        return r === r && !Qe(r);
      }
      function Wd(r, i) {
        return function(u) {
          return u == null ? !1 : u[r] === i && (i !== t || r in Ye(u));
        };
      }
      function R2(r) {
        var i = co(r, function(f) {
          return u.size === h && u.clear(), f;
        }), u = i.cache;
        return i;
      }
      function A2(r, i) {
        var u = r[1], f = i[1], m = u | f, y = m < (C | N | Y), x = f == Y && u == A || f == Y && u == z && r[7].length <= i[8] || f == (Y | z) && i[7].length <= i[8] && u == A;
        if (!(y || x))
          return r;
        f & C && (r[2] = i[2], m |= u & C ? 0 : $);
        var O = i[3];
        if (O) {
          var E = r[3];
          r[3] = E ? bd(E, O, i[4]) : O, r[4] = E ? Jn(r[3], p) : i[4];
        }
        return O = i[5], O && (E = r[5], r[5] = E ? _d(E, O, i[6]) : O, r[6] = E ? Jn(r[5], p) : i[6]), O = i[7], O && (r[7] = O), f & Y && (r[8] = r[8] == null ? i[8] : bt(r[8], i[8])), r[9] == null && (r[9] = i[9]), r[0] = i[0], r[1] = m, r;
      }
      function I2(r) {
        var i = [];
        if (r != null)
          for (var u in Ye(r))
            i.push(u);
        return i;
      }
      function L2(r) {
        return Ni.call(r);
      }
      function Vd(r, i, u) {
        return i = dt(i === t ? r.length - 1 : i, 0), function() {
          for (var f = arguments, m = -1, y = dt(f.length - i, 0), x = L(y); ++m < y; )
            x[m] = f[i + m];
          m = -1;
          for (var O = L(i + 1); ++m < i; )
            O[m] = f[m];
          return O[i] = u(x), Vt(r, this, O);
        };
      }
      function $d(r, i) {
        return i.length < 2 ? r : Sr(r, Zt(i, 0, -1));
      }
      function F2(r, i) {
        for (var u = r.length, f = bt(i.length, u), m = At(r); f--; ) {
          var y = i[f];
          r[f] = Ln(y, u) ? m[y] : t;
        }
        return r;
      }
      function Au(r, i) {
        if (!(i === "constructor" && typeof r[i] == "function") && i != "__proto__")
          return r[i];
      }
      var Yd = Hd(cd), Ba = X1 || function(r, i) {
        return vt.setTimeout(r, i);
      }, Iu = Hd(a2);
      function Bd(r, i, u) {
        var f = i + "";
        return Iu(r, M2(f, N2(D2(f), u)));
      }
      function Hd(r) {
        var i = 0, u = 0;
        return function() {
          var f = ey(), m = Te - (f - u);
          if (u = f, m > 0) {
            if (++i >= Ae)
              return arguments[0];
          } else
            i = 0;
          return r.apply(t, arguments);
        };
      }
      function oo(r, i) {
        var u = -1, f = r.length, m = f - 1;
        for (i = i === t ? f : i; ++u < i; ) {
          var y = mu(u, m), x = r[y];
          r[y] = r[u], r[u] = x;
        }
        return r.length = i, r;
      }
      var Ud = R2(function(r) {
        var i = [];
        return r.charCodeAt(0) === 46 && i.push(""), r.replace(Og, function(u, f, m, y) {
          i.push(m ? y.replace(Ig, "$1") : f || u);
        }), i;
      });
      function mn(r) {
        if (typeof r == "string" || Bt(r))
          return r;
        var i = r + "";
        return i == "0" && 1 / r == -Pe ? "-0" : i;
      }
      function Mr(r) {
        if (r != null) {
          try {
            return Fi.call(r);
          } catch {
          }
          try {
            return r + "";
          } catch {
          }
        }
        return "";
      }
      function N2(r, i) {
        return qt(M, function(u) {
          var f = "_." + u[0];
          i & u[1] && !Ei(r, f) && r.push(f);
        }), r.sort();
      }
      function jd(r) {
        if (r instanceof Oe)
          return r.clone();
        var i = new Kt(r.__wrapped__, r.__chain__);
        return i.__actions__ = At(r.__actions__), i.__index__ = r.__index__, i.__values__ = r.__values__, i;
      }
      function k2(r, i, u) {
        (u ? Mt(r, i, u) : i === t) ? i = 1 : i = dt(be(i), 0);
        var f = r == null ? 0 : r.length;
        if (!f || i < 1)
          return [];
        for (var m = 0, y = 0, x = L(Bi(f / i)); m < f; )
          x[y++] = Zt(r, m, m += i);
        return x;
      }
      function W2(r) {
        for (var i = -1, u = r == null ? 0 : r.length, f = 0, m = []; ++i < u; ) {
          var y = r[i];
          y && (m[f++] = y);
        }
        return m;
      }
      function V2() {
        var r = arguments.length;
        if (!r)
          return [];
        for (var i = L(r - 1), u = arguments[0], f = r; f--; )
          i[f - 1] = arguments[f];
        return Qn(we(u) ? At(u) : [u], gt(i, 1));
      }
      var $2 = De(function(r, i) {
        return it(r) ? Na(r, gt(i, 1, it, !0)) : [];
      }), Y2 = De(function(r, i) {
        var u = Qt(i);
        return it(u) && (u = t), it(r) ? Na(r, gt(i, 1, it, !0), fe(u, 2)) : [];
      }), B2 = De(function(r, i) {
        var u = Qt(i);
        return it(u) && (u = t), it(r) ? Na(r, gt(i, 1, it, !0), t, u) : [];
      });
      function H2(r, i, u) {
        var f = r == null ? 0 : r.length;
        return f ? (i = u || i === t ? 1 : be(i), Zt(r, i < 0 ? 0 : i, f)) : [];
      }
      function U2(r, i, u) {
        var f = r == null ? 0 : r.length;
        return f ? (i = u || i === t ? 1 : be(i), i = f - i, Zt(r, 0, i < 0 ? 0 : i)) : [];
      }
      function j2(r, i) {
        return r && r.length ? Qi(r, fe(i, 3), !0, !0) : [];
      }
      function z2(r, i) {
        return r && r.length ? Qi(r, fe(i, 3), !0) : [];
      }
      function q2(r, i, u, f) {
        var m = r == null ? 0 : r.length;
        return m ? (u && typeof u != "number" && Mt(r, i, u) && (u = 0, f = m), Vy(r, i, u, f)) : [];
      }
      function zd(r, i, u) {
        var f = r == null ? 0 : r.length;
        if (!f)
          return -1;
        var m = u == null ? 0 : be(u);
        return m < 0 && (m = dt(f + m, 0)), Ri(r, fe(i, 3), m);
      }
      function qd(r, i, u) {
        var f = r == null ? 0 : r.length;
        if (!f)
          return -1;
        var m = f - 1;
        return u !== t && (m = be(u), m = u < 0 ? dt(f + m, 0) : bt(m, f - 1)), Ri(r, fe(i, 3), m, !0);
      }
      function Gd(r) {
        var i = r == null ? 0 : r.length;
        return i ? gt(r, 1) : [];
      }
      function G2(r) {
        var i = r == null ? 0 : r.length;
        return i ? gt(r, Pe) : [];
      }
      function K2(r, i) {
        var u = r == null ? 0 : r.length;
        return u ? (i = i === t ? 1 : be(i), gt(r, i)) : [];
      }
      function X2(r) {
        for (var i = -1, u = r == null ? 0 : r.length, f = {}; ++i < u; ) {
          var m = r[i];
          f[m[0]] = m[1];
        }
        return f;
      }
      function Kd(r) {
        return r && r.length ? r[0] : t;
      }
      function Z2(r, i, u) {
        var f = r == null ? 0 : r.length;
        if (!f)
          return -1;
        var m = u == null ? 0 : be(u);
        return m < 0 && (m = dt(f + m, 0)), Kr(r, i, m);
      }
      function Q2(r) {
        var i = r == null ? 0 : r.length;
        return i ? Zt(r, 0, -1) : [];
      }
      var J2 = De(function(r) {
        var i = Ze(r, bu);
        return i.length && i[0] === r[0] ? cu(i) : [];
      }), ew = De(function(r) {
        var i = Qt(r), u = Ze(r, bu);
        return i === Qt(u) ? i = t : u.pop(), u.length && u[0] === r[0] ? cu(u, fe(i, 2)) : [];
      }), tw = De(function(r) {
        var i = Qt(r), u = Ze(r, bu);
        return i = typeof i == "function" ? i : t, i && u.pop(), u.length && u[0] === r[0] ? cu(u, t, i) : [];
      });
      function nw(r, i) {
        return r == null ? "" : Q1.call(r, i);
      }
      function Qt(r) {
        var i = r == null ? 0 : r.length;
        return i ? r[i - 1] : t;
      }
      function rw(r, i, u) {
        var f = r == null ? 0 : r.length;
        if (!f)
          return -1;
        var m = f;
        return u !== t && (m = be(u), m = m < 0 ? dt(f + m, 0) : bt(m, f - 1)), i === i ? N1(r, i, m) : Ri(r, Tf, m, !0);
      }
      function aw(r, i) {
        return r && r.length ? od(r, be(i)) : t;
      }
      var iw = De(Xd);
      function Xd(r, i) {
        return r && r.length && i && i.length ? pu(r, i) : r;
      }
      function ow(r, i, u) {
        return r && r.length && i && i.length ? pu(r, i, fe(u, 2)) : r;
      }
      function sw(r, i, u) {
        return r && r.length && i && i.length ? pu(r, i, t, u) : r;
      }
      var uw = In(function(r, i) {
        var u = r == null ? 0 : r.length, f = ou(r, i);
        return ld(r, Ze(i, function(m) {
          return Ln(m, u) ? +m : m;
        }).sort(wd)), f;
      });
      function lw(r, i) {
        var u = [];
        if (!(r && r.length))
          return u;
        var f = -1, m = [], y = r.length;
        for (i = fe(i, 3); ++f < y; ) {
          var x = r[f];
          i(x, f, r) && (u.push(x), m.push(f));
        }
        return ld(r, m), u;
      }
      function Lu(r) {
        return r == null ? r : ny.call(r);
      }
      function cw(r, i, u) {
        var f = r == null ? 0 : r.length;
        return f ? (u && typeof u != "number" && Mt(r, i, u) ? (i = 0, u = f) : (i = i == null ? 0 : be(i), u = u === t ? f : be(u)), Zt(r, i, u)) : [];
      }
      function fw(r, i) {
        return Zi(r, i);
      }
      function dw(r, i, u) {
        return gu(r, i, fe(u, 2));
      }
      function hw(r, i) {
        var u = r == null ? 0 : r.length;
        if (u) {
          var f = Zi(r, i);
          if (f < u && on(r[f], i))
            return f;
        }
        return -1;
      }
      function pw(r, i) {
        return Zi(r, i, !0);
      }
      function mw(r, i, u) {
        return gu(r, i, fe(u, 2), !0);
      }
      function vw(r, i) {
        var u = r == null ? 0 : r.length;
        if (u) {
          var f = Zi(r, i, !0) - 1;
          if (on(r[f], i))
            return f;
        }
        return -1;
      }
      function gw(r) {
        return r && r.length ? fd(r) : [];
      }
      function yw(r, i) {
        return r && r.length ? fd(r, fe(i, 2)) : [];
      }
      function ww(r) {
        var i = r == null ? 0 : r.length;
        return i ? Zt(r, 1, i) : [];
      }
      function bw(r, i, u) {
        return r && r.length ? (i = u || i === t ? 1 : be(i), Zt(r, 0, i < 0 ? 0 : i)) : [];
      }
      function _w(r, i, u) {
        var f = r == null ? 0 : r.length;
        return f ? (i = u || i === t ? 1 : be(i), i = f - i, Zt(r, i < 0 ? 0 : i, f)) : [];
      }
      function xw(r, i) {
        return r && r.length ? Qi(r, fe(i, 3), !1, !0) : [];
      }
      function Dw(r, i) {
        return r && r.length ? Qi(r, fe(i, 3)) : [];
      }
      var Sw = De(function(r) {
        return nr(gt(r, 1, it, !0));
      }), Ow = De(function(r) {
        var i = Qt(r);
        return it(i) && (i = t), nr(gt(r, 1, it, !0), fe(i, 2));
      }), Mw = De(function(r) {
        var i = Qt(r);
        return i = typeof i == "function" ? i : t, nr(gt(r, 1, it, !0), t, i);
      });
      function Cw(r) {
        return r && r.length ? nr(r) : [];
      }
      function Pw(r, i) {
        return r && r.length ? nr(r, fe(i, 2)) : [];
      }
      function Tw(r, i) {
        return i = typeof i == "function" ? i : t, r && r.length ? nr(r, t, i) : [];
      }
      function Fu(r) {
        if (!(r && r.length))
          return [];
        var i = 0;
        return r = Zn(r, function(u) {
          if (it(u))
            return i = dt(u.length, i), !0;
        }), Qs(i, function(u) {
          return Ze(r, Ks(u));
        });
      }
      function Zd(r, i) {
        if (!(r && r.length))
          return [];
        var u = Fu(r);
        return i == null ? u : Ze(u, function(f) {
          return Vt(i, t, f);
        });
      }
      var Ew = De(function(r, i) {
        return it(r) ? Na(r, i) : [];
      }), Rw = De(function(r) {
        return wu(Zn(r, it));
      }), Aw = De(function(r) {
        var i = Qt(r);
        return it(i) && (i = t), wu(Zn(r, it), fe(i, 2));
      }), Iw = De(function(r) {
        var i = Qt(r);
        return i = typeof i == "function" ? i : t, wu(Zn(r, it), t, i);
      }), Lw = De(Fu);
      function Fw(r, i) {
        return md(r || [], i || [], Fa);
      }
      function Nw(r, i) {
        return md(r || [], i || [], Va);
      }
      var kw = De(function(r) {
        var i = r.length, u = i > 1 ? r[i - 1] : t;
        return u = typeof u == "function" ? (r.pop(), u) : t, Zd(r, u);
      });
      function Qd(r) {
        var i = g(r);
        return i.__chain__ = !0, i;
      }
      function Ww(r, i) {
        return i(r), r;
      }
      function so(r, i) {
        return i(r);
      }
      var Vw = In(function(r) {
        var i = r.length, u = i ? r[0] : 0, f = this.__wrapped__, m = function(y) {
          return ou(y, r);
        };
        return i > 1 || this.__actions__.length || !(f instanceof Oe) || !Ln(u) ? this.thru(m) : (f = f.slice(u, +u + (i ? 1 : 0)), f.__actions__.push({
          func: so,
          args: [m],
          thisArg: t
        }), new Kt(f, this.__chain__).thru(function(y) {
          return i && !y.length && y.push(t), y;
        }));
      });
      function $w() {
        return Qd(this);
      }
      function Yw() {
        return new Kt(this.value(), this.__chain__);
      }
      function Bw() {
        this.__values__ === t && (this.__values__ = dh(this.value()));
        var r = this.__index__ >= this.__values__.length, i = r ? t : this.__values__[this.__index__++];
        return { done: r, value: i };
      }
      function Hw() {
        return this;
      }
      function Uw(r) {
        for (var i, u = this; u instanceof zi; ) {
          var f = jd(u);
          f.__index__ = 0, f.__values__ = t, i ? m.__wrapped__ = f : i = f;
          var m = f;
          u = u.__wrapped__;
        }
        return m.__wrapped__ = r, i;
      }
      function jw() {
        var r = this.__wrapped__;
        if (r instanceof Oe) {
          var i = r;
          return this.__actions__.length && (i = new Oe(this)), i = i.reverse(), i.__actions__.push({
            func: so,
            args: [Lu],
            thisArg: t
          }), new Kt(i, this.__chain__);
        }
        return this.thru(Lu);
      }
      function zw() {
        return pd(this.__wrapped__, this.__actions__);
      }
      var qw = Ji(function(r, i, u) {
        We.call(r, u) ? ++r[u] : Rn(r, u, 1);
      });
      function Gw(r, i, u) {
        var f = we(r) ? Cf : Wy;
        return u && Mt(r, i, u) && (i = t), f(r, fe(i, 3));
      }
      function Kw(r, i) {
        var u = we(r) ? Zn : Zf;
        return u(r, fe(i, 3));
      }
      var Xw = Od(zd), Zw = Od(qd);
      function Qw(r, i) {
        return gt(uo(r, i), 1);
      }
      function Jw(r, i) {
        return gt(uo(r, i), Pe);
      }
      function eb(r, i, u) {
        return u = u === t ? 1 : be(u), gt(uo(r, i), u);
      }
      function Jd(r, i) {
        var u = we(r) ? qt : tr;
        return u(r, fe(i, 3));
      }
      function eh(r, i) {
        var u = we(r) ? w1 : Xf;
        return u(r, fe(i, 3));
      }
      var tb = Ji(function(r, i, u) {
        We.call(r, u) ? r[u].push(i) : Rn(r, u, [i]);
      });
      function nb(r, i, u, f) {
        r = It(r) ? r : sa(r), u = u && !f ? be(u) : 0;
        var m = r.length;
        return u < 0 && (u = dt(m + u, 0)), po(r) ? u <= m && r.indexOf(i, u) > -1 : !!m && Kr(r, i, u) > -1;
      }
      var rb = De(function(r, i, u) {
        var f = -1, m = typeof i == "function", y = It(r) ? L(r.length) : [];
        return tr(r, function(x) {
          y[++f] = m ? Vt(i, x, u) : ka(x, i, u);
        }), y;
      }), ab = Ji(function(r, i, u) {
        Rn(r, u, i);
      });
      function uo(r, i) {
        var u = we(r) ? Ze : rd;
        return u(r, fe(i, 3));
      }
      function ib(r, i, u, f) {
        return r == null ? [] : (we(i) || (i = i == null ? [] : [i]), u = f ? t : u, we(u) || (u = u == null ? [] : [u]), sd(r, i, u));
      }
      var ob = Ji(function(r, i, u) {
        r[u ? 0 : 1].push(i);
      }, function() {
        return [[], []];
      });
      function sb(r, i, u) {
        var f = we(r) ? qs : Rf, m = arguments.length < 3;
        return f(r, fe(i, 4), u, m, tr);
      }
      function ub(r, i, u) {
        var f = we(r) ? b1 : Rf, m = arguments.length < 3;
        return f(r, fe(i, 4), u, m, Xf);
      }
      function lb(r, i) {
        var u = we(r) ? Zn : Zf;
        return u(r, fo(fe(i, 3)));
      }
      function cb(r) {
        var i = we(r) ? zf : n2;
        return i(r);
      }
      function fb(r, i, u) {
        (u ? Mt(r, i, u) : i === t) ? i = 1 : i = be(i);
        var f = we(r) ? Iy : r2;
        return f(r, i);
      }
      function db(r) {
        var i = we(r) ? Ly : i2;
        return i(r);
      }
      function hb(r) {
        if (r == null)
          return 0;
        if (It(r))
          return po(r) ? Zr(r) : r.length;
        var i = _t(r);
        return i == ve || i == Rt ? r.size : du(r).length;
      }
      function pb(r, i, u) {
        var f = we(r) ? Gs : o2;
        return u && Mt(r, i, u) && (i = t), f(r, fe(i, 3));
      }
      var mb = De(function(r, i) {
        if (r == null)
          return [];
        var u = i.length;
        return u > 1 && Mt(r, i[0], i[1]) ? i = [] : u > 2 && Mt(i[0], i[1], i[2]) && (i = [i[0]]), sd(r, gt(i, 1), []);
      }), lo = K1 || function() {
        return vt.Date.now();
      };
      function vb(r, i) {
        if (typeof i != "function")
          throw new Gt(l);
        return r = be(r), function() {
          if (--r < 1)
            return i.apply(this, arguments);
        };
      }
      function th(r, i, u) {
        return i = u ? t : i, i = r && i == null ? r.length : i, An(r, Y, t, t, t, t, i);
      }
      function nh(r, i) {
        var u;
        if (typeof i != "function")
          throw new Gt(l);
        return r = be(r), function() {
          return --r > 0 && (u = i.apply(this, arguments)), r <= 1 && (i = t), u;
        };
      }
      var Nu = De(function(r, i, u) {
        var f = C;
        if (u.length) {
          var m = Jn(u, ia(Nu));
          f |= R;
        }
        return An(r, f, i, u, m);
      }), rh = De(function(r, i, u) {
        var f = C | N;
        if (u.length) {
          var m = Jn(u, ia(rh));
          f |= R;
        }
        return An(i, f, r, u, m);
      });
      function ah(r, i, u) {
        i = u ? t : i;
        var f = An(r, A, t, t, t, t, t, i);
        return f.placeholder = ah.placeholder, f;
      }
      function ih(r, i, u) {
        i = u ? t : i;
        var f = An(r, k, t, t, t, t, t, i);
        return f.placeholder = ih.placeholder, f;
      }
      function oh(r, i, u) {
        var f, m, y, x, O, E, B = 0, H = !1, q = !1, ne = !0;
        if (typeof r != "function")
          throw new Gt(l);
        i = Jt(i) || 0, Qe(u) && (H = !!u.leading, q = "maxWait" in u, y = q ? dt(Jt(u.maxWait) || 0, i) : y, ne = "trailing" in u ? !!u.trailing : ne);
        function se(ot) {
          var sn = f, kn = m;
          return f = m = t, B = ot, x = r.apply(kn, sn), x;
        }
        function de(ot) {
          return B = ot, O = Ba(Se, i), H ? se(ot) : x;
        }
        function _e(ot) {
          var sn = ot - E, kn = ot - B, Oh = i - sn;
          return q ? bt(Oh, y - kn) : Oh;
        }
        function he(ot) {
          var sn = ot - E, kn = ot - B;
          return E === t || sn >= i || sn < 0 || q && kn >= y;
        }
        function Se() {
          var ot = lo();
          if (he(ot))
            return Me(ot);
          O = Ba(Se, _e(ot));
        }
        function Me(ot) {
          return O = t, ne && f ? se(ot) : (f = m = t, x);
        }
        function Ht() {
          O !== t && vd(O), B = 0, f = E = m = O = t;
        }
        function Ct() {
          return O === t ? x : Me(lo());
        }
        function Ut() {
          var ot = lo(), sn = he(ot);
          if (f = arguments, m = this, E = ot, sn) {
            if (O === t)
              return de(E);
            if (q)
              return vd(O), O = Ba(Se, i), se(E);
          }
          return O === t && (O = Ba(Se, i)), x;
        }
        return Ut.cancel = Ht, Ut.flush = Ct, Ut;
      }
      var gb = De(function(r, i) {
        return Kf(r, 1, i);
      }), yb = De(function(r, i, u) {
        return Kf(r, Jt(i) || 0, u);
      });
      function wb(r) {
        return An(r, oe);
      }
      function co(r, i) {
        if (typeof r != "function" || i != null && typeof i != "function")
          throw new Gt(l);
        var u = function() {
          var f = arguments, m = i ? i.apply(this, f) : f[0], y = u.cache;
          if (y.has(m))
            return y.get(m);
          var x = r.apply(this, f);
          return u.cache = y.set(m, x) || y, x;
        };
        return u.cache = new (co.Cache || En)(), u;
      }
      co.Cache = En;
      function fo(r) {
        if (typeof r != "function")
          throw new Gt(l);
        return function() {
          var i = arguments;
          switch (i.length) {
            case 0:
              return !r.call(this);
            case 1:
              return !r.call(this, i[0]);
            case 2:
              return !r.call(this, i[0], i[1]);
            case 3:
              return !r.call(this, i[0], i[1], i[2]);
          }
          return !r.apply(this, i);
        };
      }
      function bb(r) {
        return nh(2, r);
      }
      var _b = s2(function(r, i) {
        i = i.length == 1 && we(i[0]) ? Ze(i[0], $t(fe())) : Ze(gt(i, 1), $t(fe()));
        var u = i.length;
        return De(function(f) {
          for (var m = -1, y = bt(f.length, u); ++m < y; )
            f[m] = i[m].call(this, f[m]);
          return Vt(r, this, f);
        });
      }), ku = De(function(r, i) {
        var u = Jn(i, ia(ku));
        return An(r, R, t, i, u);
      }), sh = De(function(r, i) {
        var u = Jn(i, ia(sh));
        return An(r, ie, t, i, u);
      }), xb = In(function(r, i) {
        return An(r, z, t, t, t, i);
      });
      function Db(r, i) {
        if (typeof r != "function")
          throw new Gt(l);
        return i = i === t ? i : be(i), De(r, i);
      }
      function Sb(r, i) {
        if (typeof r != "function")
          throw new Gt(l);
        return i = i == null ? 0 : dt(be(i), 0), De(function(u) {
          var f = u[i], m = ar(u, 0, i);
          return f && Qn(m, f), Vt(r, this, m);
        });
      }
      function Ob(r, i, u) {
        var f = !0, m = !0;
        if (typeof r != "function")
          throw new Gt(l);
        return Qe(u) && (f = "leading" in u ? !!u.leading : f, m = "trailing" in u ? !!u.trailing : m), oh(r, i, {
          leading: f,
          maxWait: i,
          trailing: m
        });
      }
      function Mb(r) {
        return th(r, 1);
      }
      function Cb(r, i) {
        return ku(_u(i), r);
      }
      function Pb() {
        if (!arguments.length)
          return [];
        var r = arguments[0];
        return we(r) ? r : [r];
      }
      function Tb(r) {
        return Xt(r, b);
      }
      function Eb(r, i) {
        return i = typeof i == "function" ? i : t, Xt(r, b, i);
      }
      function Rb(r) {
        return Xt(r, v | b);
      }
      function Ab(r, i) {
        return i = typeof i == "function" ? i : t, Xt(r, v | b, i);
      }
      function Ib(r, i) {
        return i == null || Gf(r, i, pt(i));
      }
      function on(r, i) {
        return r === i || r !== r && i !== i;
      }
      var Lb = ro(lu), Fb = ro(function(r, i) {
        return r >= i;
      }), Cr = ed(/* @__PURE__ */ function() {
        return arguments;
      }()) ? ed : function(r) {
        return tt(r) && We.call(r, "callee") && !$f.call(r, "callee");
      }, we = L.isArray, Nb = _f ? $t(_f) : Uy;
      function It(r) {
        return r != null && ho(r.length) && !Fn(r);
      }
      function it(r) {
        return tt(r) && It(r);
      }
      function kb(r) {
        return r === !0 || r === !1 || tt(r) && Ot(r) == K;
      }
      var ir = Z1 || Gu, Wb = xf ? $t(xf) : jy;
      function Vb(r) {
        return tt(r) && r.nodeType === 1 && !Ha(r);
      }
      function $b(r) {
        if (r == null)
          return !0;
        if (It(r) && (we(r) || typeof r == "string" || typeof r.splice == "function" || ir(r) || oa(r) || Cr(r)))
          return !r.length;
        var i = _t(r);
        if (i == ve || i == Rt)
          return !r.size;
        if (Ya(r))
          return !du(r).length;
        for (var u in r)
          if (We.call(r, u))
            return !1;
        return !0;
      }
      function Yb(r, i) {
        return Wa(r, i);
      }
      function Bb(r, i, u) {
        u = typeof u == "function" ? u : t;
        var f = u ? u(r, i) : t;
        return f === t ? Wa(r, i, t, u) : !!f;
      }
      function Wu(r) {
        if (!tt(r))
          return !1;
        var i = Ot(r);
        return i == ce || i == te || typeof r.message == "string" && typeof r.name == "string" && !Ha(r);
      }
      function Hb(r) {
        return typeof r == "number" && Bf(r);
      }
      function Fn(r) {
        if (!Qe(r))
          return !1;
        var i = Ot(r);
        return i == j || i == me || i == G || i == Mi;
      }
      function uh(r) {
        return typeof r == "number" && r == be(r);
      }
      function ho(r) {
        return typeof r == "number" && r > -1 && r % 1 == 0 && r <= qe;
      }
      function Qe(r) {
        var i = typeof r;
        return r != null && (i == "object" || i == "function");
      }
      function tt(r) {
        return r != null && typeof r == "object";
      }
      var lh = Df ? $t(Df) : qy;
      function Ub(r, i) {
        return r === i || fu(r, i, Pu(i));
      }
      function jb(r, i, u) {
        return u = typeof u == "function" ? u : t, fu(r, i, Pu(i), u);
      }
      function zb(r) {
        return ch(r) && r != +r;
      }
      function qb(r) {
        if (E2(r))
          throw new ge(s);
        return td(r);
      }
      function Gb(r) {
        return r === null;
      }
      function Kb(r) {
        return r == null;
      }
      function ch(r) {
        return typeof r == "number" || tt(r) && Ot(r) == Ge;
      }
      function Ha(r) {
        if (!tt(r) || Ot(r) != at)
          return !1;
        var i = Vi(r);
        if (i === null)
          return !0;
        var u = We.call(i, "constructor") && i.constructor;
        return typeof u == "function" && u instanceof u && Fi.call(u) == j1;
      }
      var Vu = Sf ? $t(Sf) : Gy;
      function Xb(r) {
        return uh(r) && r >= -qe && r <= qe;
      }
      var fh = Of ? $t(Of) : Ky;
      function po(r) {
        return typeof r == "string" || !we(r) && tt(r) && Ot(r) == Pn;
      }
      function Bt(r) {
        return typeof r == "symbol" || tt(r) && Ot(r) == zr;
      }
      var oa = Mf ? $t(Mf) : Xy;
      function Zb(r) {
        return r === t;
      }
      function Qb(r) {
        return tt(r) && _t(r) == yr;
      }
      function Jb(r) {
        return tt(r) && Ot(r) == mg;
      }
      var e_ = ro(hu), t_ = ro(function(r, i) {
        return r <= i;
      });
      function dh(r) {
        if (!r)
          return [];
        if (It(r))
          return po(r) ? rn(r) : At(r);
        if (Ea && r[Ea])
          return I1(r[Ea]());
        var i = _t(r), u = i == ve ? eu : i == Rt ? Ai : sa;
        return u(r);
      }
      function Nn(r) {
        if (!r)
          return r === 0 ? r : 0;
        if (r = Jt(r), r === Pe || r === -Pe) {
          var i = r < 0 ? -1 : 1;
          return i * lt;
        }
        return r === r ? r : 0;
      }
      function be(r) {
        var i = Nn(r), u = i % 1;
        return i === i ? u ? i - u : i : 0;
      }
      function hh(r) {
        return r ? Dr(be(r), 0, Z) : 0;
      }
      function Jt(r) {
        if (typeof r == "number")
          return r;
        if (Bt(r))
          return U;
        if (Qe(r)) {
          var i = typeof r.valueOf == "function" ? r.valueOf() : r;
          r = Qe(i) ? i + "" : i;
        }
        if (typeof r != "string")
          return r === 0 ? r : +r;
        r = Af(r);
        var u = Ng.test(r);
        return u || Wg.test(r) ? v1(r.slice(2), u ? 2 : 8) : Fg.test(r) ? U : +r;
      }
      function ph(r) {
        return pn(r, Lt(r));
      }
      function n_(r) {
        return r ? Dr(be(r), -qe, qe) : r === 0 ? r : 0;
      }
      function Ie(r) {
        return r == null ? "" : Yt(r);
      }
      var r_ = ra(function(r, i) {
        if (Ya(i) || It(i)) {
          pn(i, pt(i), r);
          return;
        }
        for (var u in i)
          We.call(i, u) && Fa(r, u, i[u]);
      }), mh = ra(function(r, i) {
        pn(i, Lt(i), r);
      }), mo = ra(function(r, i, u, f) {
        pn(i, Lt(i), r, f);
      }), a_ = ra(function(r, i, u, f) {
        pn(i, pt(i), r, f);
      }), i_ = In(ou);
      function o_(r, i) {
        var u = na(r);
        return i == null ? u : qf(u, i);
      }
      var s_ = De(function(r, i) {
        r = Ye(r);
        var u = -1, f = i.length, m = f > 2 ? i[2] : t;
        for (m && Mt(i[0], i[1], m) && (f = 1); ++u < f; )
          for (var y = i[u], x = Lt(y), O = -1, E = x.length; ++O < E; ) {
            var B = x[O], H = r[B];
            (H === t || on(H, Jr[B]) && !We.call(r, B)) && (r[B] = y[B]);
          }
        return r;
      }), u_ = De(function(r) {
        return r.push(t, Ad), Vt(vh, t, r);
      });
      function l_(r, i) {
        return Pf(r, fe(i, 3), hn);
      }
      function c_(r, i) {
        return Pf(r, fe(i, 3), uu);
      }
      function f_(r, i) {
        return r == null ? r : su(r, fe(i, 3), Lt);
      }
      function d_(r, i) {
        return r == null ? r : Qf(r, fe(i, 3), Lt);
      }
      function h_(r, i) {
        return r && hn(r, fe(i, 3));
      }
      function p_(r, i) {
        return r && uu(r, fe(i, 3));
      }
      function m_(r) {
        return r == null ? [] : Ki(r, pt(r));
      }
      function v_(r) {
        return r == null ? [] : Ki(r, Lt(r));
      }
      function $u(r, i, u) {
        var f = r == null ? t : Sr(r, i);
        return f === t ? u : f;
      }
      function g_(r, i) {
        return r != null && Fd(r, i, $y);
      }
      function Yu(r, i) {
        return r != null && Fd(r, i, Yy);
      }
      var y_ = Cd(function(r, i, u) {
        i != null && typeof i.toString != "function" && (i = Ni.call(i)), r[i] = u;
      }, Hu(Ft)), w_ = Cd(function(r, i, u) {
        i != null && typeof i.toString != "function" && (i = Ni.call(i)), We.call(r, i) ? r[i].push(u) : r[i] = [u];
      }, fe), b_ = De(ka);
      function pt(r) {
        return It(r) ? jf(r) : du(r);
      }
      function Lt(r) {
        return It(r) ? jf(r, !0) : Zy(r);
      }
      function __(r, i) {
        var u = {};
        return i = fe(i, 3), hn(r, function(f, m, y) {
          Rn(u, i(f, m, y), f);
        }), u;
      }
      function x_(r, i) {
        var u = {};
        return i = fe(i, 3), hn(r, function(f, m, y) {
          Rn(u, m, i(f, m, y));
        }), u;
      }
      var D_ = ra(function(r, i, u) {
        Xi(r, i, u);
      }), vh = ra(function(r, i, u, f) {
        Xi(r, i, u, f);
      }), S_ = In(function(r, i) {
        var u = {};
        if (r == null)
          return u;
        var f = !1;
        i = Ze(i, function(y) {
          return y = rr(y, r), f || (f = y.length > 1), y;
        }), pn(r, Mu(r), u), f && (u = Xt(u, v | w | b, y2));
        for (var m = i.length; m--; )
          yu(u, i[m]);
        return u;
      });
      function O_(r, i) {
        return gh(r, fo(fe(i)));
      }
      var M_ = In(function(r, i) {
        return r == null ? {} : Jy(r, i);
      });
      function gh(r, i) {
        if (r == null)
          return {};
        var u = Ze(Mu(r), function(f) {
          return [f];
        });
        return i = fe(i), ud(r, u, function(f, m) {
          return i(f, m[0]);
        });
      }
      function C_(r, i, u) {
        i = rr(i, r);
        var f = -1, m = i.length;
        for (m || (m = 1, r = t); ++f < m; ) {
          var y = r == null ? t : r[mn(i[f])];
          y === t && (f = m, y = u), r = Fn(y) ? y.call(r) : y;
        }
        return r;
      }
      function P_(r, i, u) {
        return r == null ? r : Va(r, i, u);
      }
      function T_(r, i, u, f) {
        return f = typeof f == "function" ? f : t, r == null ? r : Va(r, i, u, f);
      }
      var yh = Ed(pt), wh = Ed(Lt);
      function E_(r, i, u) {
        var f = we(r), m = f || ir(r) || oa(r);
        if (i = fe(i, 4), u == null) {
          var y = r && r.constructor;
          m ? u = f ? new y() : [] : Qe(r) ? u = Fn(y) ? na(Vi(r)) : {} : u = {};
        }
        return (m ? qt : hn)(r, function(x, O, E) {
          return i(u, x, O, E);
        }), u;
      }
      function R_(r, i) {
        return r == null ? !0 : yu(r, i);
      }
      function A_(r, i, u) {
        return r == null ? r : hd(r, i, _u(u));
      }
      function I_(r, i, u, f) {
        return f = typeof f == "function" ? f : t, r == null ? r : hd(r, i, _u(u), f);
      }
      function sa(r) {
        return r == null ? [] : Js(r, pt(r));
      }
      function L_(r) {
        return r == null ? [] : Js(r, Lt(r));
      }
      function F_(r, i, u) {
        return u === t && (u = i, i = t), u !== t && (u = Jt(u), u = u === u ? u : 0), i !== t && (i = Jt(i), i = i === i ? i : 0), Dr(Jt(r), i, u);
      }
      function N_(r, i, u) {
        return i = Nn(i), u === t ? (u = i, i = 0) : u = Nn(u), r = Jt(r), By(r, i, u);
      }
      function k_(r, i, u) {
        if (u && typeof u != "boolean" && Mt(r, i, u) && (i = u = t), u === t && (typeof i == "boolean" ? (u = i, i = t) : typeof r == "boolean" && (u = r, r = t)), r === t && i === t ? (r = 0, i = 1) : (r = Nn(r), i === t ? (i = r, r = 0) : i = Nn(i)), r > i) {
          var f = r;
          r = i, i = f;
        }
        if (u || r % 1 || i % 1) {
          var m = Hf();
          return bt(r + m * (i - r + m1("1e-" + ((m + "").length - 1))), i);
        }
        return mu(r, i);
      }
      var W_ = aa(function(r, i, u) {
        return i = i.toLowerCase(), r + (u ? bh(i) : i);
      });
      function bh(r) {
        return Bu(Ie(r).toLowerCase());
      }
      function _h(r) {
        return r = Ie(r), r && r.replace($g, P1).replace(i1, "");
      }
      function V_(r, i, u) {
        r = Ie(r), i = Yt(i);
        var f = r.length;
        u = u === t ? f : Dr(be(u), 0, f);
        var m = u;
        return u -= i.length, u >= 0 && r.slice(u, m) == i;
      }
      function $_(r) {
        return r = Ie(r), r && bg.test(r) ? r.replace(Zc, T1) : r;
      }
      function Y_(r) {
        return r = Ie(r), r && Mg.test(r) ? r.replace(ks, "\\$&") : r;
      }
      var B_ = aa(function(r, i, u) {
        return r + (u ? "-" : "") + i.toLowerCase();
      }), H_ = aa(function(r, i, u) {
        return r + (u ? " " : "") + i.toLowerCase();
      }), U_ = Sd("toLowerCase");
      function j_(r, i, u) {
        r = Ie(r), i = be(i);
        var f = i ? Zr(r) : 0;
        if (!i || f >= i)
          return r;
        var m = (i - f) / 2;
        return no(Hi(m), u) + r + no(Bi(m), u);
      }
      function z_(r, i, u) {
        r = Ie(r), i = be(i);
        var f = i ? Zr(r) : 0;
        return i && f < i ? r + no(i - f, u) : r;
      }
      function q_(r, i, u) {
        r = Ie(r), i = be(i);
        var f = i ? Zr(r) : 0;
        return i && f < i ? no(i - f, u) + r : r;
      }
      function G_(r, i, u) {
        return u || i == null ? i = 0 : i && (i = +i), ty(Ie(r).replace(Ws, ""), i || 0);
      }
      function K_(r, i, u) {
        return (u ? Mt(r, i, u) : i === t) ? i = 1 : i = be(i), vu(Ie(r), i);
      }
      function X_() {
        var r = arguments, i = Ie(r[0]);
        return r.length < 3 ? i : i.replace(r[1], r[2]);
      }
      var Z_ = aa(function(r, i, u) {
        return r + (u ? "_" : "") + i.toLowerCase();
      });
      function Q_(r, i, u) {
        return u && typeof u != "number" && Mt(r, i, u) && (i = u = t), u = u === t ? Z : u >>> 0, u ? (r = Ie(r), r && (typeof i == "string" || i != null && !Vu(i)) && (i = Yt(i), !i && Xr(r)) ? ar(rn(r), 0, u) : r.split(i, u)) : [];
      }
      var J_ = aa(function(r, i, u) {
        return r + (u ? " " : "") + Bu(i);
      });
      function e3(r, i, u) {
        return r = Ie(r), u = u == null ? 0 : Dr(be(u), 0, r.length), i = Yt(i), r.slice(u, u + i.length) == i;
      }
      function t3(r, i, u) {
        var f = g.templateSettings;
        u && Mt(r, i, u) && (i = t), r = Ie(r), i = mo({}, i, f, Rd);
        var m = mo({}, i.imports, f.imports, Rd), y = pt(m), x = Js(m, y), O, E, B = 0, H = i.interpolate || Ci, q = "__p += '", ne = tu(
          (i.escape || Ci).source + "|" + H.source + "|" + (H === Qc ? Lg : Ci).source + "|" + (i.evaluate || Ci).source + "|$",
          "g"
        ), se = "//# sourceURL=" + (We.call(i, "sourceURL") ? (i.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++c1 + "]") + `
`;
        r.replace(ne, function(he, Se, Me, Ht, Ct, Ut) {
          return Me || (Me = Ht), q += r.slice(B, Ut).replace(Yg, E1), Se && (O = !0, q += `' +
__e(` + Se + `) +
'`), Ct && (E = !0, q += `';
` + Ct + `;
__p += '`), Me && (q += `' +
((__t = (` + Me + `)) == null ? '' : __t) +
'`), B = Ut + he.length, he;
        }), q += `';
`;
        var de = We.call(i, "variable") && i.variable;
        if (!de)
          q = `with (obj) {
` + q + `
}
`;
        else if (Ag.test(de))
          throw new ge(c);
        q = (E ? q.replace(vg, "") : q).replace(gg, "$1").replace(yg, "$1;"), q = "function(" + (de || "obj") + `) {
` + (de ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (O ? ", __e = _.escape" : "") + (E ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + q + `return __p
}`;
        var _e = Dh(function() {
          return Ee(y, se + "return " + q).apply(t, x);
        });
        if (_e.source = q, Wu(_e))
          throw _e;
        return _e;
      }
      function n3(r) {
        return Ie(r).toLowerCase();
      }
      function r3(r) {
        return Ie(r).toUpperCase();
      }
      function a3(r, i, u) {
        if (r = Ie(r), r && (u || i === t))
          return Af(r);
        if (!r || !(i = Yt(i)))
          return r;
        var f = rn(r), m = rn(i), y = If(f, m), x = Lf(f, m) + 1;
        return ar(f, y, x).join("");
      }
      function i3(r, i, u) {
        if (r = Ie(r), r && (u || i === t))
          return r.slice(0, Nf(r) + 1);
        if (!r || !(i = Yt(i)))
          return r;
        var f = rn(r), m = Lf(f, rn(i)) + 1;
        return ar(f, 0, m).join("");
      }
      function o3(r, i, u) {
        if (r = Ie(r), r && (u || i === t))
          return r.replace(Ws, "");
        if (!r || !(i = Yt(i)))
          return r;
        var f = rn(r), m = If(f, rn(i));
        return ar(f, m).join("");
      }
      function s3(r, i) {
        var u = xe, f = Ne;
        if (Qe(i)) {
          var m = "separator" in i ? i.separator : m;
          u = "length" in i ? be(i.length) : u, f = "omission" in i ? Yt(i.omission) : f;
        }
        r = Ie(r);
        var y = r.length;
        if (Xr(r)) {
          var x = rn(r);
          y = x.length;
        }
        if (u >= y)
          return r;
        var O = u - Zr(f);
        if (O < 1)
          return f;
        var E = x ? ar(x, 0, O).join("") : r.slice(0, O);
        if (m === t)
          return E + f;
        if (x && (O += E.length - O), Vu(m)) {
          if (r.slice(O).search(m)) {
            var B, H = E;
            for (m.global || (m = tu(m.source, Ie(Jc.exec(m)) + "g")), m.lastIndex = 0; B = m.exec(H); )
              var q = B.index;
            E = E.slice(0, q === t ? O : q);
          }
        } else if (r.indexOf(Yt(m), O) != O) {
          var ne = E.lastIndexOf(m);
          ne > -1 && (E = E.slice(0, ne));
        }
        return E + f;
      }
      function u3(r) {
        return r = Ie(r), r && wg.test(r) ? r.replace(Xc, k1) : r;
      }
      var l3 = aa(function(r, i, u) {
        return r + (u ? " " : "") + i.toUpperCase();
      }), Bu = Sd("toUpperCase");
      function xh(r, i, u) {
        return r = Ie(r), i = u ? t : i, i === t ? A1(r) ? $1(r) : D1(r) : r.match(i) || [];
      }
      var Dh = De(function(r, i) {
        try {
          return Vt(r, t, i);
        } catch (u) {
          return Wu(u) ? u : new ge(u);
        }
      }), c3 = In(function(r, i) {
        return qt(i, function(u) {
          u = mn(u), Rn(r, u, Nu(r[u], r));
        }), r;
      });
      function f3(r) {
        var i = r == null ? 0 : r.length, u = fe();
        return r = i ? Ze(r, function(f) {
          if (typeof f[1] != "function")
            throw new Gt(l);
          return [u(f[0]), f[1]];
        }) : [], De(function(f) {
          for (var m = -1; ++m < i; ) {
            var y = r[m];
            if (Vt(y[0], this, f))
              return Vt(y[1], this, f);
          }
        });
      }
      function d3(r) {
        return ky(Xt(r, v));
      }
      function Hu(r) {
        return function() {
          return r;
        };
      }
      function h3(r, i) {
        return r == null || r !== r ? i : r;
      }
      var p3 = Md(), m3 = Md(!0);
      function Ft(r) {
        return r;
      }
      function Uu(r) {
        return nd(typeof r == "function" ? r : Xt(r, v));
      }
      function v3(r) {
        return ad(Xt(r, v));
      }
      function g3(r, i) {
        return id(r, Xt(i, v));
      }
      var y3 = De(function(r, i) {
        return function(u) {
          return ka(u, r, i);
        };
      }), w3 = De(function(r, i) {
        return function(u) {
          return ka(r, u, i);
        };
      });
      function ju(r, i, u) {
        var f = pt(i), m = Ki(i, f);
        u == null && !(Qe(i) && (m.length || !f.length)) && (u = i, i = r, r = this, m = Ki(i, pt(i)));
        var y = !(Qe(u) && "chain" in u) || !!u.chain, x = Fn(r);
        return qt(m, function(O) {
          var E = i[O];
          r[O] = E, x && (r.prototype[O] = function() {
            var B = this.__chain__;
            if (y || B) {
              var H = r(this.__wrapped__), q = H.__actions__ = At(this.__actions__);
              return q.push({ func: E, args: arguments, thisArg: r }), H.__chain__ = B, H;
            }
            return E.apply(r, Qn([this.value()], arguments));
          });
        }), r;
      }
      function b3() {
        return vt._ === this && (vt._ = z1), this;
      }
      function zu() {
      }
      function _3(r) {
        return r = be(r), De(function(i) {
          return od(i, r);
        });
      }
      var x3 = Du(Ze), D3 = Du(Cf), S3 = Du(Gs);
      function Sh(r) {
        return Eu(r) ? Ks(mn(r)) : e2(r);
      }
      function O3(r) {
        return function(i) {
          return r == null ? t : Sr(r, i);
        };
      }
      var M3 = Pd(), C3 = Pd(!0);
      function qu() {
        return [];
      }
      function Gu() {
        return !1;
      }
      function P3() {
        return {};
      }
      function T3() {
        return "";
      }
      function E3() {
        return !0;
      }
      function R3(r, i) {
        if (r = be(r), r < 1 || r > qe)
          return [];
        var u = Z, f = bt(r, Z);
        i = fe(i), r -= Z;
        for (var m = Qs(f, i); ++u < r; )
          i(u);
        return m;
      }
      function A3(r) {
        return we(r) ? Ze(r, mn) : Bt(r) ? [r] : At(Ud(Ie(r)));
      }
      function I3(r) {
        var i = ++U1;
        return Ie(r) + i;
      }
      var L3 = to(function(r, i) {
        return r + i;
      }, 0), F3 = Su("ceil"), N3 = to(function(r, i) {
        return r / i;
      }, 1), k3 = Su("floor");
      function W3(r) {
        return r && r.length ? Gi(r, Ft, lu) : t;
      }
      function V3(r, i) {
        return r && r.length ? Gi(r, fe(i, 2), lu) : t;
      }
      function $3(r) {
        return Ef(r, Ft);
      }
      function Y3(r, i) {
        return Ef(r, fe(i, 2));
      }
      function B3(r) {
        return r && r.length ? Gi(r, Ft, hu) : t;
      }
      function H3(r, i) {
        return r && r.length ? Gi(r, fe(i, 2), hu) : t;
      }
      var U3 = to(function(r, i) {
        return r * i;
      }, 1), j3 = Su("round"), z3 = to(function(r, i) {
        return r - i;
      }, 0);
      function q3(r) {
        return r && r.length ? Zs(r, Ft) : 0;
      }
      function G3(r, i) {
        return r && r.length ? Zs(r, fe(i, 2)) : 0;
      }
      return g.after = vb, g.ary = th, g.assign = r_, g.assignIn = mh, g.assignInWith = mo, g.assignWith = a_, g.at = i_, g.before = nh, g.bind = Nu, g.bindAll = c3, g.bindKey = rh, g.castArray = Pb, g.chain = Qd, g.chunk = k2, g.compact = W2, g.concat = V2, g.cond = f3, g.conforms = d3, g.constant = Hu, g.countBy = qw, g.create = o_, g.curry = ah, g.curryRight = ih, g.debounce = oh, g.defaults = s_, g.defaultsDeep = u_, g.defer = gb, g.delay = yb, g.difference = $2, g.differenceBy = Y2, g.differenceWith = B2, g.drop = H2, g.dropRight = U2, g.dropRightWhile = j2, g.dropWhile = z2, g.fill = q2, g.filter = Kw, g.flatMap = Qw, g.flatMapDeep = Jw, g.flatMapDepth = eb, g.flatten = Gd, g.flattenDeep = G2, g.flattenDepth = K2, g.flip = wb, g.flow = p3, g.flowRight = m3, g.fromPairs = X2, g.functions = m_, g.functionsIn = v_, g.groupBy = tb, g.initial = Q2, g.intersection = J2, g.intersectionBy = ew, g.intersectionWith = tw, g.invert = y_, g.invertBy = w_, g.invokeMap = rb, g.iteratee = Uu, g.keyBy = ab, g.keys = pt, g.keysIn = Lt, g.map = uo, g.mapKeys = __, g.mapValues = x_, g.matches = v3, g.matchesProperty = g3, g.memoize = co, g.merge = D_, g.mergeWith = vh, g.method = y3, g.methodOf = w3, g.mixin = ju, g.negate = fo, g.nthArg = _3, g.omit = S_, g.omitBy = O_, g.once = bb, g.orderBy = ib, g.over = x3, g.overArgs = _b, g.overEvery = D3, g.overSome = S3, g.partial = ku, g.partialRight = sh, g.partition = ob, g.pick = M_, g.pickBy = gh, g.property = Sh, g.propertyOf = O3, g.pull = iw, g.pullAll = Xd, g.pullAllBy = ow, g.pullAllWith = sw, g.pullAt = uw, g.range = M3, g.rangeRight = C3, g.rearg = xb, g.reject = lb, g.remove = lw, g.rest = Db, g.reverse = Lu, g.sampleSize = fb, g.set = P_, g.setWith = T_, g.shuffle = db, g.slice = cw, g.sortBy = mb, g.sortedUniq = gw, g.sortedUniqBy = yw, g.split = Q_, g.spread = Sb, g.tail = ww, g.take = bw, g.takeRight = _w, g.takeRightWhile = xw, g.takeWhile = Dw, g.tap = Ww, g.throttle = Ob, g.thru = so, g.toArray = dh, g.toPairs = yh, g.toPairsIn = wh, g.toPath = A3, g.toPlainObject = ph, g.transform = E_, g.unary = Mb, g.union = Sw, g.unionBy = Ow, g.unionWith = Mw, g.uniq = Cw, g.uniqBy = Pw, g.uniqWith = Tw, g.unset = R_, g.unzip = Fu, g.unzipWith = Zd, g.update = A_, g.updateWith = I_, g.values = sa, g.valuesIn = L_, g.without = Ew, g.words = xh, g.wrap = Cb, g.xor = Rw, g.xorBy = Aw, g.xorWith = Iw, g.zip = Lw, g.zipObject = Fw, g.zipObjectDeep = Nw, g.zipWith = kw, g.entries = yh, g.entriesIn = wh, g.extend = mh, g.extendWith = mo, ju(g, g), g.add = L3, g.attempt = Dh, g.camelCase = W_, g.capitalize = bh, g.ceil = F3, g.clamp = F_, g.clone = Tb, g.cloneDeep = Rb, g.cloneDeepWith = Ab, g.cloneWith = Eb, g.conformsTo = Ib, g.deburr = _h, g.defaultTo = h3, g.divide = N3, g.endsWith = V_, g.eq = on, g.escape = $_, g.escapeRegExp = Y_, g.every = Gw, g.find = Xw, g.findIndex = zd, g.findKey = l_, g.findLast = Zw, g.findLastIndex = qd, g.findLastKey = c_, g.floor = k3, g.forEach = Jd, g.forEachRight = eh, g.forIn = f_, g.forInRight = d_, g.forOwn = h_, g.forOwnRight = p_, g.get = $u, g.gt = Lb, g.gte = Fb, g.has = g_, g.hasIn = Yu, g.head = Kd, g.identity = Ft, g.includes = nb, g.indexOf = Z2, g.inRange = N_, g.invoke = b_, g.isArguments = Cr, g.isArray = we, g.isArrayBuffer = Nb, g.isArrayLike = It, g.isArrayLikeObject = it, g.isBoolean = kb, g.isBuffer = ir, g.isDate = Wb, g.isElement = Vb, g.isEmpty = $b, g.isEqual = Yb, g.isEqualWith = Bb, g.isError = Wu, g.isFinite = Hb, g.isFunction = Fn, g.isInteger = uh, g.isLength = ho, g.isMap = lh, g.isMatch = Ub, g.isMatchWith = jb, g.isNaN = zb, g.isNative = qb, g.isNil = Kb, g.isNull = Gb, g.isNumber = ch, g.isObject = Qe, g.isObjectLike = tt, g.isPlainObject = Ha, g.isRegExp = Vu, g.isSafeInteger = Xb, g.isSet = fh, g.isString = po, g.isSymbol = Bt, g.isTypedArray = oa, g.isUndefined = Zb, g.isWeakMap = Qb, g.isWeakSet = Jb, g.join = nw, g.kebabCase = B_, g.last = Qt, g.lastIndexOf = rw, g.lowerCase = H_, g.lowerFirst = U_, g.lt = e_, g.lte = t_, g.max = W3, g.maxBy = V3, g.mean = $3, g.meanBy = Y3, g.min = B3, g.minBy = H3, g.stubArray = qu, g.stubFalse = Gu, g.stubObject = P3, g.stubString = T3, g.stubTrue = E3, g.multiply = U3, g.nth = aw, g.noConflict = b3, g.noop = zu, g.now = lo, g.pad = j_, g.padEnd = z_, g.padStart = q_, g.parseInt = G_, g.random = k_, g.reduce = sb, g.reduceRight = ub, g.repeat = K_, g.replace = X_, g.result = C_, g.round = j3, g.runInContext = P, g.sample = cb, g.size = hb, g.snakeCase = Z_, g.some = pb, g.sortedIndex = fw, g.sortedIndexBy = dw, g.sortedIndexOf = hw, g.sortedLastIndex = pw, g.sortedLastIndexBy = mw, g.sortedLastIndexOf = vw, g.startCase = J_, g.startsWith = e3, g.subtract = z3, g.sum = q3, g.sumBy = G3, g.template = t3, g.times = R3, g.toFinite = Nn, g.toInteger = be, g.toLength = hh, g.toLower = n3, g.toNumber = Jt, g.toSafeInteger = n_, g.toString = Ie, g.toUpper = r3, g.trim = a3, g.trimEnd = i3, g.trimStart = o3, g.truncate = s3, g.unescape = u3, g.uniqueId = I3, g.upperCase = l3, g.upperFirst = Bu, g.each = Jd, g.eachRight = eh, g.first = Kd, ju(g, function() {
        var r = {};
        return hn(g, function(i, u) {
          We.call(g.prototype, u) || (r[u] = i);
        }), r;
      }(), { chain: !1 }), g.VERSION = a, qt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(r) {
        g[r].placeholder = g;
      }), qt(["drop", "take"], function(r, i) {
        Oe.prototype[r] = function(u) {
          u = u === t ? 1 : dt(be(u), 0);
          var f = this.__filtered__ && !i ? new Oe(this) : this.clone();
          return f.__filtered__ ? f.__takeCount__ = bt(u, f.__takeCount__) : f.__views__.push({
            size: bt(u, Z),
            type: r + (f.__dir__ < 0 ? "Right" : "")
          }), f;
        }, Oe.prototype[r + "Right"] = function(u) {
          return this.reverse()[r](u).reverse();
        };
      }), qt(["filter", "map", "takeWhile"], function(r, i) {
        var u = i + 1, f = u == ke || u == He;
        Oe.prototype[r] = function(m) {
          var y = this.clone();
          return y.__iteratees__.push({
            iteratee: fe(m, 3),
            type: u
          }), y.__filtered__ = y.__filtered__ || f, y;
        };
      }), qt(["head", "last"], function(r, i) {
        var u = "take" + (i ? "Right" : "");
        Oe.prototype[r] = function() {
          return this[u](1).value()[0];
        };
      }), qt(["initial", "tail"], function(r, i) {
        var u = "drop" + (i ? "" : "Right");
        Oe.prototype[r] = function() {
          return this.__filtered__ ? new Oe(this) : this[u](1);
        };
      }), Oe.prototype.compact = function() {
        return this.filter(Ft);
      }, Oe.prototype.find = function(r) {
        return this.filter(r).head();
      }, Oe.prototype.findLast = function(r) {
        return this.reverse().find(r);
      }, Oe.prototype.invokeMap = De(function(r, i) {
        return typeof r == "function" ? new Oe(this) : this.map(function(u) {
          return ka(u, r, i);
        });
      }), Oe.prototype.reject = function(r) {
        return this.filter(fo(fe(r)));
      }, Oe.prototype.slice = function(r, i) {
        r = be(r);
        var u = this;
        return u.__filtered__ && (r > 0 || i < 0) ? new Oe(u) : (r < 0 ? u = u.takeRight(-r) : r && (u = u.drop(r)), i !== t && (i = be(i), u = i < 0 ? u.dropRight(-i) : u.take(i - r)), u);
      }, Oe.prototype.takeRightWhile = function(r) {
        return this.reverse().takeWhile(r).reverse();
      }, Oe.prototype.toArray = function() {
        return this.take(Z);
      }, hn(Oe.prototype, function(r, i) {
        var u = /^(?:filter|find|map|reject)|While$/.test(i), f = /^(?:head|last)$/.test(i), m = g[f ? "take" + (i == "last" ? "Right" : "") : i], y = f || /^find/.test(i);
        m && (g.prototype[i] = function() {
          var x = this.__wrapped__, O = f ? [1] : arguments, E = x instanceof Oe, B = O[0], H = E || we(x), q = function(Se) {
            var Me = m.apply(g, Qn([Se], O));
            return f && ne ? Me[0] : Me;
          };
          H && u && typeof B == "function" && B.length != 1 && (E = H = !1);
          var ne = this.__chain__, se = !!this.__actions__.length, de = y && !ne, _e = E && !se;
          if (!y && H) {
            x = _e ? x : new Oe(this);
            var he = r.apply(x, O);
            return he.__actions__.push({ func: so, args: [q], thisArg: t }), new Kt(he, ne);
          }
          return de && _e ? r.apply(this, O) : (he = this.thru(q), de ? f ? he.value()[0] : he.value() : he);
        });
      }), qt(["pop", "push", "shift", "sort", "splice", "unshift"], function(r) {
        var i = Ii[r], u = /^(?:push|sort|unshift)$/.test(r) ? "tap" : "thru", f = /^(?:pop|shift)$/.test(r);
        g.prototype[r] = function() {
          var m = arguments;
          if (f && !this.__chain__) {
            var y = this.value();
            return i.apply(we(y) ? y : [], m);
          }
          return this[u](function(x) {
            return i.apply(we(x) ? x : [], m);
          });
        };
      }), hn(Oe.prototype, function(r, i) {
        var u = g[i];
        if (u) {
          var f = u.name + "";
          We.call(ta, f) || (ta[f] = []), ta[f].push({ name: i, func: u });
        }
      }), ta[eo(t, N).name] = [{
        name: "wrapper",
        func: t
      }], Oe.prototype.clone = uy, Oe.prototype.reverse = ly, Oe.prototype.value = cy, g.prototype.at = Vw, g.prototype.chain = $w, g.prototype.commit = Yw, g.prototype.next = Bw, g.prototype.plant = Uw, g.prototype.reverse = jw, g.prototype.toJSON = g.prototype.valueOf = g.prototype.value = zw, g.prototype.first = g.prototype.head, Ea && (g.prototype[Ea] = Hw), g;
    }, Qr = Y1();
    wr ? ((wr.exports = Qr)._ = Qr, Us._ = Qr) : vt._ = Qr;
  }).call(fa);
})(Fo, Fo.exports);
var a9 = Fo.exports;
const oT = ({
  primary: e,
  secondary: n,
  danger: t,
  success: a,
  outline: o,
  link: s,
  linkWithoutBackgound: l,
  underline_link: c,
  endIcon: d,
  startIcon: h,
  className: p,
  isSelected: v,
  children: w,
  ...b
}) => o ? /* @__PURE__ */ Ve(
  "button",
  {
    className: fn(
      "outline-button",
      {
        "outline-button--secondary": n,
        "outline-button--danger": t,
        "outline-button-with-icon": h || d,
        "outline-button-with-icon--start": h,
        "outline-button-with-icon--end": d,
        "outline-button--selected": v
      },
      p
    ),
    ...a9.omit(b, ["primary"]),
    children: [
      h,
      w,
      d
    ]
  }
) : s || c || l ? /* @__PURE__ */ Ve(
  "button",
  {
    className: fn(
      "button-link",
      {
        "button-link--secondary": n,
        "button-link--danger": t,
        "button-link--success": a,
        "button-link-with-icon": h || d,
        "button-link-with-icon--start": h,
        "button-link-with-icon--end": d,
        "button-link--underline": c,
        "button-link--without-background": l
      },
      p
    ),
    ...b,
    children: [
      h || null,
      w,
      d || null
    ]
  }
) : /* @__PURE__ */ Ve(
  "button",
  {
    className: fn(
      "button",
      {
        "button--secondary": n,
        "button--danger": t,
        "button-with-icon": h || d,
        "button-with-icon--start": h
      },
      p
    ),
    ...b,
    children: [
      h || null,
      w,
      d || null
    ]
  }
), sT = ({ danger: e, secondary: n, ...t }) => /* @__PURE__ */ ee(
  "button",
  {
    className: fn("icon-button", {
      "icon-button--secondary": n,
      "icon-button--danger": e
    }),
    ...t,
    children: t.children
  }
), Mh = ({
  isPartiallySelected: e,
  label: n,
  className: t,
  labelClassName: a,
  ...o
}) => {
  const s = J3(), l = o.id ? o.id : s;
  return /* @__PURE__ */ Ve(
    "div",
    {
      onClick: (c) => c.stopPropagation(),
      className: fn("checkbox-container", t),
      children: [
        /* @__PURE__ */ ee(
          "input",
          {
            type: "checkbox",
            className: fn("checkbox", {
              "checkbox--partial-checked": e
            }),
            ...o,
            id: l
          }
        ),
        /* @__PURE__ */ ee("label", { htmlFor: l, className: a, children: n })
      ]
    }
  );
}, uT = (e) => /* @__PURE__ */ Ve(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ ee("title", { children: "Arrowhead Down Icon" }),
      /* @__PURE__ */ ee("g", { id: "arrowhead-down", children: /* @__PURE__ */ ee(
        "path",
        {
          id: "Icon",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.00078 10.3999C7.74898 10.3999 7.51186 10.2813 7.36078 10.0799L4.96079 6.87985C4.77898 6.63744 4.74973 6.31311 4.88524 6.04208C5.02076 5.77106 5.29777 5.59985 5.60078 5.59985H10.4008C10.7038 5.59985 10.9808 5.77106 11.1163 6.04208C11.2518 6.31311 11.2226 6.63744 11.0408 6.87985L8.64078 10.0799C8.4897 10.2813 8.25259 10.3999 8.00078 10.3999Z",
          fill: "#C0C0CB"
        }
      ) })
    ]
  }
), lT = () => /* @__PURE__ */ Ve(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ ee("title", { children: "Logout Outline Icon" }),
      /* @__PURE__ */ ee("g", { id: "logout", children: /* @__PURE__ */ ee(
        "path",
        {
          id: "Icon (Stroke)",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21.3609 12.6105C21.6792 12.2657 21.6792 11.7344 21.3609 11.3896L17.7609 7.4896C17.4238 7.12436 16.8544 7.10158 16.4892 7.43873C16.1239 7.77587 16.1011 8.34526 16.4383 8.7105L18.644 11.1L10.4996 11.1C10.0026 11.1 9.59961 11.503 9.59961 12C9.59961 12.4971 10.0026 12.9 10.4996 12.9L18.644 12.9L16.4383 15.2896C16.1011 15.6548 16.1239 16.2242 16.4892 16.5614C16.8544 16.8985 17.4238 16.8757 17.7609 16.5105L21.3609 12.6105ZM11.9996 21.9C11.9996 21.403 11.5967 21 11.0996 21L5.69961 21C4.87118 21 4.19961 20.3285 4.19961 19.5L4.19961 4.50005C4.19961 3.67162 4.87118 3.00005 5.69961 3.00005L11.0996 3.00005C11.5967 3.00005 11.9996 2.59711 11.9996 2.10005C11.9996 1.60299 11.5967 1.20005 11.0996 1.20005L5.69961 1.20005C3.87707 1.20005 2.39961 2.67751 2.39961 4.50005L2.39961 19.5C2.39961 21.3226 3.87707 22.8 5.69961 22.8L11.0996 22.8C11.5967 22.8 11.9996 22.3971 11.9996 21.9Z",
          fill: "#7370FF"
        }
      ) })
    ]
  }
), cT = (e) => /* @__PURE__ */ ee(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: /* @__PURE__ */ ee(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.05516 1.00958C7.27082 1.26118 7.24168 1.63996 6.99008 1.85561L5.42156 3.20006H7.59961C10.9133 3.20006 13.5996 5.88635 13.5996 9.20006C13.5996 12.5138 10.9133 15.2001 7.59961 15.2001C4.2859 15.2001 1.59961 12.5138 1.59961 9.20006C1.59961 8.74265 1.6509 8.29649 1.74829 7.86729C1.82162 7.54413 2.14304 7.34161 2.46619 7.41494C2.78935 7.48826 2.99187 7.80968 2.91854 8.13283C2.84079 8.4755 2.79961 8.8326 2.79961 9.20006C2.79961 11.851 4.94864 14.0001 7.59961 14.0001C10.2506 14.0001 12.3996 11.851 12.3996 9.20006C12.3996 6.54909 10.2506 4.40006 7.59961 4.40006H5.42156L6.99008 5.74451C7.24168 5.96016 7.27082 6.33894 7.05516 6.59054C6.83951 6.84213 6.46073 6.87127 6.20914 6.65561L3.40913 4.25561C3.27615 4.14162 3.19961 3.97521 3.19961 3.80006C3.19961 3.62491 3.27615 3.4585 3.40913 3.34451L6.20914 0.944506C6.46073 0.728852 6.83951 0.757989 7.05516 1.00958Z",
        fill: "#7370FF"
      }
    )
  }
), fT = (e) => /* @__PURE__ */ ee(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ ee(
      "path",
      {
        d: "M19.4999 13.5C19.5018 13.8058 19.4089 14.1047 19.234 14.3555C19.059 14.6063 18.8107 14.7968 18.523 14.9006L13.6808 16.6819L11.8996 21.5203C11.7941 21.8069 11.6033 22.0542 11.3528 22.2289C11.1023 22.4036 10.8043 22.4972 10.499 22.4972C10.1936 22.4972 9.89559 22.4036 9.64513 22.2289C9.39467 22.0542 9.20383 21.8069 9.09834 21.5203L7.31241 16.6875L2.47303 14.9062C2.18646 14.8008 1.93915 14.6099 1.76445 14.3595C1.58976 14.109 1.49609 13.811 1.49609 13.5056C1.49609 13.2003 1.58976 12.9022 1.76445 12.6518C1.93915 12.4013 2.18646 12.2105 2.47303 12.105L7.31522 10.3238L9.09647 5.48531C9.20195 5.19875 9.3928 4.95143 9.64326 4.77674C9.89371 4.60204 10.1917 4.50838 10.4971 4.50838C10.8025 4.50838 11.1005 4.60204 11.3509 4.77674C11.6014 4.95143 11.7922 5.19875 11.8977 5.48531L13.679 10.3275L18.5174 12.1088C18.8046 12.2111 19.0531 12.3998 19.229 12.6488C19.4048 12.8978 19.4995 13.1951 19.4999 13.5ZM14.2499 4.5H15.7499V6C15.7499 6.19891 15.8289 6.38968 15.9696 6.53033C16.1102 6.67098 16.301 6.75 16.4999 6.75C16.6988 6.75 16.8896 6.67098 17.0302 6.53033C17.1709 6.38968 17.2499 6.19891 17.2499 6V4.5H18.7499C18.9488 4.5 19.1396 4.42098 19.2802 4.28033C19.4209 4.13968 19.4999 3.94891 19.4999 3.75C19.4999 3.55109 19.4209 3.36032 19.2802 3.21967C19.1396 3.07902 18.9488 3 18.7499 3H17.2499V1.5C17.2499 1.30109 17.1709 1.11032 17.0302 0.96967C16.8896 0.829018 16.6988 0.75 16.4999 0.75C16.301 0.75 16.1102 0.829018 15.9696 0.96967C15.8289 1.11032 15.7499 1.30109 15.7499 1.5V3H14.2499C14.051 3 13.8602 3.07902 13.7196 3.21967C13.5789 3.36032 13.4999 3.55109 13.4999 3.75C13.4999 3.94891 13.5789 4.13968 13.7196 4.28033C13.8602 4.42098 14.051 4.5 14.2499 4.5ZM22.4999 7.5H21.7499V6.75C21.7499 6.55109 21.6709 6.36032 21.5302 6.21967C21.3896 6.07902 21.1988 6 20.9999 6C20.801 6 20.6102 6.07902 20.4696 6.21967C20.3289 6.36032 20.2499 6.55109 20.2499 6.75V7.5H19.4999C19.301 7.5 19.1102 7.57902 18.9696 7.71967C18.8289 7.86032 18.7499 8.05109 18.7499 8.25C18.7499 8.44891 18.8289 8.63968 18.9696 8.78033C19.1102 8.92098 19.301 9 19.4999 9H20.2499V9.75C20.2499 9.94891 20.3289 10.1397 20.4696 10.2803C20.6102 10.421 20.801 10.5 20.9999 10.5C21.1988 10.5 21.3896 10.421 21.5302 10.2803C21.6709 10.1397 21.7499 9.94891 21.7499 9.75V9H22.4999C22.6988 9 22.8896 8.92098 23.0302 8.78033C23.1709 8.63968 23.2499 8.44891 23.2499 8.25C23.2499 8.05109 23.1709 7.86032 23.0302 7.71967C22.8896 7.57902 22.6988 7.5 22.4999 7.5Z",
        fill: "#7370FF"
      }
    )
  }
), dT = (e) => /* @__PURE__ */ Ve(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "54",
    height: "54",
    viewBox: "0 0 54 54",
    fill: "none",
    ...e,
    children: [
      /* @__PURE__ */ ee(
        "path",
        {
          d: "M43.8748 30.375C43.8791 31.063 43.67 31.7355 43.2764 32.2999C42.8828 32.8642 42.324 33.2927 41.6768 33.5264L30.7819 37.5342L26.7741 48.4207C26.5367 49.0655 26.1073 49.6219 25.5438 50.015C24.9803 50.4081 24.3097 50.6188 23.6227 50.6188C22.9356 50.6188 22.2651 50.4081 21.7015 50.015C21.138 49.6219 20.7086 49.0655 20.4713 48.4207L16.4529 37.5469L5.56432 33.5391C4.91954 33.3017 4.36308 32.8723 3.97002 32.3088C3.57696 31.7453 3.36621 31.0747 3.36621 30.3877C3.36621 29.7006 3.57696 29.03 3.97002 28.4665C4.36308 27.903 4.91954 27.4736 5.56432 27.2362L16.4592 23.2284L20.4671 12.342C20.7044 11.6972 21.1338 11.1407 21.6973 10.7477C22.2609 10.3546 22.9314 10.1438 23.6185 10.1438C24.3055 10.1438 24.9761 10.3546 25.5396 10.7477C26.1031 11.1407 26.5325 11.6972 26.7699 12.342L30.7777 23.2369L41.6642 27.2447C42.3103 27.4751 42.8694 27.8995 43.2651 28.4598C43.6608 29.0201 43.8738 29.689 43.8748 30.375ZM32.0623 10.125H35.4373V13.5C35.4373 13.9476 35.6151 14.3768 35.9315 14.6932C36.248 15.0097 36.6772 15.1875 37.1248 15.1875C37.5723 15.1875 38.0016 15.0097 38.318 14.6932C38.6345 14.3768 38.8123 13.9476 38.8123 13.5V10.125H42.1873C42.6348 10.125 43.0641 9.94721 43.3805 9.63074C43.697 9.31427 43.8748 8.88505 43.8748 8.4375C43.8748 7.98995 43.697 7.56072 43.3805 7.24426C43.0641 6.92779 42.6348 6.75 42.1873 6.75L38.8123 6.75V3.375C38.8123 2.92745 38.6345 2.49822 38.318 2.18176C38.0016 1.86529 37.5723 1.6875 37.1248 1.6875C36.6772 1.6875 36.248 1.86529 35.9315 2.18176C35.6151 2.49822 35.4373 2.92745 35.4373 3.375V6.75H32.0623C31.6147 6.75 31.1855 6.92779 30.869 7.24426C30.5526 7.56072 30.3748 7.98995 30.3748 8.4375C30.3748 8.88505 30.5526 9.31427 30.869 9.63074C31.1855 9.94721 31.6147 10.125 32.0623 10.125ZM50.6248 16.875H48.9373V15.1875C48.9373 14.7399 48.7595 14.3107 48.443 13.9943C48.1266 13.6778 47.6973 13.5 47.2498 13.5C46.8022 13.5 46.373 13.6778 46.0565 13.9943C45.7401 14.3107 45.5623 14.7399 45.5623 15.1875V16.875H43.8748C43.4272 16.875 42.998 17.0528 42.6815 17.3693C42.3651 17.6857 42.1873 18.1149 42.1873 18.5625C42.1873 19.0101 42.3651 19.4393 42.6815 19.7557C42.998 20.0722 43.4272 20.25 43.8748 20.25H45.5623V21.9375C45.5623 22.3851 45.7401 22.8143 46.0565 23.1307C46.373 23.4472 46.8022 23.625 47.2498 23.625C47.6973 23.625 48.1266 23.4472 48.443 23.1307C48.7595 22.8143 48.9373 22.3851 48.9373 21.9375V20.25H50.6248C51.0723 20.25 51.5016 20.0722 51.818 19.7557C52.1345 19.4393 52.3123 19.0101 52.3123 18.5625C52.3123 18.1149 52.1345 17.6857 51.818 17.3693C51.5016 17.0528 51.0723 16.875 50.6248 16.875Z",
          fill: "#9391FB"
        }
      ),
      /* @__PURE__ */ ee(
        "path",
        {
          d: "M43.8748 30.375C43.8791 31.063 43.67 31.7355 43.2764 32.2999C42.8828 32.8642 42.324 33.2927 41.6768 33.5264L30.7819 37.5342L26.7741 48.4207C26.5367 49.0655 26.1073 49.6219 25.5438 50.015C24.9803 50.4081 24.3097 50.6188 23.6227 50.6188C22.9356 50.6188 22.2651 50.4081 21.7015 50.015C21.138 49.6219 20.7086 49.0655 20.4713 48.4207L16.4529 37.5469L5.56432 33.5391C4.91954 33.3017 4.36308 32.8723 3.97002 32.3088C3.57696 31.7453 3.36621 31.0747 3.36621 30.3877C3.36621 29.7006 3.57696 29.03 3.97002 28.4665C4.36308 27.903 4.91954 27.4736 5.56432 27.2362L16.4592 23.2284L20.4671 12.342C20.7044 11.6972 21.1338 11.1407 21.6973 10.7477C22.2609 10.3546 22.9314 10.1438 23.6185 10.1438C24.3055 10.1438 24.9761 10.3546 25.5396 10.7477C26.1031 11.1407 26.5325 11.6972 26.7699 12.342L30.7777 23.2369L41.6642 27.2447C42.3103 27.4751 42.8694 27.8995 43.2651 28.4598C43.6608 29.0201 43.8738 29.689 43.8748 30.375ZM32.0623 10.125H35.4373V13.5C35.4373 13.9476 35.6151 14.3768 35.9315 14.6932C36.248 15.0097 36.6772 15.1875 37.1248 15.1875C37.5723 15.1875 38.0016 15.0097 38.318 14.6932C38.6345 14.3768 38.8123 13.9476 38.8123 13.5V10.125H42.1873C42.6348 10.125 43.0641 9.94721 43.3805 9.63074C43.697 9.31427 43.8748 8.88505 43.8748 8.4375C43.8748 7.98995 43.697 7.56072 43.3805 7.24426C43.0641 6.92779 42.6348 6.75 42.1873 6.75L38.8123 6.75V3.375C38.8123 2.92745 38.6345 2.49822 38.318 2.18176C38.0016 1.86529 37.5723 1.6875 37.1248 1.6875C36.6772 1.6875 36.248 1.86529 35.9315 2.18176C35.6151 2.49822 35.4373 2.92745 35.4373 3.375V6.75H32.0623C31.6147 6.75 31.1855 6.92779 30.869 7.24426C30.5526 7.56072 30.3748 7.98995 30.3748 8.4375C30.3748 8.88505 30.5526 9.31427 30.869 9.63074C31.1855 9.94721 31.6147 10.125 32.0623 10.125ZM50.6248 16.875H48.9373V15.1875C48.9373 14.7399 48.7595 14.3107 48.443 13.9943C48.1266 13.6778 47.6973 13.5 47.2498 13.5C46.8022 13.5 46.373 13.6778 46.0565 13.9943C45.7401 14.3107 45.5623 14.7399 45.5623 15.1875V16.875H43.8748C43.4272 16.875 42.998 17.0528 42.6815 17.3693C42.3651 17.6857 42.1873 18.1149 42.1873 18.5625C42.1873 19.0101 42.3651 19.4393 42.6815 19.7557C42.998 20.0722 43.4272 20.25 43.8748 20.25H45.5623V21.9375C45.5623 22.3851 45.7401 22.8143 46.0565 23.1307C46.373 23.4472 46.8022 23.625 47.2498 23.625C47.6973 23.625 48.1266 23.4472 48.443 23.1307C48.7595 22.8143 48.9373 22.3851 48.9373 21.9375V20.25H50.6248C51.0723 20.25 51.5016 20.0722 51.818 19.7557C52.1345 19.4393 52.3123 19.0101 52.3123 18.5625C52.3123 18.1149 52.1345 17.6857 51.818 17.3693C51.5016 17.0528 51.0723 16.875 50.6248 16.875Z",
          fill: "url(#paint0_linear_17352_65548)"
        }
      ),
      /* @__PURE__ */ ee("defs", { children: /* @__PURE__ */ Ve(
        "linearGradient",
        {
          id: "paint0_linear_17352_65548",
          x1: "16.0321",
          y1: "45.6828",
          x2: "60.7551",
          y2: "6.21856",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ ee("stop", { "stop-color": "#A4A2FF" }),
            /* @__PURE__ */ ee("stop", { offset: "0.35683", "stop-color": "#EFCAFF" }),
            /* @__PURE__ */ ee("stop", { offset: "1", "stop-color": "#F9EBFF" })
          ]
        }
      ) })
    ]
  }
), i9 = ({ className: e = "", size: n = "24" }) => /* @__PURE__ */ ee(
  "svg",
  {
    className: e,
    width: n,
    height: n,
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#8684ff",
    "data-testid": "loading",
    children: /* @__PURE__ */ ee("g", { fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ Ve("g", { transform: "translate(1 1)", strokeWidth: "2", children: [
      /* @__PURE__ */ ee("circle", { strokeOpacity: ".5", cx: "18", cy: "18", r: "18" }),
      /* @__PURE__ */ ee("path", { d: "M36 18c0-9.94-8.06-18-18-18", children: /* @__PURE__ */ ee(
        "animateTransform",
        {
          attributeName: "transform",
          type: "rotate",
          from: "0 18 18",
          to: "360 18 18",
          dur: "1s",
          repeatCount: "indefinite"
        }
      ) })
    ] }) })
  }
);
var wl = { exports: {} }, Le = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ch;
function o9() {
  if (Ch) return Le;
  Ch = 1;
  var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, v = e ? Symbol.for("react.suspense") : 60113, w = e ? Symbol.for("react.suspense_list") : 60120, b = e ? Symbol.for("react.memo") : 60115, _ = e ? Symbol.for("react.lazy") : 60116, D = e ? Symbol.for("react.block") : 60121, C = e ? Symbol.for("react.fundamental") : 60117, N = e ? Symbol.for("react.responder") : 60118, $ = e ? Symbol.for("react.scope") : 60119;
  function A(R) {
    if (typeof R == "object" && R !== null) {
      var ie = R.$$typeof;
      switch (ie) {
        case n:
          switch (R = R.type, R) {
            case d:
            case h:
            case a:
            case s:
            case o:
            case v:
              return R;
            default:
              switch (R = R && R.$$typeof, R) {
                case c:
                case p:
                case _:
                case b:
                case l:
                  return R;
                default:
                  return ie;
              }
          }
        case t:
          return ie;
      }
    }
  }
  function k(R) {
    return A(R) === h;
  }
  return Le.AsyncMode = d, Le.ConcurrentMode = h, Le.ContextConsumer = c, Le.ContextProvider = l, Le.Element = n, Le.ForwardRef = p, Le.Fragment = a, Le.Lazy = _, Le.Memo = b, Le.Portal = t, Le.Profiler = s, Le.StrictMode = o, Le.Suspense = v, Le.isAsyncMode = function(R) {
    return k(R) || A(R) === d;
  }, Le.isConcurrentMode = k, Le.isContextConsumer = function(R) {
    return A(R) === c;
  }, Le.isContextProvider = function(R) {
    return A(R) === l;
  }, Le.isElement = function(R) {
    return typeof R == "object" && R !== null && R.$$typeof === n;
  }, Le.isForwardRef = function(R) {
    return A(R) === p;
  }, Le.isFragment = function(R) {
    return A(R) === a;
  }, Le.isLazy = function(R) {
    return A(R) === _;
  }, Le.isMemo = function(R) {
    return A(R) === b;
  }, Le.isPortal = function(R) {
    return A(R) === t;
  }, Le.isProfiler = function(R) {
    return A(R) === s;
  }, Le.isStrictMode = function(R) {
    return A(R) === o;
  }, Le.isSuspense = function(R) {
    return A(R) === v;
  }, Le.isValidElementType = function(R) {
    return typeof R == "string" || typeof R == "function" || R === a || R === h || R === s || R === o || R === v || R === w || typeof R == "object" && R !== null && (R.$$typeof === _ || R.$$typeof === b || R.$$typeof === l || R.$$typeof === c || R.$$typeof === p || R.$$typeof === C || R.$$typeof === N || R.$$typeof === $ || R.$$typeof === D);
  }, Le.typeOf = A, Le;
}
var Fe = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ph;
function s9() {
  return Ph || (Ph = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, v = e ? Symbol.for("react.suspense") : 60113, w = e ? Symbol.for("react.suspense_list") : 60120, b = e ? Symbol.for("react.memo") : 60115, _ = e ? Symbol.for("react.lazy") : 60116, D = e ? Symbol.for("react.block") : 60121, C = e ? Symbol.for("react.fundamental") : 60117, N = e ? Symbol.for("react.responder") : 60118, $ = e ? Symbol.for("react.scope") : 60119;
    function A(j) {
      return typeof j == "string" || typeof j == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      j === a || j === h || j === s || j === o || j === v || j === w || typeof j == "object" && j !== null && (j.$$typeof === _ || j.$$typeof === b || j.$$typeof === l || j.$$typeof === c || j.$$typeof === p || j.$$typeof === C || j.$$typeof === N || j.$$typeof === $ || j.$$typeof === D);
    }
    function k(j) {
      if (typeof j == "object" && j !== null) {
        var me = j.$$typeof;
        switch (me) {
          case n:
            var ve = j.type;
            switch (ve) {
              case d:
              case h:
              case a:
              case s:
              case o:
              case v:
                return ve;
              default:
                var Ge = ve && ve.$$typeof;
                switch (Ge) {
                  case c:
                  case p:
                  case _:
                  case b:
                  case l:
                    return Ge;
                  default:
                    return me;
                }
            }
          case t:
            return me;
        }
      }
    }
    var R = d, ie = h, Y = c, z = l, oe = n, xe = p, Ne = a, Ae = _, Te = b, ke = t, et = s, He = o, Pe = v, qe = !1;
    function lt(j) {
      return qe || (qe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), U(j) || k(j) === d;
    }
    function U(j) {
      return k(j) === h;
    }
    function Z(j) {
      return k(j) === c;
    }
    function V(j) {
      return k(j) === l;
    }
    function I(j) {
      return typeof j == "object" && j !== null && j.$$typeof === n;
    }
    function M(j) {
      return k(j) === p;
    }
    function S(j) {
      return k(j) === a;
    }
    function F(j) {
      return k(j) === _;
    }
    function G(j) {
      return k(j) === b;
    }
    function K(j) {
      return k(j) === t;
    }
    function Q(j) {
      return k(j) === s;
    }
    function te(j) {
      return k(j) === o;
    }
    function ce(j) {
      return k(j) === v;
    }
    Fe.AsyncMode = R, Fe.ConcurrentMode = ie, Fe.ContextConsumer = Y, Fe.ContextProvider = z, Fe.Element = oe, Fe.ForwardRef = xe, Fe.Fragment = Ne, Fe.Lazy = Ae, Fe.Memo = Te, Fe.Portal = ke, Fe.Profiler = et, Fe.StrictMode = He, Fe.Suspense = Pe, Fe.isAsyncMode = lt, Fe.isConcurrentMode = U, Fe.isContextConsumer = Z, Fe.isContextProvider = V, Fe.isElement = I, Fe.isForwardRef = M, Fe.isFragment = S, Fe.isLazy = F, Fe.isMemo = G, Fe.isPortal = K, Fe.isProfiler = Q, Fe.isStrictMode = te, Fe.isSuspense = ce, Fe.isValidElementType = A, Fe.typeOf = k;
  }()), Fe;
}
process.env.NODE_ENV === "production" ? wl.exports = o9() : wl.exports = s9();
var f0 = wl.exports, bl = function(e, n) {
  return bl = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, a) {
    t.__proto__ = a;
  } || function(t, a) {
    for (var o in a) Object.prototype.hasOwnProperty.call(a, o) && (t[o] = a[o]);
  }, bl(e, n);
};
function d0(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
  bl(e, n);
  function t() {
    this.constructor = e;
  }
  e.prototype = n === null ? Object.create(n) : (t.prototype = n.prototype, new t());
}
var J = function() {
  return J = Object.assign || function(n) {
    for (var t, a = 1, o = arguments.length; a < o; a++) {
      t = arguments[a];
      for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && (n[s] = t[s]);
    }
    return n;
  }, J.apply(this, arguments);
};
function nn(e, n) {
  var t = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && n.indexOf(a) < 0 && (t[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, a = Object.getOwnPropertySymbols(e); o < a.length; o++)
      n.indexOf(a[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[o]) && (t[a[o]] = e[a[o]]);
  return t;
}
function ht(e, n) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t) return e;
  var a = t.call(e), o, s = [], l;
  try {
    for (; (n === void 0 || n-- > 0) && !(o = a.next()).done; ) s.push(o.value);
  } catch (c) {
    l = { error: c };
  } finally {
    try {
      o && !o.done && (t = a.return) && t.call(a);
    } finally {
      if (l) throw l.error;
    }
  }
  return s;
}
function xn(e, n, t) {
  if (t || arguments.length === 2) for (var a = 0, o = n.length, s; a < o; a++)
    (s || !(a in n)) && (s || (s = Array.prototype.slice.call(n, 0, a)), s[a] = n[a]);
  return e.concat(s || Array.prototype.slice.call(n));
}
var Th = "production", h0 = typeof process > "u" || process.env === void 0 ? Th : process.env.NODE_ENV || Th, Wn = function(e) {
  return {
    isEnabled: function(n) {
      return e.some(function(t) {
        return !!n[t];
      });
    }
  };
}, si = {
  measureLayout: Wn(["layout", "layoutId", "drag"]),
  animation: Wn([
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView"
  ]),
  exit: Wn(["exit"]),
  drag: Wn(["drag", "dragControls"]),
  focus: Wn(["whileFocus"]),
  hover: Wn(["whileHover", "onHoverStart", "onHoverEnd"]),
  tap: Wn(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
  pan: Wn([
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
  ]),
  inView: Wn([
    "whileInView",
    "onViewportEnter",
    "onViewportLeave"
  ])
};
function u9(e) {
  for (var n in e)
    e[n] !== null && (n === "projectionNodeConstructor" ? si.projectionNodeConstructor = e[n] : si[n].Component = e[n]);
}
var hi = function() {
}, tn = function() {
};
process.env.NODE_ENV !== "production" && (hi = function(e, n) {
  !e && typeof console < "u" && console.warn(n);
}, tn = function(e, n) {
  if (!e)
    throw new Error(n);
});
var p0 = Vr({ strict: !1 }), m0 = Object.keys(si), l9 = m0.length;
function c9(e, n, t) {
  var a = [], o = Dt(p0);
  if (!n)
    return null;
  h0 !== "production" && t && o.strict && tn(!1, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
  for (var s = 0; s < l9; s++) {
    var l = m0[s], c = si[l], d = c.isEnabled, h = c.Component;
    d(e) && h && a.push(Lo.createElement(h, J({ key: l }, e, { visualElement: n })));
  }
  return a;
}
var Xl = Vr({
  transformPagePoint: function(e) {
    return e;
  },
  isStatic: !1,
  reducedMotion: "never"
}), rs = Vr({});
function f9() {
  return Dt(rs).visualElement;
}
var as = Vr(null), Oa = typeof document < "u", Eh = Oa ? e9 : St, _l = { current: null }, v0 = !1;
function d9() {
  if (v0 = !0, !!Oa)
    if (window.matchMedia) {
      var e = window.matchMedia("(prefers-reduced-motion)"), n = function() {
        return _l.current = e.matches;
      };
      e.addListener(n), n();
    } else
      _l.current = !1;
}
function h9() {
  !v0 && d9();
  var e = ht(Sa(_l.current), 1), n = e[0];
  return n;
}
function p9() {
  var e = h9(), n = Dt(Xl).reducedMotion;
  return n === "never" ? !1 : n === "always" ? !0 : e;
}
function m9(e, n, t, a) {
  var o = Dt(p0), s = f9(), l = Dt(as), c = p9(), d = Wr(void 0);
  a || (a = o.renderer), !d.current && a && (d.current = a(e, {
    visualState: n,
    parent: s,
    props: t,
    presenceId: l == null ? void 0 : l.id,
    blockInitialAnimation: (l == null ? void 0 : l.initial) === !1,
    shouldReduceMotion: c
  }));
  var h = d.current;
  return Eh(function() {
    h == null || h.syncRender();
  }), St(function() {
    var p;
    (p = h == null ? void 0 : h.animationState) === null || p === void 0 || p.animateChanges();
  }), Eh(function() {
    return function() {
      return h == null ? void 0 : h.notifyUnmount();
    };
  }, []), h;
}
function ha(e) {
  return typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function v9(e, n, t) {
  return ca(
    function(a) {
      var o;
      a && ((o = e.mount) === null || o === void 0 || o.call(e, a)), n && (a ? n.mount(a) : n.unmount()), t && (typeof t == "function" ? t(a) : ha(t) && (t.current = a));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [n]
  );
}
function g0(e) {
  return Array.isArray(e);
}
function cn(e) {
  return typeof e == "string" || g0(e);
}
function g9(e) {
  var n = {};
  return e.forEachValue(function(t, a) {
    return n[a] = t.get();
  }), n;
}
function y9(e) {
  var n = {};
  return e.forEachValue(function(t, a) {
    return n[a] = t.getVelocity();
  }), n;
}
function y0(e, n, t, a, o) {
  var s;
  return a === void 0 && (a = {}), o === void 0 && (o = {}), typeof n == "function" && (n = n(t ?? e.custom, a, o)), typeof n == "string" && (n = (s = e.variants) === null || s === void 0 ? void 0 : s[n]), typeof n == "function" && (n = n(t ?? e.custom, a, o)), n;
}
function is(e, n, t) {
  var a = e.getProps();
  return y0(a, n, t ?? a.custom, g9(e), y9(e));
}
function os(e) {
  var n;
  return typeof ((n = e.animate) === null || n === void 0 ? void 0 : n.start) == "function" || cn(e.initial) || cn(e.animate) || cn(e.whileHover) || cn(e.whileDrag) || cn(e.whileTap) || cn(e.whileFocus) || cn(e.exit);
}
function w0(e) {
  return !!(os(e) || e.variants);
}
function w9(e, n) {
  if (os(e)) {
    var t = e.initial, a = e.animate;
    return {
      initial: t === !1 || cn(t) ? t : void 0,
      animate: cn(a) ? a : void 0
    };
  }
  return e.inherit !== !1 ? n : {};
}
function b9(e) {
  var n = w9(e, Dt(rs)), t = n.initial, a = n.animate;
  return Kl(function() {
    return { initial: t, animate: a };
  }, [Rh(t), Rh(a)]);
}
function Rh(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
function ss(e) {
  var n = Wr(null);
  return n.current === null && (n.current = e()), n.current;
}
var Ja = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, _9 = 1;
function x9() {
  return ss(function() {
    if (Ja.hasEverUpdated)
      return _9++;
  });
}
var b0 = Vr({}), _0 = Vr({});
function D9(e, n, t, a) {
  var o, s = n.layoutId, l = n.layout, c = n.drag, d = n.dragConstraints, h = n.layoutScroll, p = Dt(_0);
  !a || !t || t != null && t.projection || (t.projection = new a(e, t.getLatestValues(), (o = t.parent) === null || o === void 0 ? void 0 : o.projection), t.projection.setOptions({
    layoutId: s,
    layout: l,
    alwaysMeasureLayout: !!c || d && ha(d),
    visualElement: t,
    scheduleRender: function() {
      return t.scheduleRender();
    },
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof l == "string" ? l : "both",
    initialPromotionConfig: p,
    layoutScroll: h
  }));
}
var S9 = (
  /** @class */
  function(e) {
    d0(n, e);
    function n() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return n.prototype.getSnapshotBeforeUpdate = function() {
      return this.updateProps(), null;
    }, n.prototype.componentDidUpdate = function() {
    }, n.prototype.updateProps = function() {
      var t = this.props, a = t.visualElement, o = t.props;
      a && a.setProps(o);
    }, n.prototype.render = function() {
      return this.props.children;
    }, n;
  }(X.Component)
);
function O9(e) {
  var n = e.preloadedFeatures, t = e.createVisualElement, a = e.projectionNodeConstructor, o = e.useRender, s = e.useVisualState, l = e.Component;
  n && u9(n);
  function c(d, h) {
    var p = M9(d);
    d = J(J({}, d), { layoutId: p });
    var v = Dt(Xl), w = null, b = b9(d), _ = v.isStatic ? void 0 : x9(), D = s(d, v.isStatic);
    return !v.isStatic && Oa && (b.visualElement = m9(l, D, J(J({}, v), d), t), D9(_, d, b.visualElement, a || si.projectionNodeConstructor), w = c9(d, b.visualElement, n)), Lo.createElement(
      S9,
      { visualElement: b.visualElement, props: J(J({}, v), d) },
      w,
      Lo.createElement(rs.Provider, { value: b }, o(l, d, _, v9(D, b.visualElement, h), D, v.isStatic, b.visualElement))
    );
  }
  return o0(c);
}
function M9(e) {
  var n, t = e.layoutId, a = (n = Dt(b0)) === null || n === void 0 ? void 0 : n.id;
  return a && t !== void 0 ? a + "-" + t : t;
}
function C9(e) {
  function n(a, o) {
    return o === void 0 && (o = {}), O9(e(a, o));
  }
  if (typeof Proxy > "u")
    return n;
  var t = /* @__PURE__ */ new Map();
  return new Proxy(n, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: function(a, o) {
      return t.has(o) || t.set(o, n(o)), t.get(o);
    }
  });
}
var P9 = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "tspan",
  "use",
  "view"
];
function Zl(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(P9.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(e))
    )
  );
}
var No = {};
function T9(e) {
  Object.assign(No, e);
}
var xl = ["", "X", "Y", "Z"], E9 = ["translate", "scale", "rotate", "skew"], ui = ["transformPerspective", "x", "y", "z"];
E9.forEach(function(e) {
  return xl.forEach(function(n) {
    return ui.push(e + n);
  });
});
function R9(e, n) {
  return ui.indexOf(e) - ui.indexOf(n);
}
var A9 = new Set(ui);
function pi(e) {
  return A9.has(e);
}
var I9 = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]);
function x0(e) {
  return I9.has(e);
}
function D0(e, n) {
  var t = n.layout, a = n.layoutId;
  return pi(e) || x0(e) || (t || a !== void 0) && (!!No[e] || e === "opacity");
}
var Yn = function(e) {
  return !!(e !== null && typeof e == "object" && e.getVelocity);
}, L9 = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
function F9(e, n, t, a) {
  var o = e.transform, s = e.transformKeys, l = n.enableHardwareAcceleration, c = l === void 0 ? !0 : l, d = n.allowTransformNone, h = d === void 0 ? !0 : d, p = "";
  s.sort(R9);
  for (var v = !1, w = s.length, b = 0; b < w; b++) {
    var _ = s[b];
    p += "".concat(L9[_] || _, "(").concat(o[_], ") "), _ === "z" && (v = !0);
  }
  return !v && c ? p += "translateZ(0)" : p = p.trim(), a ? p = a(o, t ? "" : p) : h && t && (p = "none"), p;
}
function N9(e) {
  var n = e.originX, t = n === void 0 ? "50%" : n, a = e.originY, o = a === void 0 ? "50%" : a, s = e.originZ, l = s === void 0 ? 0 : s;
  return "".concat(t, " ").concat(o, " ").concat(l);
}
function S0(e) {
  return e.startsWith("--");
}
var k9 = function(e, n) {
  return n && typeof e == "number" ? n.transform(e) : e;
};
const O0 = (e, n) => (t) => Math.max(Math.min(t, n), e), ei = (e) => e % 1 ? Number(e.toFixed(5)) : e, li = /(-)?([\d]*\.?[\d])+/g, Dl = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi, W9 = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function mi(e) {
  return typeof e == "string";
}
const $r = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, ti = Object.assign(Object.assign({}, $r), { transform: O0(0, 1) }), vo = Object.assign(Object.assign({}, $r), { default: 1 }), vi = (e) => ({
  test: (n) => mi(n) && n.endsWith(e) && n.split(" ").length === 1,
  parse: parseFloat,
  transform: (n) => `${n}${e}`
}), or = vi("deg"), Dn = vi("%"), pe = vi("px"), V9 = vi("vh"), $9 = vi("vw"), Ah = Object.assign(Object.assign({}, Dn), { parse: (e) => Dn.parse(e) / 100, transform: (e) => Dn.transform(e * 100) }), Ql = (e, n) => (t) => !!(mi(t) && W9.test(t) && t.startsWith(e) || n && Object.prototype.hasOwnProperty.call(t, n)), M0 = (e, n, t) => (a) => {
  if (!mi(a))
    return a;
  const [o, s, l, c] = a.match(li);
  return {
    [e]: parseFloat(o),
    [n]: parseFloat(s),
    [t]: parseFloat(l),
    alpha: c !== void 0 ? parseFloat(c) : 1
  };
}, Nr = {
  test: Ql("hsl", "hue"),
  parse: M0("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: n, lightness: t, alpha: a = 1 }) => "hsla(" + Math.round(e) + ", " + Dn.transform(ei(n)) + ", " + Dn.transform(ei(t)) + ", " + ei(ti.transform(a)) + ")"
}, Y9 = O0(0, 255), Xu = Object.assign(Object.assign({}, $r), { transform: (e) => Math.round(Y9(e)) }), cr = {
  test: Ql("rgb", "red"),
  parse: M0("red", "green", "blue"),
  transform: ({ red: e, green: n, blue: t, alpha: a = 1 }) => "rgba(" + Xu.transform(e) + ", " + Xu.transform(n) + ", " + Xu.transform(t) + ", " + ei(ti.transform(a)) + ")"
};
function B9(e) {
  let n = "", t = "", a = "", o = "";
  return e.length > 5 ? (n = e.substr(1, 2), t = e.substr(3, 2), a = e.substr(5, 2), o = e.substr(7, 2)) : (n = e.substr(1, 1), t = e.substr(2, 1), a = e.substr(3, 1), o = e.substr(4, 1), n += n, t += t, a += a, o += o), {
    red: parseInt(n, 16),
    green: parseInt(t, 16),
    blue: parseInt(a, 16),
    alpha: o ? parseInt(o, 16) / 255 : 1
  };
}
const Sl = {
  test: Ql("#"),
  parse: B9,
  transform: cr.transform
}, Tt = {
  test: (e) => cr.test(e) || Sl.test(e) || Nr.test(e),
  parse: (e) => cr.test(e) ? cr.parse(e) : Nr.test(e) ? Nr.parse(e) : Sl.parse(e),
  transform: (e) => mi(e) ? e : e.hasOwnProperty("red") ? cr.transform(e) : Nr.transform(e)
}, C0 = "${c}", P0 = "${n}";
function H9(e) {
  var n, t, a, o;
  return isNaN(e) && mi(e) && ((t = (n = e.match(li)) === null || n === void 0 ? void 0 : n.length) !== null && t !== void 0 ? t : 0) + ((o = (a = e.match(Dl)) === null || a === void 0 ? void 0 : a.length) !== null && o !== void 0 ? o : 0) > 0;
}
function T0(e) {
  typeof e == "number" && (e = `${e}`);
  const n = [];
  let t = 0;
  const a = e.match(Dl);
  a && (t = a.length, e = e.replace(Dl, C0), n.push(...a.map(Tt.parse)));
  const o = e.match(li);
  return o && (e = e.replace(li, P0), n.push(...o.map($r.parse))), { values: n, numColors: t, tokenised: e };
}
function E0(e) {
  return T0(e).values;
}
function R0(e) {
  const { values: n, numColors: t, tokenised: a } = T0(e), o = n.length;
  return (s) => {
    let l = a;
    for (let c = 0; c < o; c++)
      l = l.replace(c < t ? C0 : P0, c < t ? Tt.transform(s[c]) : ei(s[c]));
    return l;
  };
}
const U9 = (e) => typeof e == "number" ? 0 : e;
function j9(e) {
  const n = E0(e);
  return R0(e)(n.map(U9));
}
const Bn = { test: H9, parse: E0, createTransformer: R0, getAnimatableNone: j9 }, z9 = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function q9(e) {
  let [n, t] = e.slice(0, -1).split("(");
  if (n === "drop-shadow")
    return e;
  const [a] = t.match(li) || [];
  if (!a)
    return e;
  const o = t.replace(a, "");
  let s = z9.has(n) ? 1 : 0;
  return a !== t && (s *= 100), n + "(" + s + o + ")";
}
const G9 = /([a-z-]*)\(.*?\)/g, Ol = Object.assign(Object.assign({}, Bn), { getAnimatableNone: (e) => {
  const n = e.match(G9);
  return n ? n.map(q9).join(" ") : e;
} });
var Ih = J(J({}, $r), { transform: Math.round }), A0 = {
  // Border props
  borderWidth: pe,
  borderTopWidth: pe,
  borderRightWidth: pe,
  borderBottomWidth: pe,
  borderLeftWidth: pe,
  borderRadius: pe,
  radius: pe,
  borderTopLeftRadius: pe,
  borderTopRightRadius: pe,
  borderBottomRightRadius: pe,
  borderBottomLeftRadius: pe,
  // Positioning props
  width: pe,
  maxWidth: pe,
  height: pe,
  maxHeight: pe,
  size: pe,
  top: pe,
  right: pe,
  bottom: pe,
  left: pe,
  // Spacing props
  padding: pe,
  paddingTop: pe,
  paddingRight: pe,
  paddingBottom: pe,
  paddingLeft: pe,
  margin: pe,
  marginTop: pe,
  marginRight: pe,
  marginBottom: pe,
  marginLeft: pe,
  // Transform props
  rotate: or,
  rotateX: or,
  rotateY: or,
  rotateZ: or,
  scale: vo,
  scaleX: vo,
  scaleY: vo,
  scaleZ: vo,
  skew: or,
  skewX: or,
  skewY: or,
  distance: pe,
  translateX: pe,
  translateY: pe,
  translateZ: pe,
  x: pe,
  y: pe,
  z: pe,
  perspective: pe,
  transformPerspective: pe,
  opacity: ti,
  originX: Ah,
  originY: Ah,
  originZ: pe,
  // Misc
  zIndex: Ih,
  // SVG
  fillOpacity: ti,
  strokeOpacity: ti,
  numOctaves: Ih
};
function Jl(e, n, t, a) {
  var o, s = e.style, l = e.vars, c = e.transform, d = e.transformKeys, h = e.transformOrigin;
  d.length = 0;
  var p = !1, v = !1, w = !0;
  for (var b in n) {
    var _ = n[b];
    if (S0(b)) {
      l[b] = _;
      continue;
    }
    var D = A0[b], C = k9(_, D);
    if (pi(b)) {
      if (p = !0, c[b] = C, d.push(b), !w)
        continue;
      _ !== ((o = D.default) !== null && o !== void 0 ? o : 0) && (w = !1);
    } else x0(b) ? (h[b] = C, v = !0) : s[b] = C;
  }
  p ? s.transform = F9(e, t, w, a) : a ? s.transform = a({}, "") : !n.transform && s.transform && (s.transform = "none"), v && (s.transformOrigin = N9(h));
}
var ec = function() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};
function I0(e, n, t) {
  for (var a in n)
    !Yn(n[a]) && !D0(a, t) && (e[a] = n[a]);
}
function K9(e, n, t) {
  var a = e.transformTemplate;
  return Kl(function() {
    var o = ec();
    Jl(o, n, { enableHardwareAcceleration: !t }, a);
    var s = o.vars, l = o.style;
    return J(J({}, s), l);
  }, [n]);
}
function X9(e, n, t) {
  var a = e.style || {}, o = {};
  return I0(o, a, e), Object.assign(o, K9(e, n, t)), e.transformValues && (o = e.transformValues(o)), o;
}
function Z9(e, n, t) {
  var a = {}, o = X9(e, n, t);
  return e.drag && e.dragListener !== !1 && (a.draggable = !1, o.userSelect = o.WebkitUserSelect = o.WebkitTouchCallout = "none", o.touchAction = e.drag === !0 ? "none" : "pan-".concat(e.drag === "x" ? "y" : "x")), a.style = o, a;
}
var Q9 = /* @__PURE__ */ new Set([
  "initial",
  "animate",
  "exit",
  "style",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "layout",
  "layoutId",
  "layoutDependency",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "drag",
  "dragControls",
  "dragListener",
  "dragConstraints",
  "dragDirectionLock",
  "dragSnapToOrigin",
  "_dragX",
  "_dragY",
  "dragElastic",
  "dragMomentum",
  "dragPropagation",
  "dragTransition",
  "whileDrag",
  "onPan",
  "onPanStart",
  "onPanEnd",
  "onPanSessionStart",
  "onTap",
  "onTapStart",
  "onTapCancel",
  "onHoverStart",
  "onHoverEnd",
  "whileFocus",
  "whileTap",
  "whileHover",
  "whileInView",
  "onViewportEnter",
  "onViewportLeave",
  "viewport",
  "layoutScroll"
]);
function ko(e) {
  return Q9.has(e);
}
var L0 = function(e) {
  return !ko(e);
};
function J9(e) {
  e && (L0 = function(n) {
    return n.startsWith("on") ? !ko(n) : e(n);
  });
}
try {
  J9(require("@emotion/is-prop-valid").default);
} catch {
}
function ex(e, n, t) {
  var a = {};
  for (var o in e)
    (L0(o) || t === !0 && ko(o) || !n && !ko(o) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && o.startsWith("onDrag")) && (a[o] = e[o]);
  return a;
}
function Lh(e, n, t) {
  return typeof e == "string" ? e : pe.transform(n + t * e);
}
function tx(e, n, t) {
  var a = Lh(n, e.x, e.width), o = Lh(t, e.y, e.height);
  return "".concat(a, " ").concat(o);
}
var nx = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function rx(e, n, t, a, o) {
  t === void 0 && (t = 1), a === void 0 && (a = 0), e.pathLength = 1;
  var s = nx;
  e[s.offset] = pe.transform(-a);
  var l = pe.transform(n), c = pe.transform(t);
  e[s.array] = "".concat(l, " ").concat(c);
}
function tc(e, n, t, a) {
  var o = n.attrX, s = n.attrY, l = n.originX, c = n.originY, d = n.pathLength, h = n.pathSpacing, p = h === void 0 ? 1 : h, v = n.pathOffset, w = v === void 0 ? 0 : v, b = nn(n, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
  Jl(e, b, t, a), e.attrs = e.style, e.style = {};
  var _ = e.attrs, D = e.style, C = e.dimensions;
  _.transform && (C && (D.transform = _.transform), delete _.transform), C && (l !== void 0 || c !== void 0 || D.transform) && (D.transformOrigin = tx(C, l !== void 0 ? l : 0.5, c !== void 0 ? c : 0.5)), o !== void 0 && (_.x = o), s !== void 0 && (_.y = s), d !== void 0 && rx(_, d, p, w);
}
var F0 = function() {
  return J(J({}, ec()), { attrs: {} });
};
function ax(e, n) {
  var t = Kl(function() {
    var o = F0();
    return tc(o, n, { enableHardwareAcceleration: !1 }, e.transformTemplate), J(J({}, o.attrs), { style: J({}, o.style) });
  }, [n]);
  if (e.style) {
    var a = {};
    I0(a, e.style, e), t.style = J(J({}, a), t.style);
  }
  return t;
}
function ix(e) {
  e === void 0 && (e = !1);
  var n = function(t, a, o, s, l, c) {
    var d = l.latestValues, h = Zl(t) ? ax : Z9, p = h(a, d, c), v = ex(a, typeof t == "string", e), w = J(J(J({}, v), p), { ref: s });
    return o && (w["data-projection-id"] = o), t9(t, w);
  };
  return n;
}
var ox = /([a-z])([A-Z])/g, sx = "$1-$2", N0 = function(e) {
  return e.replace(ox, sx).toLowerCase();
};
function k0(e, n, t, a) {
  var o = n.style, s = n.vars;
  Object.assign(e.style, o, a && a.getProjectionStyles(t));
  for (var l in s)
    e.style.setProperty(l, s[l]);
}
var W0 = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength"
]);
function V0(e, n, t, a) {
  k0(e, n, void 0, a);
  for (var o in n.attrs)
    e.setAttribute(W0.has(o) ? o : N0(o), n.attrs[o]);
}
function nc(e) {
  var n = e.style, t = {};
  for (var a in n)
    (Yn(n[a]) || D0(a, e)) && (t[a] = n[a]);
  return t;
}
function $0(e) {
  var n = nc(e);
  for (var t in e)
    if (Yn(e[t])) {
      var a = t === "x" || t === "y" ? "attr" + t.toUpperCase() : t;
      n[a] = e[t];
    }
  return n;
}
function rc(e) {
  return typeof e == "object" && typeof e.start == "function";
}
var ci = function(e) {
  return Array.isArray(e);
}, ux = function(e) {
  return !!(e && typeof e == "object" && e.mix && e.toValue);
}, Y0 = function(e) {
  return ci(e) ? e[e.length - 1] || 0 : e;
};
function Eo(e) {
  var n = Yn(e) ? e.get() : e;
  return ux(n) ? n.toValue() : n;
}
function Fh(e, n, t, a) {
  var o = e.scrapeMotionValuesFromProps, s = e.createRenderState, l = e.onMount, c = {
    latestValues: lx(n, t, a, o),
    renderState: s()
  };
  return l && (c.mount = function(d) {
    return l(n, d, c);
  }), c;
}
var B0 = function(e) {
  return function(n, t) {
    var a = Dt(rs), o = Dt(as);
    return t ? Fh(e, n, a, o) : ss(function() {
      return Fh(e, n, a, o);
    });
  };
};
function lx(e, n, t, a) {
  var o = {}, s = (t == null ? void 0 : t.initial) === !1, l = a(e);
  for (var c in l)
    o[c] = Eo(l[c]);
  var d = e.initial, h = e.animate, p = os(e), v = w0(e);
  n && v && !p && e.inherit !== !1 && (d ?? (d = n.initial), h ?? (h = n.animate));
  var w = s || d === !1, b = w ? h : d;
  if (b && typeof b != "boolean" && !rc(b)) {
    var _ = Array.isArray(b) ? b : [b];
    _.forEach(function(D) {
      var C = y0(e, D);
      if (C) {
        var N = C.transitionEnd;
        C.transition;
        var $ = nn(C, ["transitionEnd", "transition"]);
        for (var A in $) {
          var k = $[A];
          if (Array.isArray(k)) {
            var R = w ? k.length - 1 : 0;
            k = k[R];
          }
          k !== null && (o[A] = k);
        }
        for (var A in N)
          o[A] = N[A];
      }
    });
  }
  return o;
}
var cx = {
  useVisualState: B0({
    scrapeMotionValuesFromProps: $0,
    createRenderState: F0,
    onMount: function(e, n, t) {
      var a = t.renderState, o = t.latestValues;
      try {
        a.dimensions = typeof n.getBBox == "function" ? n.getBBox() : n.getBoundingClientRect();
      } catch {
        a.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      tc(a, o, { enableHardwareAcceleration: !1 }, e.transformTemplate), V0(n, a);
    }
  })
}, fx = {
  useVisualState: B0({
    scrapeMotionValuesFromProps: nc,
    createRenderState: ec
  })
};
function dx(e, n, t, a, o) {
  var s = n.forwardMotionProps, l = s === void 0 ? !1 : s, c = Zl(e) ? cx : fx;
  return J(J({}, c), { preloadedFeatures: t, useRender: ix(l), createVisualElement: a, projectionNodeConstructor: o, Component: e });
}
var ze;
(function(e) {
  e.Animate = "animate", e.Hover = "whileHover", e.Tap = "whileTap", e.Drag = "whileDrag", e.Focus = "whileFocus", e.InView = "whileInView", e.Exit = "exit";
})(ze || (ze = {}));
function us(e, n, t, a) {
  return a === void 0 && (a = { passive: !0 }), e.addEventListener(n, t, a), function() {
    return e.removeEventListener(n, t);
  };
}
function Ml(e, n, t, a) {
  St(function() {
    var o = e.current;
    if (t && o)
      return us(o, n, t, a);
  }, [e, n, t, a]);
}
function hx(e) {
  var n = e.whileFocus, t = e.visualElement, a = function() {
    var s;
    (s = t.animationState) === null || s === void 0 || s.setActive(ze.Focus, !0);
  }, o = function() {
    var s;
    (s = t.animationState) === null || s === void 0 || s.setActive(ze.Focus, !1);
  };
  Ml(t, "focus", n ? a : void 0), Ml(t, "blur", n ? o : void 0);
}
function H0(e) {
  return typeof PointerEvent < "u" && e instanceof PointerEvent ? e.pointerType === "mouse" : e instanceof MouseEvent;
}
function U0(e) {
  var n = !!e.touches;
  return n;
}
function px(e) {
  return function(n) {
    var t = n instanceof MouseEvent, a = !t || t && n.button === 0;
    a && e(n);
  };
}
var mx = { pageX: 0, pageY: 0 };
function vx(e, n) {
  n === void 0 && (n = "page");
  var t = e.touches[0] || e.changedTouches[0], a = t || mx;
  return {
    x: a[n + "X"],
    y: a[n + "Y"]
  };
}
function gx(e, n) {
  return n === void 0 && (n = "page"), {
    x: e[n + "X"],
    y: e[n + "Y"]
  };
}
function ac(e, n) {
  return n === void 0 && (n = "page"), {
    point: U0(e) ? vx(e, n) : gx(e, n)
  };
}
var j0 = function(e, n) {
  n === void 0 && (n = !1);
  var t = function(a) {
    return e(a, ac(a));
  };
  return n ? px(t) : t;
}, yx = function() {
  return Oa && window.onpointerdown === null;
}, wx = function() {
  return Oa && window.ontouchstart === null;
}, bx = function() {
  return Oa && window.onmousedown === null;
}, _x = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
}, xx = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function z0(e) {
  return yx() ? e : wx() ? xx[e] : bx() ? _x[e] : e;
}
function va(e, n, t, a) {
  return us(e, z0(n), j0(t, n === "pointerdown"), a);
}
function Wo(e, n, t, a) {
  return Ml(e, z0(n), t && j0(t, n === "pointerdown"), a);
}
function q0(e) {
  var n = null;
  return function() {
    var t = function() {
      n = null;
    };
    return n === null ? (n = e, t) : !1;
  };
}
var Nh = q0("dragHorizontal"), kh = q0("dragVertical");
function G0(e) {
  var n = !1;
  if (e === "y")
    n = kh();
  else if (e === "x")
    n = Nh();
  else {
    var t = Nh(), a = kh();
    t && a ? n = function() {
      t(), a();
    } : (t && t(), a && a());
  }
  return n;
}
function K0() {
  var e = G0(!0);
  return e ? (e(), !1) : !0;
}
function Wh(e, n, t) {
  return function(a, o) {
    var s;
    !H0(a) || K0() || ((s = e.animationState) === null || s === void 0 || s.setActive(ze.Hover, n), t == null || t(a, o));
  };
}
function Dx(e) {
  var n = e.onHoverStart, t = e.onHoverEnd, a = e.whileHover, o = e.visualElement;
  Wo(o, "pointerenter", n || a ? Wh(o, !0, n) : void 0, { passive: !n }), Wo(o, "pointerleave", t || a ? Wh(o, !1, t) : void 0, { passive: !t });
}
var X0 = function(e, n) {
  return n ? e === n ? !0 : X0(e, n.parentElement) : !1;
};
function Z0(e) {
  return St(function() {
    return function() {
      return e();
    };
  }, []);
}
const Vo = (e, n, t) => Math.min(Math.max(t, e), n), Zu = 1e-3, Sx = 0.01, Vh = 10, Ox = 0.05, Mx = 1;
function Cx({ duration: e = 800, bounce: n = 0.25, velocity: t = 0, mass: a = 1 }) {
  let o, s;
  hi(e <= Vh * 1e3, "Spring duration must be 10 seconds or less");
  let l = 1 - n;
  l = Vo(Ox, Mx, l), e = Vo(Sx, Vh, e / 1e3), l < 1 ? (o = (h) => {
    const p = h * l, v = p * e, w = p - t, b = Cl(h, l), _ = Math.exp(-v);
    return Zu - w / b * _;
  }, s = (h) => {
    const v = h * l * e, w = v * t + t, b = Math.pow(l, 2) * Math.pow(h, 2) * e, _ = Math.exp(-v), D = Cl(Math.pow(h, 2), l);
    return (-o(h) + Zu > 0 ? -1 : 1) * ((w - b) * _) / D;
  }) : (o = (h) => {
    const p = Math.exp(-h * e), v = (h - t) * e + 1;
    return -Zu + p * v;
  }, s = (h) => {
    const p = Math.exp(-h * e), v = (t - h) * (e * e);
    return p * v;
  });
  const c = 5 / e, d = Tx(o, s, c);
  if (e = e * 1e3, isNaN(d))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const h = Math.pow(d, 2) * a;
    return {
      stiffness: h,
      damping: l * 2 * Math.sqrt(a * h),
      duration: e
    };
  }
}
const Px = 12;
function Tx(e, n, t) {
  let a = t;
  for (let o = 1; o < Px; o++)
    a = a - e(a) / n(a);
  return a;
}
function Cl(e, n) {
  return e * Math.sqrt(1 - n * n);
}
const Ex = ["duration", "bounce"], Rx = ["stiffness", "damping", "mass"];
function $h(e, n) {
  return n.some((t) => e[t] !== void 0);
}
function Ax(e) {
  let n = Object.assign({ velocity: 0, stiffness: 100, damping: 10, mass: 1, isResolvedFromDuration: !1 }, e);
  if (!$h(e, Rx) && $h(e, Ex)) {
    const t = Cx(e);
    n = Object.assign(Object.assign(Object.assign({}, n), t), { velocity: 0, mass: 1 }), n.isResolvedFromDuration = !0;
  }
  return n;
}
function ic(e) {
  var { from: n = 0, to: t = 1, restSpeed: a = 2, restDelta: o } = e, s = nn(e, ["from", "to", "restSpeed", "restDelta"]);
  const l = { done: !1, value: n };
  let { stiffness: c, damping: d, mass: h, velocity: p, duration: v, isResolvedFromDuration: w } = Ax(s), b = Yh, _ = Yh;
  function D() {
    const C = p ? -(p / 1e3) : 0, N = t - n, $ = d / (2 * Math.sqrt(c * h)), A = Math.sqrt(c / h) / 1e3;
    if (o === void 0 && (o = Math.min(Math.abs(t - n) / 100, 0.4)), $ < 1) {
      const k = Cl(A, $);
      b = (R) => {
        const ie = Math.exp(-$ * A * R);
        return t - ie * ((C + $ * A * N) / k * Math.sin(k * R) + N * Math.cos(k * R));
      }, _ = (R) => {
        const ie = Math.exp(-$ * A * R);
        return $ * A * ie * (Math.sin(k * R) * (C + $ * A * N) / k + N * Math.cos(k * R)) - ie * (Math.cos(k * R) * (C + $ * A * N) - k * N * Math.sin(k * R));
      };
    } else if ($ === 1)
      b = (k) => t - Math.exp(-A * k) * (N + (C + A * N) * k);
    else {
      const k = A * Math.sqrt($ * $ - 1);
      b = (R) => {
        const ie = Math.exp(-$ * A * R), Y = Math.min(k * R, 300);
        return t - ie * ((C + $ * A * N) * Math.sinh(Y) + k * N * Math.cosh(Y)) / k;
      };
    }
  }
  return D(), {
    next: (C) => {
      const N = b(C);
      if (w)
        l.done = C >= v;
      else {
        const $ = _(C) * 1e3, A = Math.abs($) <= a, k = Math.abs(t - N) <= o;
        l.done = A && k;
      }
      return l.value = l.done ? t : N, l;
    },
    flipTarget: () => {
      p = -p, [n, t] = [t, n], D();
    }
  };
}
ic.needsInterpolation = (e, n) => typeof e == "string" || typeof n == "string";
const Yh = (e) => 0, fi = (e, n, t) => {
  const a = n - e;
  return a === 0 ? 1 : (t - e) / a;
}, nt = (e, n, t) => -t * e + t * n + e;
function Qu(e, n, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? e + (n - e) * 6 * t : t < 1 / 2 ? n : t < 2 / 3 ? e + (n - e) * (2 / 3 - t) * 6 : e;
}
function Bh({ hue: e, saturation: n, lightness: t, alpha: a }) {
  e /= 360, n /= 100, t /= 100;
  let o = 0, s = 0, l = 0;
  if (!n)
    o = s = l = t;
  else {
    const c = t < 0.5 ? t * (1 + n) : t + n - t * n, d = 2 * t - c;
    o = Qu(d, c, e + 1 / 3), s = Qu(d, c, e), l = Qu(d, c, e - 1 / 3);
  }
  return {
    red: Math.round(o * 255),
    green: Math.round(s * 255),
    blue: Math.round(l * 255),
    alpha: a
  };
}
const Ix = (e, n, t) => {
  const a = e * e, o = n * n;
  return Math.sqrt(Math.max(0, t * (o - a) + a));
}, Lx = [Sl, cr, Nr], Hh = (e) => Lx.find((n) => n.test(e)), Uh = (e) => `'${e}' is not an animatable color. Use the equivalent color code instead.`, Q0 = (e, n) => {
  let t = Hh(e), a = Hh(n);
  tn(!!t, Uh(e)), tn(!!a, Uh(n));
  let o = t.parse(e), s = a.parse(n);
  t === Nr && (o = Bh(o), t = cr), a === Nr && (s = Bh(s), a = cr);
  const l = Object.assign({}, o);
  return (c) => {
    for (const d in l)
      d !== "alpha" && (l[d] = Ix(o[d], s[d], c));
    return l.alpha = nt(o.alpha, s.alpha, c), t.transform(l);
  };
}, Pl = (e) => typeof e == "number", Fx = (e, n) => (t) => n(e(t)), ls = (...e) => e.reduce(Fx);
function J0(e, n) {
  return Pl(e) ? (t) => nt(e, n, t) : Tt.test(e) ? Q0(e, n) : tm(e, n);
}
const em = (e, n) => {
  const t = [...e], a = t.length, o = e.map((s, l) => J0(s, n[l]));
  return (s) => {
    for (let l = 0; l < a; l++)
      t[l] = o[l](s);
    return t;
  };
}, Nx = (e, n) => {
  const t = Object.assign(Object.assign({}, e), n), a = {};
  for (const o in t)
    e[o] !== void 0 && n[o] !== void 0 && (a[o] = J0(e[o], n[o]));
  return (o) => {
    for (const s in a)
      t[s] = a[s](o);
    return t;
  };
};
function jh(e) {
  const n = Bn.parse(e), t = n.length;
  let a = 0, o = 0, s = 0;
  for (let l = 0; l < t; l++)
    a || typeof n[l] == "number" ? a++ : n[l].hue !== void 0 ? s++ : o++;
  return { parsed: n, numNumbers: a, numRGB: o, numHSL: s };
}
const tm = (e, n) => {
  const t = Bn.createTransformer(n), a = jh(e), o = jh(n);
  return a.numHSL === o.numHSL && a.numRGB === o.numRGB && a.numNumbers >= o.numNumbers ? ls(em(a.parsed, o.parsed), t) : (hi(!0, `Complex values '${e}' and '${n}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), (l) => `${l > 0 ? n : e}`);
}, kx = (e, n) => (t) => nt(e, n, t);
function Wx(e) {
  if (typeof e == "number")
    return kx;
  if (typeof e == "string")
    return Tt.test(e) ? Q0 : tm;
  if (Array.isArray(e))
    return em;
  if (typeof e == "object")
    return Nx;
}
function Vx(e, n, t) {
  const a = [], o = t || Wx(e[0]), s = e.length - 1;
  for (let l = 0; l < s; l++) {
    let c = o(e[l], e[l + 1]);
    if (n) {
      const d = Array.isArray(n) ? n[l] : n;
      c = ls(d, c);
    }
    a.push(c);
  }
  return a;
}
function $x([e, n], [t]) {
  return (a) => t(fi(e, n, a));
}
function Yx(e, n) {
  const t = e.length, a = t - 1;
  return (o) => {
    let s = 0, l = !1;
    if (o <= e[0] ? l = !0 : o >= e[a] && (s = a - 1, l = !0), !l) {
      let d = 1;
      for (; d < t && !(e[d] > o || d === a); d++)
        ;
      s = d - 1;
    }
    const c = fi(e[s], e[s + 1], o);
    return n[s](c);
  };
}
function nm(e, n, { clamp: t = !0, ease: a, mixer: o } = {}) {
  const s = e.length;
  tn(s === n.length, "Both input and output ranges must be the same length"), tn(!a || !Array.isArray(a) || a.length === s - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values."), e[0] > e[s - 1] && (e = [].concat(e), n = [].concat(n), e.reverse(), n.reverse());
  const l = Vx(n, a, o), c = s === 2 ? $x(e, l) : Yx(e, l);
  return t ? (d) => c(Vo(e[0], e[s - 1], d)) : c;
}
const cs = (e) => (n) => 1 - e(1 - n), oc = (e) => (n) => n <= 0.5 ? e(2 * n) / 2 : (2 - e(2 * (1 - n))) / 2, Bx = (e) => (n) => Math.pow(n, e), rm = (e) => (n) => n * n * ((e + 1) * n - e), Hx = (e) => {
  const n = rm(e);
  return (t) => (t *= 2) < 1 ? 0.5 * n(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1)));
}, am = 1.525, Ux = 4 / 11, jx = 8 / 11, zx = 9 / 10, sc = (e) => e, uc = Bx(2), qx = cs(uc), im = oc(uc), om = (e) => 1 - Math.sin(Math.acos(e)), lc = cs(om), Gx = oc(lc), cc = rm(am), Kx = cs(cc), Xx = oc(cc), Zx = Hx(am), Qx = 4356 / 361, Jx = 35442 / 1805, eD = 16061 / 1805, $o = (e) => {
  if (e === 1 || e === 0)
    return e;
  const n = e * e;
  return e < Ux ? 7.5625 * n : e < jx ? 9.075 * n - 9.9 * e + 3.4 : e < zx ? Qx * n - Jx * e + eD : 10.8 * e * e - 20.52 * e + 10.72;
}, tD = cs($o), nD = (e) => e < 0.5 ? 0.5 * (1 - $o(1 - e * 2)) : 0.5 * $o(e * 2 - 1) + 0.5;
function rD(e, n) {
  return e.map(() => n || im).splice(0, e.length - 1);
}
function aD(e) {
  const n = e.length;
  return e.map((t, a) => a !== 0 ? a / (n - 1) : 0);
}
function iD(e, n) {
  return e.map((t) => t * n);
}
function Ro({ from: e = 0, to: n = 1, ease: t, offset: a, duration: o = 300 }) {
  const s = { done: !1, value: e }, l = Array.isArray(n) ? n : [e, n], c = iD(a && a.length === l.length ? a : aD(l), o);
  function d() {
    return nm(c, l, {
      ease: Array.isArray(t) ? t : rD(l, t)
    });
  }
  let h = d();
  return {
    next: (p) => (s.value = h(p), s.done = p >= o, s),
    flipTarget: () => {
      l.reverse(), h = d();
    }
  };
}
function oD({ velocity: e = 0, from: n = 0, power: t = 0.8, timeConstant: a = 350, restDelta: o = 0.5, modifyTarget: s }) {
  const l = { done: !1, value: n };
  let c = t * e;
  const d = n + c, h = s === void 0 ? d : s(d);
  return h !== d && (c = h - n), {
    next: (p) => {
      const v = -c * Math.exp(-p / a);
      return l.done = !(v > o || v < -o), l.value = l.done ? h : h + v, l;
    },
    flipTarget: () => {
    }
  };
}
const zh = { keyframes: Ro, spring: ic, decay: oD };
function sD(e) {
  if (Array.isArray(e.to))
    return Ro;
  if (zh[e.type])
    return zh[e.type];
  const n = new Set(Object.keys(e));
  return n.has("ease") || n.has("duration") && !n.has("dampingRatio") ? Ro : n.has("dampingRatio") || n.has("stiffness") || n.has("mass") || n.has("damping") || n.has("restSpeed") || n.has("restDelta") ? ic : Ro;
}
const sm = 1 / 60 * 1e3, uD = typeof performance < "u" ? () => performance.now() : () => Date.now(), um = typeof window < "u" ? (e) => window.requestAnimationFrame(e) : (e) => setTimeout(() => e(uD()), sm);
function lD(e) {
  let n = [], t = [], a = 0, o = !1, s = !1;
  const l = /* @__PURE__ */ new WeakSet(), c = {
    schedule: (d, h = !1, p = !1) => {
      const v = p && o, w = v ? n : t;
      return h && l.add(d), w.indexOf(d) === -1 && (w.push(d), v && o && (a = n.length)), d;
    },
    cancel: (d) => {
      const h = t.indexOf(d);
      h !== -1 && t.splice(h, 1), l.delete(d);
    },
    process: (d) => {
      if (o) {
        s = !0;
        return;
      }
      if (o = !0, [n, t] = [t, n], t.length = 0, a = n.length, a)
        for (let h = 0; h < a; h++) {
          const p = n[h];
          p(d), l.has(p) && (c.schedule(p), e());
        }
      o = !1, s && (s = !1, c.process(d));
    }
  };
  return c;
}
const cD = 40;
let Tl = !0, di = !1, El = !1;
const ga = {
  delta: 0,
  timestamp: 0
}, gi = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], fs = gi.reduce((e, n) => (e[n] = lD(() => di = !0), e), {}), Sn = gi.reduce((e, n) => {
  const t = fs[n];
  return e[n] = (a, o = !1, s = !1) => (di || dD(), t.schedule(a, o, s)), e;
}, {}), ba = gi.reduce((e, n) => (e[n] = fs[n].cancel, e), {}), Ju = gi.reduce((e, n) => (e[n] = () => fs[n].process(ga), e), {}), fD = (e) => fs[e].process(ga), lm = (e) => {
  di = !1, ga.delta = Tl ? sm : Math.max(Math.min(e - ga.timestamp, cD), 1), ga.timestamp = e, El = !0, gi.forEach(fD), El = !1, di && (Tl = !1, um(lm));
}, dD = () => {
  di = !0, Tl = !0, El || um(lm);
}, Yo = () => ga;
function cm(e, n, t = 0) {
  return e - n - t;
}
function hD(e, n, t = 0, a = !0) {
  return a ? cm(n + -e, n, t) : n - (e - n) + t;
}
function pD(e, n, t, a) {
  return a ? e >= n + t : e <= -t;
}
const mD = (e) => {
  const n = ({ delta: t }) => e(t);
  return {
    start: () => Sn.update(n, !0),
    stop: () => ba.update(n)
  };
};
function fm(e) {
  var n, t, { from: a, autoplay: o = !0, driver: s = mD, elapsed: l = 0, repeat: c = 0, repeatType: d = "loop", repeatDelay: h = 0, onPlay: p, onStop: v, onComplete: w, onRepeat: b, onUpdate: _ } = e, D = nn(e, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
  let { to: C } = D, N, $ = 0, A = D.duration, k, R = !1, ie = !0, Y;
  const z = sD(D);
  !((t = (n = z).needsInterpolation) === null || t === void 0) && t.call(n, a, C) && (Y = nm([0, 100], [a, C], {
    clamp: !1
  }), a = 0, C = 100);
  const oe = z(Object.assign(Object.assign({}, D), { from: a, to: C }));
  function xe() {
    $++, d === "reverse" ? (ie = $ % 2 === 0, l = hD(l, A, h, ie)) : (l = cm(l, A, h), d === "mirror" && oe.flipTarget()), R = !1, b && b();
  }
  function Ne() {
    N.stop(), w && w();
  }
  function Ae(ke) {
    if (ie || (ke = -ke), l += ke, !R) {
      const et = oe.next(Math.max(0, l));
      k = et.value, Y && (k = Y(k)), R = ie ? et.done : l <= 0;
    }
    _ == null || _(k), R && ($ === 0 && (A ?? (A = l)), $ < c ? pD(l, A, h, ie) && xe() : Ne());
  }
  function Te() {
    p == null || p(), N = s(Ae), N.start();
  }
  return o && Te(), {
    stop: () => {
      v == null || v(), N.stop();
    }
  };
}
function dm(e, n) {
  return n ? e * (1e3 / n) : 0;
}
function vD({ from: e = 0, velocity: n = 0, min: t, max: a, power: o = 0.8, timeConstant: s = 750, bounceStiffness: l = 500, bounceDamping: c = 10, restDelta: d = 1, modifyTarget: h, driver: p, onUpdate: v, onComplete: w, onStop: b }) {
  let _;
  function D(A) {
    return t !== void 0 && A < t || a !== void 0 && A > a;
  }
  function C(A) {
    return t === void 0 ? a : a === void 0 || Math.abs(t - A) < Math.abs(a - A) ? t : a;
  }
  function N(A) {
    _ == null || _.stop(), _ = fm(Object.assign(Object.assign({}, A), {
      driver: p,
      onUpdate: (k) => {
        var R;
        v == null || v(k), (R = A.onUpdate) === null || R === void 0 || R.call(A, k);
      },
      onComplete: w,
      onStop: b
    }));
  }
  function $(A) {
    N(Object.assign({ type: "spring", stiffness: l, damping: c, restDelta: d }, A));
  }
  if (D(e))
    $({ from: e, velocity: n, to: C(e) });
  else {
    let A = o * n + e;
    typeof h < "u" && (A = h(A));
    const k = C(A), R = k === t ? -1 : 1;
    let ie, Y;
    const z = (oe) => {
      ie = Y, Y = oe, n = dm(oe - ie, Yo().delta), (R === 1 && oe > k || R === -1 && oe < k) && $({ from: oe, to: k, velocity: n });
    };
    N({
      type: "decay",
      from: e,
      velocity: n,
      timeConstant: s,
      power: o,
      restDelta: d,
      modifyTarget: h,
      onUpdate: D(A) ? z : void 0
    });
  }
  return {
    stop: () => _ == null ? void 0 : _.stop()
  };
}
const Rl = (e) => e.hasOwnProperty("x") && e.hasOwnProperty("y"), qh = (e) => Rl(e) && e.hasOwnProperty("z"), go = (e, n) => Math.abs(e - n);
function hm(e, n) {
  if (Pl(e) && Pl(n))
    return go(e, n);
  if (Rl(e) && Rl(n)) {
    const t = go(e.x, n.x), a = go(e.y, n.y), o = qh(e) && qh(n) ? go(e.z, n.z) : 0;
    return Math.sqrt(Math.pow(t, 2) + Math.pow(a, 2) + Math.pow(o, 2));
  }
}
const pm = (e, n) => 1 - 3 * n + 3 * e, mm = (e, n) => 3 * n - 6 * e, vm = (e) => 3 * e, Bo = (e, n, t) => ((pm(n, t) * e + mm(n, t)) * e + vm(n)) * e, gm = (e, n, t) => 3 * pm(n, t) * e * e + 2 * mm(n, t) * e + vm(n), gD = 1e-7, yD = 10;
function wD(e, n, t, a, o) {
  let s, l, c = 0;
  do
    l = n + (t - n) / 2, s = Bo(l, a, o) - e, s > 0 ? t = l : n = l;
  while (Math.abs(s) > gD && ++c < yD);
  return l;
}
const bD = 8, _D = 1e-3;
function xD(e, n, t, a) {
  for (let o = 0; o < bD; ++o) {
    const s = gm(n, t, a);
    if (s === 0)
      return n;
    const l = Bo(n, t, a) - e;
    n -= l / s;
  }
  return n;
}
const Ao = 11, yo = 1 / (Ao - 1);
function DD(e, n, t, a) {
  if (e === n && t === a)
    return sc;
  const o = new Float32Array(Ao);
  for (let l = 0; l < Ao; ++l)
    o[l] = Bo(l * yo, e, t);
  function s(l) {
    let c = 0, d = 1;
    const h = Ao - 1;
    for (; d !== h && o[d] <= l; ++d)
      c += yo;
    --d;
    const p = (l - o[d]) / (o[d + 1] - o[d]), v = c + p * yo, w = gm(v, e, t);
    return w >= _D ? xD(l, v, e, t) : w === 0 ? v : wD(l, c, c + yo, e, t);
  }
  return (l) => l === 0 || l === 1 ? l : Bo(s(l), n, a);
}
function SD(e) {
  var n = e.onTap, t = e.onTapStart, a = e.onTapCancel, o = e.whileTap, s = e.visualElement, l = n || t || a || o, c = Wr(!1), d = Wr(null), h = {
    passive: !(t || n || a || _)
  };
  function p() {
    var D;
    (D = d.current) === null || D === void 0 || D.call(d), d.current = null;
  }
  function v() {
    var D;
    return p(), c.current = !1, (D = s.animationState) === null || D === void 0 || D.setActive(ze.Tap, !1), !K0();
  }
  function w(D, C) {
    v() && (X0(s.getInstance(), D.target) ? n == null || n(D, C) : a == null || a(D, C));
  }
  function b(D, C) {
    v() && (a == null || a(D, C));
  }
  function _(D, C) {
    var N;
    p(), !c.current && (c.current = !0, d.current = ls(va(window, "pointerup", w, h), va(window, "pointercancel", b, h)), (N = s.animationState) === null || N === void 0 || N.setActive(ze.Tap, !0), t == null || t(D, C));
  }
  Wo(s, "pointerdown", l ? _ : void 0, h), Z0(p);
}
var Gh = /* @__PURE__ */ new Set();
function ym(e, n, t) {
  e || Gh.has(n) || (console.warn(n), Gh.add(n));
}
var Al = /* @__PURE__ */ new WeakMap(), el = /* @__PURE__ */ new WeakMap(), OD = function(e) {
  var n;
  (n = Al.get(e.target)) === null || n === void 0 || n(e);
}, MD = function(e) {
  e.forEach(OD);
};
function CD(e) {
  var n = e.root, t = nn(e, ["root"]), a = n || document;
  el.has(a) || el.set(a, {});
  var o = el.get(a), s = JSON.stringify(t);
  return o[s] || (o[s] = new IntersectionObserver(MD, J({ root: n }, t))), o[s];
}
function PD(e, n, t) {
  var a = CD(n);
  return Al.set(e, t), a.observe(e), function() {
    Al.delete(e), a.unobserve(e);
  };
}
function TD(e) {
  var n = e.visualElement, t = e.whileInView, a = e.onViewportEnter, o = e.onViewportLeave, s = e.viewport, l = s === void 0 ? {} : s, c = Wr({
    hasEnteredView: !1,
    isInView: !1
  }), d = !!(t || a || o);
  l.once && c.current.hasEnteredView && (d = !1);
  var h = typeof IntersectionObserver > "u" ? AD : RD;
  h(d, c.current, n, l);
}
var ED = {
  some: 0,
  all: 1
};
function RD(e, n, t, a) {
  var o = a.root, s = a.margin, l = a.amount, c = l === void 0 ? "some" : l, d = a.once;
  St(function() {
    if (e) {
      var h = {
        root: o == null ? void 0 : o.current,
        rootMargin: s,
        threshold: typeof c == "number" ? c : ED[c]
      }, p = function(v) {
        var w, b = v.isIntersecting;
        if (n.isInView !== b && (n.isInView = b, !(d && !b && n.hasEnteredView))) {
          b && (n.hasEnteredView = !0), (w = t.animationState) === null || w === void 0 || w.setActive(ze.InView, b);
          var _ = t.getProps(), D = b ? _.onViewportEnter : _.onViewportLeave;
          D == null || D(v);
        }
      };
      return PD(t.getInstance(), h, p);
    }
  }, [e, o, s, c]);
}
function AD(e, n, t, a) {
  var o = a.fallback, s = o === void 0 ? !0 : o;
  St(function() {
    !e || !s || (h0 !== "production" && ym(!1, "IntersectionObserver not available on this device. whileInView animations will trigger on mount."), requestAnimationFrame(function() {
      var l;
      n.hasEnteredView = !0;
      var c = t.getProps().onViewportEnter;
      c == null || c(null), (l = t.animationState) === null || l === void 0 || l.setActive(ze.InView, !0);
    }));
  }, [e]);
}
var fr = function(e) {
  return function(n) {
    return e(n), null;
  };
}, ID = {
  inView: fr(TD),
  tap: fr(SD),
  focus: fr(hx),
  hover: fr(Dx)
}, LD = 0, FD = function() {
  return LD++;
}, ND = function() {
  return ss(FD);
};
function wm() {
  var e = Dt(as);
  if (e === null)
    return [!0, null];
  var n = e.isPresent, t = e.onExitComplete, a = e.register, o = ND();
  St(function() {
    return a(o);
  }, []);
  var s = function() {
    return t == null ? void 0 : t(o);
  };
  return !n && t ? [!1, s] : [!0];
}
function bm(e, n) {
  if (!Array.isArray(n))
    return !1;
  var t = n.length;
  if (t !== e.length)
    return !1;
  for (var a = 0; a < t; a++)
    if (n[a] !== e[a])
      return !1;
  return !0;
}
var Ho = function(e) {
  return e * 1e3;
}, Kh = {
  linear: sc,
  easeIn: uc,
  easeInOut: im,
  easeOut: qx,
  circIn: om,
  circInOut: Gx,
  circOut: lc,
  backIn: cc,
  backInOut: Xx,
  backOut: Kx,
  anticipate: Zx,
  bounceIn: tD,
  bounceInOut: nD,
  bounceOut: $o
}, Xh = function(e) {
  if (Array.isArray(e)) {
    tn(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    var n = ht(e, 4), t = n[0], a = n[1], o = n[2], s = n[3];
    return DD(t, a, o, s);
  } else if (typeof e == "string")
    return tn(Kh[e] !== void 0, "Invalid easing type '".concat(e, "'")), Kh[e];
  return e;
}, kD = function(e) {
  return Array.isArray(e) && typeof e[0] != "number";
}, Zh = function(e, n) {
  return e === "zIndex" ? !1 : !!(typeof n == "number" || Array.isArray(n) || typeof n == "string" && // It's animatable if we have a string
  Bn.test(n) && // And it contains numbers and/or colors
  !n.startsWith("url("));
}, Pr = function() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  };
}, wo = function(e) {
  return {
    type: "spring",
    stiffness: 550,
    damping: e === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  };
}, tl = function() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: 0.3
  };
}, WD = function(e) {
  return {
    type: "keyframes",
    duration: 0.8,
    values: e
  };
}, Qh = {
  x: Pr,
  y: Pr,
  z: Pr,
  rotate: Pr,
  rotateX: Pr,
  rotateY: Pr,
  rotateZ: Pr,
  scaleX: wo,
  scaleY: wo,
  scale: wo,
  opacity: tl,
  backgroundColor: tl,
  color: tl,
  default: wo
}, VD = function(e, n) {
  var t;
  return ci(n) ? t = WD : t = Qh[e] || Qh.default, J({ to: n }, t(n));
}, $D = J(J({}, A0), {
  // Color props
  color: Tt,
  backgroundColor: Tt,
  outlineColor: Tt,
  fill: Tt,
  stroke: Tt,
  // Border props
  borderColor: Tt,
  borderTopColor: Tt,
  borderRightColor: Tt,
  borderBottomColor: Tt,
  borderLeftColor: Tt,
  filter: Ol,
  WebkitFilter: Ol
}), fc = function(e) {
  return $D[e];
};
function dc(e, n) {
  var t, a = fc(e);
  return a !== Ol && (a = Bn), (t = a.getAnimatableNone) === null || t === void 0 ? void 0 : t.call(a, n);
}
function YD(e) {
  e.when, e.delay, e.delayChildren, e.staggerChildren, e.staggerDirection, e.repeat, e.repeatType, e.repeatDelay, e.from;
  var n = nn(e, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
  return !!Object.keys(n).length;
}
var Jh = !1;
function BD(e) {
  var n = e.ease, t = e.times, a = e.yoyo, o = e.flip, s = e.loop, l = nn(e, ["ease", "times", "yoyo", "flip", "loop"]), c = J({}, l);
  return t && (c.offset = t), l.duration && (c.duration = Ho(l.duration)), l.repeatDelay && (c.repeatDelay = Ho(l.repeatDelay)), n && (c.ease = kD(n) ? n.map(Xh) : Xh(n)), l.type === "tween" && (c.type = "keyframes"), (a || s || o) && (hi(!Jh, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options."), Jh = !0, a ? c.repeatType = "reverse" : s ? c.repeatType = "loop" : o && (c.repeatType = "mirror"), c.repeat = s || a || o || l.repeat), l.type !== "spring" && (c.type = "keyframes"), c;
}
function HD(e, n) {
  var t, a, o = hc(e, n) || {};
  return (a = (t = o.delay) !== null && t !== void 0 ? t : e.delay) !== null && a !== void 0 ? a : 0;
}
function UD(e) {
  return Array.isArray(e.to) && e.to[0] === null && (e.to = xn([], ht(e.to), !1), e.to[0] = e.from), e;
}
function jD(e, n, t) {
  var a;
  return Array.isArray(n.to) && ((a = e.duration) !== null && a !== void 0 || (e.duration = 0.8)), UD(n), YD(e) || (e = J(J({}, e), VD(t, n.to))), J(J({}, n), BD(e));
}
function zD(e, n, t, a, o) {
  var s, l = hc(a, e), c = (s = l.from) !== null && s !== void 0 ? s : n.get(), d = Zh(e, t);
  c === "none" && d && typeof t == "string" ? c = dc(e, t) : ep(c) && typeof t == "string" ? c = tp(t) : !Array.isArray(t) && ep(t) && typeof c == "string" && (t = tp(c));
  var h = Zh(e, c);
  hi(h === d, "You are trying to animate ".concat(e, ' from "').concat(c, '" to "').concat(t, '". ').concat(c, " is not an animatable value - to enable this animation set ").concat(c, " to a value animatable to ").concat(t, " via the `style` property."));
  function p() {
    var w = {
      from: c,
      to: t,
      velocity: n.getVelocity(),
      onComplete: o,
      onUpdate: function(b) {
        return n.set(b);
      }
    };
    return l.type === "inertia" || l.type === "decay" ? vD(J(J({}, w), l)) : fm(J(J({}, jD(l, w, e)), { onUpdate: function(b) {
      var _;
      w.onUpdate(b), (_ = l.onUpdate) === null || _ === void 0 || _.call(l, b);
    }, onComplete: function() {
      var b;
      w.onComplete(), (b = l.onComplete) === null || b === void 0 || b.call(l);
    } }));
  }
  function v() {
    var w, b, _ = Y0(t);
    return n.set(_), o(), (w = l == null ? void 0 : l.onUpdate) === null || w === void 0 || w.call(l, _), (b = l == null ? void 0 : l.onComplete) === null || b === void 0 || b.call(l), { stop: function() {
    } };
  }
  return !h || !d || l.type === !1 ? v : p;
}
function ep(e) {
  return e === 0 || typeof e == "string" && parseFloat(e) === 0 && e.indexOf(" ") === -1;
}
function tp(e) {
  return typeof e == "number" ? 0 : dc("", e);
}
function hc(e, n) {
  return e[n] || e.default || e;
}
function pc(e, n, t, a) {
  return a === void 0 && (a = {}), n.start(function(o) {
    var s, l, c = zD(e, n, t, a, o), d = HD(a, e), h = function() {
      return l = c();
    };
    return d ? s = window.setTimeout(h, Ho(d)) : h(), function() {
      clearTimeout(s), l == null || l.stop();
    };
  });
}
var qD = function(e) {
  return /^\-?\d*\.?\d+$/.test(e);
}, GD = function(e) {
  return /^0[^.\s]+$/.test(e);
};
function mc(e, n) {
  e.indexOf(n) === -1 && e.push(n);
}
function vc(e, n) {
  var t = e.indexOf(n);
  t > -1 && e.splice(t, 1);
}
var ni = (
  /** @class */
  function() {
    function e() {
      this.subscriptions = [];
    }
    return e.prototype.add = function(n) {
      var t = this;
      return mc(this.subscriptions, n), function() {
        return vc(t.subscriptions, n);
      };
    }, e.prototype.notify = function(n, t, a) {
      var o = this.subscriptions.length;
      if (o)
        if (o === 1)
          this.subscriptions[0](n, t, a);
        else
          for (var s = 0; s < o; s++) {
            var l = this.subscriptions[s];
            l && l(n, t, a);
          }
    }, e.prototype.getSize = function() {
      return this.subscriptions.length;
    }, e.prototype.clear = function() {
      this.subscriptions.length = 0;
    }, e;
  }()
), KD = function(e) {
  return !isNaN(parseFloat(e));
}, XD = (
  /** @class */
  function() {
    function e(n) {
      var t = this;
      this.version = "6.5.1", this.timeDelta = 0, this.lastUpdated = 0, this.updateSubscribers = new ni(), this.velocityUpdateSubscribers = new ni(), this.renderSubscribers = new ni(), this.canTrackVelocity = !1, this.updateAndNotify = function(a, o) {
        o === void 0 && (o = !0), t.prev = t.current, t.current = a;
        var s = Yo(), l = s.delta, c = s.timestamp;
        t.lastUpdated !== c && (t.timeDelta = l, t.lastUpdated = c, Sn.postRender(t.scheduleVelocityCheck)), t.prev !== t.current && t.updateSubscribers.notify(t.current), t.velocityUpdateSubscribers.getSize() && t.velocityUpdateSubscribers.notify(t.getVelocity()), o && t.renderSubscribers.notify(t.current);
      }, this.scheduleVelocityCheck = function() {
        return Sn.postRender(t.velocityCheck);
      }, this.velocityCheck = function(a) {
        var o = a.timestamp;
        o !== t.lastUpdated && (t.prev = t.current, t.velocityUpdateSubscribers.notify(t.getVelocity()));
      }, this.hasAnimated = !1, this.prev = this.current = n, this.canTrackVelocity = KD(this.current);
    }
    return e.prototype.onChange = function(n) {
      return this.updateSubscribers.add(n);
    }, e.prototype.clearListeners = function() {
      this.updateSubscribers.clear();
    }, e.prototype.onRenderRequest = function(n) {
      return n(this.get()), this.renderSubscribers.add(n);
    }, e.prototype.attach = function(n) {
      this.passiveEffect = n;
    }, e.prototype.set = function(n, t) {
      t === void 0 && (t = !0), !t || !this.passiveEffect ? this.updateAndNotify(n, t) : this.passiveEffect(n, this.updateAndNotify);
    }, e.prototype.get = function() {
      return this.current;
    }, e.prototype.getPrevious = function() {
      return this.prev;
    }, e.prototype.getVelocity = function() {
      return this.canTrackVelocity ? (
        // These casts could be avoided if parseFloat would be typed better
        dm(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
      ) : 0;
    }, e.prototype.start = function(n) {
      var t = this;
      return this.stop(), new Promise(function(a) {
        t.hasAnimated = !0, t.stopAnimation = n(a);
      }).then(function() {
        return t.clearAnimation();
      });
    }, e.prototype.stop = function() {
      this.stopAnimation && this.stopAnimation(), this.clearAnimation();
    }, e.prototype.isAnimating = function() {
      return !!this.stopAnimation;
    }, e.prototype.clearAnimation = function() {
      this.stopAnimation = null;
    }, e.prototype.destroy = function() {
      this.updateSubscribers.clear(), this.renderSubscribers.clear(), this.stop();
    }, e;
  }()
);
function _a(e) {
  return new XD(e);
}
var _m = function(e) {
  return function(n) {
    return n.test(e);
  };
}, ZD = {
  test: function(e) {
    return e === "auto";
  },
  parse: function(e) {
    return e;
  }
}, xm = [$r, pe, Dn, or, $9, V9, ZD], Ua = function(e) {
  return xm.find(_m(e));
}, QD = xn(xn([], ht(xm), !1), [Tt, Bn], !1), JD = function(e) {
  return QD.find(_m(e));
};
function e6(e, n, t) {
  e.hasValue(n) ? e.getValue(n).set(t) : e.addValue(n, _a(t));
}
function t6(e, n) {
  var t = is(e, n), a = t ? e.makeTargetAnimatable(t, !1) : {}, o = a.transitionEnd, s = o === void 0 ? {} : o;
  a.transition;
  var l = nn(a, ["transitionEnd", "transition"]);
  l = J(J({}, l), s);
  for (var c in l) {
    var d = Y0(l[c]);
    e6(e, c, d);
  }
}
function n6(e, n, t) {
  var a, o, s, l, c = Object.keys(n).filter(function(b) {
    return !e.hasValue(b);
  }), d = c.length;
  if (d)
    for (var h = 0; h < d; h++) {
      var p = c[h], v = n[p], w = null;
      Array.isArray(v) && (w = v[0]), w === null && (w = (o = (a = t[p]) !== null && a !== void 0 ? a : e.readValue(p)) !== null && o !== void 0 ? o : n[p]), w != null && (typeof w == "string" && (qD(w) || GD(w)) ? w = parseFloat(w) : !JD(w) && Bn.test(v) && (w = dc(p, v)), e.addValue(p, _a(w)), (s = (l = t)[p]) !== null && s !== void 0 || (l[p] = w), e.setBaseTarget(p, w));
    }
}
function r6(e, n) {
  if (n) {
    var t = n[e] || n.default || n;
    return t.from;
  }
}
function a6(e, n, t) {
  var a, o, s = {};
  for (var l in e)
    s[l] = (a = r6(l, n)) !== null && a !== void 0 ? a : (o = t.getValue(l)) === null || o === void 0 ? void 0 : o.get();
  return s;
}
function i6(e, n, t) {
  t === void 0 && (t = {}), e.notifyAnimationStart(n);
  var a;
  if (Array.isArray(n)) {
    var o = n.map(function(l) {
      return Il(e, l, t);
    });
    a = Promise.all(o);
  } else if (typeof n == "string")
    a = Il(e, n, t);
  else {
    var s = typeof n == "function" ? is(e, n, t.custom) : n;
    a = Dm(e, s, t);
  }
  return a.then(function() {
    return e.notifyAnimationComplete(n);
  });
}
function Il(e, n, t) {
  var a;
  t === void 0 && (t = {});
  var o = is(e, n, t.custom), s = (o || {}).transition, l = s === void 0 ? e.getDefaultTransition() || {} : s;
  t.transitionOverride && (l = t.transitionOverride);
  var c = o ? function() {
    return Dm(e, o, t);
  } : function() {
    return Promise.resolve();
  }, d = !((a = e.variantChildren) === null || a === void 0) && a.size ? function(b) {
    b === void 0 && (b = 0);
    var _ = l.delayChildren, D = _ === void 0 ? 0 : _, C = l.staggerChildren, N = l.staggerDirection;
    return o6(e, n, D + b, C, N, t);
  } : function() {
    return Promise.resolve();
  }, h = l.when;
  if (h) {
    var p = ht(h === "beforeChildren" ? [c, d] : [d, c], 2), v = p[0], w = p[1];
    return v().then(w);
  } else
    return Promise.all([c(), d(t.delay)]);
}
function Dm(e, n, t) {
  var a, o = t === void 0 ? {} : t, s = o.delay, l = s === void 0 ? 0 : s, c = o.transitionOverride, d = o.type, h = e.makeTargetAnimatable(n), p = h.transition, v = p === void 0 ? e.getDefaultTransition() : p, w = h.transitionEnd, b = nn(h, ["transition", "transitionEnd"]);
  c && (v = c);
  var _ = [], D = d && ((a = e.animationState) === null || a === void 0 ? void 0 : a.getState()[d]);
  for (var C in b) {
    var N = e.getValue(C), $ = b[C];
    if (!(!N || $ === void 0 || D && u6(D, C))) {
      var A = J({ delay: l }, v);
      e.shouldReduceMotion && pi(C) && (A = J(J({}, A), { type: !1, delay: 0 }));
      var k = pc(C, N, $, A);
      _.push(k);
    }
  }
  return Promise.all(_).then(function() {
    w && t6(e, w);
  });
}
function o6(e, n, t, a, o, s) {
  t === void 0 && (t = 0), a === void 0 && (a = 0), o === void 0 && (o = 1);
  var l = [], c = (e.variantChildren.size - 1) * a, d = o === 1 ? function(h) {
    return h === void 0 && (h = 0), h * a;
  } : function(h) {
    return h === void 0 && (h = 0), c - h * a;
  };
  return Array.from(e.variantChildren).sort(s6).forEach(function(h, p) {
    l.push(Il(h, n, J(J({}, s), { delay: t + d(p) })).then(function() {
      return h.notifyAnimationComplete(n);
    }));
  }), Promise.all(l);
}
function s6(e, n) {
  return e.sortNodePosition(n);
}
function u6(e, n) {
  var t = e.protectedKeys, a = e.needsAnimating, o = t.hasOwnProperty(n) && a[n] !== !0;
  return a[n] = !1, o;
}
var gc = [
  ze.Animate,
  ze.InView,
  ze.Focus,
  ze.Hover,
  ze.Tap,
  ze.Drag,
  ze.Exit
], l6 = xn([], ht(gc), !1).reverse(), c6 = gc.length;
function f6(e) {
  return function(n) {
    return Promise.all(n.map(function(t) {
      var a = t.animation, o = t.options;
      return i6(e, a, o);
    }));
  };
}
function d6(e) {
  var n = f6(e), t = p6(), a = {}, o = !0, s = function(p, v) {
    var w = is(e, v);
    if (w) {
      w.transition;
      var b = w.transitionEnd, _ = nn(w, ["transition", "transitionEnd"]);
      p = J(J(J({}, p), _), b);
    }
    return p;
  };
  function l(p) {
    return a[p] !== void 0;
  }
  function c(p) {
    n = p(e);
  }
  function d(p, v) {
    for (var w, b = e.getProps(), _ = e.getVariantContext(!0) || {}, D = [], C = /* @__PURE__ */ new Set(), N = {}, $ = 1 / 0, A = function(Y) {
      var z = l6[Y], oe = t[z], xe = (w = b[z]) !== null && w !== void 0 ? w : _[z], Ne = cn(xe), Ae = z === v ? oe.isActive : null;
      Ae === !1 && ($ = Y);
      var Te = xe === _[z] && xe !== b[z] && Ne;
      if (Te && o && e.manuallyAnimateOnMount && (Te = !1), oe.protectedKeys = J({}, N), // If it isn't active and hasn't *just* been set as inactive
      !oe.isActive && Ae === null || // If we didn't and don't have any defined prop for this animation type
      !xe && !oe.prevProp || // Or if the prop doesn't define an animation
      rc(xe) || typeof xe == "boolean")
        return "continue";
      var ke = h6(oe.prevProp, xe), et = ke || // If we're making this variant active, we want to always make it active
      z === v && oe.isActive && !Te && Ne || // If we removed a higher-priority variant (i is in reverse order)
      Y > $ && Ne, He = Array.isArray(xe) ? xe : [xe], Pe = He.reduce(s, {});
      Ae === !1 && (Pe = {});
      var qe = oe.prevResolvedValues, lt = qe === void 0 ? {} : qe, U = J(J({}, lt), Pe), Z = function(S) {
        et = !0, C.delete(S), oe.needsAnimating[S] = !0;
      };
      for (var V in U) {
        var I = Pe[V], M = lt[V];
        N.hasOwnProperty(V) || (I !== M ? ci(I) && ci(M) ? !bm(I, M) || ke ? Z(V) : oe.protectedKeys[V] = !0 : I !== void 0 ? Z(V) : C.add(V) : I !== void 0 && C.has(V) ? Z(V) : oe.protectedKeys[V] = !0);
      }
      oe.prevProp = xe, oe.prevResolvedValues = Pe, oe.isActive && (N = J(J({}, N), Pe)), o && e.blockInitialAnimation && (et = !1), et && !Te && D.push.apply(D, xn([], ht(He.map(function(S) {
        return {
          animation: S,
          options: J({ type: z }, p)
        };
      })), !1));
    }, k = 0; k < c6; k++)
      A(k);
    if (a = J({}, N), C.size) {
      var R = {};
      C.forEach(function(Y) {
        var z = e.getBaseTarget(Y);
        z !== void 0 && (R[Y] = z);
      }), D.push({ animation: R });
    }
    var ie = !!D.length;
    return o && b.initial === !1 && !e.manuallyAnimateOnMount && (ie = !1), o = !1, ie ? n(D) : Promise.resolve();
  }
  function h(p, v, w) {
    var b;
    if (t[p].isActive === v)
      return Promise.resolve();
    (b = e.variantChildren) === null || b === void 0 || b.forEach(function(C) {
      var N;
      return (N = C.animationState) === null || N === void 0 ? void 0 : N.setActive(p, v);
    }), t[p].isActive = v;
    var _ = d(w, p);
    for (var D in t)
      t[D].protectedKeys = {};
    return _;
  }
  return {
    isAnimated: l,
    animateChanges: d,
    setActive: h,
    setAnimateFunction: c,
    getState: function() {
      return t;
    }
  };
}
function h6(e, n) {
  return typeof n == "string" ? n !== e : g0(n) ? !bm(n, e) : !1;
}
function Tr(e) {
  return e === void 0 && (e = !1), {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function p6() {
  var e;
  return e = {}, e[ze.Animate] = Tr(!0), e[ze.InView] = Tr(), e[ze.Hover] = Tr(), e[ze.Tap] = Tr(), e[ze.Drag] = Tr(), e[ze.Focus] = Tr(), e[ze.Exit] = Tr(), e;
}
var m6 = {
  animation: fr(function(e) {
    var n = e.visualElement, t = e.animate;
    n.animationState || (n.animationState = d6(n)), rc(t) && St(function() {
      return t.subscribe(n);
    }, [t]);
  }),
  exit: fr(function(e) {
    var n = e.custom, t = e.visualElement, a = ht(wm(), 2), o = a[0], s = a[1], l = Dt(as);
    St(function() {
      var c, d;
      t.isPresent = o;
      var h = (c = t.animationState) === null || c === void 0 ? void 0 : c.setActive(ze.Exit, !o, { custom: (d = l == null ? void 0 : l.custom) !== null && d !== void 0 ? d : n });
      !o && (h == null || h.then(s));
    }, [o]);
  })
}, Sm = (
  /** @class */
  function() {
    function e(n, t, a) {
      var o = this, s = a === void 0 ? {} : a, l = s.transformPagePoint;
      if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = function() {
        if (o.lastMoveEvent && o.lastMoveEventInfo) {
          var w = rl(o.lastMoveEventInfo, o.history), b = o.startEvent !== null, _ = hm(w.offset, { x: 0, y: 0 }) >= 3;
          if (!(!b && !_)) {
            var D = w.point, C = Yo().timestamp;
            o.history.push(J(J({}, D), { timestamp: C }));
            var N = o.handlers, $ = N.onStart, A = N.onMove;
            b || ($ && $(o.lastMoveEvent, w), o.startEvent = o.lastMoveEvent), A && A(o.lastMoveEvent, w);
          }
        }
      }, this.handlePointerMove = function(w, b) {
        if (o.lastMoveEvent = w, o.lastMoveEventInfo = nl(b, o.transformPagePoint), H0(w) && w.buttons === 0) {
          o.handlePointerUp(w, b);
          return;
        }
        Sn.update(o.updatePoint, !0);
      }, this.handlePointerUp = function(w, b) {
        o.end();
        var _ = o.handlers, D = _.onEnd, C = _.onSessionEnd, N = rl(nl(b, o.transformPagePoint), o.history);
        o.startEvent && D && D(w, N), C && C(w, N);
      }, !(U0(n) && n.touches.length > 1)) {
        this.handlers = t, this.transformPagePoint = l;
        var c = ac(n), d = nl(c, this.transformPagePoint), h = d.point, p = Yo().timestamp;
        this.history = [J(J({}, h), { timestamp: p })];
        var v = t.onSessionStart;
        v && v(n, rl(d, this.history)), this.removeListeners = ls(va(window, "pointermove", this.handlePointerMove), va(window, "pointerup", this.handlePointerUp), va(window, "pointercancel", this.handlePointerUp));
      }
    }
    return e.prototype.updateHandlers = function(n) {
      this.handlers = n;
    }, e.prototype.end = function() {
      this.removeListeners && this.removeListeners(), ba.update(this.updatePoint);
    }, e;
  }()
);
function nl(e, n) {
  return n ? { point: n(e.point) } : e;
}
function np(e, n) {
  return { x: e.x - n.x, y: e.y - n.y };
}
function rl(e, n) {
  var t = e.point;
  return {
    point: t,
    delta: np(t, Om(n)),
    offset: np(t, v6(n)),
    velocity: g6(n, 0.1)
  };
}
function v6(e) {
  return e[0];
}
function Om(e) {
  return e[e.length - 1];
}
function g6(e, n) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  for (var t = e.length - 1, a = null, o = Om(e); t >= 0 && (a = e[t], !(o.timestamp - a.timestamp > Ho(n))); )
    t--;
  if (!a)
    return { x: 0, y: 0 };
  var s = (o.timestamp - a.timestamp) / 1e3;
  if (s === 0)
    return { x: 0, y: 0 };
  var l = {
    x: (o.x - a.x) / s,
    y: (o.y - a.y) / s
  };
  return l.x === 1 / 0 && (l.x = 0), l.y === 1 / 0 && (l.y = 0), l;
}
function Hn(e) {
  return e.max - e.min;
}
function rp(e, n, t) {
  return n === void 0 && (n = 0), t === void 0 && (t = 0.01), hm(e, n) < t;
}
function ap(e, n, t, a) {
  a === void 0 && (a = 0.5), e.origin = a, e.originPoint = nt(n.min, n.max, e.origin), e.scale = Hn(t) / Hn(n), (rp(e.scale, 1, 1e-4) || isNaN(e.scale)) && (e.scale = 1), e.translate = nt(t.min, t.max, e.origin) - e.originPoint, (rp(e.translate) || isNaN(e.translate)) && (e.translate = 0);
}
function ri(e, n, t, a) {
  ap(e.x, n.x, t.x, a == null ? void 0 : a.originX), ap(e.y, n.y, t.y, a == null ? void 0 : a.originY);
}
function ip(e, n, t) {
  e.min = t.min + n.min, e.max = e.min + Hn(n);
}
function y6(e, n, t) {
  ip(e.x, n.x, t.x), ip(e.y, n.y, t.y);
}
function op(e, n, t) {
  e.min = n.min - t.min, e.max = e.min + Hn(n);
}
function ai(e, n, t) {
  op(e.x, n.x, t.x), op(e.y, n.y, t.y);
}
function w6(e, n, t) {
  var a = n.min, o = n.max;
  return a !== void 0 && e < a ? e = t ? nt(a, e, t.min) : Math.max(e, a) : o !== void 0 && e > o && (e = t ? nt(o, e, t.max) : Math.min(e, o)), e;
}
function sp(e, n, t) {
  return {
    min: n !== void 0 ? e.min + n : void 0,
    max: t !== void 0 ? e.max + t - (e.max - e.min) : void 0
  };
}
function b6(e, n) {
  var t = n.top, a = n.left, o = n.bottom, s = n.right;
  return {
    x: sp(e.x, a, s),
    y: sp(e.y, t, o)
  };
}
function up(e, n) {
  var t, a = n.min - e.min, o = n.max - e.max;
  return n.max - n.min < e.max - e.min && (t = ht([o, a], 2), a = t[0], o = t[1]), { min: a, max: o };
}
function _6(e, n) {
  return {
    x: up(e.x, n.x),
    y: up(e.y, n.y)
  };
}
function x6(e, n) {
  var t = 0.5, a = Hn(e), o = Hn(n);
  return o > a ? t = fi(n.min, n.max - a, e.min) : a > o && (t = fi(e.min, e.max - o, n.min)), Vo(0, 1, t);
}
function D6(e, n) {
  var t = {};
  return n.min !== void 0 && (t.min = n.min - e.min), n.max !== void 0 && (t.max = n.max - e.min), t;
}
var Ll = 0.35;
function S6(e) {
  return e === void 0 && (e = Ll), e === !1 ? e = 0 : e === !0 && (e = Ll), {
    x: lp(e, "left", "right"),
    y: lp(e, "top", "bottom")
  };
}
function lp(e, n, t) {
  return {
    min: cp(e, n),
    max: cp(e, t)
  };
}
function cp(e, n) {
  var t;
  return typeof e == "number" ? e : (t = e[n]) !== null && t !== void 0 ? t : 0;
}
var fp = function() {
  return {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };
}, ii = function() {
  return {
    x: fp(),
    y: fp()
  };
}, dp = function() {
  return { min: 0, max: 0 };
}, xt = function() {
  return {
    x: dp(),
    y: dp()
  };
};
function yn(e) {
  return [e("x"), e("y")];
}
function Mm(e) {
  var n = e.top, t = e.left, a = e.right, o = e.bottom;
  return {
    x: { min: t, max: a },
    y: { min: n, max: o }
  };
}
function O6(e) {
  var n = e.x, t = e.y;
  return { top: t.min, right: n.max, bottom: t.max, left: n.min };
}
function M6(e, n) {
  if (!n)
    return e;
  var t = n({ x: e.left, y: e.top }), a = n({ x: e.right, y: e.bottom });
  return {
    top: t.y,
    left: t.x,
    bottom: a.y,
    right: a.x
  };
}
function al(e) {
  return e === void 0 || e === 1;
}
function Cm(e) {
  var n = e.scale, t = e.scaleX, a = e.scaleY;
  return !al(n) || !al(t) || !al(a);
}
function sr(e) {
  return Cm(e) || hp(e.x) || hp(e.y) || e.z || e.rotate || e.rotateX || e.rotateY;
}
function hp(e) {
  return e && e !== "0%";
}
function Uo(e, n, t) {
  var a = e - t, o = n * a;
  return t + o;
}
function pp(e, n, t, a, o) {
  return o !== void 0 && (e = Uo(e, o, a)), Uo(e, t, a) + n;
}
function Fl(e, n, t, a, o) {
  n === void 0 && (n = 0), t === void 0 && (t = 1), e.min = pp(e.min, n, t, a, o), e.max = pp(e.max, n, t, a, o);
}
function Pm(e, n) {
  var t = n.x, a = n.y;
  Fl(e.x, t.translate, t.scale, t.originPoint), Fl(e.y, a.translate, a.scale, a.originPoint);
}
function C6(e, n, t, a) {
  var o, s;
  a === void 0 && (a = !1);
  var l = t.length;
  if (l) {
    n.x = n.y = 1;
    for (var c, d, h = 0; h < l; h++)
      c = t[h], d = c.projectionDelta, ((s = (o = c.instance) === null || o === void 0 ? void 0 : o.style) === null || s === void 0 ? void 0 : s.display) !== "contents" && (a && c.options.layoutScroll && c.scroll && c !== c.root && pa(e, { x: -c.scroll.x, y: -c.scroll.y }), d && (n.x *= d.x.scale, n.y *= d.y.scale, Pm(e, d)), a && sr(c.latestValues) && pa(e, c.latestValues));
  }
}
function lr(e, n) {
  e.min = e.min + n, e.max = e.max + n;
}
function mp(e, n, t) {
  var a = ht(t, 3), o = a[0], s = a[1], l = a[2], c = n[l] !== void 0 ? n[l] : 0.5, d = nt(e.min, e.max, c);
  Fl(e, n[o], n[s], d, n.scale);
}
var P6 = ["x", "scaleX", "originX"], T6 = ["y", "scaleY", "originY"];
function pa(e, n) {
  mp(e.x, n, P6), mp(e.y, n, T6);
}
function Tm(e, n) {
  return Mm(M6(e.getBoundingClientRect(), n));
}
function E6(e, n, t) {
  var a = Tm(e, t), o = n.scroll;
  return o && (lr(a.x, o.x), lr(a.y, o.y)), a;
}
var R6 = /* @__PURE__ */ new WeakMap(), A6 = (
  /** @class */
  function() {
    function e(n) {
      this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = xt(), this.visualElement = n;
    }
    return e.prototype.start = function(n, t) {
      var a = this, o = t === void 0 ? {} : t, s = o.snapToCursor, l = s === void 0 ? !1 : s;
      if (this.visualElement.isPresent !== !1) {
        var c = function(v) {
          a.stopAnimation(), l && a.snapToCursor(ac(v, "page").point);
        }, d = function(v, w) {
          var b, _ = a.getProps(), D = _.drag, C = _.dragPropagation, N = _.onDragStart;
          D && !C && (a.openGlobalLock && a.openGlobalLock(), a.openGlobalLock = G0(D), !a.openGlobalLock) || (a.isDragging = !0, a.currentDirection = null, a.resolveConstraints(), a.visualElement.projection && (a.visualElement.projection.isAnimationBlocked = !0, a.visualElement.projection.target = void 0), yn(function($) {
            var A, k, R = a.getAxisMotionValue($).get() || 0;
            if (Dn.test(R)) {
              var ie = (k = (A = a.visualElement.projection) === null || A === void 0 ? void 0 : A.layout) === null || k === void 0 ? void 0 : k.actual[$];
              if (ie) {
                var Y = Hn(ie);
                R = Y * (parseFloat(R) / 100);
              }
            }
            a.originPoint[$] = R;
          }), N == null || N(v, w), (b = a.visualElement.animationState) === null || b === void 0 || b.setActive(ze.Drag, !0));
        }, h = function(v, w) {
          var b = a.getProps(), _ = b.dragPropagation, D = b.dragDirectionLock, C = b.onDirectionLock, N = b.onDrag;
          if (!(!_ && !a.openGlobalLock)) {
            var $ = w.offset;
            if (D && a.currentDirection === null) {
              a.currentDirection = I6($), a.currentDirection !== null && (C == null || C(a.currentDirection));
              return;
            }
            a.updateAxis("x", w.point, $), a.updateAxis("y", w.point, $), a.visualElement.syncRender(), N == null || N(v, w);
          }
        }, p = function(v, w) {
          return a.stop(v, w);
        };
        this.panSession = new Sm(n, {
          onSessionStart: c,
          onStart: d,
          onMove: h,
          onSessionEnd: p
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
      }
    }, e.prototype.stop = function(n, t) {
      var a = this.isDragging;
      if (this.cancel(), !!a) {
        var o = t.velocity;
        this.startAnimation(o);
        var s = this.getProps().onDragEnd;
        s == null || s(n, t);
      }
    }, e.prototype.cancel = function() {
      var n, t;
      this.isDragging = !1, this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !1), (n = this.panSession) === null || n === void 0 || n.end(), this.panSession = void 0;
      var a = this.getProps().dragPropagation;
      !a && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), (t = this.visualElement.animationState) === null || t === void 0 || t.setActive(ze.Drag, !1);
    }, e.prototype.updateAxis = function(n, t, a) {
      var o = this.getProps().drag;
      if (!(!a || !bo(n, o, this.currentDirection))) {
        var s = this.getAxisMotionValue(n), l = this.originPoint[n] + a[n];
        this.constraints && this.constraints[n] && (l = w6(l, this.constraints[n], this.elastic[n])), s.set(l);
      }
    }, e.prototype.resolveConstraints = function() {
      var n = this, t = this.getProps(), a = t.dragConstraints, o = t.dragElastic, s = (this.visualElement.projection || {}).layout, l = this.constraints;
      a && ha(a) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : a && s ? this.constraints = b6(s.actual, a) : this.constraints = !1, this.elastic = S6(o), l !== this.constraints && s && this.constraints && !this.hasMutatedConstraints && yn(function(c) {
        n.getAxisMotionValue(c) && (n.constraints[c] = D6(s.actual[c], n.constraints[c]));
      });
    }, e.prototype.resolveRefConstraints = function() {
      var n = this.getProps(), t = n.dragConstraints, a = n.onMeasureDragConstraints;
      if (!t || !ha(t))
        return !1;
      var o = t.current;
      tn(o !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
      var s = this.visualElement.projection;
      if (!s || !s.layout)
        return !1;
      var l = E6(o, s.root, this.visualElement.getTransformPagePoint()), c = _6(s.layout.actual, l);
      if (a) {
        var d = a(O6(c));
        this.hasMutatedConstraints = !!d, d && (c = Mm(d));
      }
      return c;
    }, e.prototype.startAnimation = function(n) {
      var t = this, a = this.getProps(), o = a.drag, s = a.dragMomentum, l = a.dragElastic, c = a.dragTransition, d = a.dragSnapToOrigin, h = a.onDragTransitionEnd, p = this.constraints || {}, v = yn(function(w) {
        var b;
        if (bo(w, o, t.currentDirection)) {
          var _ = (b = p == null ? void 0 : p[w]) !== null && b !== void 0 ? b : {};
          d && (_ = { min: 0, max: 0 });
          var D = l ? 200 : 1e6, C = l ? 40 : 1e7, N = J(J({ type: "inertia", velocity: s ? n[w] : 0, bounceStiffness: D, bounceDamping: C, timeConstant: 750, restDelta: 1, restSpeed: 10 }, c), _);
          return t.startAxisValueAnimation(w, N);
        }
      });
      return Promise.all(v).then(h);
    }, e.prototype.startAxisValueAnimation = function(n, t) {
      var a = this.getAxisMotionValue(n);
      return pc(n, a, 0, t);
    }, e.prototype.stopAnimation = function() {
      var n = this;
      yn(function(t) {
        return n.getAxisMotionValue(t).stop();
      });
    }, e.prototype.getAxisMotionValue = function(n) {
      var t, a, o = "_drag" + n.toUpperCase(), s = this.visualElement.getProps()[o];
      return s || this.visualElement.getValue(n, (a = (t = this.visualElement.getProps().initial) === null || t === void 0 ? void 0 : t[n]) !== null && a !== void 0 ? a : 0);
    }, e.prototype.snapToCursor = function(n) {
      var t = this;
      yn(function(a) {
        var o = t.getProps().drag;
        if (bo(a, o, t.currentDirection)) {
          var s = t.visualElement.projection, l = t.getAxisMotionValue(a);
          if (s && s.layout) {
            var c = s.layout.actual[a], d = c.min, h = c.max;
            l.set(n[a] - nt(d, h, 0.5));
          }
        }
      });
    }, e.prototype.scalePositionWithinConstraints = function() {
      var n = this, t, a = this.getProps(), o = a.drag, s = a.dragConstraints, l = this.visualElement.projection;
      if (!(!ha(s) || !l || !this.constraints)) {
        this.stopAnimation();
        var c = { x: 0, y: 0 };
        yn(function(h) {
          var p = n.getAxisMotionValue(h);
          if (p) {
            var v = p.get();
            c[h] = x6({ min: v, max: v }, n.constraints[h]);
          }
        });
        var d = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = d ? d({}, "") : "none", (t = l.root) === null || t === void 0 || t.updateScroll(), l.updateLayout(), this.resolveConstraints(), yn(function(h) {
          if (bo(h, o, null)) {
            var p = n.getAxisMotionValue(h), v = n.constraints[h], w = v.min, b = v.max;
            p.set(nt(w, b, c[h]));
          }
        });
      }
    }, e.prototype.addListeners = function() {
      var n = this, t;
      R6.set(this.visualElement, this);
      var a = this.visualElement.getInstance(), o = va(a, "pointerdown", function(h) {
        var p = n.getProps(), v = p.drag, w = p.dragListener, b = w === void 0 ? !0 : w;
        v && b && n.start(h);
      }), s = function() {
        var h = n.getProps().dragConstraints;
        ha(h) && (n.constraints = n.resolveRefConstraints());
      }, l = this.visualElement.projection, c = l.addEventListener("measure", s);
      l && !l.layout && ((t = l.root) === null || t === void 0 || t.updateScroll(), l.updateLayout()), s();
      var d = us(window, "resize", function() {
        return n.scalePositionWithinConstraints();
      });
      return l.addEventListener("didUpdate", function(h) {
        var p = h.delta, v = h.hasLayoutChanged;
        n.isDragging && v && (yn(function(w) {
          var b = n.getAxisMotionValue(w);
          b && (n.originPoint[w] += p[w].translate, b.set(b.get() + p[w].translate));
        }), n.visualElement.syncRender());
      }), function() {
        d(), o(), c();
      };
    }, e.prototype.getProps = function() {
      var n = this.visualElement.getProps(), t = n.drag, a = t === void 0 ? !1 : t, o = n.dragDirectionLock, s = o === void 0 ? !1 : o, l = n.dragPropagation, c = l === void 0 ? !1 : l, d = n.dragConstraints, h = d === void 0 ? !1 : d, p = n.dragElastic, v = p === void 0 ? Ll : p, w = n.dragMomentum, b = w === void 0 ? !0 : w;
      return J(J({}, n), { drag: a, dragDirectionLock: s, dragPropagation: c, dragConstraints: h, dragElastic: v, dragMomentum: b });
    }, e;
  }()
);
function bo(e, n, t) {
  return (n === !0 || n === e) && (t === null || t === e);
}
function I6(e, n) {
  n === void 0 && (n = 10);
  var t = null;
  return Math.abs(e.y) > n ? t = "y" : Math.abs(e.x) > n && (t = "x"), t;
}
function L6(e) {
  var n = e.dragControls, t = e.visualElement, a = ss(function() {
    return new A6(t);
  });
  St(function() {
    return n && n.subscribe(a);
  }, [a, n]), St(function() {
    return a.addListeners();
  }, [a]);
}
function F6(e) {
  var n = e.onPan, t = e.onPanStart, a = e.onPanEnd, o = e.onPanSessionStart, s = e.visualElement, l = n || t || a || o, c = Wr(null), d = Dt(Xl).transformPagePoint, h = {
    onSessionStart: o,
    onStart: t,
    onMove: n,
    onEnd: function(v, w) {
      c.current = null, a && a(v, w);
    }
  };
  St(function() {
    c.current !== null && c.current.updateHandlers(h);
  });
  function p(v) {
    c.current = new Sm(v, h, {
      transformPagePoint: d
    });
  }
  Wo(s, "pointerdown", l && p), Z0(function() {
    return c.current && c.current.end();
  });
}
var N6 = {
  pan: fr(F6),
  drag: fr(L6)
}, _o = [
  "LayoutMeasure",
  "BeforeLayoutMeasure",
  "LayoutUpdate",
  "ViewportBoxUpdate",
  "Update",
  "Render",
  "AnimationComplete",
  "LayoutAnimationComplete",
  "AnimationStart",
  "LayoutAnimationStart",
  "SetAxisTarget",
  "Unmount"
];
function k6() {
  var e = _o.map(function() {
    return new ni();
  }), n = {}, t = {
    clearAllListeners: function() {
      return e.forEach(function(a) {
        return a.clear();
      });
    },
    updatePropListeners: function(a) {
      _o.forEach(function(o) {
        var s, l = "on" + o, c = a[l];
        (s = n[o]) === null || s === void 0 || s.call(n), c && (n[o] = t[l](c));
      });
    }
  };
  return e.forEach(function(a, o) {
    t["on" + _o[o]] = function(s) {
      return a.add(s);
    }, t["notify" + _o[o]] = function() {
      for (var s = [], l = 0; l < arguments.length; l++)
        s[l] = arguments[l];
      return a.notify.apply(a, xn([], ht(s), !1));
    };
  }), t;
}
function W6(e, n, t) {
  var a;
  for (var o in n) {
    var s = n[o], l = t[o];
    if (Yn(s))
      e.addValue(o, s), process.env.NODE_ENV === "development" && ym(s.version === "6.5.1", "Attempting to mix Framer Motion versions ".concat(s.version, " with 6.5.1 may not work as expected."));
    else if (Yn(l))
      e.addValue(o, _a(s));
    else if (l !== s)
      if (e.hasValue(o)) {
        var c = e.getValue(o);
        !c.hasAnimated && c.set(s);
      } else
        e.addValue(o, _a((a = e.getStaticValue(o)) !== null && a !== void 0 ? a : s));
  }
  for (var o in t)
    n[o] === void 0 && e.removeValue(o);
  return n;
}
var Em = function(e) {
  var n = e.treeType, t = n === void 0 ? "" : n, a = e.build, o = e.getBaseTarget, s = e.makeTargetAnimatable, l = e.measureViewportBox, c = e.render, d = e.readValueFromInstance, h = e.removeValueFromRenderState, p = e.sortNodePosition, v = e.scrapeMotionValuesFromProps;
  return function(w, b) {
    var _ = w.parent, D = w.props, C = w.presenceId, N = w.blockInitialAnimation, $ = w.visualState, A = w.shouldReduceMotion;
    b === void 0 && (b = {});
    var k = !1, R = $.latestValues, ie = $.renderState, Y, z = k6(), oe = /* @__PURE__ */ new Map(), xe = /* @__PURE__ */ new Map(), Ne = {}, Ae = J({}, R), Te;
    function ke() {
      !Y || !k || (et(), c(Y, ie, D.style, I.projection));
    }
    function et() {
      a(I, ie, R, b, D);
    }
    function He() {
      z.notifyUpdate(R);
    }
    function Pe(M, S) {
      var F = S.onChange(function(K) {
        R[M] = K, D.onUpdate && Sn.update(He, !1, !0);
      }), G = S.onRenderRequest(I.scheduleRender);
      xe.set(M, function() {
        F(), G();
      });
    }
    var qe = v(D);
    for (var lt in qe) {
      var U = qe[lt];
      R[lt] !== void 0 && Yn(U) && U.set(R[lt], !1);
    }
    var Z = os(D), V = w0(D), I = J(J({
      treeType: t,
      /**
       * This is a mirror of the internal instance prop, which keeps
       * VisualElement type-compatible with React's RefObject.
       */
      current: null,
      /**
       * The depth of this visual element within the visual element tree.
       */
      depth: _ ? _.depth + 1 : 0,
      parent: _,
      children: /* @__PURE__ */ new Set(),
      /**
       *
       */
      presenceId: C,
      shouldReduceMotion: A,
      /**
       * If this component is part of the variant tree, it should track
       * any children that are also part of the tree. This is essentially
       * a shadow tree to simplify logic around how to stagger over children.
       */
      variantChildren: V ? /* @__PURE__ */ new Set() : void 0,
      /**
       * Whether this instance is visible. This can be changed imperatively
       * by the projection tree, is analogous to CSS's visibility in that
       * hidden elements should take up layout, and needs enacting by the configured
       * render function.
       */
      isVisible: void 0,
      /**
       * Normally, if a component is controlled by a parent's variants, it can
       * rely on that ancestor to trigger animations further down the tree.
       * However, if a component is created after its parent is mounted, the parent
       * won't trigger that mount animation so the child needs to.
       *
       * TODO: This might be better replaced with a method isParentMounted
       */
      manuallyAnimateOnMount: !!(_ != null && _.isMounted()),
      /**
       * This can be set by AnimatePresence to force components that mount
       * at the same time as it to mount as if they have initial={false} set.
       */
      blockInitialAnimation: N,
      /**
       * Determine whether this component has mounted yet. This is mostly used
       * by variant children to determine whether they need to trigger their
       * own animations on mount.
       */
      isMounted: function() {
        return !!Y;
      },
      mount: function(M) {
        k = !0, Y = I.current = M, I.projection && I.projection.mount(M), V && _ && !Z && (Te = _ == null ? void 0 : _.addVariantChild(I)), oe.forEach(function(S, F) {
          return Pe(F, S);
        }), _ == null || _.children.add(I), I.setProps(D);
      },
      /**
       *
       */
      unmount: function() {
        var M;
        (M = I.projection) === null || M === void 0 || M.unmount(), ba.update(He), ba.render(ke), xe.forEach(function(S) {
          return S();
        }), Te == null || Te(), _ == null || _.children.delete(I), z.clearAllListeners(), Y = void 0, k = !1;
      },
      /**
       * Add a child visual element to our set of children.
       */
      addVariantChild: function(M) {
        var S, F = I.getClosestVariantNode();
        if (F)
          return (S = F.variantChildren) === null || S === void 0 || S.add(M), function() {
            return F.variantChildren.delete(M);
          };
      },
      sortNodePosition: function(M) {
        return !p || t !== M.treeType ? 0 : p(I.getInstance(), M.getInstance());
      },
      /**
       * Returns the closest variant node in the tree starting from
       * this visual element.
       */
      getClosestVariantNode: function() {
        return V ? I : _ == null ? void 0 : _.getClosestVariantNode();
      },
      /**
       * Expose the latest layoutId prop.
       */
      getLayoutId: function() {
        return D.layoutId;
      },
      /**
       * Returns the current instance.
       */
      getInstance: function() {
        return Y;
      },
      /**
       * Get/set the latest static values.
       */
      getStaticValue: function(M) {
        return R[M];
      },
      setStaticValue: function(M, S) {
        return R[M] = S;
      },
      /**
       * Returns the latest motion value state. Currently only used to take
       * a snapshot of the visual element - perhaps this can return the whole
       * visual state
       */
      getLatestValues: function() {
        return R;
      },
      /**
       * Set the visiblity of the visual element. If it's changed, schedule
       * a render to reflect these changes.
       */
      setVisibility: function(M) {
        I.isVisible !== M && (I.isVisible = M, I.scheduleRender());
      },
      /**
       * Make a target animatable by Popmotion. For instance, if we're
       * trying to animate width from 100px to 100vw we need to measure 100vw
       * in pixels to determine what we really need to animate to. This is also
       * pluggable to support Framer's custom value types like Color,
       * and CSS variables.
       */
      makeTargetAnimatable: function(M, S) {
        return S === void 0 && (S = !0), s(I, M, D, S);
      },
      /**
       * Measure the current viewport box with or without transforms.
       * Only measures axis-aligned boxes, rotate and skew must be manually
       * removed with a re-render to work.
       */
      measureViewportBox: function() {
        return l(Y, D);
      },
      // Motion values ========================
      /**
       * Add a motion value and bind it to this visual element.
       */
      addValue: function(M, S) {
        I.hasValue(M) && I.removeValue(M), oe.set(M, S), R[M] = S.get(), Pe(M, S);
      },
      /**
       * Remove a motion value and unbind any active subscriptions.
       */
      removeValue: function(M) {
        var S;
        oe.delete(M), (S = xe.get(M)) === null || S === void 0 || S(), xe.delete(M), delete R[M], h(M, ie);
      },
      /**
       * Check whether we have a motion value for this key
       */
      hasValue: function(M) {
        return oe.has(M);
      },
      /**
       * Get a motion value for this key. If called with a default
       * value, we'll create one if none exists.
       */
      getValue: function(M, S) {
        var F = oe.get(M);
        return F === void 0 && S !== void 0 && (F = _a(S), I.addValue(M, F)), F;
      },
      /**
       * Iterate over our motion values.
       */
      forEachValue: function(M) {
        return oe.forEach(M);
      },
      /**
       * If we're trying to animate to a previously unencountered value,
       * we need to check for it in our state and as a last resort read it
       * directly from the instance (which might have performance implications).
       */
      readValue: function(M) {
        var S;
        return (S = R[M]) !== null && S !== void 0 ? S : d(Y, M, b);
      },
      /**
       * Set the base target to later animate back to. This is currently
       * only hydrated on creation and when we first read a value.
       */
      setBaseTarget: function(M, S) {
        Ae[M] = S;
      },
      /**
       * Find the base target for a value thats been removed from all animation
       * props.
       */
      getBaseTarget: function(M) {
        if (o) {
          var S = o(D, M);
          if (S !== void 0 && !Yn(S))
            return S;
        }
        return Ae[M];
      }
    }, z), {
      /**
       * Build the renderer state based on the latest visual state.
       */
      build: function() {
        return et(), ie;
      },
      /**
       * Schedule a render on the next animation frame.
       */
      scheduleRender: function() {
        Sn.render(ke, !1, !0);
      },
      /**
       * Synchronously fire render. It's prefered that we batch renders but
       * in many circumstances, like layout measurement, we need to run this
       * synchronously. However in those instances other measures should be taken
       * to batch reads/writes.
       */
      syncRender: ke,
      /**
       * Update the provided props. Ensure any newly-added motion values are
       * added to our map, old ones removed, and listeners updated.
       */
      setProps: function(M) {
        (M.transformTemplate || D.transformTemplate) && I.scheduleRender(), D = M, z.updatePropListeners(M), Ne = W6(I, v(D), Ne);
      },
      getProps: function() {
        return D;
      },
      // Variants ==============================
      /**
       * Returns the variant definition with a given name.
       */
      getVariant: function(M) {
        var S;
        return (S = D.variants) === null || S === void 0 ? void 0 : S[M];
      },
      /**
       * Returns the defined default transition on this component.
       */
      getDefaultTransition: function() {
        return D.transition;
      },
      getTransformPagePoint: function() {
        return D.transformPagePoint;
      },
      /**
       * Used by child variant nodes to get the closest ancestor variant props.
       */
      getVariantContext: function(M) {
        if (M === void 0 && (M = !1), M)
          return _ == null ? void 0 : _.getVariantContext();
        if (!Z) {
          var S = (_ == null ? void 0 : _.getVariantContext()) || {};
          return D.initial !== void 0 && (S.initial = D.initial), S;
        }
        for (var F = {}, G = 0; G < V6; G++) {
          var K = Rm[G], Q = D[K];
          (cn(Q) || Q === !1) && (F[K] = Q);
        }
        return F;
      }
    });
    return I;
  };
}, Rm = xn(["initial"], ht(gc), !1), V6 = Rm.length;
function Nl(e) {
  return typeof e == "string" && e.startsWith("var(--");
}
var Am = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $6(e) {
  var n = Am.exec(e);
  if (!n)
    return [,];
  var t = ht(n, 3), a = t[1], o = t[2];
  return [a, o];
}
var Y6 = 4;
function kl(e, n, t) {
  t === void 0 && (t = 1), tn(t <= Y6, 'Max CSS variable fallback depth detected in property "'.concat(e, '". This may indicate a circular fallback dependency.'));
  var a = ht($6(e), 2), o = a[0], s = a[1];
  if (o) {
    var l = window.getComputedStyle(n).getPropertyValue(o);
    return l ? l.trim() : Nl(s) ? kl(s, n, t + 1) : s;
  }
}
function B6(e, n, t) {
  var a, o = nn(n, []), s = e.getInstance();
  if (!(s instanceof Element))
    return { target: o, transitionEnd: t };
  t && (t = J({}, t)), e.forEachValue(function(h) {
    var p = h.get();
    if (Nl(p)) {
      var v = kl(p, s);
      v && h.set(v);
    }
  });
  for (var l in o) {
    var c = o[l];
    if (Nl(c)) {
      var d = kl(c, s);
      d && (o[l] = d, t && ((a = t[l]) !== null && a !== void 0 || (t[l] = c)));
    }
  }
  return { target: o, transitionEnd: t };
}
var H6 = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), Im = function(e) {
  return H6.has(e);
}, U6 = function(e) {
  return Object.keys(e).some(Im);
}, Lm = function(e, n) {
  e.set(n, !1), e.set(n);
}, xo = function(e) {
  return e === $r || e === pe;
}, vp;
(function(e) {
  e.width = "width", e.height = "height", e.left = "left", e.right = "right", e.top = "top", e.bottom = "bottom";
})(vp || (vp = {}));
var gp = function(e, n) {
  return parseFloat(e.split(", ")[n]);
}, yp = function(e, n) {
  return function(t, a) {
    var o = a.transform;
    if (o === "none" || !o)
      return 0;
    var s = o.match(/^matrix3d\((.+)\)$/);
    if (s)
      return gp(s[1], n);
    var l = o.match(/^matrix\((.+)\)$/);
    return l ? gp(l[1], e) : 0;
  };
}, j6 = /* @__PURE__ */ new Set(["x", "y", "z"]), z6 = ui.filter(function(e) {
  return !j6.has(e);
});
function q6(e) {
  var n = [];
  return z6.forEach(function(t) {
    var a = e.getValue(t);
    a !== void 0 && (n.push([t, a.get()]), a.set(t.startsWith("scale") ? 1 : 0));
  }), n.length && e.syncRender(), n;
}
var wp = {
  // Dimensions
  width: function(e, n) {
    var t = e.x, a = n.paddingLeft, o = a === void 0 ? "0" : a, s = n.paddingRight, l = s === void 0 ? "0" : s;
    return t.max - t.min - parseFloat(o) - parseFloat(l);
  },
  height: function(e, n) {
    var t = e.y, a = n.paddingTop, o = a === void 0 ? "0" : a, s = n.paddingBottom, l = s === void 0 ? "0" : s;
    return t.max - t.min - parseFloat(o) - parseFloat(l);
  },
  top: function(e, n) {
    var t = n.top;
    return parseFloat(t);
  },
  left: function(e, n) {
    var t = n.left;
    return parseFloat(t);
  },
  bottom: function(e, n) {
    var t = e.y, a = n.top;
    return parseFloat(a) + (t.max - t.min);
  },
  right: function(e, n) {
    var t = e.x, a = n.left;
    return parseFloat(a) + (t.max - t.min);
  },
  // Transform
  x: yp(4, 13),
  y: yp(5, 14)
}, G6 = function(e, n, t) {
  var a = n.measureViewportBox(), o = n.getInstance(), s = getComputedStyle(o), l = s.display, c = {};
  l === "none" && n.setStaticValue("display", e.display || "block"), t.forEach(function(h) {
    c[h] = wp[h](a, s);
  }), n.syncRender();
  var d = n.measureViewportBox();
  return t.forEach(function(h) {
    var p = n.getValue(h);
    Lm(p, c[h]), e[h] = wp[h](d, s);
  }), e;
}, K6 = function(e, n, t, a) {
  t === void 0 && (t = {}), a === void 0 && (a = {}), n = J({}, n), a = J({}, a);
  var o = Object.keys(n).filter(Im), s = [], l = !1, c = [];
  if (o.forEach(function(p) {
    var v = e.getValue(p);
    if (e.hasValue(p)) {
      var w = t[p], b = Ua(w), _ = n[p], D;
      if (ci(_)) {
        var C = _.length, N = _[0] === null ? 1 : 0;
        w = _[N], b = Ua(w);
        for (var $ = N; $ < C; $++)
          D ? tn(Ua(_[$]) === D, "All keyframes must be of the same type") : (D = Ua(_[$]), tn(D === b || xo(b) && xo(D), "Keyframes must be of the same dimension as the current value"));
      } else
        D = Ua(_);
      if (b !== D)
        if (xo(b) && xo(D)) {
          var A = v.get();
          typeof A == "string" && v.set(parseFloat(A)), typeof _ == "string" ? n[p] = parseFloat(_) : Array.isArray(_) && D === pe && (n[p] = _.map(parseFloat));
        } else b != null && b.transform && (D != null && D.transform) && (w === 0 || _ === 0) ? w === 0 ? v.set(D.transform(w)) : n[p] = b.transform(_) : (l || (s = q6(e), l = !0), c.push(p), a[p] = a[p] !== void 0 ? a[p] : n[p], Lm(v, _));
    }
  }), c.length) {
    var d = c.indexOf("height") >= 0 ? window.pageYOffset : null, h = G6(n, e, c);
    return s.length && s.forEach(function(p) {
      var v = ht(p, 2), w = v[0], b = v[1];
      e.getValue(w).set(b);
    }), e.syncRender(), d !== null && window.scrollTo({ top: d }), { target: h, transitionEnd: a };
  } else
    return { target: n, transitionEnd: a };
};
function X6(e, n, t, a) {
  return U6(n) ? K6(e, n, t, a) : { target: n, transitionEnd: a };
}
var Z6 = function(e, n, t, a) {
  var o = B6(e, n, a);
  return n = o.target, a = o.transitionEnd, X6(e, n, t, a);
};
function Q6(e) {
  return window.getComputedStyle(e);
}
var Fm = {
  treeType: "dom",
  readValueFromInstance: function(e, n) {
    if (pi(n)) {
      var t = fc(n);
      return t && t.default || 0;
    } else {
      var a = Q6(e);
      return (S0(n) ? a.getPropertyValue(n) : a[n]) || 0;
    }
  },
  sortNodePosition: function(e, n) {
    return e.compareDocumentPosition(n) & 2 ? 1 : -1;
  },
  getBaseTarget: function(e, n) {
    var t;
    return (t = e.style) === null || t === void 0 ? void 0 : t[n];
  },
  measureViewportBox: function(e, n) {
    var t = n.transformPagePoint;
    return Tm(e, t);
  },
  /**
   * Reset the transform on the current Element. This is called as part
   * of a batched process across the entire layout tree. To remove this write
   * cycle it'd be interesting to see if it's possible to "undo" all the current
   * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
   * works
   */
  resetTransform: function(e, n, t) {
    var a = t.transformTemplate;
    n.style.transform = a ? a({}, "") : "none", e.scheduleRender();
  },
  restoreTransform: function(e, n) {
    e.style.transform = n.style.transform;
  },
  removeValueFromRenderState: function(e, n) {
    var t = n.vars, a = n.style;
    delete t[e], delete a[e];
  },
  /**
   * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
   * can be animated by Motion.
   */
  makeTargetAnimatable: function(e, n, t, a) {
    var o = t.transformValues;
    a === void 0 && (a = !0);
    var s = n.transition, l = n.transitionEnd, c = nn(n, ["transition", "transitionEnd"]), d = a6(c, s || {}, e);
    if (o && (l && (l = o(l)), c && (c = o(c)), d && (d = o(d))), a) {
      n6(e, c, d);
      var h = Z6(e, c, d, l);
      l = h.transitionEnd, c = h.target;
    }
    return J({ transition: s, transitionEnd: l }, c);
  },
  scrapeMotionValuesFromProps: nc,
  build: function(e, n, t, a, o) {
    e.isVisible !== void 0 && (n.style.visibility = e.isVisible ? "visible" : "hidden"), Jl(n, t, a, o.transformTemplate);
  },
  render: k0
}, J6 = Em(Fm), e4 = Em(J(J({}, Fm), { getBaseTarget: function(e, n) {
  return e[n];
}, readValueFromInstance: function(e, n) {
  var t;
  return pi(n) ? ((t = fc(n)) === null || t === void 0 ? void 0 : t.default) || 0 : (n = W0.has(n) ? n : N0(n), e.getAttribute(n));
}, scrapeMotionValuesFromProps: $0, build: function(e, n, t, a, o) {
  tc(n, t, a, o.transformTemplate);
}, render: V0 })), t4 = function(e, n) {
  return Zl(e) ? e4(n, { enableHardwareAcceleration: !1 }) : J6(n, { enableHardwareAcceleration: !0 });
};
function bp(e, n) {
  return n.max === n.min ? 0 : e / (n.max - n.min) * 100;
}
var ja = {
  correct: function(e, n) {
    if (!n.target)
      return e;
    if (typeof e == "string")
      if (pe.test(e))
        e = parseFloat(e);
      else
        return e;
    var t = bp(e, n.target.x), a = bp(e, n.target.y);
    return "".concat(t, "% ").concat(a, "%");
  }
}, _p = "_$css", n4 = {
  correct: function(e, n) {
    var t = n.treeScale, a = n.projectionDelta, o = e, s = e.includes("var("), l = [];
    s && (e = e.replace(Am, function(D) {
      return l.push(D), _p;
    }));
    var c = Bn.parse(e);
    if (c.length > 5)
      return o;
    var d = Bn.createTransformer(e), h = typeof c[0] != "number" ? 1 : 0, p = a.x.scale * t.x, v = a.y.scale * t.y;
    c[0 + h] /= p, c[1 + h] /= v;
    var w = nt(p, v, 0.5);
    typeof c[2 + h] == "number" && (c[2 + h] /= w), typeof c[3 + h] == "number" && (c[3 + h] /= w);
    var b = d(c);
    if (s) {
      var _ = 0;
      b = b.replace(_p, function() {
        var D = l[_];
        return _++, D;
      });
    }
    return b;
  }
}, r4 = (
  /** @class */
  function(e) {
    d0(n, e);
    function n() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return n.prototype.componentDidMount = function() {
      var t = this, a = this.props, o = a.visualElement, s = a.layoutGroup, l = a.switchLayoutGroup, c = a.layoutId, d = o.projection;
      T9(i4), d && (s != null && s.group && s.group.add(d), l != null && l.register && c && l.register(d), d.root.didUpdate(), d.addEventListener("animationComplete", function() {
        t.safeToRemove();
      }), d.setOptions(J(J({}, d.options), { onExitComplete: function() {
        return t.safeToRemove();
      } }))), Ja.hasEverUpdated = !0;
    }, n.prototype.getSnapshotBeforeUpdate = function(t) {
      var a = this, o = this.props, s = o.layoutDependency, l = o.visualElement, c = o.drag, d = o.isPresent, h = l.projection;
      return h && (h.isPresent = d, c || t.layoutDependency !== s || s === void 0 ? h.willUpdate() : this.safeToRemove(), t.isPresent !== d && (d ? h.promote() : h.relegate() || Sn.postRender(function() {
        var p;
        !((p = h.getStack()) === null || p === void 0) && p.members.length || a.safeToRemove();
      }))), null;
    }, n.prototype.componentDidUpdate = function() {
      var t = this.props.visualElement.projection;
      t && (t.root.didUpdate(), !t.currentAnimation && t.isLead() && this.safeToRemove());
    }, n.prototype.componentWillUnmount = function() {
      var t = this.props, a = t.visualElement, o = t.layoutGroup, s = t.switchLayoutGroup, l = a.projection;
      l && (l.scheduleCheckAfterUnmount(), o != null && o.group && o.group.remove(l), s != null && s.deregister && s.deregister(l));
    }, n.prototype.safeToRemove = function() {
      var t = this.props.safeToRemove;
      t == null || t();
    }, n.prototype.render = function() {
      return null;
    }, n;
  }(X.Component)
);
function a4(e) {
  var n = ht(wm(), 2), t = n[0], a = n[1], o = Dt(b0);
  return X.createElement(r4, J({}, e, { layoutGroup: o, switchLayoutGroup: Dt(_0), isPresent: t, safeToRemove: a }));
}
var i4 = {
  borderRadius: J(J({}, ja), { applyTo: [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ] }),
  borderTopLeftRadius: ja,
  borderTopRightRadius: ja,
  borderBottomLeftRadius: ja,
  borderBottomRightRadius: ja,
  boxShadow: n4
}, o4 = {
  measureLayout: a4
};
function s4(e, n, t) {
  t === void 0 && (t = {});
  var a = Yn(e) ? e : _a(e);
  return pc("", a, n, t), {
    stop: function() {
      return a.stop();
    },
    isAnimating: function() {
      return a.isAnimating();
    }
  };
}
var Nm = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], u4 = Nm.length, xp = function(e) {
  return typeof e == "string" ? parseFloat(e) : e;
}, Dp = function(e) {
  return typeof e == "number" || pe.test(e);
};
function l4(e, n, t, a, o, s) {
  var l, c, d, h;
  o ? (e.opacity = nt(
    0,
    // (follow?.opacity as number) ?? 0,
    // TODO Reinstate this if only child
    (l = t.opacity) !== null && l !== void 0 ? l : 1,
    c4(a)
  ), e.opacityExit = nt((c = n.opacity) !== null && c !== void 0 ? c : 1, 0, f4(a))) : s && (e.opacity = nt((d = n.opacity) !== null && d !== void 0 ? d : 1, (h = t.opacity) !== null && h !== void 0 ? h : 1, a));
  for (var p = 0; p < u4; p++) {
    var v = "border".concat(Nm[p], "Radius"), w = Sp(n, v), b = Sp(t, v);
    if (!(w === void 0 && b === void 0)) {
      w || (w = 0), b || (b = 0);
      var _ = w === 0 || b === 0 || Dp(w) === Dp(b);
      _ ? (e[v] = Math.max(nt(xp(w), xp(b), a), 0), (Dn.test(b) || Dn.test(w)) && (e[v] += "%")) : e[v] = b;
    }
  }
  (n.rotate || t.rotate) && (e.rotate = nt(n.rotate || 0, t.rotate || 0, a));
}
function Sp(e, n) {
  var t;
  return (t = e[n]) !== null && t !== void 0 ? t : e.borderRadius;
}
var c4 = km(0, 0.5, lc), f4 = km(0.5, 0.95, sc);
function km(e, n, t) {
  return function(a) {
    return a < e ? 0 : a > n ? 1 : t(fi(e, n, a));
  };
}
function Op(e, n) {
  e.min = n.min, e.max = n.max;
}
function un(e, n) {
  Op(e.x, n.x), Op(e.y, n.y);
}
function Mp(e, n, t, a, o) {
  return e -= n, e = Uo(e, 1 / t, a), o !== void 0 && (e = Uo(e, 1 / o, a)), e;
}
function d4(e, n, t, a, o, s, l) {
  if (n === void 0 && (n = 0), t === void 0 && (t = 1), a === void 0 && (a = 0.5), s === void 0 && (s = e), l === void 0 && (l = e), Dn.test(n)) {
    n = parseFloat(n);
    var c = nt(l.min, l.max, n / 100);
    n = c - l.min;
  }
  if (typeof n == "number") {
    var d = nt(s.min, s.max, a);
    e === s && (d -= n), e.min = Mp(e.min, n, t, d, o), e.max = Mp(e.max, n, t, d, o);
  }
}
function Cp(e, n, t, a, o) {
  var s = ht(t, 3), l = s[0], c = s[1], d = s[2];
  d4(e, n[l], n[c], n[d], n.scale, a, o);
}
var h4 = ["x", "scaleX", "originX"], p4 = ["y", "scaleY", "originY"];
function Pp(e, n, t, a) {
  Cp(e.x, n, h4, t == null ? void 0 : t.x, a == null ? void 0 : a.x), Cp(e.y, n, p4, t == null ? void 0 : t.y, a == null ? void 0 : a.y);
}
function Tp(e) {
  return e.translate === 0 && e.scale === 1;
}
function Wm(e) {
  return Tp(e.x) && Tp(e.y);
}
function Vm(e, n) {
  return e.x.min === n.x.min && e.x.max === n.x.max && e.y.min === n.y.min && e.y.max === n.y.max;
}
var m4 = (
  /** @class */
  function() {
    function e() {
      this.members = [];
    }
    return e.prototype.add = function(n) {
      mc(this.members, n), n.scheduleRender();
    }, e.prototype.remove = function(n) {
      if (vc(this.members, n), n === this.prevLead && (this.prevLead = void 0), n === this.lead) {
        var t = this.members[this.members.length - 1];
        t && this.promote(t);
      }
    }, e.prototype.relegate = function(n) {
      var t = this.members.findIndex(function(l) {
        return n === l;
      });
      if (t === 0)
        return !1;
      for (var a, o = t; o >= 0; o--) {
        var s = this.members[o];
        if (s.isPresent !== !1) {
          a = s;
          break;
        }
      }
      return a ? (this.promote(a), !0) : !1;
    }, e.prototype.promote = function(n, t) {
      var a, o = this.lead;
      if (n !== o && (this.prevLead = o, this.lead = n, n.show(), o)) {
        o.instance && o.scheduleRender(), n.scheduleRender(), n.resumeFrom = o, t && (n.resumeFrom.preserveOpacity = !0), o.snapshot && (n.snapshot = o.snapshot, n.snapshot.latestValues = o.animationValues || o.latestValues, n.snapshot.isShared = !0), !((a = n.root) === null || a === void 0) && a.isUpdating && (n.isLayoutDirty = !0);
        var s = n.options.crossfade;
        s === !1 && o.hide();
      }
    }, e.prototype.exitAnimationComplete = function() {
      this.members.forEach(function(n) {
        var t, a, o, s, l;
        (a = (t = n.options).onExitComplete) === null || a === void 0 || a.call(t), (l = (o = n.resumingFrom) === null || o === void 0 ? void 0 : (s = o.options).onExitComplete) === null || l === void 0 || l.call(s);
      });
    }, e.prototype.scheduleRender = function() {
      this.members.forEach(function(n) {
        n.instance && n.scheduleRender(!1);
      });
    }, e.prototype.removeLeadSnapshot = function() {
      this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
    }, e;
  }()
), v4 = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function Ep(e, n, t) {
  var a = e.x.translate / n.x, o = e.y.translate / n.y, s = "translate3d(".concat(a, "px, ").concat(o, "px, 0) ");
  if (s += "scale(".concat(1 / n.x, ", ").concat(1 / n.y, ") "), t) {
    var l = t.rotate, c = t.rotateX, d = t.rotateY;
    l && (s += "rotate(".concat(l, "deg) ")), c && (s += "rotateX(".concat(c, "deg) ")), d && (s += "rotateY(".concat(d, "deg) "));
  }
  var h = e.x.scale * n.x, p = e.y.scale * n.y;
  return s += "scale(".concat(h, ", ").concat(p, ")"), s === v4 ? "none" : s;
}
var g4 = function(e, n) {
  return e.depth - n.depth;
}, y4 = (
  /** @class */
  function() {
    function e() {
      this.children = [], this.isDirty = !1;
    }
    return e.prototype.add = function(n) {
      mc(this.children, n), this.isDirty = !0;
    }, e.prototype.remove = function(n) {
      vc(this.children, n), this.isDirty = !0;
    }, e.prototype.forEach = function(n) {
      this.isDirty && this.children.sort(g4), this.isDirty = !1, this.children.forEach(n);
    }, e;
  }()
), Rp = 1e3;
function $m(e) {
  var n = e.attachResizeListener, t = e.defaultParent, a = e.measureScroll, o = e.checkIsScrollRoot, s = e.resetTransform;
  return (
    /** @class */
    function() {
      function l(c, d, h) {
        var p = this;
        d === void 0 && (d = {}), h === void 0 && (h = t == null ? void 0 : t()), this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.potentialNodes = /* @__PURE__ */ new Map(), this.checkUpdateFailed = function() {
          p.isUpdating && (p.isUpdating = !1, p.clearAllSnapshots());
        }, this.updateProjection = function() {
          p.nodes.forEach(S4), p.nodes.forEach(O4);
        }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.id = c, this.latestValues = d, this.root = h ? h.root || h : this, this.path = h ? xn(xn([], ht(h.path), !1), [h], !1) : [], this.parent = h, this.depth = h ? h.depth + 1 : 0, c && this.root.registerPotentialNode(c, this);
        for (var v = 0; v < this.path.length; v++)
          this.path[v].shouldResetTransform = !0;
        this.root === this && (this.nodes = new y4());
      }
      return l.prototype.addEventListener = function(c, d) {
        return this.eventHandlers.has(c) || this.eventHandlers.set(c, new ni()), this.eventHandlers.get(c).add(d);
      }, l.prototype.notifyListeners = function(c) {
        for (var d = [], h = 1; h < arguments.length; h++)
          d[h - 1] = arguments[h];
        var p = this.eventHandlers.get(c);
        p == null || p.notify.apply(p, xn([], ht(d), !1));
      }, l.prototype.hasListeners = function(c) {
        return this.eventHandlers.has(c);
      }, l.prototype.registerPotentialNode = function(c, d) {
        this.potentialNodes.set(c, d);
      }, l.prototype.mount = function(c, d) {
        var h = this, p;
        if (d === void 0 && (d = !1), !this.instance) {
          this.isSVG = c instanceof SVGElement && c.tagName !== "svg", this.instance = c;
          var v = this.options, w = v.layoutId, b = v.layout, _ = v.visualElement;
          if (_ && !_.getInstance() && _.mount(c), this.root.nodes.add(this), (p = this.parent) === null || p === void 0 || p.children.add(this), this.id && this.root.potentialNodes.delete(this.id), d && (b || w) && (this.isLayoutDirty = !0), n) {
            var D, C = function() {
              return h.root.updateBlockedByResize = !1;
            };
            n(c, function() {
              h.root.updateBlockedByResize = !0, clearTimeout(D), D = window.setTimeout(C, 250), Ja.hasAnimatedSinceResize && (Ja.hasAnimatedSinceResize = !1, h.nodes.forEach(D4));
            });
          }
          w && this.root.registerSharedNode(w, this), this.options.animate !== !1 && _ && (w || b) && this.addEventListener("didUpdate", function(N) {
            var $, A, k, R, ie, Y = N.delta, z = N.hasLayoutChanged, oe = N.hasRelativeTargetChanged, xe = N.layout;
            if (h.isTreeAnimationBlocked()) {
              h.target = void 0, h.relativeTarget = void 0;
              return;
            }
            var Ne = (A = ($ = h.options.transition) !== null && $ !== void 0 ? $ : _.getDefaultTransition()) !== null && A !== void 0 ? A : E4, Ae = _.getProps(), Te = Ae.onLayoutAnimationStart, ke = Ae.onLayoutAnimationComplete, et = !h.targetLayout || !Vm(h.targetLayout, xe) || oe, He = !z && oe;
            if (!((k = h.resumeFrom) === null || k === void 0) && k.instance || He || z && (et || !h.currentAnimation)) {
              h.resumeFrom && (h.resumingFrom = h.resumeFrom, h.resumingFrom.resumingFrom = void 0), h.setAnimationOrigin(Y, He);
              var Pe = J(J({}, hc(Ne, "layout")), { onPlay: Te, onComplete: ke });
              _.shouldReduceMotion && (Pe.delay = 0, Pe.type = !1), h.startAnimation(Pe);
            } else
              !z && h.animationProgress === 0 && h.finishAnimation(), h.isLead() && ((ie = (R = h.options).onExitComplete) === null || ie === void 0 || ie.call(R));
            h.targetLayout = xe;
          });
        }
      }, l.prototype.unmount = function() {
        var c, d;
        this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this), (c = this.getStack()) === null || c === void 0 || c.remove(this), (d = this.parent) === null || d === void 0 || d.children.delete(this), this.instance = void 0, ba.preRender(this.updateProjection);
      }, l.prototype.blockUpdate = function() {
        this.updateManuallyBlocked = !0;
      }, l.prototype.unblockUpdate = function() {
        this.updateManuallyBlocked = !1;
      }, l.prototype.isUpdateBlocked = function() {
        return this.updateManuallyBlocked || this.updateBlockedByResize;
      }, l.prototype.isTreeAnimationBlocked = function() {
        var c;
        return this.isAnimationBlocked || ((c = this.parent) === null || c === void 0 ? void 0 : c.isTreeAnimationBlocked()) || !1;
      }, l.prototype.startUpdate = function() {
        var c;
        this.isUpdateBlocked() || (this.isUpdating = !0, (c = this.nodes) === null || c === void 0 || c.forEach(M4));
      }, l.prototype.willUpdate = function(c) {
        var d, h, p;
        if (c === void 0 && (c = !0), this.root.isUpdateBlocked()) {
          (h = (d = this.options).onExitComplete) === null || h === void 0 || h.call(d);
          return;
        }
        if (!this.root.isUpdating && this.root.startUpdate(), !this.isLayoutDirty) {
          this.isLayoutDirty = !0;
          for (var v = 0; v < this.path.length; v++) {
            var w = this.path[v];
            w.shouldResetTransform = !0, w.updateScroll();
          }
          var b = this.options, _ = b.layoutId, D = b.layout;
          if (!(_ === void 0 && !D)) {
            var C = (p = this.options.visualElement) === null || p === void 0 ? void 0 : p.getProps().transformTemplate;
            this.prevTransformTemplateValue = C == null ? void 0 : C(this.latestValues, ""), this.updateSnapshot(), c && this.notifyListeners("willUpdate");
          }
        }
      }, l.prototype.didUpdate = function() {
        var c = this.isUpdateBlocked();
        if (c) {
          this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Ap);
          return;
        }
        this.isUpdating && (this.isUpdating = !1, this.potentialNodes.size && (this.potentialNodes.forEach(R4), this.potentialNodes.clear()), this.nodes.forEach(x4), this.nodes.forEach(w4), this.nodes.forEach(b4), this.clearAllSnapshots(), Ju.update(), Ju.preRender(), Ju.render());
      }, l.prototype.clearAllSnapshots = function() {
        this.nodes.forEach(_4), this.sharedNodes.forEach(C4);
      }, l.prototype.scheduleUpdateProjection = function() {
        Sn.preRender(this.updateProjection, !1, !0);
      }, l.prototype.scheduleCheckAfterUnmount = function() {
        var c = this;
        Sn.postRender(function() {
          c.isLayoutDirty ? c.root.didUpdate() : c.root.checkUpdateFailed();
        });
      }, l.prototype.updateSnapshot = function() {
        if (!(this.snapshot || !this.instance)) {
          var c = this.measure(), d = this.removeTransform(this.removeElementScroll(c));
          Np(d), this.snapshot = {
            measured: c,
            layout: d,
            latestValues: {}
          };
        }
      }, l.prototype.updateLayout = function() {
        var c;
        if (this.instance && (this.updateScroll(), !(!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))) {
          if (this.resumeFrom && !this.resumeFrom.instance)
            for (var d = 0; d < this.path.length; d++) {
              var h = this.path[d];
              h.updateScroll();
            }
          var p = this.measure();
          Np(p);
          var v = this.layout;
          this.layout = {
            measured: p,
            actual: this.removeElementScroll(p)
          }, this.layoutCorrected = xt(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.actual), (c = this.options.visualElement) === null || c === void 0 || c.notifyLayoutMeasure(this.layout.actual, v == null ? void 0 : v.actual);
        }
      }, l.prototype.updateScroll = function() {
        this.options.layoutScroll && this.instance && (this.isScrollRoot = o(this.instance), this.scroll = a(this.instance));
      }, l.prototype.resetTransform = function() {
        var c;
        if (s) {
          var d = this.isLayoutDirty || this.shouldResetTransform, h = this.projectionDelta && !Wm(this.projectionDelta), p = (c = this.options.visualElement) === null || c === void 0 ? void 0 : c.getProps().transformTemplate, v = p == null ? void 0 : p(this.latestValues, ""), w = v !== this.prevTransformTemplateValue;
          d && (h || sr(this.latestValues) || w) && (s(this.instance, v), this.shouldResetTransform = !1, this.scheduleRender());
        }
      }, l.prototype.measure = function() {
        var c = this.options.visualElement;
        if (!c)
          return xt();
        var d = c.measureViewportBox(), h = this.root.scroll;
        return h && (lr(d.x, h.x), lr(d.y, h.y)), d;
      }, l.prototype.removeElementScroll = function(c) {
        var d = xt();
        un(d, c);
        for (var h = 0; h < this.path.length; h++) {
          var p = this.path[h], v = p.scroll, w = p.options, b = p.isScrollRoot;
          if (p !== this.root && v && w.layoutScroll) {
            if (b) {
              un(d, c);
              var _ = this.root.scroll;
              _ && (lr(d.x, -_.x), lr(d.y, -_.y));
            }
            lr(d.x, v.x), lr(d.y, v.y);
          }
        }
        return d;
      }, l.prototype.applyTransform = function(c, d) {
        d === void 0 && (d = !1);
        var h = xt();
        un(h, c);
        for (var p = 0; p < this.path.length; p++) {
          var v = this.path[p];
          !d && v.options.layoutScroll && v.scroll && v !== v.root && pa(h, {
            x: -v.scroll.x,
            y: -v.scroll.y
          }), sr(v.latestValues) && pa(h, v.latestValues);
        }
        return sr(this.latestValues) && pa(h, this.latestValues), h;
      }, l.prototype.removeTransform = function(c) {
        var d, h = xt();
        un(h, c);
        for (var p = 0; p < this.path.length; p++) {
          var v = this.path[p];
          if (v.instance && sr(v.latestValues)) {
            Cm(v.latestValues) && v.updateSnapshot();
            var w = xt(), b = v.measure();
            un(w, b), Pp(h, v.latestValues, (d = v.snapshot) === null || d === void 0 ? void 0 : d.layout, w);
          }
        }
        return sr(this.latestValues) && Pp(h, this.latestValues), h;
      }, l.prototype.setTargetDelta = function(c) {
        this.targetDelta = c, this.root.scheduleUpdateProjection();
      }, l.prototype.setOptions = function(c) {
        var d;
        this.options = J(J(J({}, this.options), c), { crossfade: (d = c.crossfade) !== null && d !== void 0 ? d : !0 });
      }, l.prototype.clearMeasurements = function() {
        this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
      }, l.prototype.resolveTargetDelta = function() {
        var c, d = this.options, h = d.layout, p = d.layoutId;
        !this.layout || !(h || p) || (!this.targetDelta && !this.relativeTarget && (this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && this.relativeParent.layout && (this.relativeTarget = xt(), this.relativeTargetOrigin = xt(), ai(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual), un(this.relativeTarget, this.relativeTargetOrigin))), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = xt(), this.targetWithTransforms = xt()), this.relativeTarget && this.relativeTargetOrigin && (!((c = this.relativeParent) === null || c === void 0) && c.target) ? y6(this.target, this.relativeTarget, this.relativeParent.target) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.actual) : un(this.target, this.layout.actual), Pm(this.target, this.targetDelta)) : un(this.target, this.layout.actual), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && !!this.relativeParent.resumingFrom == !!this.resumingFrom && !this.relativeParent.options.layoutScroll && this.relativeParent.target && (this.relativeTarget = xt(), this.relativeTargetOrigin = xt(), ai(this.relativeTargetOrigin, this.target, this.relativeParent.target), un(this.relativeTarget, this.relativeTargetOrigin)))));
      }, l.prototype.getClosestProjectingParent = function() {
        if (!(!this.parent || sr(this.parent.latestValues)))
          return (this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout ? this.parent : this.parent.getClosestProjectingParent();
      }, l.prototype.calcProjection = function() {
        var c, d = this.options, h = d.layout, p = d.layoutId;
        if (this.isTreeAnimating = !!(!((c = this.parent) === null || c === void 0) && c.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !(!this.layout || !(h || p))) {
          var v = this.getLead();
          un(this.layoutCorrected, this.layout.actual), C6(this.layoutCorrected, this.treeScale, this.path, !!this.resumingFrom || this !== v);
          var w = v.target;
          if (w) {
            this.projectionDelta || (this.projectionDelta = ii(), this.projectionDeltaWithTransform = ii());
            var b = this.treeScale.x, _ = this.treeScale.y, D = this.projectionTransform;
            ri(this.projectionDelta, this.layoutCorrected, w, this.latestValues), this.projectionTransform = Ep(this.projectionDelta, this.treeScale), (this.projectionTransform !== D || this.treeScale.x !== b || this.treeScale.y !== _) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", w));
          }
        }
      }, l.prototype.hide = function() {
        this.isVisible = !1;
      }, l.prototype.show = function() {
        this.isVisible = !0;
      }, l.prototype.scheduleRender = function(c) {
        var d, h, p;
        c === void 0 && (c = !0), (h = (d = this.options).scheduleRender) === null || h === void 0 || h.call(d), c && ((p = this.getStack()) === null || p === void 0 || p.scheduleRender()), this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
      }, l.prototype.setAnimationOrigin = function(c, d) {
        var h = this, p;
        d === void 0 && (d = !1);
        var v = this.snapshot, w = (v == null ? void 0 : v.latestValues) || {}, b = J({}, this.latestValues), _ = ii();
        this.relativeTarget = this.relativeTargetOrigin = void 0, this.attemptToResolveRelativeTarget = !d;
        var D = xt(), C = v == null ? void 0 : v.isShared, N = (((p = this.getStack()) === null || p === void 0 ? void 0 : p.members.length) || 0) <= 1, $ = !!(C && !N && this.options.crossfade === !0 && !this.path.some(T4));
        this.animationProgress = 0, this.mixTargetDelta = function(A) {
          var k, R = A / 1e3;
          Ip(_.x, c.x, R), Ip(_.y, c.y, R), h.setTargetDelta(_), h.relativeTarget && h.relativeTargetOrigin && h.layout && (!((k = h.relativeParent) === null || k === void 0) && k.layout) && (ai(D, h.layout.actual, h.relativeParent.layout.actual), P4(h.relativeTarget, h.relativeTargetOrigin, D, R)), C && (h.animationValues = b, l4(b, w, h.latestValues, R, $, N)), h.root.scheduleUpdateProjection(), h.scheduleRender(), h.animationProgress = R;
        }, this.mixTargetDelta(0);
      }, l.prototype.startAnimation = function(c) {
        var d = this, h, p;
        this.notifyListeners("animationStart"), (h = this.currentAnimation) === null || h === void 0 || h.stop(), this.resumingFrom && ((p = this.resumingFrom.currentAnimation) === null || p === void 0 || p.stop()), this.pendingAnimation && (ba.update(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Sn.update(function() {
          Ja.hasAnimatedSinceResize = !0, d.currentAnimation = s4(0, Rp, J(J({}, c), { onUpdate: function(v) {
            var w;
            d.mixTargetDelta(v), (w = c.onUpdate) === null || w === void 0 || w.call(c, v);
          }, onComplete: function() {
            var v;
            (v = c.onComplete) === null || v === void 0 || v.call(c), d.completeAnimation();
          } })), d.resumingFrom && (d.resumingFrom.currentAnimation = d.currentAnimation), d.pendingAnimation = void 0;
        });
      }, l.prototype.completeAnimation = function() {
        var c;
        this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0), (c = this.getStack()) === null || c === void 0 || c.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
      }, l.prototype.finishAnimation = function() {
        var c;
        this.currentAnimation && ((c = this.mixTargetDelta) === null || c === void 0 || c.call(this, Rp), this.currentAnimation.stop()), this.completeAnimation();
      }, l.prototype.applyTransformsToTarget = function() {
        var c = this.getLead(), d = c.targetWithTransforms, h = c.target, p = c.layout, v = c.latestValues;
        !d || !h || !p || (un(d, h), pa(d, v), ri(this.projectionDeltaWithTransform, this.layoutCorrected, d, v));
      }, l.prototype.registerSharedNode = function(c, d) {
        var h, p, v;
        this.sharedNodes.has(c) || this.sharedNodes.set(c, new m4());
        var w = this.sharedNodes.get(c);
        w.add(d), d.promote({
          transition: (h = d.options.initialPromotionConfig) === null || h === void 0 ? void 0 : h.transition,
          preserveFollowOpacity: (v = (p = d.options.initialPromotionConfig) === null || p === void 0 ? void 0 : p.shouldPreserveFollowOpacity) === null || v === void 0 ? void 0 : v.call(p, d)
        });
      }, l.prototype.isLead = function() {
        var c = this.getStack();
        return c ? c.lead === this : !0;
      }, l.prototype.getLead = function() {
        var c, d = this.options.layoutId;
        return d ? ((c = this.getStack()) === null || c === void 0 ? void 0 : c.lead) || this : this;
      }, l.prototype.getPrevLead = function() {
        var c, d = this.options.layoutId;
        return d ? (c = this.getStack()) === null || c === void 0 ? void 0 : c.prevLead : void 0;
      }, l.prototype.getStack = function() {
        var c = this.options.layoutId;
        if (c)
          return this.root.sharedNodes.get(c);
      }, l.prototype.promote = function(c) {
        var d = c === void 0 ? {} : c, h = d.needsReset, p = d.transition, v = d.preserveFollowOpacity, w = this.getStack();
        w && w.promote(this, v), h && (this.projectionDelta = void 0, this.needsReset = !0), p && this.setOptions({ transition: p });
      }, l.prototype.relegate = function() {
        var c = this.getStack();
        return c ? c.relegate(this) : !1;
      }, l.prototype.resetRotation = function() {
        var c = this.options.visualElement;
        if (c) {
          for (var d = !1, h = {}, p = 0; p < xl.length; p++) {
            var v = xl[p], w = "rotate" + v;
            c.getStaticValue(w) && (d = !0, h[w] = c.getStaticValue(w), c.setStaticValue(w, 0));
          }
          if (d) {
            c == null || c.syncRender();
            for (var w in h)
              c.setStaticValue(w, h[w]);
            c.scheduleRender();
          }
        }
      }, l.prototype.getProjectionStyles = function(c) {
        var d, h, p, v, w, b;
        c === void 0 && (c = {});
        var _ = {};
        if (!this.instance || this.isSVG)
          return _;
        if (this.isVisible)
          _.visibility = "";
        else
          return { visibility: "hidden" };
        var D = (d = this.options.visualElement) === null || d === void 0 ? void 0 : d.getProps().transformTemplate;
        if (this.needsReset)
          return this.needsReset = !1, _.opacity = "", _.pointerEvents = Eo(c.pointerEvents) || "", _.transform = D ? D(this.latestValues, "") : "none", _;
        var C = this.getLead();
        if (!this.projectionDelta || !this.layout || !C.target) {
          var N = {};
          return this.options.layoutId && (N.opacity = (h = this.latestValues.opacity) !== null && h !== void 0 ? h : 1, N.pointerEvents = Eo(c.pointerEvents) || ""), this.hasProjected && !sr(this.latestValues) && (N.transform = D ? D({}, "") : "none", this.hasProjected = !1), N;
        }
        var $ = C.animationValues || C.latestValues;
        this.applyTransformsToTarget(), _.transform = Ep(this.projectionDeltaWithTransform, this.treeScale, $), D && (_.transform = D($, _.transform));
        var A = this.projectionDelta, k = A.x, R = A.y;
        _.transformOrigin = "".concat(k.origin * 100, "% ").concat(R.origin * 100, "% 0"), C.animationValues ? _.opacity = C === this ? (v = (p = $.opacity) !== null && p !== void 0 ? p : this.latestValues.opacity) !== null && v !== void 0 ? v : 1 : this.preserveOpacity ? this.latestValues.opacity : $.opacityExit : _.opacity = C === this ? (w = $.opacity) !== null && w !== void 0 ? w : "" : (b = $.opacityExit) !== null && b !== void 0 ? b : 0;
        for (var ie in No)
          if ($[ie] !== void 0) {
            var Y = No[ie], z = Y.correct, oe = Y.applyTo, xe = z($[ie], C);
            if (oe)
              for (var Ne = oe.length, Ae = 0; Ae < Ne; Ae++)
                _[oe[Ae]] = xe;
            else
              _[ie] = xe;
          }
        return this.options.layoutId && (_.pointerEvents = C === this ? Eo(c.pointerEvents) || "" : "none"), _;
      }, l.prototype.clearSnapshot = function() {
        this.resumeFrom = this.snapshot = void 0;
      }, l.prototype.resetTree = function() {
        this.root.nodes.forEach(function(c) {
          var d;
          return (d = c.currentAnimation) === null || d === void 0 ? void 0 : d.stop();
        }), this.root.nodes.forEach(Ap), this.root.sharedNodes.clear();
      }, l;
    }()
  );
}
function w4(e) {
  e.updateLayout();
}
function b4(e) {
  var n, t, a, o, s = (t = (n = e.resumeFrom) === null || n === void 0 ? void 0 : n.snapshot) !== null && t !== void 0 ? t : e.snapshot;
  if (e.isLead() && e.layout && s && e.hasListeners("didUpdate")) {
    var l = e.layout, c = l.actual, d = l.measured;
    e.options.animationType === "size" ? yn(function($) {
      var A = s.isShared ? s.measured[$] : s.layout[$], k = Hn(A);
      A.min = c[$].min, A.max = A.min + k;
    }) : e.options.animationType === "position" && yn(function($) {
      var A = s.isShared ? s.measured[$] : s.layout[$], k = Hn(c[$]);
      A.max = A.min + k;
    });
    var h = ii();
    ri(h, c, s.layout);
    var p = ii();
    s.isShared ? ri(p, e.applyTransform(d, !0), s.measured) : ri(p, c, s.layout);
    var v = !Wm(h), w = !1;
    if (!e.resumeFrom && (e.relativeParent = e.getClosestProjectingParent(), e.relativeParent && !e.relativeParent.resumeFrom)) {
      var b = e.relativeParent, _ = b.snapshot, D = b.layout;
      if (_ && D) {
        var C = xt();
        ai(C, s.layout, _.layout);
        var N = xt();
        ai(N, c, D.actual), Vm(C, N) || (w = !0);
      }
    }
    e.notifyListeners("didUpdate", {
      layout: c,
      snapshot: s,
      delta: p,
      layoutDelta: h,
      hasLayoutChanged: v,
      hasRelativeTargetChanged: w
    });
  } else e.isLead() && ((o = (a = e.options).onExitComplete) === null || o === void 0 || o.call(a));
  e.options.transition = void 0;
}
function _4(e) {
  e.clearSnapshot();
}
function Ap(e) {
  e.clearMeasurements();
}
function x4(e) {
  var n = e.options.visualElement;
  n != null && n.getProps().onBeforeLayoutMeasure && n.notifyBeforeLayoutMeasure(), e.resetTransform();
}
function D4(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0;
}
function S4(e) {
  e.resolveTargetDelta();
}
function O4(e) {
  e.calcProjection();
}
function M4(e) {
  e.resetRotation();
}
function C4(e) {
  e.removeLeadSnapshot();
}
function Ip(e, n, t) {
  e.translate = nt(n.translate, 0, t), e.scale = nt(n.scale, 1, t), e.origin = n.origin, e.originPoint = n.originPoint;
}
function Lp(e, n, t, a) {
  e.min = nt(n.min, t.min, a), e.max = nt(n.max, t.max, a);
}
function P4(e, n, t, a) {
  Lp(e.x, n.x, t.x, a), Lp(e.y, n.y, t.y, a);
}
function T4(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
var E4 = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function R4(e, n) {
  for (var t = e.root, a = e.path.length - 1; a >= 0; a--)
    if (e.path[a].instance) {
      t = e.path[a];
      break;
    }
  var o = t && t !== e.root ? t.instance : document, s = o.querySelector('[data-projection-id="'.concat(n, '"]'));
  s && e.mount(s, !0);
}
function Fp(e) {
  e.min = Math.round(e.min), e.max = Math.round(e.max);
}
function Np(e) {
  Fp(e.x), Fp(e.y);
}
var A4 = $m({
  attachResizeListener: function(e, n) {
    return us(e, "resize", n);
  },
  measureScroll: function() {
    return {
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop
    };
  },
  checkIsScrollRoot: function() {
    return !0;
  }
}), il = {
  current: void 0
}, I4 = $m({
  measureScroll: function(e) {
    return {
      x: e.scrollLeft,
      y: e.scrollTop
    };
  },
  defaultParent: function() {
    if (!il.current) {
      var e = new A4(0, {});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), il.current = e;
    }
    return il.current;
  },
  resetTransform: function(e, n) {
    e.style.transform = n ?? "none";
  },
  checkIsScrollRoot: function(e) {
    return window.getComputedStyle(e).position === "fixed";
  }
}), L4 = J(J(J(J({}, m6), ID), N6), o4), Ym = /* @__PURE__ */ C9(function(e, n) {
  return dx(e, n, L4, t4, I4);
}), F4 = {}, yi = {}, Wl = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ol, kp;
function N4() {
  if (kp) return ol;
  kp = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function a(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var l = {}, c = 0; c < 10; c++)
        l["_" + String.fromCharCode(c)] = c;
      var d = Object.getOwnPropertyNames(l).map(function(p) {
        return l[p];
      });
      if (d.join("") !== "0123456789")
        return !1;
      var h = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(p) {
        h[p] = p;
      }), Object.keys(Object.assign({}, h)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ol = o() ? Object.assign : function(s, l) {
    for (var c, d = a(s), h, p = 1; p < arguments.length; p++) {
      c = Object(arguments[p]);
      for (var v in c)
        n.call(c, v) && (d[v] = c[v]);
      if (e) {
        h = e(c);
        for (var w = 0; w < h.length; w++)
          t.call(c, h[w]) && (d[h[w]] = c[h[w]]);
      }
    }
    return d;
  }, ol;
}
var sl, Wp;
function yc() {
  if (Wp) return sl;
  Wp = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return sl = e, sl;
}
var ul, Vp;
function Bm() {
  return Vp || (Vp = 1, ul = Function.call.bind(Object.prototype.hasOwnProperty)), ul;
}
var ll, $p;
function k4() {
  if ($p) return ll;
  $p = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var n = yc(), t = {}, a = Bm();
    e = function(s) {
      var l = "Warning: " + s;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function o(s, l, c, d, h) {
    if (process.env.NODE_ENV !== "production") {
      for (var p in s)
        if (a(s, p)) {
          var v;
          try {
            if (typeof s[p] != "function") {
              var w = Error(
                (d || "React class") + ": " + c + " type `" + p + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[p] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw w.name = "Invariant Violation", w;
            }
            v = s[p](l, p, d, c, null, n);
          } catch (_) {
            v = _;
          }
          if (v && !(v instanceof Error) && e(
            (d || "React class") + ": type specification of " + c + " `" + p + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof v + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), v instanceof Error && !(v.message in t)) {
            t[v.message] = !0;
            var b = h ? h() : "";
            e(
              "Failed " + c + " type: " + v.message + (b ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, ll = o, ll;
}
var cl, Yp;
function W4() {
  if (Yp) return cl;
  Yp = 1;
  var e = f0, n = N4(), t = yc(), a = Bm(), o = k4(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(c) {
    var d = "Warning: " + c;
    typeof console < "u" && console.error(d);
    try {
      throw new Error(d);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return cl = function(c, d) {
    var h = typeof Symbol == "function" && Symbol.iterator, p = "@@iterator";
    function v(U) {
      var Z = U && (h && U[h] || U[p]);
      if (typeof Z == "function")
        return Z;
    }
    var w = "<<anonymous>>", b = {
      array: N("array"),
      bigint: N("bigint"),
      bool: N("boolean"),
      func: N("function"),
      number: N("number"),
      object: N("object"),
      string: N("string"),
      symbol: N("symbol"),
      any: $(),
      arrayOf: A,
      element: k(),
      elementType: R(),
      instanceOf: ie,
      node: xe(),
      objectOf: z,
      oneOf: Y,
      oneOfType: oe,
      shape: Ae,
      exact: Te
    };
    function _(U, Z) {
      return U === Z ? U !== 0 || 1 / U === 1 / Z : U !== U && Z !== Z;
    }
    function D(U, Z) {
      this.message = U, this.data = Z && typeof Z == "object" ? Z : {}, this.stack = "";
    }
    D.prototype = Error.prototype;
    function C(U) {
      if (process.env.NODE_ENV !== "production")
        var Z = {}, V = 0;
      function I(S, F, G, K, Q, te, ce) {
        if (K = K || w, te = te || G, ce !== t) {
          if (d) {
            var j = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw j.name = "Invariant Violation", j;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var me = K + ":" + G;
            !Z[me] && // Avoid spamming the console because they are often not actionable except for lib authors
            V < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + te + "` prop on `" + K + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Z[me] = !0, V++);
          }
        }
        return F[G] == null ? S ? F[G] === null ? new D("The " + Q + " `" + te + "` is marked as required " + ("in `" + K + "`, but its value is `null`.")) : new D("The " + Q + " `" + te + "` is marked as required in " + ("`" + K + "`, but its value is `undefined`.")) : null : U(F, G, K, Q, te);
      }
      var M = I.bind(null, !1);
      return M.isRequired = I.bind(null, !0), M;
    }
    function N(U) {
      function Z(V, I, M, S, F, G) {
        var K = V[I], Q = He(K);
        if (Q !== U) {
          var te = Pe(K);
          return new D(
            "Invalid " + S + " `" + F + "` of type " + ("`" + te + "` supplied to `" + M + "`, expected ") + ("`" + U + "`."),
            { expectedType: U }
          );
        }
        return null;
      }
      return C(Z);
    }
    function $() {
      return C(l);
    }
    function A(U) {
      function Z(V, I, M, S, F) {
        if (typeof U != "function")
          return new D("Property `" + F + "` of component `" + M + "` has invalid PropType notation inside arrayOf.");
        var G = V[I];
        if (!Array.isArray(G)) {
          var K = He(G);
          return new D("Invalid " + S + " `" + F + "` of type " + ("`" + K + "` supplied to `" + M + "`, expected an array."));
        }
        for (var Q = 0; Q < G.length; Q++) {
          var te = U(G, Q, M, S, F + "[" + Q + "]", t);
          if (te instanceof Error)
            return te;
        }
        return null;
      }
      return C(Z);
    }
    function k() {
      function U(Z, V, I, M, S) {
        var F = Z[V];
        if (!c(F)) {
          var G = He(F);
          return new D("Invalid " + M + " `" + S + "` of type " + ("`" + G + "` supplied to `" + I + "`, expected a single ReactElement."));
        }
        return null;
      }
      return C(U);
    }
    function R() {
      function U(Z, V, I, M, S) {
        var F = Z[V];
        if (!e.isValidElementType(F)) {
          var G = He(F);
          return new D("Invalid " + M + " `" + S + "` of type " + ("`" + G + "` supplied to `" + I + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return C(U);
    }
    function ie(U) {
      function Z(V, I, M, S, F) {
        if (!(V[I] instanceof U)) {
          var G = U.name || w, K = lt(V[I]);
          return new D("Invalid " + S + " `" + F + "` of type " + ("`" + K + "` supplied to `" + M + "`, expected ") + ("instance of `" + G + "`."));
        }
        return null;
      }
      return C(Z);
    }
    function Y(U) {
      if (!Array.isArray(U))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), l;
      function Z(V, I, M, S, F) {
        for (var G = V[I], K = 0; K < U.length; K++)
          if (_(G, U[K]))
            return null;
        var Q = JSON.stringify(U, function(ce, j) {
          var me = Pe(j);
          return me === "symbol" ? String(j) : j;
        });
        return new D("Invalid " + S + " `" + F + "` of value `" + String(G) + "` " + ("supplied to `" + M + "`, expected one of " + Q + "."));
      }
      return C(Z);
    }
    function z(U) {
      function Z(V, I, M, S, F) {
        if (typeof U != "function")
          return new D("Property `" + F + "` of component `" + M + "` has invalid PropType notation inside objectOf.");
        var G = V[I], K = He(G);
        if (K !== "object")
          return new D("Invalid " + S + " `" + F + "` of type " + ("`" + K + "` supplied to `" + M + "`, expected an object."));
        for (var Q in G)
          if (a(G, Q)) {
            var te = U(G, Q, M, S, F + "." + Q, t);
            if (te instanceof Error)
              return te;
          }
        return null;
      }
      return C(Z);
    }
    function oe(U) {
      if (!Array.isArray(U))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var Z = 0; Z < U.length; Z++) {
        var V = U[Z];
        if (typeof V != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + qe(V) + " at index " + Z + "."
          ), l;
      }
      function I(M, S, F, G, K) {
        for (var Q = [], te = 0; te < U.length; te++) {
          var ce = U[te], j = ce(M, S, F, G, K, t);
          if (j == null)
            return null;
          j.data && a(j.data, "expectedType") && Q.push(j.data.expectedType);
        }
        var me = Q.length > 0 ? ", expected one of type [" + Q.join(", ") + "]" : "";
        return new D("Invalid " + G + " `" + K + "` supplied to " + ("`" + F + "`" + me + "."));
      }
      return C(I);
    }
    function xe() {
      function U(Z, V, I, M, S) {
        return ke(Z[V]) ? null : new D("Invalid " + M + " `" + S + "` supplied to " + ("`" + I + "`, expected a ReactNode."));
      }
      return C(U);
    }
    function Ne(U, Z, V, I, M) {
      return new D(
        (U || "React class") + ": " + Z + " type `" + V + "." + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + M + "`."
      );
    }
    function Ae(U) {
      function Z(V, I, M, S, F) {
        var G = V[I], K = He(G);
        if (K !== "object")
          return new D("Invalid " + S + " `" + F + "` of type `" + K + "` " + ("supplied to `" + M + "`, expected `object`."));
        for (var Q in U) {
          var te = U[Q];
          if (typeof te != "function")
            return Ne(M, S, F, Q, Pe(te));
          var ce = te(G, Q, M, S, F + "." + Q, t);
          if (ce)
            return ce;
        }
        return null;
      }
      return C(Z);
    }
    function Te(U) {
      function Z(V, I, M, S, F) {
        var G = V[I], K = He(G);
        if (K !== "object")
          return new D("Invalid " + S + " `" + F + "` of type `" + K + "` " + ("supplied to `" + M + "`, expected `object`."));
        var Q = n({}, V[I], U);
        for (var te in Q) {
          var ce = U[te];
          if (a(U, te) && typeof ce != "function")
            return Ne(M, S, F, te, Pe(ce));
          if (!ce)
            return new D(
              "Invalid " + S + " `" + F + "` key `" + te + "` supplied to `" + M + "`.\nBad object: " + JSON.stringify(V[I], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(U), null, "  ")
            );
          var j = ce(G, te, M, S, F + "." + te, t);
          if (j)
            return j;
        }
        return null;
      }
      return C(Z);
    }
    function ke(U) {
      switch (typeof U) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !U;
        case "object":
          if (Array.isArray(U))
            return U.every(ke);
          if (U === null || c(U))
            return !0;
          var Z = v(U);
          if (Z) {
            var V = Z.call(U), I;
            if (Z !== U.entries) {
              for (; !(I = V.next()).done; )
                if (!ke(I.value))
                  return !1;
            } else
              for (; !(I = V.next()).done; ) {
                var M = I.value;
                if (M && !ke(M[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function et(U, Z) {
      return U === "symbol" ? !0 : Z ? Z["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Z instanceof Symbol : !1;
    }
    function He(U) {
      var Z = typeof U;
      return Array.isArray(U) ? "array" : U instanceof RegExp ? "object" : et(Z, U) ? "symbol" : Z;
    }
    function Pe(U) {
      if (typeof U > "u" || U === null)
        return "" + U;
      var Z = He(U);
      if (Z === "object") {
        if (U instanceof Date)
          return "date";
        if (U instanceof RegExp)
          return "regexp";
      }
      return Z;
    }
    function qe(U) {
      var Z = Pe(U);
      switch (Z) {
        case "array":
        case "object":
          return "an " + Z;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Z;
        default:
          return Z;
      }
    }
    function lt(U) {
      return !U.constructor || !U.constructor.name ? w : U.constructor.name;
    }
    return b.checkPropTypes = o, b.resetWarningCache = o.resetWarningCache, b.PropTypes = b, b;
  }, cl;
}
var fl, Bp;
function V4() {
  if (Bp) return fl;
  Bp = 1;
  var e = yc();
  function n() {
  }
  function t() {
  }
  return t.resetWarningCache = n, fl = function() {
    function a(l, c, d, h, p, v) {
      if (v !== e) {
        var w = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw w.name = "Invariant Violation", w;
      }
    }
    a.isRequired = a;
    function o() {
      return a;
    }
    var s = {
      array: a,
      bigint: a,
      bool: a,
      func: a,
      number: a,
      object: a,
      string: a,
      symbol: a,
      any: a,
      arrayOf: o,
      element: a,
      elementType: a,
      instanceOf: o,
      node: a,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: t,
      resetWarningCache: n
    };
    return s.PropTypes = s, s;
  }, fl;
}
if (process.env.NODE_ENV !== "production") {
  var $4 = f0, Y4 = !0;
  Wl.exports = W4()($4.isElement, Y4);
} else
  Wl.exports = V4()();
var qn = Wl.exports, wi = {}, Un = {}, Hm = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var n = {}.hasOwnProperty;
    function t() {
      for (var s = "", l = 0; l < arguments.length; l++) {
        var c = arguments[l];
        c && (s = o(s, a(c)));
      }
      return s;
    }
    function a(s) {
      if (typeof s == "string" || typeof s == "number")
        return s;
      if (typeof s != "object")
        return "";
      if (Array.isArray(s))
        return t.apply(null, s);
      if (s.toString !== Object.prototype.toString && !s.toString.toString().includes("[native code]"))
        return s.toString();
      var l = "";
      for (var c in s)
        n.call(s, c) && s[c] && (l = o(l, c));
      return l;
    }
    function o(s, l) {
      return l ? s ? s + " " + l : s + l : s;
    }
    e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
  })();
})(Hm);
var Yr = Hm.exports;
function T(e) {
  const n = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && n === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || n === "[object Number]" || typeof e == "string" || n === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function ye(e, n) {
  return e instanceof Date ? new e.constructor(n) : new Date(n);
}
function Cn(e, n) {
  const t = T(e);
  return isNaN(n) ? ye(e, NaN) : (n && t.setDate(t.getDate() + n), t);
}
function bi(e, n) {
  const t = T(e);
  if (isNaN(n)) return ye(e, NaN);
  if (!n)
    return t;
  const a = t.getDate(), o = ye(e, t.getTime());
  o.setMonth(t.getMonth() + n + 1, 0);
  const s = o.getDate();
  return a >= s ? o : (t.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    a
  ), t);
}
function da(e, n) {
  const {
    years: t = 0,
    months: a = 0,
    weeks: o = 0,
    days: s = 0,
    hours: l = 0,
    minutes: c = 0,
    seconds: d = 0
  } = n, h = T(e), p = a || t ? bi(h, a + t * 12) : h, v = s || o ? Cn(p, s + o * 7) : p, w = c + l * 60, _ = (d + w * 60) * 1e3;
  return ye(e, v.getTime() + _);
}
function Um(e) {
  return T(e).getDay() === 6;
}
function jm(e) {
  return T(e).getDay() === 0;
}
function ya(e) {
  const n = T(e).getDay();
  return n === 0 || n === 6;
}
function zm(e, n) {
  const t = T(e), a = ya(t);
  if (isNaN(n)) return ye(e, NaN);
  const o = t.getHours(), s = n < 0 ? -1 : 1, l = Math.trunc(n / 5);
  t.setDate(t.getDate() + l * 7);
  let c = Math.abs(n % 5);
  for (; c > 0; )
    t.setDate(t.getDate() + s), ya(t) || (c -= 1);
  return a && ya(t) && n !== 0 && (Um(t) && t.setDate(t.getDate() + (s < 0 ? 2 : -1)), jm(t) && t.setDate(t.getDate() + (s < 0 ? 1 : -2))), t.setHours(o), t;
}
function _i(e, n) {
  const t = +T(e);
  return ye(e, t + n);
}
const qm = 7, jo = 365.2425, xi = 6048e5, Gm = 864e5, jn = 6e4, Br = 36e5, wc = 1e3, Hp = 525600, ma = 43200, zo = 1440, Km = 60, Xm = 3, Zm = 12, Qm = 4, ds = 3600, bc = 60, _c = ds * 24, B4 = _c * 7, Jm = _c * jo, ev = Jm / 12, H4 = ev * 3;
function xc(e, n) {
  return _i(e, n * Br);
}
let tv = {};
function Et() {
  return tv;
}
function U4(e) {
  tv = e;
}
function yt(e, n) {
  var c, d, h, p;
  const t = Et(), a = (n == null ? void 0 : n.weekStartsOn) ?? ((d = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : d.weekStartsOn) ?? t.weekStartsOn ?? ((p = (h = t.locale) == null ? void 0 : h.options) == null ? void 0 : p.weekStartsOn) ?? 0, o = T(e), s = o.getDay(), l = (s < a ? 7 : 0) + s - a;
  return o.setDate(o.getDate() - l), o.setHours(0, 0, 0, 0), o;
}
function dn(e) {
  return yt(e, { weekStartsOn: 1 });
}
function dr(e) {
  const n = T(e), t = n.getFullYear(), a = ye(e, 0);
  a.setFullYear(t + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const o = dn(a), s = ye(e, 0);
  s.setFullYear(t, 0, 4), s.setHours(0, 0, 0, 0);
  const l = dn(s);
  return n.getTime() >= o.getTime() ? t + 1 : n.getTime() >= l.getTime() ? t : t - 1;
}
function xa(e) {
  const n = T(e);
  return n.setHours(0, 0, 0, 0), n;
}
function kt(e) {
  const n = T(e), t = new Date(
    Date.UTC(
      n.getFullYear(),
      n.getMonth(),
      n.getDate(),
      n.getHours(),
      n.getMinutes(),
      n.getSeconds(),
      n.getMilliseconds()
    )
  );
  return t.setUTCFullYear(n.getFullYear()), +e - +t;
}
function On(e, n) {
  const t = xa(e), a = xa(n), o = +t - kt(t), s = +a - kt(a);
  return Math.round((o - s) / Gm);
}
function hr(e) {
  const n = dr(e), t = ye(e, 0);
  return t.setFullYear(n, 0, 4), t.setHours(0, 0, 0, 0), dn(t);
}
function nv(e, n) {
  let t = T(e);
  const a = On(t, hr(t)), o = ye(e, 0);
  return o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0), t = hr(o), t.setDate(t.getDate() + a), t;
}
function rv(e, n) {
  return nv(e, dr(e) + n);
}
function Dc(e, n) {
  return _i(e, n * jn);
}
function Sc(e, n) {
  const t = n * 3;
  return bi(e, t);
}
function av(e, n) {
  return _i(e, n * 1e3);
}
function hs(e, n) {
  const t = n * 7;
  return Cn(e, t);
}
function iv(e, n) {
  return bi(e, n * 12);
}
function j4(e, n, t) {
  const [a, o] = [
    +T(e.start),
    +T(e.end)
  ].sort((c, d) => c - d), [s, l] = [
    +T(n.start),
    +T(n.end)
  ].sort((c, d) => c - d);
  return t != null && t.inclusive ? a <= l && s <= o : a < l && s < o;
}
function ov(e) {
  let n;
  return e.forEach(function(t) {
    const a = T(t);
    (n === void 0 || n < a || isNaN(Number(a))) && (n = a);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function sv(e) {
  let n;
  return e.forEach((t) => {
    const a = T(t);
    (!n || n > a || isNaN(+a)) && (n = a);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function z4(e, n) {
  return sv([ov([e, n.start]), n.end]);
}
function q4(e, n) {
  const t = T(e);
  if (isNaN(Number(t))) return NaN;
  const a = t.getTime();
  let o, s;
  return n.forEach(function(l, c) {
    const d = T(l);
    if (isNaN(Number(d))) {
      o = NaN, s = NaN;
      return;
    }
    const h = Math.abs(a - d.getTime());
    (o == null || h < s) && (o = c, s = h);
  }), o;
}
function G4(e, n) {
  const t = T(e);
  if (isNaN(Number(t))) return ye(e, NaN);
  const a = t.getTime();
  let o, s;
  return n.forEach((l) => {
    const c = T(l);
    if (isNaN(Number(c))) {
      o = ye(e, NaN), s = NaN;
      return;
    }
    const d = Math.abs(a - c.getTime());
    (o == null || d < s) && (o = c, s = d);
  }), o;
}
function Mn(e, n) {
  const t = T(e), a = T(n), o = t.getTime() - a.getTime();
  return o < 0 ? -1 : o > 0 ? 1 : o;
}
function K4(e, n) {
  const t = T(e), a = T(n), o = t.getTime() - a.getTime();
  return o > 0 ? -1 : o < 0 ? 1 : o;
}
function Wt(e) {
  return ye(e, Date.now());
}
function X4(e) {
  const n = e / qm, t = Math.trunc(n);
  return t === 0 ? 0 : t;
}
function Di(e, n) {
  const t = xa(e), a = xa(n);
  return +t == +a;
}
function uv(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function zn(e) {
  if (!uv(e) && typeof e != "number")
    return !1;
  const n = T(e);
  return !isNaN(Number(n));
}
function Z4(e, n) {
  const t = T(e);
  let a = T(n);
  if (!zn(t) || !zn(a)) return NaN;
  const o = On(t, a), s = o < 0 ? -1 : 1, l = Math.trunc(o / 7);
  let c = l * 5;
  for (a = Cn(a, l * 7); !Di(t, a); )
    c += ya(a) ? 0 : s, a = Cn(a, s);
  return c === 0 ? 0 : c;
}
function lv(e, n) {
  return dr(e) - dr(n);
}
function Q4(e, n) {
  const t = dn(e), a = dn(n), o = +t - kt(t), s = +a - kt(a);
  return Math.round((o - s) / xi);
}
function qo(e, n) {
  const t = T(e), a = T(n), o = t.getFullYear() - a.getFullYear(), s = t.getMonth() - a.getMonth();
  return o * 12 + s;
}
function Vl(e) {
  const n = T(e);
  return Math.trunc(n.getMonth() / 3) + 1;
}
function Io(e, n) {
  const t = T(e), a = T(n), o = t.getFullYear() - a.getFullYear(), s = Vl(t) - Vl(a);
  return o * 4 + s;
}
function Go(e, n, t) {
  const a = yt(e, t), o = yt(n, t), s = +a - kt(a), l = +o - kt(o);
  return Math.round((s - l) / xi);
}
function oi(e, n) {
  const t = T(e), a = T(n);
  return t.getFullYear() - a.getFullYear();
}
function Oc(e, n) {
  const t = T(e), a = T(n), o = Up(t, a), s = Math.abs(On(t, a));
  t.setDate(t.getDate() - o * s);
  const l = +(Up(t, a) === -o), c = o * (s - l);
  return c === 0 ? 0 : c;
}
function Up(e, n) {
  const t = e.getFullYear() - n.getFullYear() || e.getMonth() - n.getMonth() || e.getDate() - n.getDate() || e.getHours() - n.getHours() || e.getMinutes() - n.getMinutes() || e.getSeconds() - n.getSeconds() || e.getMilliseconds() - n.getMilliseconds();
  return t < 0 ? -1 : t > 0 ? 1 : t;
}
function mr(e) {
  return (n) => {
    const a = (e ? Math[e] : Math.trunc)(n);
    return a === 0 ? 0 : a;
  };
}
function ps(e, n) {
  return +T(e) - +T(n);
}
function Ko(e, n, t) {
  const a = ps(e, n) / Br;
  return mr(t == null ? void 0 : t.roundingMethod)(a);
}
function cv(e, n) {
  return rv(e, -n);
}
function J4(e, n) {
  let t = T(e);
  const a = T(n), o = Mn(t, a), s = Math.abs(
    lv(t, a)
  );
  t = cv(t, o * s);
  const l = +(Mn(t, a) === -o), c = o * (s - l);
  return c === 0 ? 0 : c;
}
function Xo(e, n, t) {
  const a = ps(e, n) / jn;
  return mr(t == null ? void 0 : t.roundingMethod)(a);
}
function Mc(e) {
  const n = T(e);
  return n.setHours(23, 59, 59, 999), n;
}
function Cc(e) {
  const n = T(e), t = n.getMonth();
  return n.setFullYear(n.getFullYear(), t + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function fv(e) {
  const n = T(e);
  return +Mc(n) == +Cc(n);
}
function ms(e, n) {
  const t = T(e), a = T(n), o = Mn(t, a), s = Math.abs(
    qo(t, a)
  );
  let l;
  if (s < 1)
    l = 0;
  else {
    t.getMonth() === 1 && t.getDate() > 27 && t.setDate(30), t.setMonth(t.getMonth() - o * s);
    let c = Mn(t, a) === -o;
    fv(T(e)) && s === 1 && Mn(e, a) === 1 && (c = !1), l = o * (s - Number(c));
  }
  return l === 0 ? 0 : l;
}
function eS(e, n, t) {
  const a = ms(e, n) / 3;
  return mr(t == null ? void 0 : t.roundingMethod)(a);
}
function wa(e, n, t) {
  const a = ps(e, n) / 1e3;
  return mr(t == null ? void 0 : t.roundingMethod)(a);
}
function tS(e, n, t) {
  const a = Oc(e, n) / 7;
  return mr(t == null ? void 0 : t.roundingMethod)(a);
}
function dv(e, n) {
  const t = T(e), a = T(n), o = Mn(t, a), s = Math.abs(oi(t, a));
  t.setFullYear(1584), a.setFullYear(1584);
  const l = Mn(t, a) === -o, c = o * (s - +l);
  return c === 0 ? 0 : c;
}
function hv(e, n) {
  const t = T(e.start), a = T(e.end);
  let o = +t > +a;
  const s = o ? +t : +a, l = o ? a : t;
  l.setHours(0, 0, 0, 0);
  let c = (n == null ? void 0 : n.step) ?? 1;
  if (!c) return [];
  c < 0 && (c = -c, o = !o);
  const d = [];
  for (; +l <= s; )
    d.push(T(l)), l.setDate(l.getDate() + c), l.setHours(0, 0, 0, 0);
  return o ? d.reverse() : d;
}
function nS(e, n) {
  const t = T(e.start), a = T(e.end);
  let o = +t > +a;
  const s = o ? +t : +a;
  let l = o ? a : t;
  l.setMinutes(0, 0, 0);
  let c = (n == null ? void 0 : n.step) ?? 1;
  if (!c) return [];
  c < 0 && (c = -c, o = !o);
  const d = [];
  for (; +l <= s; )
    d.push(T(l)), l = xc(l, c);
  return o ? d.reverse() : d;
}
function Zo(e) {
  const n = T(e);
  return n.setSeconds(0, 0), n;
}
function rS(e, n) {
  const t = Zo(T(e.start)), a = T(e.end);
  let o = +t > +a;
  const s = o ? +t : +a;
  let l = o ? a : t, c = (n == null ? void 0 : n.step) ?? 1;
  if (!c) return [];
  c < 0 && (c = -c, o = !o);
  const d = [];
  for (; +l <= s; )
    d.push(T(l)), l = Dc(l, c);
  return o ? d.reverse() : d;
}
function aS(e, n) {
  const t = T(e.start), a = T(e.end);
  let o = +t > +a;
  const s = o ? +t : +a, l = o ? a : t;
  l.setHours(0, 0, 0, 0), l.setDate(1);
  let c = (n == null ? void 0 : n.step) ?? 1;
  if (!c) return [];
  c < 0 && (c = -c, o = !o);
  const d = [];
  for (; +l <= s; )
    d.push(T(l)), l.setMonth(l.getMonth() + c);
  return o ? d.reverse() : d;
}
function kr(e) {
  const n = T(e), t = n.getMonth(), a = t - t % 3;
  return n.setMonth(a, 1), n.setHours(0, 0, 0, 0), n;
}
function iS(e, n) {
  const t = T(e.start), a = T(e.end);
  let o = +t > +a;
  const s = o ? +kr(t) : +kr(a);
  let l = kr(o ? a : t), c = (n == null ? void 0 : n.step) ?? 1;
  if (!c) return [];
  c < 0 && (c = -c, o = !o);
  const d = [];
  for (; +l <= s; )
    d.push(T(l)), l = Sc(l, c);
  return o ? d.reverse() : d;
}
function oS(e, n) {
  const t = T(e.start), a = T(e.end);
  let o = +t > +a;
  const s = yt(o ? a : t, n), l = yt(o ? t : a, n);
  s.setHours(15), l.setHours(15);
  const c = +l.getTime();
  let d = s, h = (n == null ? void 0 : n.step) ?? 1;
  if (!h) return [];
  h < 0 && (h = -h, o = !o);
  const p = [];
  for (; +d <= c; )
    d.setHours(0), p.push(T(d)), d = hs(d, h), d.setHours(15);
  return o ? p.reverse() : p;
}
function Pc(e) {
  const n = hv(e), t = [];
  let a = 0;
  for (; a < n.length; ) {
    const o = n[a++];
    ya(o) && t.push(o);
  }
  return t;
}
function vs(e) {
  const n = T(e);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function sS(e) {
  const n = vs(e), t = Cc(e);
  return Pc({ start: n, end: t });
}
function pv(e) {
  const n = T(e), t = n.getFullYear();
  return n.setFullYear(t + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function Tc(e) {
  const n = T(e), t = ye(e, 0);
  return t.setFullYear(n.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function uS(e) {
  const n = Tc(e), t = pv(e);
  return Pc({ start: n, end: t });
}
function lS(e, n) {
  const t = T(e.start), a = T(e.end);
  let o = +t > +a;
  const s = o ? +t : +a, l = o ? a : t;
  l.setHours(0, 0, 0, 0), l.setMonth(0, 1);
  let c = (n == null ? void 0 : n.step) ?? 1;
  if (!c) return [];
  c < 0 && (c = -c, o = !o);
  const d = [];
  for (; +l <= s; )
    d.push(T(l)), l.setFullYear(l.getFullYear() + c);
  return o ? d.reverse() : d;
}
function cS(e) {
  const n = T(e), t = n.getFullYear(), a = 9 + Math.floor(t / 10) * 10;
  return n.setFullYear(a, 11, 31), n.setHours(23, 59, 59, 999), n;
}
function fS(e) {
  const n = T(e);
  return n.setMinutes(59, 59, 999), n;
}
function mv(e, n) {
  var c, d, h, p;
  const t = Et(), a = (n == null ? void 0 : n.weekStartsOn) ?? ((d = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : d.weekStartsOn) ?? t.weekStartsOn ?? ((p = (h = t.locale) == null ? void 0 : h.options) == null ? void 0 : p.weekStartsOn) ?? 0, o = T(e), s = o.getDay(), l = (s < a ? -7 : 0) + 6 - (s - a);
  return o.setDate(o.getDate() + l), o.setHours(23, 59, 59, 999), o;
}
function dS(e) {
  return mv(e, { weekStartsOn: 1 });
}
function hS(e) {
  const n = dr(e), t = ye(e, 0);
  t.setFullYear(n + 1, 0, 4), t.setHours(0, 0, 0, 0);
  const a = dn(t);
  return a.setMilliseconds(a.getMilliseconds() - 1), a;
}
function pS(e) {
  const n = T(e);
  return n.setSeconds(59, 999), n;
}
function mS(e) {
  const n = T(e), t = n.getMonth(), a = t - t % 3 + 3;
  return n.setMonth(a, 0), n.setHours(23, 59, 59, 999), n;
}
function vS(e) {
  const n = T(e);
  return n.setMilliseconds(999), n;
}
function gS() {
  return Mc(Date.now());
}
function yS() {
  const e = /* @__PURE__ */ new Date(), n = e.getFullYear(), t = e.getMonth(), a = e.getDate(), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(n, t, a + 1), o.setHours(23, 59, 59, 999), o;
}
function wS() {
  const e = /* @__PURE__ */ new Date(), n = e.getFullYear(), t = e.getMonth(), a = e.getDate(), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(n, t, a - 1), o.setHours(23, 59, 59, 999), o;
}
const bS = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, _S = (e, n, t) => {
  let a;
  const o = bS[e];
  return typeof o == "string" ? a = o : n === 1 ? a = o.one : a = o.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + a : a + " ago" : a;
};
function dl(e) {
  return (n = {}) => {
    const t = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const xS = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, DS = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, SS = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, OS = {
  date: dl({
    formats: xS,
    defaultWidth: "full"
  }),
  time: dl({
    formats: DS,
    defaultWidth: "full"
  }),
  dateTime: dl({
    formats: SS,
    defaultWidth: "full"
  })
}, MS = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, CS = (e, n, t, a) => MS[e];
function za(e) {
  return (n, t) => {
    const a = t != null && t.context ? String(t.context) : "standalone";
    let o;
    if (a === "formatting" && e.formattingValues) {
      const l = e.defaultFormattingWidth || e.defaultWidth, c = t != null && t.width ? String(t.width) : l;
      o = e.formattingValues[c] || e.formattingValues[l];
    } else {
      const l = e.defaultWidth, c = t != null && t.width ? String(t.width) : e.defaultWidth;
      o = e.values[c] || e.values[l];
    }
    const s = e.argumentCallback ? e.argumentCallback(n) : n;
    return o[s];
  };
}
const PS = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, TS = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, ES = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, RS = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, AS = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, IS = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, LS = (e, n) => {
  const t = Number(e), a = t % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, FS = {
  ordinalNumber: LS,
  era: za({
    values: PS,
    defaultWidth: "wide"
  }),
  quarter: za({
    values: TS,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: za({
    values: ES,
    defaultWidth: "wide"
  }),
  day: za({
    values: RS,
    defaultWidth: "wide"
  }),
  dayPeriod: za({
    values: AS,
    defaultWidth: "wide",
    formattingValues: IS,
    defaultFormattingWidth: "wide"
  })
};
function qa(e) {
  return (n, t = {}) => {
    const a = t.width, o = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], s = n.match(o);
    if (!s)
      return null;
    const l = s[0], c = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], d = Array.isArray(c) ? kS(c, (v) => v.test(l)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      NS(c, (v) => v.test(l))
    );
    let h;
    h = e.valueCallback ? e.valueCallback(d) : d, h = t.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      t.valueCallback(h)
    ) : h;
    const p = n.slice(l.length);
    return { value: h, rest: p };
  };
}
function NS(e, n) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && n(e[t]))
      return t;
}
function kS(e, n) {
  for (let t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
function WS(e) {
  return (n, t = {}) => {
    const a = n.match(e.matchPattern);
    if (!a) return null;
    const o = a[0], s = n.match(e.parsePattern);
    if (!s) return null;
    let l = e.valueCallback ? e.valueCallback(s[0]) : s[0];
    l = t.valueCallback ? t.valueCallback(l) : l;
    const c = n.slice(o.length);
    return { value: l, rest: c };
  };
}
const VS = /^(\d+)(th|st|nd|rd)?/i, $S = /\d+/i, YS = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, BS = {
  any: [/^b/i, /^(a|c)/i]
}, HS = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, US = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, jS = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, zS = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, qS = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, GS = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, KS = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, XS = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, ZS = {
  ordinalNumber: WS({
    matchPattern: VS,
    parsePattern: $S,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: qa({
    matchPatterns: YS,
    defaultMatchWidth: "wide",
    parsePatterns: BS,
    defaultParseWidth: "any"
  }),
  quarter: qa({
    matchPatterns: HS,
    defaultMatchWidth: "wide",
    parsePatterns: US,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: qa({
    matchPatterns: jS,
    defaultMatchWidth: "wide",
    parsePatterns: zS,
    defaultParseWidth: "any"
  }),
  day: qa({
    matchPatterns: qS,
    defaultMatchWidth: "wide",
    parsePatterns: GS,
    defaultParseWidth: "any"
  }),
  dayPeriod: qa({
    matchPatterns: KS,
    defaultMatchWidth: "any",
    parsePatterns: XS,
    defaultParseWidth: "any"
  })
}, Ma = {
  code: "en-US",
  formatDistance: _S,
  formatLong: OS,
  formatRelative: CS,
  localize: FS,
  match: ZS,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function vv(e) {
  const n = T(e);
  return On(n, Tc(n)) + 1;
}
function Ec(e) {
  const n = T(e), t = +dn(n) - +hr(n);
  return Math.round(t / xi) + 1;
}
function gs(e, n) {
  var p, v, w, b;
  const t = T(e), a = t.getFullYear(), o = Et(), s = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((v = (p = n == null ? void 0 : n.locale) == null ? void 0 : p.options) == null ? void 0 : v.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((b = (w = o.locale) == null ? void 0 : w.options) == null ? void 0 : b.firstWeekContainsDate) ?? 1, l = ye(e, 0);
  l.setFullYear(a + 1, 0, s), l.setHours(0, 0, 0, 0);
  const c = yt(l, n), d = ye(e, 0);
  d.setFullYear(a, 0, s), d.setHours(0, 0, 0, 0);
  const h = yt(d, n);
  return t.getTime() >= c.getTime() ? a + 1 : t.getTime() >= h.getTime() ? a : a - 1;
}
function Qo(e, n) {
  var c, d, h, p;
  const t = Et(), a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((p = (h = t.locale) == null ? void 0 : h.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, o = gs(e, n), s = ye(e, 0);
  return s.setFullYear(o, 0, a), s.setHours(0, 0, 0, 0), yt(s, n);
}
function Rc(e, n) {
  const t = T(e), a = +yt(t, n) - +Qo(t, n);
  return Math.round(a / xi) + 1;
}
function ue(e, n) {
  const t = e < 0 ? "-" : "", a = Math.abs(e).toString().padStart(n, "0");
  return t + a;
}
const wn = {
  // Year
  y(e, n) {
    const t = e.getFullYear(), a = t > 0 ? t : 1 - t;
    return ue(n === "yy" ? a % 100 : a, n.length);
  },
  // Month
  M(e, n) {
    const t = e.getMonth();
    return n === "M" ? String(t + 1) : ue(t + 1, 2);
  },
  // Day of the month
  d(e, n) {
    return ue(e.getDate(), n.length);
  },
  // AM or PM
  a(e, n) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, n) {
    return ue(e.getHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H(e, n) {
    return ue(e.getHours(), n.length);
  },
  // Minute
  m(e, n) {
    return ue(e.getMinutes(), n.length);
  },
  // Second
  s(e, n) {
    return ue(e.getSeconds(), n.length);
  },
  // Fraction of second
  S(e, n) {
    const t = n.length, a = e.getMilliseconds(), o = Math.trunc(
      a * Math.pow(10, t - 3)
    );
    return ue(o, n.length);
  }
}, ua = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, $l = {
  // Era
  G: function(e, n, t) {
    const a = e.getFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(a, { width: "abbreviated" });
      case "GGGGG":
        return t.era(a, { width: "narrow" });
      case "GGGG":
      default:
        return t.era(a, { width: "wide" });
    }
  },
  // Year
  y: function(e, n, t) {
    if (n === "yo") {
      const a = e.getFullYear(), o = a > 0 ? a : 1 - a;
      return t.ordinalNumber(o, { unit: "year" });
    }
    return wn.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, t, a) {
    const o = gs(e, a), s = o > 0 ? o : 1 - o;
    if (n === "YY") {
      const l = s % 100;
      return ue(l, 2);
    }
    return n === "Yo" ? t.ordinalNumber(s, { unit: "year" }) : ue(s, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    const t = dr(e);
    return ue(t, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    const t = e.getFullYear();
    return ue(t, n.length);
  },
  // Quarter
  Q: function(e, n, t) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(a);
      case "QQ":
        return ue(a, 2);
      case "Qo":
        return t.ordinalNumber(a, { unit: "quarter" });
      case "QQQ":
        return t.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, t) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(a);
      case "qq":
        return ue(a, 2);
      case "qo":
        return t.ordinalNumber(a, { unit: "quarter" });
      case "qqq":
        return t.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, t) {
    const a = e.getMonth();
    switch (n) {
      case "M":
      case "MM":
        return wn.M(e, n);
      case "Mo":
        return t.ordinalNumber(a + 1, { unit: "month" });
      case "MMM":
        return t.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(a, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, n, t) {
    const a = e.getMonth();
    switch (n) {
      case "L":
        return String(a + 1);
      case "LL":
        return ue(a + 1, 2);
      case "Lo":
        return t.ordinalNumber(a + 1, { unit: "month" });
      case "LLL":
        return t.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(a, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, n, t, a) {
    const o = Rc(e, a);
    return n === "wo" ? t.ordinalNumber(o, { unit: "week" }) : ue(o, n.length);
  },
  // ISO week of year
  I: function(e, n, t) {
    const a = Ec(e);
    return n === "Io" ? t.ordinalNumber(a, { unit: "week" }) : ue(a, n.length);
  },
  // Day of the month
  d: function(e, n, t) {
    return n === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : wn.d(e, n);
  },
  // Day of year
  D: function(e, n, t) {
    const a = vv(e);
    return n === "Do" ? t.ordinalNumber(a, { unit: "dayOfYear" }) : ue(a, n.length);
  },
  // Day of week
  E: function(e, n, t) {
    const a = e.getDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, t, a) {
    const o = e.getDay(), s = (o - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(s);
      case "ee":
        return ue(s, 2);
      case "eo":
        return t.ordinalNumber(s, { unit: "day" });
      case "eee":
        return t.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, t, a) {
    const o = e.getDay(), s = (o - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(s);
      case "cc":
        return ue(s, n.length);
      case "co":
        return t.ordinalNumber(s, { unit: "day" });
      case "ccc":
        return t.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, t) {
    const a = e.getDay(), o = a === 0 ? 7 : a;
    switch (n) {
      case "i":
        return String(o);
      case "ii":
        return ue(o, n.length);
      case "io":
        return t.ordinalNumber(o, { unit: "day" });
      case "iii":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, t) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, t) {
    const a = e.getHours();
    let o;
    switch (a === 12 ? o = ua.noon : a === 0 ? o = ua.midnight : o = a / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, t) {
    const a = e.getHours();
    let o;
    switch (a >= 17 ? o = ua.evening : a >= 12 ? o = ua.afternoon : a >= 4 ? o = ua.morning : o = ua.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, t) {
    if (n === "ho") {
      let a = e.getHours() % 12;
      return a === 0 && (a = 12), t.ordinalNumber(a, { unit: "hour" });
    }
    return wn.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, t) {
    return n === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : wn.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, t) {
    const a = e.getHours() % 12;
    return n === "Ko" ? t.ordinalNumber(a, { unit: "hour" }) : ue(a, n.length);
  },
  // Hour [1-24]
  k: function(e, n, t) {
    let a = e.getHours();
    return a === 0 && (a = 24), n === "ko" ? t.ordinalNumber(a, { unit: "hour" }) : ue(a, n.length);
  },
  // Minute
  m: function(e, n, t) {
    return n === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : wn.m(e, n);
  },
  // Second
  s: function(e, n, t) {
    return n === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : wn.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return wn.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, t) {
    const a = e.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (n) {
      case "X":
        return zp(a);
      case "XXXX":
      case "XX":
        return Lr(a);
      case "XXXXX":
      case "XXX":
      default:
        return Lr(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      case "x":
        return zp(a);
      case "xxxx":
      case "xx":
        return Lr(a);
      case "xxxxx":
      case "xxx":
      default:
        return Lr(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + jp(a, ":");
      case "OOOO":
      default:
        return "GMT" + Lr(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + jp(a, ":");
      case "zzzz":
      default:
        return "GMT" + Lr(a, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, t) {
    const a = Math.trunc(e.getTime() / 1e3);
    return ue(a, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, t) {
    const a = e.getTime();
    return ue(a, n.length);
  }
};
function jp(e, n = "") {
  const t = e > 0 ? "-" : "+", a = Math.abs(e), o = Math.trunc(a / 60), s = a % 60;
  return s === 0 ? t + String(o) : t + String(o) + n + ue(s, 2);
}
function zp(e, n) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + ue(Math.abs(e) / 60, 2) : Lr(e, n);
}
function Lr(e, n = "") {
  const t = e > 0 ? "-" : "+", a = Math.abs(e), o = ue(Math.trunc(a / 60), 2), s = ue(a % 60, 2);
  return t + o + n + s;
}
const qp = (e, n) => {
  switch (e) {
    case "P":
      return n.date({ width: "short" });
    case "PP":
      return n.date({ width: "medium" });
    case "PPP":
      return n.date({ width: "long" });
    case "PPPP":
    default:
      return n.date({ width: "full" });
  }
}, gv = (e, n) => {
  switch (e) {
    case "p":
      return n.time({ width: "short" });
    case "pp":
      return n.time({ width: "medium" });
    case "ppp":
      return n.time({ width: "long" });
    case "pppp":
    default:
      return n.time({ width: "full" });
  }
}, QS = (e, n) => {
  const t = e.match(/(P+)(p+)?/) || [], a = t[1], o = t[2];
  if (!o)
    return qp(e, n);
  let s;
  switch (a) {
    case "P":
      s = n.dateTime({ width: "short" });
      break;
    case "PP":
      s = n.dateTime({ width: "medium" });
      break;
    case "PPP":
      s = n.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      s = n.dateTime({ width: "full" });
      break;
  }
  return s.replace("{{date}}", qp(a, n)).replace("{{time}}", gv(o, n));
}, Jo = {
  p: gv,
  P: QS
}, JS = /^D+$/, e5 = /^Y+$/, t5 = ["D", "DD", "YY", "YYYY"];
function yv(e) {
  return JS.test(e);
}
function wv(e) {
  return e5.test(e);
}
function Yl(e, n, t) {
  const a = n5(e, n, t);
  if (console.warn(a), t5.includes(e)) throw new RangeError(a);
}
function n5(e, n, t) {
  const a = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${n}\`) for formatting ${a} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const r5 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, a5 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, i5 = /^'([^]*?)'?$/, o5 = /''/g, s5 = /[a-zA-Z]/;
function Bl(e, n, t) {
  var p, v, w, b, _, D, C, N;
  const a = Et(), o = (t == null ? void 0 : t.locale) ?? a.locale ?? Ma, s = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((v = (p = t == null ? void 0 : t.locale) == null ? void 0 : p.options) == null ? void 0 : v.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((b = (w = a.locale) == null ? void 0 : w.options) == null ? void 0 : b.firstWeekContainsDate) ?? 1, l = (t == null ? void 0 : t.weekStartsOn) ?? ((D = (_ = t == null ? void 0 : t.locale) == null ? void 0 : _.options) == null ? void 0 : D.weekStartsOn) ?? a.weekStartsOn ?? ((N = (C = a.locale) == null ? void 0 : C.options) == null ? void 0 : N.weekStartsOn) ?? 0, c = T(e);
  if (!zn(c))
    throw new RangeError("Invalid time value");
  let d = n.match(a5).map(($) => {
    const A = $[0];
    if (A === "p" || A === "P") {
      const k = Jo[A];
      return k($, o.formatLong);
    }
    return $;
  }).join("").match(r5).map(($) => {
    if ($ === "''")
      return { isToken: !1, value: "'" };
    const A = $[0];
    if (A === "'")
      return { isToken: !1, value: u5($) };
    if ($l[A])
      return { isToken: !0, value: $ };
    if (A.match(s5))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + A + "`"
      );
    return { isToken: !1, value: $ };
  });
  o.localize.preprocessor && (d = o.localize.preprocessor(c, d));
  const h = {
    firstWeekContainsDate: s,
    weekStartsOn: l,
    locale: o
  };
  return d.map(($) => {
    if (!$.isToken) return $.value;
    const A = $.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && wv(A) || !(t != null && t.useAdditionalDayOfYearTokens) && yv(A)) && Yl(A, n, String(e));
    const k = $l[A[0]];
    return k(c, A, o.localize, h);
  }).join("");
}
function u5(e) {
  const n = e.match(i5);
  return n ? n[1].replace(o5, "'") : e;
}
function bv(e, n, t) {
  const a = Et(), o = (t == null ? void 0 : t.locale) ?? a.locale ?? Ma, s = 2520, l = Mn(e, n);
  if (isNaN(l))
    throw new RangeError("Invalid time value");
  const c = Object.assign({}, t, {
    addSuffix: t == null ? void 0 : t.addSuffix,
    comparison: l
  });
  let d, h;
  l > 0 ? (d = T(n), h = T(e)) : (d = T(e), h = T(n));
  const p = wa(h, d), v = (kt(h) - kt(d)) / 1e3, w = Math.round((p - v) / 60);
  let b;
  if (w < 2)
    return t != null && t.includeSeconds ? p < 5 ? o.formatDistance("lessThanXSeconds", 5, c) : p < 10 ? o.formatDistance("lessThanXSeconds", 10, c) : p < 20 ? o.formatDistance("lessThanXSeconds", 20, c) : p < 40 ? o.formatDistance("halfAMinute", 0, c) : p < 60 ? o.formatDistance("lessThanXMinutes", 1, c) : o.formatDistance("xMinutes", 1, c) : w === 0 ? o.formatDistance("lessThanXMinutes", 1, c) : o.formatDistance("xMinutes", w, c);
  if (w < 45)
    return o.formatDistance("xMinutes", w, c);
  if (w < 90)
    return o.formatDistance("aboutXHours", 1, c);
  if (w < zo) {
    const _ = Math.round(w / 60);
    return o.formatDistance("aboutXHours", _, c);
  } else {
    if (w < s)
      return o.formatDistance("xDays", 1, c);
    if (w < ma) {
      const _ = Math.round(w / zo);
      return o.formatDistance("xDays", _, c);
    } else if (w < ma * 2)
      return b = Math.round(w / ma), o.formatDistance("aboutXMonths", b, c);
  }
  if (b = ms(h, d), b < 12) {
    const _ = Math.round(w / ma);
    return o.formatDistance("xMonths", _, c);
  } else {
    const _ = b % 12, D = Math.trunc(b / 12);
    return _ < 3 ? o.formatDistance("aboutXYears", D, c) : _ < 9 ? o.formatDistance("overXYears", D, c) : o.formatDistance("almostXYears", D + 1, c);
  }
}
function _v(e, n, t) {
  const a = Et(), o = (t == null ? void 0 : t.locale) ?? a.locale ?? Ma, s = Mn(e, n);
  if (isNaN(s))
    throw new RangeError("Invalid time value");
  const l = Object.assign({}, t, {
    addSuffix: t == null ? void 0 : t.addSuffix,
    comparison: s
  });
  let c, d;
  s > 0 ? (c = T(n), d = T(e)) : (c = T(e), d = T(n));
  const h = mr((t == null ? void 0 : t.roundingMethod) ?? "round"), p = d.getTime() - c.getTime(), v = p / jn, w = kt(d) - kt(c), b = (p - w) / jn, _ = t == null ? void 0 : t.unit;
  let D;
  if (_ ? D = _ : v < 1 ? D = "second" : v < 60 ? D = "minute" : v < zo ? D = "hour" : b < ma ? D = "day" : b < Hp ? D = "month" : D = "year", D === "second") {
    const C = h(p / 1e3);
    return o.formatDistance("xSeconds", C, l);
  } else if (D === "minute") {
    const C = h(v);
    return o.formatDistance("xMinutes", C, l);
  } else if (D === "hour") {
    const C = h(v / 60);
    return o.formatDistance("xHours", C, l);
  } else if (D === "day") {
    const C = h(b / zo);
    return o.formatDistance("xDays", C, l);
  } else if (D === "month") {
    const C = h(b / ma);
    return C === 12 && _ !== "month" ? o.formatDistance("xYears", 1, l) : o.formatDistance("xMonths", C, l);
  } else {
    const C = h(b / Hp);
    return o.formatDistance("xYears", C, l);
  }
}
function l5(e, n) {
  return bv(e, Wt(e), n);
}
function c5(e, n) {
  return _v(e, Wt(e), n);
}
const f5 = [
  "years",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds"
];
function d5(e, n) {
  const t = Et(), a = (n == null ? void 0 : n.locale) ?? t.locale ?? Ma, o = (n == null ? void 0 : n.format) ?? f5, s = (n == null ? void 0 : n.zero) ?? !1, l = (n == null ? void 0 : n.delimiter) ?? " ";
  return a.formatDistance ? o.reduce((d, h) => {
    const p = `x${h.replace(/(^.)/, (w) => w.toUpperCase())}`, v = e[h];
    return v !== void 0 && (s || e[h]) ? d.concat(a.formatDistance(p, v)) : d;
  }, []).join(l) : "";
}
function h5(e, n) {
  const t = T(e);
  if (isNaN(t.getTime()))
    throw new RangeError("Invalid time value");
  const a = (n == null ? void 0 : n.format) ?? "extended", o = (n == null ? void 0 : n.representation) ?? "complete";
  let s = "", l = "";
  const c = a === "extended" ? "-" : "", d = a === "extended" ? ":" : "";
  if (o !== "time") {
    const h = ue(t.getDate(), 2), p = ue(t.getMonth() + 1, 2);
    s = `${ue(t.getFullYear(), 4)}${c}${p}${c}${h}`;
  }
  if (o !== "date") {
    const h = t.getTimezoneOffset();
    if (h !== 0) {
      const D = Math.abs(h), C = ue(Math.trunc(D / 60), 2), N = ue(D % 60, 2);
      l = `${h < 0 ? "+" : "-"}${C}:${N}`;
    } else
      l = "Z";
    const p = ue(t.getHours(), 2), v = ue(t.getMinutes(), 2), w = ue(t.getSeconds(), 2), b = s === "" ? "" : "T", _ = [p, v, w].join(d);
    s = `${s}${b}${_}${l}`;
  }
  return s;
}
function p5(e, n) {
  const t = T(e);
  if (!zn(t))
    throw new RangeError("Invalid time value");
  const a = (n == null ? void 0 : n.format) ?? "extended", o = (n == null ? void 0 : n.representation) ?? "complete";
  let s = "";
  const l = a === "extended" ? "-" : "", c = a === "extended" ? ":" : "";
  if (o !== "time") {
    const d = ue(t.getDate(), 2), h = ue(t.getMonth() + 1, 2);
    s = `${ue(t.getFullYear(), 4)}${l}${h}${l}${d}`;
  }
  if (o !== "date") {
    const d = ue(t.getHours(), 2), h = ue(t.getMinutes(), 2), p = ue(t.getSeconds(), 2);
    s = `${s}${s === "" ? "" : " "}${d}${c}${h}${c}${p}`;
  }
  return s;
}
function m5(e) {
  const {
    years: n = 0,
    months: t = 0,
    days: a = 0,
    hours: o = 0,
    minutes: s = 0,
    seconds: l = 0
  } = e;
  return `P${n}Y${t}M${a}DT${o}H${s}M${l}S`;
}
function v5(e, n) {
  const t = T(e);
  if (!zn(t))
    throw new RangeError("Invalid time value");
  const a = (n == null ? void 0 : n.fractionDigits) ?? 0, o = ue(t.getDate(), 2), s = ue(t.getMonth() + 1, 2), l = t.getFullYear(), c = ue(t.getHours(), 2), d = ue(t.getMinutes(), 2), h = ue(t.getSeconds(), 2);
  let p = "";
  if (a > 0) {
    const b = t.getMilliseconds(), _ = Math.trunc(
      b * Math.pow(10, a - 3)
    );
    p = "." + ue(_, a);
  }
  let v = "";
  const w = t.getTimezoneOffset();
  if (w !== 0) {
    const b = Math.abs(w), _ = ue(Math.trunc(b / 60), 2), D = ue(b % 60, 2);
    v = `${w < 0 ? "+" : "-"}${_}:${D}`;
  } else
    v = "Z";
  return `${l}-${s}-${o}T${c}:${d}:${h}${p}${v}`;
}
const g5 = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], y5 = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
function w5(e) {
  const n = T(e);
  if (!zn(n))
    throw new RangeError("Invalid time value");
  const t = g5[n.getUTCDay()], a = ue(n.getUTCDate(), 2), o = y5[n.getUTCMonth()], s = n.getUTCFullYear(), l = ue(n.getUTCHours(), 2), c = ue(n.getUTCMinutes(), 2), d = ue(n.getUTCSeconds(), 2);
  return `${t}, ${a} ${o} ${s} ${l}:${c}:${d} GMT`;
}
function b5(e, n, t) {
  var v, w, b, _;
  const a = T(e), o = T(n), s = Et(), l = (t == null ? void 0 : t.locale) ?? s.locale ?? Ma, c = (t == null ? void 0 : t.weekStartsOn) ?? ((w = (v = t == null ? void 0 : t.locale) == null ? void 0 : v.options) == null ? void 0 : w.weekStartsOn) ?? s.weekStartsOn ?? ((_ = (b = s.locale) == null ? void 0 : b.options) == null ? void 0 : _.weekStartsOn) ?? 0, d = On(a, o);
  if (isNaN(d))
    throw new RangeError("Invalid time value");
  let h;
  d < -6 ? h = "other" : d < -1 ? h = "lastWeek" : d < 0 ? h = "yesterday" : d < 1 ? h = "today" : d < 2 ? h = "tomorrow" : d < 7 ? h = "nextWeek" : h = "other";
  const p = l.formatRelative(h, a, o, {
    locale: l,
    weekStartsOn: c
  });
  return Bl(a, p, { locale: l, weekStartsOn: c });
}
function _5(e) {
  return T(e * 1e3);
}
function xv(e) {
  return T(e).getDate();
}
function ys(e) {
  return T(e).getDay();
}
function Dv(e) {
  const n = T(e), t = n.getFullYear(), a = n.getMonth(), o = ye(e, 0);
  return o.setFullYear(t, a + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function Sv(e) {
  const t = T(e).getFullYear();
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function x5(e) {
  const n = T(e);
  return String(new Date(n)) === "Invalid Date" ? NaN : Sv(n) ? 366 : 365;
}
function D5(e) {
  const t = T(e).getFullYear();
  return Math.floor(t / 10) * 10;
}
function Ov() {
  return Object.assign({}, Et());
}
function S5(e) {
  return T(e).getHours();
}
function Mv(e) {
  let t = T(e).getDay();
  return t === 0 && (t = 7), t;
}
function O5(e) {
  const n = hr(e), a = +hr(hs(n, 60)) - +n;
  return Math.round(a / xi);
}
function M5(e) {
  return T(e).getMilliseconds();
}
function C5(e) {
  return T(e).getMinutes();
}
function P5(e) {
  return T(e).getMonth();
}
function T5(e, n) {
  const [t, a] = [
    +T(e.start),
    +T(e.end)
  ].sort((v, w) => v - w), [o, s] = [
    +T(n.start),
    +T(n.end)
  ].sort((v, w) => v - w);
  if (!(t < s && o < a)) return 0;
  const c = o < t ? t : o, d = c - kt(c), h = s > a ? a : s, p = h - kt(h);
  return Math.ceil((p - d) / Gm);
}
function E5(e) {
  return T(e).getSeconds();
}
function R5(e) {
  return T(e).getTime();
}
function A5(e) {
  return Math.trunc(+T(e) / 1e3);
}
function I5(e, n) {
  var d, h, p, v;
  const t = Et(), a = (n == null ? void 0 : n.weekStartsOn) ?? ((h = (d = n == null ? void 0 : n.locale) == null ? void 0 : d.options) == null ? void 0 : h.weekStartsOn) ?? t.weekStartsOn ?? ((v = (p = t.locale) == null ? void 0 : p.options) == null ? void 0 : v.weekStartsOn) ?? 0, o = xv(e);
  if (isNaN(o)) return NaN;
  const s = ys(vs(e));
  let l = a - s;
  l <= 0 && (l += 7);
  const c = o - l;
  return Math.ceil(c / 7) + 1;
}
function Cv(e) {
  const n = T(e), t = n.getMonth();
  return n.setFullYear(n.getFullYear(), t + 1, 0), n.setHours(0, 0, 0, 0), n;
}
function L5(e, n) {
  return Go(
    Cv(e),
    vs(e),
    n
  ) + 1;
}
function F5(e) {
  return T(e).getFullYear();
}
function N5(e) {
  return Math.trunc(e * Br);
}
function k5(e) {
  return Math.trunc(e * Km);
}
function W5(e) {
  return Math.trunc(e * ds);
}
function V5(e, n, t) {
  const a = T(e);
  if (isNaN(+a)) throw new TypeError("Start date is invalid");
  const o = T(n);
  if (isNaN(+o)) throw new TypeError("End date is invalid");
  if (t != null && t.assertPositive && +a > +o)
    throw new TypeError("End date must be after start date");
  return { start: a, end: o };
}
function $5(e) {
  const n = T(e.start), t = T(e.end), a = {}, o = dv(t, n);
  o && (a.years = o);
  const s = da(n, { years: a.years }), l = ms(t, s);
  l && (a.months = l);
  const c = da(s, { months: a.months }), d = Oc(t, c);
  d && (a.days = d);
  const h = da(c, { days: a.days }), p = Ko(t, h);
  p && (a.hours = p);
  const v = da(h, { hours: a.hours }), w = Xo(t, v);
  w && (a.minutes = w);
  const b = da(v, { minutes: a.minutes }), _ = wa(t, b);
  return _ && (a.seconds = _), a;
}
function Y5(e, n, t) {
  let a;
  return B5(n) ? a = n : t = n, new Intl.DateTimeFormat(t == null ? void 0 : t.locale, a).format(
    T(e)
  );
}
function B5(e) {
  return e !== void 0 && !("locale" in e);
}
function H5(e, n, t) {
  let a = 0, o;
  const s = T(e), l = T(n);
  if (t != null && t.unit)
    o = t == null ? void 0 : t.unit, o === "second" ? a = wa(s, l) : o === "minute" ? a = Xo(s, l) : o === "hour" ? a = Ko(s, l) : o === "day" ? a = On(s, l) : o === "week" ? a = Go(s, l) : o === "month" ? a = qo(s, l) : o === "quarter" ? a = Io(s, l) : o === "year" && (a = oi(s, l));
  else {
    const d = wa(s, l);
    Math.abs(d) < bc ? (a = wa(s, l), o = "second") : Math.abs(d) < ds ? (a = Xo(s, l), o = "minute") : Math.abs(d) < _c && Math.abs(On(s, l)) < 1 ? (a = Ko(s, l), o = "hour") : Math.abs(d) < B4 && (a = On(s, l)) && Math.abs(a) < 7 ? o = "day" : Math.abs(d) < ev ? (a = Go(s, l), o = "week") : Math.abs(d) < H4 ? (a = qo(s, l), o = "month") : Math.abs(d) < Jm && Io(s, l) < 4 ? (a = Io(s, l), o = "quarter") : (a = oi(s, l), o = "year");
  }
  return new Intl.RelativeTimeFormat(t == null ? void 0 : t.locale, {
    localeMatcher: t == null ? void 0 : t.localeMatcher,
    numeric: (t == null ? void 0 : t.numeric) || "auto",
    style: t == null ? void 0 : t.style
  }).format(a, o);
}
function U5(e, n) {
  const t = T(e), a = T(n);
  return t.getTime() > a.getTime();
}
function j5(e, n) {
  const t = T(e), a = T(n);
  return +t < +a;
}
function z5(e, n) {
  const t = T(e), a = T(n);
  return +t == +a;
}
function q5(e, n, t) {
  const a = new Date(e, n, t);
  return a.getFullYear() === e && a.getMonth() === n && a.getDate() === t;
}
function G5(e) {
  return T(e).getDate() === 1;
}
function K5(e) {
  return T(e).getDay() === 5;
}
function X5(e) {
  return +T(e) > Date.now();
}
function Pv(e, n) {
  const t = n instanceof Date ? ye(n, 0) : new n(0);
  return t.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), t.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), t;
}
const Z5 = 10;
class Tv {
  constructor() {
    re(this, "subPriority", 0);
  }
  validate(n, t) {
    return !0;
  }
}
class Q5 extends Tv {
  constructor(n, t, a, o, s) {
    super(), this.value = n, this.validateValue = t, this.setValue = a, this.priority = o, s && (this.subPriority = s);
  }
  validate(n, t) {
    return this.validateValue(n, this.value, t);
  }
  set(n, t, a) {
    return this.setValue(n, t, this.value, a);
  }
}
class J5 extends Tv {
  constructor() {
    super(...arguments);
    re(this, "priority", Z5);
    re(this, "subPriority", -1);
  }
  set(t, a) {
    return a.timestampIsSet ? t : ye(t, Pv(t, Date));
  }
}
class Re {
  run(n, t, a, o) {
    const s = this.parse(n, t, a, o);
    return s ? {
      setter: new Q5(
        s.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: s.rest
    } : null;
  }
  validate(n, t, a) {
    return !0;
  }
}
class eO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 140);
    re(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, a, o) {
    switch (a) {
      case "G":
      case "GG":
      case "GGG":
        return o.era(t, { width: "abbreviated" }) || o.era(t, { width: "narrow" });
      case "GGGGG":
        return o.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return o.era(t, { width: "wide" }) || o.era(t, { width: "abbreviated" }) || o.era(t, { width: "narrow" });
    }
  }
  set(t, a, o) {
    return a.era = o, t.setFullYear(o, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const st = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, bn = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function ut(e, n) {
  return e && {
    value: n(e.value),
    rest: e.rest
  };
}
function Je(e, n) {
  const t = n.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: n.slice(t[0].length)
  } : null;
}
function _n(e, n) {
  const t = n.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  const a = t[1] === "+" ? 1 : -1, o = t[2] ? parseInt(t[2], 10) : 0, s = t[3] ? parseInt(t[3], 10) : 0, l = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: a * (o * Br + s * jn + l * wc),
    rest: n.slice(t[0].length)
  };
}
function Ev(e) {
  return Je(st.anyDigitsSigned, e);
}
function rt(e, n) {
  switch (e) {
    case 1:
      return Je(st.singleDigit, n);
    case 2:
      return Je(st.twoDigits, n);
    case 3:
      return Je(st.threeDigits, n);
    case 4:
      return Je(st.fourDigits, n);
    default:
      return Je(new RegExp("^\\d{1," + e + "}"), n);
  }
}
function es(e, n) {
  switch (e) {
    case 1:
      return Je(st.singleDigitSigned, n);
    case 2:
      return Je(st.twoDigitsSigned, n);
    case 3:
      return Je(st.threeDigitsSigned, n);
    case 4:
      return Je(st.fourDigitsSigned, n);
    default:
      return Je(new RegExp("^-?\\d{1," + e + "}"), n);
  }
}
function Ac(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Rv(e, n) {
  const t = n > 0, a = t ? n : 1 - n;
  let o;
  if (a <= 50)
    o = e || 100;
  else {
    const s = a + 50, l = Math.trunc(s / 100) * 100, c = e >= s % 100;
    o = e + l - (c ? 100 : 0);
  }
  return t ? o : 1 - o;
}
function Av(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class tO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 130);
    re(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, a, o) {
    const s = (l) => ({
      year: l,
      isTwoDigitYear: a === "yy"
    });
    switch (a) {
      case "y":
        return ut(rt(4, t), s);
      case "yo":
        return ut(
          o.ordinalNumber(t, {
            unit: "year"
          }),
          s
        );
      default:
        return ut(rt(a.length, t), s);
    }
  }
  validate(t, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(t, a, o) {
    const s = t.getFullYear();
    if (o.isTwoDigitYear) {
      const c = Rv(
        o.year,
        s
      );
      return t.setFullYear(c, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const l = !("era" in a) || a.era === 1 ? o.year : 1 - o.year;
    return t.setFullYear(l, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class nO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 130);
    re(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, a, o) {
    const s = (l) => ({
      year: l,
      isTwoDigitYear: a === "YY"
    });
    switch (a) {
      case "Y":
        return ut(rt(4, t), s);
      case "Yo":
        return ut(
          o.ordinalNumber(t, {
            unit: "year"
          }),
          s
        );
      default:
        return ut(rt(a.length, t), s);
    }
  }
  validate(t, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(t, a, o, s) {
    const l = gs(t, s);
    if (o.isTwoDigitYear) {
      const d = Rv(
        o.year,
        l
      );
      return t.setFullYear(
        d,
        0,
        s.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), yt(t, s);
    }
    const c = !("era" in a) || a.era === 1 ? o.year : 1 - o.year;
    return t.setFullYear(c, 0, s.firstWeekContainsDate), t.setHours(0, 0, 0, 0), yt(t, s);
  }
}
class rO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 130);
    re(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a) {
    return es(a === "R" ? 4 : a.length, t);
  }
  set(t, a, o) {
    const s = ye(t, 0);
    return s.setFullYear(o, 0, 4), s.setHours(0, 0, 0, 0), dn(s);
  }
}
class aO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 130);
    re(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, a) {
    return es(a === "u" ? 4 : a.length, t);
  }
  set(t, a, o) {
    return t.setFullYear(o, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class iO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 120);
    re(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, o) {
    switch (a) {
      case "Q":
      case "QQ":
        return rt(a.length, t);
      case "Qo":
        return o.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return o.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return o.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || o.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 4;
  }
  set(t, a, o) {
    return t.setMonth((o - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class oO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 120);
    re(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, o) {
    switch (a) {
      case "q":
      case "qq":
        return rt(a.length, t);
      case "qo":
        return o.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return o.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return o.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || o.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 4;
  }
  set(t, a, o) {
    return t.setMonth((o - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class sO extends Re {
  constructor() {
    super(...arguments);
    re(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    re(this, "priority", 110);
  }
  parse(t, a, o) {
    const s = (l) => l - 1;
    switch (a) {
      case "M":
        return ut(
          Je(st.month, t),
          s
        );
      case "MM":
        return ut(rt(2, t), s);
      case "Mo":
        return ut(
          o.ordinalNumber(t, {
            unit: "month"
          }),
          s
        );
      case "MMM":
        return o.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(t, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return o.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return o.month(t, { width: "wide", context: "formatting" }) || o.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, o) {
    return t.setMonth(o, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class uO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 110);
    re(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, o) {
    const s = (l) => l - 1;
    switch (a) {
      case "L":
        return ut(
          Je(st.month, t),
          s
        );
      case "LL":
        return ut(rt(2, t), s);
      case "Lo":
        return ut(
          o.ordinalNumber(t, {
            unit: "month"
          }),
          s
        );
      case "LLL":
        return o.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(t, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return o.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return o.month(t, { width: "wide", context: "standalone" }) || o.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, o) {
    return t.setMonth(o, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function Iv(e, n, t) {
  const a = T(e), o = Rc(a, t) - n;
  return a.setDate(a.getDate() - o * 7), a;
}
class lO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 100);
    re(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, a, o) {
    switch (a) {
      case "w":
        return Je(st.week, t);
      case "wo":
        return o.ordinalNumber(t, { unit: "week" });
      default:
        return rt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 53;
  }
  set(t, a, o, s) {
    return yt(Iv(t, o, s), s);
  }
}
function Lv(e, n) {
  const t = T(e), a = Ec(t) - n;
  return t.setDate(t.getDate() - a * 7), t;
}
class cO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 100);
    re(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, o) {
    switch (a) {
      case "I":
        return Je(st.week, t);
      case "Io":
        return o.ordinalNumber(t, { unit: "week" });
      default:
        return rt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 53;
  }
  set(t, a, o) {
    return dn(Lv(t, o));
  }
}
const fO = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], dO = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class hO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 90);
    re(this, "subPriority", 1);
    re(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, o) {
    switch (a) {
      case "d":
        return Je(st.date, t);
      case "do":
        return o.ordinalNumber(t, { unit: "date" });
      default:
        return rt(a.length, t);
    }
  }
  validate(t, a) {
    const o = t.getFullYear(), s = Av(o), l = t.getMonth();
    return s ? a >= 1 && a <= dO[l] : a >= 1 && a <= fO[l];
  }
  set(t, a, o) {
    return t.setDate(o), t.setHours(0, 0, 0, 0), t;
  }
}
class pO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 90);
    re(this, "subpriority", 1);
    re(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, o) {
    switch (a) {
      case "D":
      case "DD":
        return Je(st.dayOfYear, t);
      case "Do":
        return o.ordinalNumber(t, { unit: "date" });
      default:
        return rt(a.length, t);
    }
  }
  validate(t, a) {
    const o = t.getFullYear();
    return Av(o) ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
  }
  set(t, a, o) {
    return t.setMonth(0, o), t.setHours(0, 0, 0, 0), t;
  }
}
function ws(e, n, t) {
  var v, w, b, _;
  const a = Et(), o = (t == null ? void 0 : t.weekStartsOn) ?? ((w = (v = t == null ? void 0 : t.locale) == null ? void 0 : v.options) == null ? void 0 : w.weekStartsOn) ?? a.weekStartsOn ?? ((_ = (b = a.locale) == null ? void 0 : b.options) == null ? void 0 : _.weekStartsOn) ?? 0, s = T(e), l = s.getDay(), d = (n % 7 + 7) % 7, h = 7 - o, p = n < 0 || n > 6 ? n - (l + h) % 7 : (d + h) % 7 - (l + h) % 7;
  return Cn(s, p);
}
class mO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 90);
    re(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, a, o) {
    switch (a) {
      case "E":
      case "EE":
      case "EEE":
        return o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return o.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return o.day(t, { width: "wide", context: "formatting" }) || o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, o, s) {
    return t = ws(t, o, s), t.setHours(0, 0, 0, 0), t;
  }
}
class vO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 90);
    re(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, o, s) {
    const l = (c) => {
      const d = Math.floor((c - 1) / 7) * 7;
      return (c + s.weekStartsOn + 6) % 7 + d;
    };
    switch (a) {
      case "e":
      case "ee":
        return ut(rt(a.length, t), l);
      case "eo":
        return ut(
          o.ordinalNumber(t, {
            unit: "day"
          }),
          l
        );
      case "eee":
        return o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "eeeee":
        return o.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return o.day(t, { width: "wide", context: "formatting" }) || o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, o, s) {
    return t = ws(t, o, s), t.setHours(0, 0, 0, 0), t;
  }
}
class gO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 90);
    re(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, a, o, s) {
    const l = (c) => {
      const d = Math.floor((c - 1) / 7) * 7;
      return (c + s.weekStartsOn + 6) % 7 + d;
    };
    switch (a) {
      case "c":
      case "cc":
        return ut(rt(a.length, t), l);
      case "co":
        return ut(
          o.ordinalNumber(t, {
            unit: "day"
          }),
          l
        );
      case "ccc":
        return o.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
      case "ccccc":
        return o.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return o.day(t, { width: "wide", context: "standalone" }) || o.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, o, s) {
    return t = ws(t, o, s), t.setHours(0, 0, 0, 0), t;
  }
}
function Fv(e, n) {
  const t = T(e), a = Mv(t), o = n - a;
  return Cn(t, o);
}
class yO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 90);
    re(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, o) {
    const s = (l) => l === 0 ? 7 : l;
    switch (a) {
      case "i":
      case "ii":
        return rt(a.length, t);
      case "io":
        return o.ordinalNumber(t, { unit: "day" });
      case "iii":
        return ut(
          o.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      case "iiiii":
        return ut(
          o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      case "iiiiii":
        return ut(
          o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      case "iiii":
      default:
        return ut(
          o.day(t, {
            width: "wide",
            context: "formatting"
          }) || o.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 7;
  }
  set(t, a, o) {
    return t = Fv(t, o), t.setHours(0, 0, 0, 0), t;
  }
}
class wO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 80);
    re(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, a, o) {
    switch (a) {
      case "a":
      case "aa":
      case "aaa":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, o) {
    return t.setHours(Ac(o), 0, 0, 0), t;
  }
}
class bO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 80);
    re(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, a, o) {
    switch (a) {
      case "b":
      case "bb":
      case "bbb":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, o) {
    return t.setHours(Ac(o), 0, 0, 0), t;
  }
}
class _O extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 80);
    re(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, a, o) {
    switch (a) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, o) {
    return t.setHours(Ac(o), 0, 0, 0), t;
  }
}
class xO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 70);
    re(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, a, o) {
    switch (a) {
      case "h":
        return Je(st.hour12h, t);
      case "ho":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return rt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 12;
  }
  set(t, a, o) {
    const s = t.getHours() >= 12;
    return s && o < 12 ? t.setHours(o + 12, 0, 0, 0) : !s && o === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(o, 0, 0, 0), t;
  }
}
class DO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 70);
    re(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, a, o) {
    switch (a) {
      case "H":
        return Je(st.hour23h, t);
      case "Ho":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return rt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 23;
  }
  set(t, a, o) {
    return t.setHours(o, 0, 0, 0), t;
  }
}
class SO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 70);
    re(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, a, o) {
    switch (a) {
      case "K":
        return Je(st.hour11h, t);
      case "Ko":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return rt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, o) {
    return t.getHours() >= 12 && o < 12 ? t.setHours(o + 12, 0, 0, 0) : t.setHours(o, 0, 0, 0), t;
  }
}
class OO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 70);
    re(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, a, o) {
    switch (a) {
      case "k":
        return Je(st.hour24h, t);
      case "ko":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return rt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 24;
  }
  set(t, a, o) {
    const s = o <= 24 ? o % 24 : o;
    return t.setHours(s, 0, 0, 0), t;
  }
}
class MO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 60);
    re(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a, o) {
    switch (a) {
      case "m":
        return Je(st.minute, t);
      case "mo":
        return o.ordinalNumber(t, { unit: "minute" });
      default:
        return rt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 59;
  }
  set(t, a, o) {
    return t.setMinutes(o, 0, 0), t;
  }
}
class CO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 50);
    re(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a, o) {
    switch (a) {
      case "s":
        return Je(st.second, t);
      case "so":
        return o.ordinalNumber(t, { unit: "second" });
      default:
        return rt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 59;
  }
  set(t, a, o) {
    return t.setSeconds(o, 0), t;
  }
}
class PO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 30);
    re(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a) {
    const o = (s) => Math.trunc(s * Math.pow(10, -a.length + 3));
    return ut(rt(a.length, t), o);
  }
  set(t, a, o) {
    return t.setMilliseconds(o), t;
  }
}
class TO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 10);
    re(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, a) {
    switch (a) {
      case "X":
        return _n(
          bn.basicOptionalMinutes,
          t
        );
      case "XX":
        return _n(bn.basic, t);
      case "XXXX":
        return _n(
          bn.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return _n(
          bn.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return _n(bn.extended, t);
    }
  }
  set(t, a, o) {
    return a.timestampIsSet ? t : ye(
      t,
      t.getTime() - kt(t) - o
    );
  }
}
class EO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 10);
    re(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, a) {
    switch (a) {
      case "x":
        return _n(
          bn.basicOptionalMinutes,
          t
        );
      case "xx":
        return _n(bn.basic, t);
      case "xxxx":
        return _n(
          bn.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return _n(
          bn.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return _n(bn.extended, t);
    }
  }
  set(t, a, o) {
    return a.timestampIsSet ? t : ye(
      t,
      t.getTime() - kt(t) - o
    );
  }
}
class RO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 40);
    re(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return Ev(t);
  }
  set(t, a, o) {
    return [ye(t, o * 1e3), { timestampIsSet: !0 }];
  }
}
class AO extends Re {
  constructor() {
    super(...arguments);
    re(this, "priority", 20);
    re(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return Ev(t);
  }
  set(t, a, o) {
    return [ye(t, o), { timestampIsSet: !0 }];
  }
}
const Nv = {
  G: new eO(),
  y: new tO(),
  Y: new nO(),
  R: new rO(),
  u: new aO(),
  Q: new iO(),
  q: new oO(),
  M: new sO(),
  L: new uO(),
  w: new lO(),
  I: new cO(),
  d: new hO(),
  D: new pO(),
  E: new mO(),
  e: new vO(),
  c: new gO(),
  i: new yO(),
  a: new wO(),
  b: new bO(),
  B: new _O(),
  h: new xO(),
  H: new DO(),
  K: new SO(),
  k: new OO(),
  m: new MO(),
  s: new CO(),
  S: new PO(),
  X: new TO(),
  x: new EO(),
  t: new RO(),
  T: new AO()
}, IO = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, LO = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, FO = /^'([^]*?)'?$/, NO = /''/g, kO = /\S/, WO = /[a-zA-Z]/;
function kv(e, n, t, a) {
  var D, C, N, $, A, k, R, ie;
  const o = Ov(), s = (a == null ? void 0 : a.locale) ?? o.locale ?? Ma, l = (a == null ? void 0 : a.firstWeekContainsDate) ?? ((C = (D = a == null ? void 0 : a.locale) == null ? void 0 : D.options) == null ? void 0 : C.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? (($ = (N = o.locale) == null ? void 0 : N.options) == null ? void 0 : $.firstWeekContainsDate) ?? 1, c = (a == null ? void 0 : a.weekStartsOn) ?? ((k = (A = a == null ? void 0 : a.locale) == null ? void 0 : A.options) == null ? void 0 : k.weekStartsOn) ?? o.weekStartsOn ?? ((ie = (R = o.locale) == null ? void 0 : R.options) == null ? void 0 : ie.weekStartsOn) ?? 0;
  if (n === "")
    return e === "" ? T(t) : ye(t, NaN);
  const d = {
    firstWeekContainsDate: l,
    weekStartsOn: c,
    locale: s
  }, h = [new J5()], p = n.match(LO).map((Y) => {
    const z = Y[0];
    if (z in Jo) {
      const oe = Jo[z];
      return oe(Y, s.formatLong);
    }
    return Y;
  }).join("").match(IO), v = [];
  for (let Y of p) {
    !(a != null && a.useAdditionalWeekYearTokens) && wv(Y) && Yl(Y, n, e), !(a != null && a.useAdditionalDayOfYearTokens) && yv(Y) && Yl(Y, n, e);
    const z = Y[0], oe = Nv[z];
    if (oe) {
      const { incompatibleTokens: xe } = oe;
      if (Array.isArray(xe)) {
        const Ae = v.find(
          (Te) => xe.includes(Te.token) || Te.token === z
        );
        if (Ae)
          throw new RangeError(
            `The format string mustn't contain \`${Ae.fullToken}\` and \`${Y}\` at the same time`
          );
      } else if (oe.incompatibleTokens === "*" && v.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${Y}\` and any other token at the same time`
        );
      v.push({ token: z, fullToken: Y });
      const Ne = oe.run(
        e,
        Y,
        s.match,
        d
      );
      if (!Ne)
        return ye(t, NaN);
      h.push(Ne.setter), e = Ne.rest;
    } else {
      if (z.match(WO))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + z + "`"
        );
      if (Y === "''" ? Y = "'" : z === "'" && (Y = VO(Y)), e.indexOf(Y) === 0)
        e = e.slice(Y.length);
      else
        return ye(t, NaN);
    }
  }
  if (e.length > 0 && kO.test(e))
    return ye(t, NaN);
  const w = h.map((Y) => Y.priority).sort((Y, z) => z - Y).filter((Y, z, oe) => oe.indexOf(Y) === z).map(
    (Y) => h.filter((z) => z.priority === Y).sort((z, oe) => oe.subPriority - z.subPriority)
  ).map((Y) => Y[0]);
  let b = T(t);
  if (isNaN(b.getTime()))
    return ye(t, NaN);
  const _ = {};
  for (const Y of w) {
    if (!Y.validate(b, d))
      return ye(t, NaN);
    const z = Y.set(b, _, d);
    Array.isArray(z) ? (b = z[0], Object.assign(_, z[1])) : b = z;
  }
  return ye(t, b);
}
function VO(e) {
  return e.match(FO)[1].replace(NO, "'");
}
function $O(e, n, t) {
  return zn(kv(e, n, /* @__PURE__ */ new Date(), t));
}
function YO(e) {
  return T(e).getDay() === 1;
}
function BO(e) {
  return +T(e) < Date.now();
}
function Hl(e) {
  const n = T(e);
  return n.setMinutes(0, 0, 0), n;
}
function Wv(e, n) {
  const t = Hl(e), a = Hl(n);
  return +t == +a;
}
function Ic(e, n, t) {
  const a = yt(e, t), o = yt(n, t);
  return +a == +o;
}
function Vv(e, n) {
  return Ic(e, n, { weekStartsOn: 1 });
}
function HO(e, n) {
  const t = hr(e), a = hr(n);
  return +t == +a;
}
function $v(e, n) {
  const t = Zo(e), a = Zo(n);
  return +t == +a;
}
function Yv(e, n) {
  const t = T(e), a = T(n);
  return t.getFullYear() === a.getFullYear() && t.getMonth() === a.getMonth();
}
function Bv(e, n) {
  const t = kr(e), a = kr(n);
  return +t == +a;
}
function Ul(e) {
  const n = T(e);
  return n.setMilliseconds(0), n;
}
function Hv(e, n) {
  const t = Ul(e), a = Ul(n);
  return +t == +a;
}
function Uv(e, n) {
  const t = T(e), a = T(n);
  return t.getFullYear() === a.getFullYear();
}
function UO(e) {
  return Wv(e, Wt(e));
}
function jO(e) {
  return Vv(e, Wt(e));
}
function zO(e) {
  return $v(e, Wt(e));
}
function qO(e) {
  return Yv(e, Wt(e));
}
function GO(e) {
  return Bv(e, Wt(e));
}
function KO(e) {
  return Hv(e, Wt(e));
}
function XO(e, n) {
  return Ic(e, Wt(e), n);
}
function ZO(e) {
  return Uv(e, Wt(e));
}
function QO(e) {
  return T(e).getDay() === 4;
}
function JO(e) {
  return Di(e, Wt(e));
}
function e7(e) {
  return Di(e, Cn(Wt(e), 1));
}
function t7(e) {
  return T(e).getDay() === 2;
}
function n7(e) {
  return T(e).getDay() === 3;
}
function r7(e, n) {
  const t = +T(e), [a, o] = [
    +T(n.start),
    +T(n.end)
  ].sort((s, l) => s - l);
  return t >= a && t <= o;
}
function bs(e, n) {
  return Cn(e, -n);
}
function a7(e) {
  return Di(e, bs(Wt(e), 1));
}
function i7(e) {
  const n = T(e), t = n.getFullYear(), a = 9 + Math.floor(t / 10) * 10;
  return n.setFullYear(a + 1, 0, 0), n.setHours(0, 0, 0, 0), n;
}
function jv(e, n) {
  var c, d, h, p;
  const t = Et(), a = (n == null ? void 0 : n.weekStartsOn) ?? ((d = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : d.weekStartsOn) ?? t.weekStartsOn ?? ((p = (h = t.locale) == null ? void 0 : h.options) == null ? void 0 : p.weekStartsOn) ?? 0, o = T(e), s = o.getDay(), l = (s < a ? -7 : 0) + 6 - (s - a);
  return o.setHours(0, 0, 0, 0), o.setDate(o.getDate() + l), o;
}
function o7(e) {
  return jv(e, { weekStartsOn: 1 });
}
function s7(e) {
  const n = dr(e), t = ye(e, 0);
  t.setFullYear(n + 1, 0, 4), t.setHours(0, 0, 0, 0);
  const a = dn(t);
  return a.setDate(a.getDate() - 1), a;
}
function u7(e) {
  const n = T(e), t = n.getMonth(), a = t - t % 3 + 3;
  return n.setMonth(a, 0), n.setHours(0, 0, 0, 0), n;
}
function l7(e) {
  const n = T(e), t = n.getFullYear();
  return n.setFullYear(t + 1, 0, 0), n.setHours(0, 0, 0, 0), n;
}
const c7 = /(\w)\1*|''|'(''|[^'])+('|$)|./g, f7 = /^'([^]*?)'?$/, d7 = /''/g, h7 = /[a-zA-Z]/;
function p7(e, n) {
  const t = T(e);
  if (!zn(t))
    throw new RangeError("Invalid time value");
  const a = n.match(c7);
  return a ? a.map((s) => {
    if (s === "''")
      return "'";
    const l = s[0];
    if (l === "'")
      return m7(s);
    const c = wn[l];
    if (c)
      return c(t, s);
    if (l.match(h7))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + l + "`"
      );
    return s;
  }).join("") : "";
}
function m7(e) {
  const n = e.match(f7);
  return n ? n[1].replace(d7, "'") : e;
}
function v7({
  years: e,
  months: n,
  weeks: t,
  days: a,
  hours: o,
  minutes: s,
  seconds: l
}) {
  let c = 0;
  e && (c += e * jo), n && (c += n * (jo / 12)), t && (c += t * 7), a && (c += a);
  let d = c * 24 * 60 * 60;
  return o && (d += o * 60 * 60), s && (d += s * 60), l && (d += l), Math.trunc(d * 1e3);
}
function g7(e) {
  const n = e / Br;
  return Math.trunc(n);
}
function y7(e) {
  const n = e / jn;
  return Math.trunc(n);
}
function w7(e) {
  const n = e / wc;
  return Math.trunc(n);
}
function b7(e) {
  const n = e / Km;
  return Math.trunc(n);
}
function _7(e) {
  return Math.trunc(e * jn);
}
function x7(e) {
  return Math.trunc(e * bc);
}
function D7(e) {
  const n = e / Xm;
  return Math.trunc(n);
}
function S7(e) {
  const n = e / Zm;
  return Math.trunc(n);
}
function vr(e, n) {
  let t = n - ys(e);
  return t <= 0 && (t += 7), Cn(e, t);
}
function O7(e) {
  return vr(e, 5);
}
function M7(e) {
  return vr(e, 1);
}
function C7(e) {
  return vr(e, 6);
}
function P7(e) {
  return vr(e, 0);
}
function T7(e) {
  return vr(e, 4);
}
function E7(e) {
  return vr(e, 2);
}
function R7(e) {
  return vr(e, 3);
}
function A7(e, n) {
  const t = (n == null ? void 0 : n.additionalDigits) ?? 2, a = N7(e);
  let o;
  if (a.date) {
    const d = k7(a.date, t);
    o = W7(d.restDateString, d.year);
  }
  if (!o || isNaN(o.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const s = o.getTime();
  let l = 0, c;
  if (a.time && (l = V7(a.time), isNaN(l)))
    return /* @__PURE__ */ new Date(NaN);
  if (a.timezone) {
    if (c = $7(a.timezone), isNaN(c))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const d = new Date(s + l), h = /* @__PURE__ */ new Date(0);
    return h.setFullYear(
      d.getUTCFullYear(),
      d.getUTCMonth(),
      d.getUTCDate()
    ), h.setHours(
      d.getUTCHours(),
      d.getUTCMinutes(),
      d.getUTCSeconds(),
      d.getUTCMilliseconds()
    ), h;
  }
  return new Date(s + l + c);
}
const Do = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, I7 = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, L7 = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, F7 = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function N7(e) {
  const n = {}, t = e.split(Do.dateTimeDelimiter);
  let a;
  if (t.length > 2)
    return n;
  if (/:/.test(t[0]) ? a = t[0] : (n.date = t[0], a = t[1], Do.timeZoneDelimiter.test(n.date) && (n.date = e.split(Do.timeZoneDelimiter)[0], a = e.substr(
    n.date.length,
    e.length
  ))), a) {
    const o = Do.timezone.exec(a);
    o ? (n.time = a.replace(o[1], ""), n.timezone = o[1]) : n.time = a;
  }
  return n;
}
function k7(e, n) {
  const t = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + n) + "})|(\\d{2}|[+-]\\d{" + (2 + n) + "})$)"
  ), a = e.match(t);
  if (!a) return { year: NaN, restDateString: "" };
  const o = a[1] ? parseInt(a[1]) : null, s = a[2] ? parseInt(a[2]) : null;
  return {
    year: s === null ? o : s * 100,
    restDateString: e.slice((a[1] || a[2]).length)
  };
}
function W7(e, n) {
  if (n === null) return /* @__PURE__ */ new Date(NaN);
  const t = e.match(I7);
  if (!t) return /* @__PURE__ */ new Date(NaN);
  const a = !!t[4], o = Ga(t[1]), s = Ga(t[2]) - 1, l = Ga(t[3]), c = Ga(t[4]), d = Ga(t[5]) - 1;
  if (a)
    return j7(n, c, d) ? Y7(n, c, d) : /* @__PURE__ */ new Date(NaN);
  {
    const h = /* @__PURE__ */ new Date(0);
    return !H7(n, s, l) || !U7(n, o) ? /* @__PURE__ */ new Date(NaN) : (h.setUTCFullYear(n, s, Math.max(o, l)), h);
  }
}
function Ga(e) {
  return e ? parseInt(e) : 1;
}
function V7(e) {
  const n = e.match(L7);
  if (!n) return NaN;
  const t = hl(n[1]), a = hl(n[2]), o = hl(n[3]);
  return z7(t, a, o) ? t * Br + a * jn + o * 1e3 : NaN;
}
function hl(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function $7(e) {
  if (e === "Z") return 0;
  const n = e.match(F7);
  if (!n) return 0;
  const t = n[1] === "+" ? -1 : 1, a = parseInt(n[2]), o = n[3] && parseInt(n[3]) || 0;
  return q7(a, o) ? t * (a * Br + o * jn) : NaN;
}
function Y7(e, n, t) {
  const a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(e, 0, 4);
  const o = a.getUTCDay() || 7, s = (n - 1) * 7 + t + 1 - o;
  return a.setUTCDate(a.getUTCDate() + s), a;
}
const B7 = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function zv(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function H7(e, n, t) {
  return n >= 0 && n <= 11 && t >= 1 && t <= (B7[n] || (zv(e) ? 29 : 28));
}
function U7(e, n) {
  return n >= 1 && n <= (zv(e) ? 366 : 365);
}
function j7(e, n, t) {
  return n >= 1 && n <= 53 && t >= 0 && t <= 6;
}
function z7(e, n, t) {
  return e === 24 ? n === 0 && t === 0 : t >= 0 && t < 60 && n >= 0 && n < 60 && e >= 0 && e < 25;
}
function q7(e, n) {
  return n >= 0 && n <= 59;
}
function G7(e) {
  const n = e.match(
    /(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/
  );
  return n ? new Date(
    Date.UTC(
      +n[1],
      +n[2] - 1,
      +n[3],
      +n[4] - (+n[9] || 0) * (n[8] == "-" ? -1 : 1),
      +n[5] - (+n[10] || 0) * (n[8] == "-" ? -1 : 1),
      +n[6],
      +((n[7] || "0") + "00").substring(0, 3)
    )
  ) : /* @__PURE__ */ new Date(NaN);
}
function gr(e, n) {
  let t = ys(e) - n;
  return t <= 0 && (t += 7), bs(e, t);
}
function K7(e) {
  return gr(e, 5);
}
function X7(e) {
  return gr(e, 1);
}
function Z7(e) {
  return gr(e, 6);
}
function Q7(e) {
  return gr(e, 0);
}
function J7(e) {
  return gr(e, 4);
}
function eM(e) {
  return gr(e, 2);
}
function tM(e) {
  return gr(e, 3);
}
function nM(e) {
  return Math.trunc(e * Xm);
}
function rM(e) {
  const n = e / Qm;
  return Math.trunc(n);
}
function aM(e, n) {
  const t = (n == null ? void 0 : n.nearestTo) ?? 1;
  if (t < 1 || t > 12) return ye(e, NaN);
  const a = T(e), o = a.getMinutes() / 60, s = a.getSeconds() / 60 / 60, l = a.getMilliseconds() / 1e3 / 60 / 60, c = a.getHours() + o + s + l, d = (n == null ? void 0 : n.roundingMethod) ?? "round", p = mr(d)(c / t) * t, v = ye(e, a);
  return v.setHours(p, 0, 0, 0), v;
}
function iM(e, n) {
  const t = (n == null ? void 0 : n.nearestTo) ?? 1;
  if (t < 1 || t > 30) return ye(e, NaN);
  const a = T(e), o = a.getSeconds() / 60, s = a.getMilliseconds() / 1e3 / 60, l = a.getMinutes() + o + s, c = (n == null ? void 0 : n.roundingMethod) ?? "round", h = mr(c)(l / t) * t, p = ye(e, a);
  return p.setMinutes(h, 0, 0), p;
}
function oM(e) {
  const n = e / ds;
  return Math.trunc(n);
}
function sM(e) {
  return e * wc;
}
function uM(e) {
  const n = e / bc;
  return Math.trunc(n);
}
function Lc(e, n) {
  const t = T(e), a = t.getFullYear(), o = t.getDate(), s = ye(e, 0);
  s.setFullYear(a, n, 15), s.setHours(0, 0, 0, 0);
  const l = Dv(s);
  return t.setMonth(n, Math.min(o, l)), t;
}
function lM(e, n) {
  let t = T(e);
  return isNaN(+t) ? ye(e, NaN) : (n.year != null && t.setFullYear(n.year), n.month != null && (t = Lc(t, n.month)), n.date != null && t.setDate(n.date), n.hours != null && t.setHours(n.hours), n.minutes != null && t.setMinutes(n.minutes), n.seconds != null && t.setSeconds(n.seconds), n.milliseconds != null && t.setMilliseconds(n.milliseconds), t);
}
function cM(e, n) {
  const t = T(e);
  return t.setDate(n), t;
}
function fM(e, n) {
  const t = T(e);
  return t.setMonth(0), t.setDate(n), t;
}
function dM(e) {
  const n = {}, t = Et();
  for (const a in t)
    Object.prototype.hasOwnProperty.call(t, a) && (n[a] = t[a]);
  for (const a in e)
    Object.prototype.hasOwnProperty.call(e, a) && (e[a] === void 0 ? delete n[a] : n[a] = e[a]);
  U4(n);
}
function hM(e, n) {
  const t = T(e);
  return t.setHours(n), t;
}
function pM(e, n) {
  const t = T(e);
  return t.setMilliseconds(n), t;
}
function mM(e, n) {
  const t = T(e);
  return t.setMinutes(n), t;
}
function vM(e, n) {
  const t = T(e), a = Math.trunc(t.getMonth() / 3) + 1, o = n - a;
  return Lc(t, t.getMonth() + o * 3);
}
function gM(e, n) {
  const t = T(e);
  return t.setSeconds(n), t;
}
function yM(e, n, t) {
  var d, h, p, v;
  const a = Et(), o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((h = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : h.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((v = (p = a.locale) == null ? void 0 : p.options) == null ? void 0 : v.firstWeekContainsDate) ?? 1;
  let s = T(e);
  const l = On(s, Qo(s, t)), c = ye(e, 0);
  return c.setFullYear(n, 0, o), c.setHours(0, 0, 0, 0), s = Qo(c, t), s.setDate(s.getDate() + l), s;
}
function wM(e, n) {
  const t = T(e);
  return isNaN(+t) ? ye(e, NaN) : (t.setFullYear(n), t);
}
function bM(e) {
  const n = T(e), t = n.getFullYear(), a = Math.floor(t / 10) * 10;
  return n.setFullYear(a, 0, 1), n.setHours(0, 0, 0, 0), n;
}
function _M() {
  return xa(Date.now());
}
function xM() {
  const e = /* @__PURE__ */ new Date(), n = e.getFullYear(), t = e.getMonth(), a = e.getDate(), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(n, t, a + 1), o.setHours(0, 0, 0, 0), o;
}
function DM() {
  const e = /* @__PURE__ */ new Date(), n = e.getFullYear(), t = e.getMonth(), a = e.getDate(), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(n, t, a - 1), o.setHours(0, 0, 0, 0), o;
}
function qv(e, n) {
  return bi(e, -n);
}
function SM(e, n) {
  const {
    years: t = 0,
    months: a = 0,
    weeks: o = 0,
    days: s = 0,
    hours: l = 0,
    minutes: c = 0,
    seconds: d = 0
  } = n, h = qv(e, a + t * 12), p = bs(h, s + o * 7), v = c + l * 60, b = (d + v * 60) * 1e3;
  return ye(e, p.getTime() - b);
}
function OM(e, n) {
  return zm(e, -n);
}
function MM(e, n) {
  return xc(e, -n);
}
function CM(e, n) {
  return _i(e, -n);
}
function PM(e, n) {
  return Dc(e, -n);
}
function TM(e, n) {
  return Sc(e, -n);
}
function EM(e, n) {
  return av(e, -n);
}
function RM(e, n) {
  return hs(e, -n);
}
function AM(e, n) {
  return iv(e, -n);
}
function IM(e) {
  return Math.trunc(e * qm);
}
function LM(e) {
  return Math.trunc(e * jo);
}
function FM(e) {
  return Math.trunc(e * Zm);
}
function NM(e) {
  return Math.trunc(e * Qm);
}
const kM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  add: da,
  addBusinessDays: zm,
  addDays: Cn,
  addHours: xc,
  addISOWeekYears: rv,
  addMilliseconds: _i,
  addMinutes: Dc,
  addMonths: bi,
  addQuarters: Sc,
  addSeconds: av,
  addWeeks: hs,
  addYears: iv,
  areIntervalsOverlapping: j4,
  clamp: z4,
  closestIndexTo: q4,
  closestTo: G4,
  compareAsc: Mn,
  compareDesc: K4,
  constructFrom: ye,
  constructNow: Wt,
  daysToWeeks: X4,
  differenceInBusinessDays: Z4,
  differenceInCalendarDays: On,
  differenceInCalendarISOWeekYears: lv,
  differenceInCalendarISOWeeks: Q4,
  differenceInCalendarMonths: qo,
  differenceInCalendarQuarters: Io,
  differenceInCalendarWeeks: Go,
  differenceInCalendarYears: oi,
  differenceInDays: Oc,
  differenceInHours: Ko,
  differenceInISOWeekYears: J4,
  differenceInMilliseconds: ps,
  differenceInMinutes: Xo,
  differenceInMonths: ms,
  differenceInQuarters: eS,
  differenceInSeconds: wa,
  differenceInWeeks: tS,
  differenceInYears: dv,
  eachDayOfInterval: hv,
  eachHourOfInterval: nS,
  eachMinuteOfInterval: rS,
  eachMonthOfInterval: aS,
  eachQuarterOfInterval: iS,
  eachWeekOfInterval: oS,
  eachWeekendOfInterval: Pc,
  eachWeekendOfMonth: sS,
  eachWeekendOfYear: uS,
  eachYearOfInterval: lS,
  endOfDay: Mc,
  endOfDecade: cS,
  endOfHour: fS,
  endOfISOWeek: dS,
  endOfISOWeekYear: hS,
  endOfMinute: pS,
  endOfMonth: Cc,
  endOfQuarter: mS,
  endOfSecond: vS,
  endOfToday: gS,
  endOfTomorrow: yS,
  endOfWeek: mv,
  endOfYear: pv,
  endOfYesterday: wS,
  format: Bl,
  formatDate: Bl,
  formatDistance: bv,
  formatDistanceStrict: _v,
  formatDistanceToNow: l5,
  formatDistanceToNowStrict: c5,
  formatDuration: d5,
  formatISO: h5,
  formatISO9075: p5,
  formatISODuration: m5,
  formatRFC3339: v5,
  formatRFC7231: w5,
  formatRelative: b5,
  formatters: $l,
  fromUnixTime: _5,
  getDate: xv,
  getDay: ys,
  getDayOfYear: vv,
  getDaysInMonth: Dv,
  getDaysInYear: x5,
  getDecade: D5,
  getDefaultOptions: Ov,
  getHours: S5,
  getISODay: Mv,
  getISOWeek: Ec,
  getISOWeekYear: dr,
  getISOWeeksInYear: O5,
  getMilliseconds: M5,
  getMinutes: C5,
  getMonth: P5,
  getOverlappingDaysInIntervals: T5,
  getQuarter: Vl,
  getSeconds: E5,
  getTime: R5,
  getUnixTime: A5,
  getWeek: Rc,
  getWeekOfMonth: I5,
  getWeekYear: gs,
  getWeeksInMonth: L5,
  getYear: F5,
  hoursToMilliseconds: N5,
  hoursToMinutes: k5,
  hoursToSeconds: W5,
  interval: V5,
  intervalToDuration: $5,
  intlFormat: Y5,
  intlFormatDistance: H5,
  isAfter: U5,
  isBefore: j5,
  isDate: uv,
  isEqual: z5,
  isExists: q5,
  isFirstDayOfMonth: G5,
  isFriday: K5,
  isFuture: X5,
  isLastDayOfMonth: fv,
  isLeapYear: Sv,
  isMatch: $O,
  isMonday: YO,
  isPast: BO,
  isSameDay: Di,
  isSameHour: Wv,
  isSameISOWeek: Vv,
  isSameISOWeekYear: HO,
  isSameMinute: $v,
  isSameMonth: Yv,
  isSameQuarter: Bv,
  isSameSecond: Hv,
  isSameWeek: Ic,
  isSameYear: Uv,
  isSaturday: Um,
  isSunday: jm,
  isThisHour: UO,
  isThisISOWeek: jO,
  isThisMinute: zO,
  isThisMonth: qO,
  isThisQuarter: GO,
  isThisSecond: KO,
  isThisWeek: XO,
  isThisYear: ZO,
  isThursday: QO,
  isToday: JO,
  isTomorrow: e7,
  isTuesday: t7,
  isValid: zn,
  isWednesday: n7,
  isWeekend: ya,
  isWithinInterval: r7,
  isYesterday: a7,
  lastDayOfDecade: i7,
  lastDayOfISOWeek: o7,
  lastDayOfISOWeekYear: s7,
  lastDayOfMonth: Cv,
  lastDayOfQuarter: u7,
  lastDayOfWeek: jv,
  lastDayOfYear: l7,
  lightFormat: p7,
  lightFormatters: wn,
  longFormatters: Jo,
  max: ov,
  milliseconds: v7,
  millisecondsToHours: g7,
  millisecondsToMinutes: y7,
  millisecondsToSeconds: w7,
  min: sv,
  minutesToHours: b7,
  minutesToMilliseconds: _7,
  minutesToSeconds: x7,
  monthsToQuarters: D7,
  monthsToYears: S7,
  nextDay: vr,
  nextFriday: O7,
  nextMonday: M7,
  nextSaturday: C7,
  nextSunday: P7,
  nextThursday: T7,
  nextTuesday: E7,
  nextWednesday: R7,
  parse: kv,
  parseISO: A7,
  parseJSON: G7,
  parsers: Nv,
  previousDay: gr,
  previousFriday: K7,
  previousMonday: X7,
  previousSaturday: Z7,
  previousSunday: Q7,
  previousThursday: J7,
  previousTuesday: eM,
  previousWednesday: tM,
  quartersToMonths: nM,
  quartersToYears: rM,
  roundToNearestHours: aM,
  roundToNearestMinutes: iM,
  secondsToHours: oM,
  secondsToMilliseconds: sM,
  secondsToMinutes: uM,
  set: lM,
  setDate: cM,
  setDay: ws,
  setDayOfYear: fM,
  setDefaultOptions: dM,
  setHours: hM,
  setISODay: Fv,
  setISOWeek: Lv,
  setISOWeekYear: nv,
  setMilliseconds: pM,
  setMinutes: mM,
  setMonth: Lc,
  setQuarter: vM,
  setSeconds: gM,
  setWeek: Iv,
  setWeekYear: yM,
  setYear: wM,
  startOfDay: xa,
  startOfDecade: bM,
  startOfHour: Hl,
  startOfISOWeek: dn,
  startOfISOWeekYear: hr,
  startOfMinute: Zo,
  startOfMonth: vs,
  startOfQuarter: kr,
  startOfSecond: Ul,
  startOfToday: _M,
  startOfTomorrow: xM,
  startOfWeek: yt,
  startOfWeekYear: Qo,
  startOfYear: Tc,
  startOfYesterday: DM,
  sub: SM,
  subBusinessDays: OM,
  subDays: bs,
  subHours: MM,
  subISOWeekYears: cv,
  subMilliseconds: CM,
  subMinutes: PM,
  subMonths: qv,
  subQuarters: TM,
  subSeconds: EM,
  subWeeks: RM,
  subYears: AM,
  toDate: T,
  transpose: Pv,
  weeksToDays: IM,
  yearsToDays: LM,
  yearsToMonths: FM,
  yearsToQuarters: NM
}, Symbol.toStringTag, { value: "Module" })), Hr = /* @__PURE__ */ c0(kM);
Object.defineProperty(Un, "__esModule", {
  value: !0
});
Un.rangeShape = Un.default = void 0;
var Er = WM(X), Ce = Gv(qn), pl = Gv(Yr), Pt = Hr;
function Gv(e) {
  return e && e.__esModule ? e : { default: e };
}
function Kv(e) {
  if (typeof WeakMap != "function") return null;
  var n = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  return (Kv = function(a) {
    return a ? t : n;
  })(e);
}
function WM(e, n) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var t = Kv(n);
  if (t && t.has(e)) return t.get(e);
  var a = { __proto__: null }, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in e) if (s !== "default" && Object.prototype.hasOwnProperty.call(e, s)) {
    var l = o ? Object.getOwnPropertyDescriptor(e, s) : null;
    l && (l.get || l.set) ? Object.defineProperty(a, s, l) : a[s] = e[s];
  }
  return a.default = e, t && t.set(e, a), a;
}
function jl() {
  return jl = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, jl.apply(this, arguments);
}
function Ka(e, n, t) {
  return n = VM(n), n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function VM(e) {
  var n = $M(e, "string");
  return typeof n == "symbol" ? n : String(n);
}
function $M(e, n) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, n);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
class Fc extends Er.Component {
  constructor(n, t) {
    super(n, t), Ka(this, "handleKeyEvent", (a) => {
      const {
        day: o,
        onMouseDown: s,
        onMouseUp: l
      } = this.props;
      [
        13,
        32
        /* enter */
      ].includes(a.keyCode) && (a.type === "keydown" ? s(o) : l(o));
    }), Ka(this, "handleMouseEvent", (a) => {
      const {
        day: o,
        disabled: s,
        onPreviewChange: l,
        onMouseEnter: c,
        onMouseDown: d,
        onMouseUp: h
      } = this.props, p = {};
      if (s) {
        l();
        return;
      }
      switch (a.type) {
        case "mouseenter":
          c(o), l(o), p.hover = !0;
          break;
        case "blur":
        case "mouseleave":
          p.hover = !1;
          break;
        case "mousedown":
          p.active = !0, d(o);
          break;
        case "mouseup":
          a.stopPropagation(), p.active = !1, h(o);
          break;
        case "focus":
          l(o);
          break;
      }
      Object.keys(p).length && this.setState(p);
    }), Ka(this, "getClassNames", () => {
      const {
        isPassive: a,
        isToday: o,
        isWeekend: s,
        isStartOfWeek: l,
        isEndOfWeek: c,
        isStartOfMonth: d,
        isEndOfMonth: h,
        disabled: p,
        styles: v
      } = this.props;
      return (0, pl.default)(v.day, {
        [v.dayPassive]: a,
        [v.dayDisabled]: p,
        [v.dayToday]: o,
        [v.dayWeekend]: s,
        [v.dayStartOfWeek]: l,
        [v.dayEndOfWeek]: c,
        [v.dayStartOfMonth]: d,
        [v.dayEndOfMonth]: h,
        [v.dayHovered]: this.state.hover,
        [v.dayActive]: this.state.active
      });
    }), Ka(this, "renderPreviewPlaceholder", () => {
      const {
        preview: a,
        day: o,
        styles: s
      } = this.props;
      if (!a) return null;
      const l = a.startDate ? (0, Pt.endOfDay)(a.startDate) : null, c = a.endDate ? (0, Pt.startOfDay)(a.endDate) : null, d = (!l || (0, Pt.isAfter)(o, l)) && (!c || (0, Pt.isBefore)(o, c)), h = !d && (0, Pt.isSameDay)(o, l), p = !d && (0, Pt.isSameDay)(o, c);
      return /* @__PURE__ */ Er.default.createElement("span", {
        className: (0, pl.default)({
          [s.dayStartPreview]: h,
          [s.dayInPreview]: d,
          [s.dayEndPreview]: p
        }),
        style: {
          color: a.color
        }
      });
    }), Ka(this, "renderSelectionPlaceholders", () => {
      const {
        styles: a,
        ranges: o,
        day: s
      } = this.props;
      return this.props.displayMode === "date" ? (0, Pt.isSameDay)(this.props.day, this.props.date) ? /* @__PURE__ */ Er.default.createElement("span", {
        className: a.selected,
        style: {
          color: this.props.color
        }
      }) : null : o.reduce((c, d) => {
        let h = d.startDate, p = d.endDate;
        h && p && (0, Pt.isBefore)(p, h) && ([h, p] = [p, h]), h = h ? (0, Pt.endOfDay)(h) : null, p = p ? (0, Pt.startOfDay)(p) : null;
        const v = (!h || (0, Pt.isAfter)(s, h)) && (!p || (0, Pt.isBefore)(s, p)), w = !v && (0, Pt.isSameDay)(s, h), b = !v && (0, Pt.isSameDay)(s, p);
        return v || w || b ? [...c, {
          isStartEdge: w,
          isEndEdge: b,
          isInRange: v,
          ...d
        }] : c;
      }, []).map((c, d) => /* @__PURE__ */ Er.default.createElement("span", {
        key: d,
        className: (0, pl.default)({
          [a.startEdge]: c.isStartEdge,
          [a.endEdge]: c.isEndEdge,
          [a.inRange]: c.isInRange
        }),
        style: {
          color: c.color || this.props.color
        }
      }));
    }), this.state = {
      hover: !1,
      active: !1
    };
  }
  render() {
    const {
      dayContentRenderer: n
    } = this.props;
    return /* @__PURE__ */ Er.default.createElement("button", jl({
      type: "button",
      onMouseEnter: this.handleMouseEvent,
      onMouseLeave: this.handleMouseEvent,
      onFocus: this.handleMouseEvent,
      onMouseDown: this.handleMouseEvent,
      onMouseUp: this.handleMouseEvent,
      onBlur: this.handleMouseEvent,
      onPauseCapture: this.handleMouseEvent,
      onKeyDown: this.handleKeyEvent,
      onKeyUp: this.handleKeyEvent,
      className: this.getClassNames(this.props.styles)
    }, this.props.disabled || this.props.isPassive ? {
      tabIndex: -1
    } : {}, {
      style: {
        color: this.props.color
      }
    }), this.renderSelectionPlaceholders(), this.renderPreviewPlaceholder(), /* @__PURE__ */ Er.default.createElement("span", {
      className: this.props.styles.dayNumber
    }, (n == null ? void 0 : n(this.props.day)) || /* @__PURE__ */ Er.default.createElement("span", null, (0, Pt.format)(this.props.day, this.props.dayDisplayFormat))));
  }
}
Fc.defaultProps = {};
const YM = Un.rangeShape = Ce.default.shape({
  startDate: Ce.default.object,
  endDate: Ce.default.object,
  color: Ce.default.string,
  key: Ce.default.string,
  autoFocus: Ce.default.bool,
  disabled: Ce.default.bool,
  showDateDisplay: Ce.default.bool
});
Fc.propTypes = {
  day: Ce.default.object.isRequired,
  dayDisplayFormat: Ce.default.string,
  date: Ce.default.object,
  ranges: Ce.default.arrayOf(YM),
  preview: Ce.default.shape({
    startDate: Ce.default.object,
    endDate: Ce.default.object,
    color: Ce.default.string
  }),
  onPreviewChange: Ce.default.func,
  previewColor: Ce.default.string,
  disabled: Ce.default.bool,
  isPassive: Ce.default.bool,
  isToday: Ce.default.bool,
  isWeekend: Ce.default.bool,
  isStartOfWeek: Ce.default.bool,
  isEndOfWeek: Ce.default.bool,
  isStartOfMonth: Ce.default.bool,
  isEndOfMonth: Ce.default.bool,
  color: Ce.default.string,
  displayMode: Ce.default.oneOf(["dateRange", "date"]),
  styles: Ce.default.object,
  onMouseDown: Ce.default.func,
  onMouseUp: Ce.default.func,
  onMouseEnter: Ce.default.func,
  dayContentRenderer: Ce.default.func
};
Un.default = Fc;
var _s = {}, Gn = {};
Object.defineProperty(Gn, "__esModule", {
  value: !0
});
Gn.calcFocusDate = UM;
Gn.findNextRangeIndex = jM;
Gn.generateStyles = qM;
Gn.getMonthDisplayRange = zM;
var BM = HM(Yr), $n = Hr;
function HM(e) {
  return e && e.__esModule ? e : { default: e };
}
function UM(e, n) {
  const {
    shownDate: t,
    date: a,
    months: o,
    ranges: s,
    focusedRange: l,
    displayMode: c
  } = n;
  let d;
  if (c === "dateRange") {
    const p = s[l[0]] || {};
    d = {
      start: p.startDate,
      end: p.endDate
    };
  } else
    d = {
      start: a,
      end: a
    };
  d.start = (0, $n.startOfMonth)(d.start || /* @__PURE__ */ new Date()), d.end = (0, $n.endOfMonth)(d.end || d.start);
  const h = d.start || d.end || t || /* @__PURE__ */ new Date();
  return e ? (0, $n.differenceInCalendarMonths)(d.start, d.end) > o ? e : h : t || h;
}
function jM(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
  const t = e.findIndex((a, o) => o > n && a.autoFocus !== !1 && !a.disabled);
  return t !== -1 ? t : e.findIndex((a) => a.autoFocus !== !1 && !a.disabled);
}
function zM(e, n, t) {
  const a = (0, $n.startOfMonth)(e, n), o = (0, $n.endOfMonth)(e, n), s = (0, $n.startOfWeek)(a, n);
  let l = (0, $n.endOfWeek)(o, n);
  return t && (0, $n.differenceInCalendarDays)(l, s) <= 34 && (l = (0, $n.addDays)(l, 7)), {
    start: s,
    end: l,
    startDateOfMonth: a,
    endDateOfMonth: o
  };
}
function qM(e) {
  return e.length ? e.filter((t) => !!t).reduce((t, a) => (Object.keys(a).forEach((o) => {
    t[o] = (0, BM.default)(t[o], a[o]);
  }), t), {}) : {};
}
Object.defineProperty(_s, "__esModule", {
  value: !0
});
_s.default = void 0;
var Fr = Qv(X), Be = KM(qn), Xv = Qv(Un), ct = Hr, GM = Gn;
function KM(e) {
  return e && e.__esModule ? e : { default: e };
}
function Zv(e) {
  if (typeof WeakMap != "function") return null;
  var n = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  return (Zv = function(a) {
    return a ? t : n;
  })(e);
}
function Qv(e, n) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var t = Zv(n);
  if (t && t.has(e)) return t.get(e);
  var a = { __proto__: null }, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in e) if (s !== "default" && Object.prototype.hasOwnProperty.call(e, s)) {
    var l = o ? Object.getOwnPropertyDescriptor(e, s) : null;
    l && (l.get || l.set) ? Object.defineProperty(a, s, l) : a[s] = e[s];
  }
  return a.default = e, t && t.set(e, a), a;
}
function zl() {
  return zl = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, zl.apply(this, arguments);
}
function XM(e, n, t) {
  const a = /* @__PURE__ */ new Date();
  return /* @__PURE__ */ Fr.default.createElement("div", {
    className: e.weekDays
  }, (0, ct.eachDayOfInterval)({
    start: (0, ct.startOfWeek)(a, n),
    end: (0, ct.endOfWeek)(a, n)
  }).map((o, s) => /* @__PURE__ */ Fr.default.createElement("span", {
    className: e.weekDay,
    key: s
  }, (0, ct.format)(o, t, n))));
}
class Nc extends Fr.PureComponent {
  render() {
    const n = /* @__PURE__ */ new Date(), {
      displayMode: t,
      focusedRange: a,
      drag: o,
      styles: s,
      disabledDates: l,
      disabledDay: c
    } = this.props, d = this.props.minDate && (0, ct.startOfDay)(this.props.minDate), h = this.props.maxDate && (0, ct.endOfDay)(this.props.maxDate), p = (0, GM.getMonthDisplayRange)(this.props.month, this.props.dateOptions, this.props.fixedHeight);
    let v = this.props.ranges;
    if (t === "dateRange" && o.status) {
      let {
        startDate: b,
        endDate: _
      } = o.range;
      v = v.map((D, C) => C !== a[0] ? D : {
        ...D,
        startDate: b,
        endDate: _
      });
    }
    const w = this.props.showPreview && !o.disablePreview;
    return /* @__PURE__ */ Fr.default.createElement("div", {
      className: s.month,
      style: this.props.style
    }, this.props.showMonthName ? /* @__PURE__ */ Fr.default.createElement("div", {
      className: s.monthName
    }, (0, ct.format)(this.props.month, this.props.monthDisplayFormat, this.props.dateOptions)) : null, this.props.showWeekDays && XM(s, this.props.dateOptions, this.props.weekdayDisplayFormat), /* @__PURE__ */ Fr.default.createElement("div", {
      className: s.days,
      onMouseLeave: this.props.onMouseLeave
    }, (0, ct.eachDayOfInterval)({
      start: p.start,
      end: p.end
    }).map((b, _) => {
      const D = (0, ct.isSameDay)(b, p.startDateOfMonth), C = (0, ct.isSameDay)(b, p.endDateOfMonth), N = d && (0, ct.isBefore)(b, d) || h && (0, ct.isAfter)(b, h), $ = l.some((k) => (0, ct.isSameDay)(k, b)), A = c(b);
      return /* @__PURE__ */ Fr.default.createElement(Xv.default, zl({}, this.props, {
        ranges: v,
        day: b,
        preview: w ? this.props.preview : null,
        isWeekend: (0, ct.isWeekend)(b, this.props.dateOptions),
        isToday: (0, ct.isSameDay)(b, n),
        isStartOfWeek: (0, ct.isSameDay)(b, (0, ct.startOfWeek)(b, this.props.dateOptions)),
        isEndOfWeek: (0, ct.isSameDay)(b, (0, ct.endOfWeek)(b, this.props.dateOptions)),
        isStartOfMonth: D,
        isEndOfMonth: C,
        key: _,
        disabled: N || $ || A,
        isPassive: !(0, ct.isWithinInterval)(b, {
          start: p.startDateOfMonth,
          end: p.endDateOfMonth
        }),
        styles: s,
        onMouseDown: this.props.onDragSelectionStart,
        onMouseUp: this.props.onDragSelectionEnd,
        onMouseEnter: this.props.onDragSelectionMove,
        dragRange: o.range,
        drag: o.status
      }));
    })));
  }
}
Nc.defaultProps = {};
Nc.propTypes = {
  style: Be.default.object,
  styles: Be.default.object,
  month: Be.default.object,
  drag: Be.default.object,
  dateOptions: Be.default.object,
  disabledDates: Be.default.array,
  disabledDay: Be.default.func,
  preview: Be.default.shape({
    startDate: Be.default.object,
    endDate: Be.default.object
  }),
  showPreview: Be.default.bool,
  displayMode: Be.default.oneOf(["dateRange", "date"]),
  minDate: Be.default.object,
  maxDate: Be.default.object,
  ranges: Be.default.arrayOf(Xv.rangeShape),
  focusedRange: Be.default.arrayOf(Be.default.number),
  onDragSelectionStart: Be.default.func,
  onDragSelectionEnd: Be.default.func,
  onDragSelectionMove: Be.default.func,
  onMouseLeave: Be.default.func,
  monthDisplayFormat: Be.default.string,
  weekdayDisplayFormat: Be.default.string,
  dayDisplayFormat: Be.default.string,
  showWeekDays: Be.default.bool,
  showMonthName: Be.default.bool,
  fixedHeight: Be.default.bool
};
_s.default = Nc;
var xs = {};
Object.defineProperty(xs, "__esModule", {
  value: !0
});
xs.default = void 0;
var So = QM(X), vn = Jv(qn), ZM = Jv(Yr), Xa = Hr;
function Jv(e) {
  return e && e.__esModule ? e : { default: e };
}
function eg(e) {
  if (typeof WeakMap != "function") return null;
  var n = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  return (eg = function(a) {
    return a ? t : n;
  })(e);
}
function QM(e, n) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var t = eg(n);
  if (t && t.has(e)) return t.get(e);
  var a = { __proto__: null }, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in e) if (s !== "default" && Object.prototype.hasOwnProperty.call(e, s)) {
    var l = o ? Object.getOwnPropertyDescriptor(e, s) : null;
    l && (l.get || l.set) ? Object.defineProperty(a, s, l) : a[s] = e[s];
  }
  return a.default = e, t && t.set(e, a), a;
}
function ml(e, n, t) {
  return n = JM(n), n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function JM(e) {
  var n = eC(e, "string");
  return typeof n == "symbol" ? n : String(n);
}
function eC(e, n) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, n);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
class kc extends So.PureComponent {
  constructor(n, t) {
    super(n, t), ml(this, "onKeyDown", (a) => {
      const {
        value: o
      } = this.state;
      a.key === "Enter" && this.update(o);
    }), ml(this, "onChange", (a) => {
      this.setState({
        value: a.target.value,
        changed: !0,
        invalid: !1
      });
    }), ml(this, "onBlur", () => {
      const {
        value: a
      } = this.state;
      this.update(a);
    }), this.state = {
      invalid: !1,
      changed: !1,
      value: this.formatDate(n)
    };
  }
  componentDidUpdate(n) {
    const {
      value: t
    } = n;
    (0, Xa.isEqual)(t, this.props.value) || this.setState({
      value: this.formatDate(this.props)
    });
  }
  formatDate(n) {
    let {
      value: t,
      dateDisplayFormat: a,
      dateOptions: o
    } = n;
    return t && (0, Xa.isValid)(t) ? (0, Xa.format)(t, a, o) : "";
  }
  update(n) {
    const {
      invalid: t,
      changed: a
    } = this.state;
    if (t || !a || !n)
      return;
    const {
      onChange: o,
      dateDisplayFormat: s,
      dateOptions: l
    } = this.props, c = (0, Xa.parse)(n, s, /* @__PURE__ */ new Date(), l);
    (0, Xa.isValid)(c) ? this.setState({
      changed: !1
    }, () => o(c)) : this.setState({
      invalid: !0
    });
  }
  render() {
    const {
      className: n,
      readOnly: t,
      placeholder: a,
      ariaLabel: o,
      disabled: s,
      onFocus: l
    } = this.props, {
      value: c,
      invalid: d
    } = this.state;
    return /* @__PURE__ */ So.default.createElement("span", {
      className: (0, ZM.default)("rdrDateInput", n)
    }, /* @__PURE__ */ So.default.createElement("input", {
      readOnly: t,
      disabled: s,
      value: c,
      placeholder: a,
      "aria-label": o,
      onKeyDown: this.onKeyDown,
      onChange: this.onChange,
      onBlur: this.onBlur,
      onFocus: l
    }), d && /* @__PURE__ */ So.default.createElement("span", {
      className: "rdrWarning"
    }, "⚠"));
  }
}
kc.propTypes = {
  value: vn.default.object,
  placeholder: vn.default.string,
  disabled: vn.default.bool,
  readOnly: vn.default.bool,
  dateOptions: vn.default.object,
  dateDisplayFormat: vn.default.string,
  ariaLabel: vn.default.string,
  className: vn.default.string,
  onFocus: vn.default.func.isRequired,
  onChange: vn.default.func.isRequired
};
kc.defaultProps = {
  readOnly: !0,
  disabled: !1,
  dateDisplayFormat: "MMM D, YYYY"
};
xs.default = kc;
var tg = {};
(function(e) {
  (function(n, t) {
    t(e, X, Z3);
  })(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : fa, function(n, t, a) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.default = void 0;
    function o(V) {
      "@babel/helpers - typeof";
      return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(I) {
        return typeof I;
      } : function(I) {
        return I && typeof Symbol == "function" && I.constructor === Symbol && I !== Symbol.prototype ? "symbol" : typeof I;
      }, o(V);
    }
    function s(V, I) {
      if (!(V instanceof I)) throw new TypeError("Cannot call a class as a function");
    }
    function l(V, I) {
      for (var M = 0; M < I.length; M++) {
        var S = I[M];
        S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(V, $(S.key), S);
      }
    }
    function c(V, I, M) {
      return I && l(V.prototype, I), M && l(V, M), Object.defineProperty(V, "prototype", { writable: !1 }), V;
    }
    function d(V, I, M) {
      return I = w(I), h(V, v() ? Reflect.construct(I, M || [], w(V).constructor) : I.apply(V, M));
    }
    function h(V, I) {
      if (I && (o(I) == "object" || typeof I == "function")) return I;
      if (I !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
      return p(V);
    }
    function p(V) {
      if (V === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return V;
    }
    function v() {
      try {
        var V = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        }));
      } catch {
      }
      return (v = function() {
        return !!V;
      })();
    }
    function w(V) {
      return w = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(I) {
        return I.__proto__ || Object.getPrototypeOf(I);
      }, w(V);
    }
    function b(V, I) {
      if (typeof I != "function" && I !== null) throw new TypeError("Super expression must either be null or a function");
      V.prototype = Object.create(I && I.prototype, { constructor: { value: V, writable: !0, configurable: !0 } }), Object.defineProperty(V, "prototype", { writable: !1 }), I && _(V, I);
    }
    function _(V, I) {
      return _ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(M, S) {
        return M.__proto__ = S, M;
      }, _(V, I);
    }
    function D(V, I) {
      var M = Object.keys(V);
      if (Object.getOwnPropertySymbols) {
        var S = Object.getOwnPropertySymbols(V);
        I && (S = S.filter(function(F) {
          return Object.getOwnPropertyDescriptor(V, F).enumerable;
        })), M.push.apply(M, S);
      }
      return M;
    }
    function C(V) {
      for (var I = 1; I < arguments.length; I++) {
        var M = arguments[I] != null ? arguments[I] : {};
        I % 2 ? D(Object(M), !0).forEach(function(S) {
          N(V, S, M[S]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(V, Object.getOwnPropertyDescriptors(M)) : D(Object(M)).forEach(function(S) {
          Object.defineProperty(V, S, Object.getOwnPropertyDescriptor(M, S));
        });
      }
      return V;
    }
    function N(V, I, M) {
      return (I = $(I)) in V ? Object.defineProperty(V, I, { value: M, enumerable: !0, configurable: !0, writable: !0 }) : V[I] = M, V;
    }
    function $(V) {
      var I = A(V, "string");
      return o(I) == "symbol" ? I : I + "";
    }
    function A(V, I) {
      if (o(V) != "object" || !V) return V;
      var M = V[Symbol.toPrimitive];
      if (M !== void 0) {
        var S = M.call(V, I);
        if (o(S) != "object") return S;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (I === "string" ? String : Number)(V);
    }
    var k = {
      x: "clientWidth",
      y: "clientHeight"
    }, R = {
      x: "clientTop",
      y: "clientLeft"
    }, ie = {
      x: "innerWidth",
      y: "innerHeight"
    }, Y = {
      x: "offsetWidth",
      y: "offsetHeight"
    }, z = {
      x: "offsetLeft",
      y: "offsetTop"
    }, oe = {
      x: "overflowX",
      y: "overflowY"
    }, xe = {
      x: "scrollWidth",
      y: "scrollHeight"
    }, Ne = {
      x: "scrollLeft",
      y: "scrollTop"
    }, Ae = {
      x: "width",
      y: "height"
    }, Te = function() {
    }, ke = function() {
      if (typeof window > "u") return !1;
      var V = !1;
      try {
        document.createElement("div").addEventListener("test", Te, {
          get passive() {
            return V = !0, !1;
          }
        });
      } catch {
      }
      return V;
    }() ? {
      passive: !0
    } : !1, et = "ReactList failed to reach a stable state.", He = 40, Pe = function(I, M) {
      for (var S in M) if (I[S] !== M[S]) return !1;
      return !0;
    }, qe = function(I) {
      for (var M = I.props.axis, S = I.getEl(), F = oe[M]; S = S.parentElement; )
        switch (window.getComputedStyle(S)[F]) {
          case "auto":
          case "scroll":
          case "overlay":
            return S;
        }
      return window;
    }, lt = function(I) {
      var M = I.props.axis, S = I.scrollParent;
      return S === window ? window[ie[M]] : S[k[M]];
    }, U = function(I, M) {
      var S = I.length, F = I.minSize, G = I.type, K = M.from, Q = M.size, te = M.itemsPerRow;
      Q = Math.max(Q, F);
      var ce = Q % te;
      return ce && (Q += te - ce), Q > S && (Q = S), K = G === "simple" || !K ? 0 : Math.max(Math.min(K, S - Q), 0), (ce = K % te) && (K -= ce, Q += ce), K === M.from && Q === M.size ? M : C(C({}, M), {}, {
        from: K,
        size: Q
      });
    }, Z = n.default = /* @__PURE__ */ function(V) {
      function I(M) {
        var S;
        return s(this, I), S = d(this, I, [M]), S.state = U(M, {
          itemsPerRow: 1,
          from: M.initialIndex,
          size: 0
        }), S.cache = {}, S.cachedScrollPosition = null, S.prevPrevState = {}, S.unstable = !1, S.updateCounter = 0, S;
      }
      return b(I, V), c(I, [{
        key: "componentDidMount",
        value: function() {
          this.updateFrameAndClearCache = this.updateFrameAndClearCache.bind(this), window.addEventListener("resize", this.updateFrameAndClearCache), this.updateFrame(this.scrollTo.bind(this, this.props.initialIndex));
        }
      }, {
        key: "componentDidUpdate",
        value: function(S) {
          var F = this;
          if (this.props.axis !== S.axis && this.clearSizeCache(), !this.unstable) {
            if (++this.updateCounter > He)
              return this.unstable = !0, console.error(et);
            this.updateCounterTimeoutId || (this.updateCounterTimeoutId = setTimeout(function() {
              F.updateCounter = 0, delete F.updateCounterTimeoutId;
            }, 0)), this.updateFrame();
          }
        }
      }, {
        key: "maybeSetState",
        value: function(S, F) {
          if (Pe(this.state, S)) return F();
          this.setState(S, F);
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          window.removeEventListener("resize", this.updateFrameAndClearCache), this.scrollParent.removeEventListener("scroll", this.updateFrameAndClearCache, ke), this.scrollParent.removeEventListener("mousewheel", Te, ke);
        }
      }, {
        key: "getOffset",
        value: function(S) {
          var F = this.props.axis, G = S[R[F]] || 0, K = z[F];
          do
            G += S[K] || 0;
          while (S = S.offsetParent);
          return G;
        }
      }, {
        key: "getEl",
        value: function() {
          return this.el || this.items;
        }
      }, {
        key: "getScrollPosition",
        value: function() {
          if (typeof this.cachedScrollPosition == "number")
            return this.cachedScrollPosition;
          var S = this.scrollParent, F = this.props.axis, G = Ne[F], K = S === window ? (
            // Firefox always returns document.body[scrollKey] as 0 and Chrome/Safari
            // always return document.documentElement[scrollKey] as 0, so take
            // whichever has a value.
            document.body[G] || document.documentElement[G]
          ) : S[G], Q = this.getScrollSize() - this.props.scrollParentViewportSizeGetter(this), te = Math.max(0, Math.min(K, Q)), ce = this.getEl();
          return this.cachedScrollPosition = this.getOffset(S) + te - this.getOffset(ce), this.cachedScrollPosition;
        }
      }, {
        key: "setScroll",
        value: function(S) {
          var F = this.scrollParent, G = this.props.axis;
          if (S += this.getOffset(this.getEl()), F === window) return window.scrollTo(0, S);
          S -= this.getOffset(this.scrollParent), F[Ne[G]] = S;
        }
      }, {
        key: "getScrollSize",
        value: function() {
          var S = this.scrollParent, F = document, G = F.body, K = F.documentElement, Q = xe[this.props.axis];
          return S === window ? Math.max(G[Q], K[Q]) : S[Q];
        }
      }, {
        key: "hasDeterminateSize",
        value: function() {
          var S = this.props, F = S.itemSizeGetter, G = S.type;
          return G === "uniform" || F;
        }
      }, {
        key: "getStartAndEnd",
        value: function() {
          var S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props.threshold, F = this.getScrollPosition(), G = Math.max(0, F - S), K = F + this.props.scrollParentViewportSizeGetter(this) + S;
          return this.hasDeterminateSize() && (K = Math.min(K, this.getSpaceBefore(this.props.length))), {
            start: G,
            end: K
          };
        }
      }, {
        key: "getItemSizeAndItemsPerRow",
        value: function() {
          var S = this.props, F = S.axis, G = S.useStaticSize, K = this.state, Q = K.itemSize, te = K.itemsPerRow;
          if (G && Q && te)
            return {
              itemSize: Q,
              itemsPerRow: te
            };
          var ce = this.items.children;
          if (!ce.length) return {};
          var j = ce[0], me = j[Y[F]], ve = Math.abs(me - Q);
          if ((isNaN(ve) || ve >= 1) && (Q = me), !Q) return {};
          var Ge = z[F], wt = j[Ge];
          te = 1;
          for (var at = ce[te]; at && at[Ge] === wt; at = ce[te])
            ++te;
          return {
            itemSize: Q,
            itemsPerRow: te
          };
        }
      }, {
        key: "clearSizeCache",
        value: function() {
          this.cachedScrollPosition = null;
        }
        // Called by 'scroll' and 'resize' events, clears scroll position cache.
      }, {
        key: "updateFrameAndClearCache",
        value: function(S) {
          return this.clearSizeCache(), this.updateFrame(S);
        }
      }, {
        key: "updateFrame",
        value: function(S) {
          switch (this.updateScrollParent(), typeof S != "function" && (S = Te), this.props.type) {
            case "simple":
              return this.updateSimpleFrame(S);
            case "variable":
              return this.updateVariableFrame(S);
            case "uniform":
              return this.updateUniformFrame(S);
          }
        }
      }, {
        key: "updateScrollParent",
        value: function() {
          var S = this.scrollParent;
          this.scrollParent = this.props.scrollParentGetter(this), S !== this.scrollParent && (S && (S.removeEventListener("scroll", this.updateFrameAndClearCache), S.removeEventListener("mousewheel", Te)), this.clearSizeCache(), this.scrollParent.addEventListener("scroll", this.updateFrameAndClearCache, ke), this.scrollParent.addEventListener("mousewheel", Te, ke));
        }
      }, {
        key: "updateSimpleFrame",
        value: function(S) {
          var F = this.getStartAndEnd(), G = F.end, K = this.items.children, Q = 0;
          if (K.length) {
            var te = this.props.axis, ce = K[0], j = K[K.length - 1];
            Q = this.getOffset(j) + j[Y[te]] - this.getOffset(ce);
          }
          if (Q > G) return S();
          var me = this.props, ve = me.pageSize, Ge = me.length, wt = Math.min(this.state.size + ve, Ge);
          this.maybeSetState({
            size: wt
          }, S);
        }
      }, {
        key: "updateVariableFrame",
        value: function(S) {
          this.props.itemSizeGetter || this.cacheSizes();
          for (var F = this.getStartAndEnd(), G = F.start, K = F.end, Q = this.props, te = Q.length, ce = Q.pageSize, j = 0, me = 0, ve = 0, Ge = te - 1; me < Ge; ) {
            var wt = this.getSizeOfItem(me);
            if (wt == null || j + wt > G) break;
            j += wt, ++me;
          }
          for (var at = te - me; ve < at && j < K; ) {
            var Kn = this.getSizeOfItem(me + ve);
            if (Kn == null) {
              ve = Math.min(ve + ce, at);
              break;
            }
            j += Kn, ++ve;
          }
          this.maybeSetState(U(this.props, {
            from: me,
            itemsPerRow: 1,
            size: ve
          }), S);
        }
      }, {
        key: "updateUniformFrame",
        value: function(S) {
          var F = this.getItemSizeAndItemsPerRow(), G = F.itemSize, K = F.itemsPerRow;
          if (!G || !K) return S();
          var Q = this.getStartAndEnd(), te = Q.start, ce = Q.end, j = U(this.props, {
            from: Math.floor(te / G) * K,
            size: (Math.ceil((ce - te) / G) + 1) * K,
            itemsPerRow: K
          }), me = j.from, ve = j.size;
          return this.maybeSetState({
            itemsPerRow: K,
            from: me,
            itemSize: G,
            size: ve
          }, S);
        }
      }, {
        key: "getSpaceBefore",
        value: function(S) {
          var F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          if (F[S] != null) return F[S];
          var G = this.state, K = G.itemSize, Q = G.itemsPerRow;
          if (K)
            return F[S] = Math.floor(S / Q) * K;
          for (var te = S; te > 0 && F[--te] == null; ) ;
          for (var ce = F[te] || 0, j = te; j < S; ++j) {
            F[j] = ce;
            var me = this.getSizeOfItem(j);
            if (me == null) break;
            ce += me;
          }
          return F[S] = ce;
        }
      }, {
        key: "cacheSizes",
        value: function() {
          for (var S = this.cache, F = this.state.from, G = this.items.children, K = Y[this.props.axis], Q = 0, te = G.length; Q < te; ++Q)
            S[F + Q] = G[Q][K];
        }
      }, {
        key: "getSizeOfItem",
        value: function(S) {
          var F = this.cache, G = this.items, K = this.props, Q = K.axis, te = K.itemSizeGetter, ce = K.itemSizeEstimator, j = K.type, me = this.state, ve = me.from, Ge = me.itemSize, wt = me.size;
          if (Ge) return Ge;
          if (te) return te(S);
          if (S in F) return F[S];
          if (j === "simple" && S >= ve && S < ve + wt && G) {
            var at = G.children[S - ve];
            if (at) return at[Y[Q]];
          }
          if (ce) return ce(S, F);
        }
      }, {
        key: "scrollTo",
        value: function(S) {
          S != null && this.setScroll(this.getSpaceBefore(S));
        }
      }, {
        key: "scrollAround",
        value: function(S) {
          var F = this.getScrollPosition(), G = this.getSpaceBefore(S), K = G - this.props.scrollParentViewportSizeGetter(this) + this.getSizeOfItem(S), Q = Math.min(K, G), te = Math.max(K, G);
          if (F <= Q) return this.setScroll(Q);
          if (F > te) return this.setScroll(te);
        }
      }, {
        key: "getVisibleRange",
        value: function() {
          for (var S = this.state, F = S.from, G = S.size, K = this.getStartAndEnd(0), Q = K.start, te = K.end, ce = {}, j, me, ve = F; ve < F + G; ++ve) {
            var Ge = this.getSpaceBefore(ve, ce), wt = Ge + this.getSizeOfItem(ve);
            j == null && wt > Q && (j = ve), j != null && Ge < te && (me = ve);
          }
          return [j, me];
        }
      }, {
        key: "renderItems",
        value: function() {
          for (var S = this, F = this.props, G = F.itemRenderer, K = F.itemsRenderer, Q = this.state, te = Q.from, ce = Q.size, j = [], me = 0; me < ce; ++me) j.push(G(te + me, me));
          return K(j, function(ve) {
            return S.items = ve;
          });
        }
      }, {
        key: "render",
        value: function() {
          var S = this, F = this.props, G = F.axis, K = F.length, Q = F.type, te = F.useTranslate3d, ce = this.state, j = ce.from, me = ce.itemsPerRow, ve = this.renderItems();
          if (Q === "simple") return ve;
          var Ge = {
            position: "relative"
          }, wt = {}, at = Math.ceil(K / me) * me, Kn = this.getSpaceBefore(at, wt);
          Kn && (Ge[Ae[G]] = Kn, G === "x" && (Ge.overflowX = "hidden"));
          var Mi = this.getSpaceBefore(j, wt), Xn = G === "x" ? Mi : 0, Rt = G === "y" ? Mi : 0, Pn = te ? "translate3d(".concat(Xn, "px, ").concat(Rt, "px, 0)") : "translate(".concat(Xn, "px, ").concat(Rt, "px)"), zr = {
            msTransform: Pn,
            WebkitTransform: Pn,
            transform: Pn
          };
          return /* @__PURE__ */ (0, a.jsx)("div", {
            style: Ge,
            ref: function(yr) {
              return S.el = yr;
            },
            children: /* @__PURE__ */ (0, a.jsx)("div", {
              style: zr,
              children: ve
            })
          });
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function(S, F) {
          var G = U(S, F);
          return G === F ? null : G;
        }
      }]);
    }(t.Component);
    N(Z, "displayName", "ReactList"), N(Z, "defaultProps", {
      axis: "y",
      itemRenderer: function(I, M) {
        return /* @__PURE__ */ (0, a.jsx)("div", {
          children: I
        }, M);
      },
      itemsRenderer: function(I, M) {
        return /* @__PURE__ */ (0, a.jsx)("div", {
          ref: M,
          children: I
        });
      },
      length: 0,
      minSize: 1,
      pageSize: 10,
      scrollParentGetter: qe,
      scrollParentViewportSizeGetter: lt,
      threshold: 100,
      type: "simple",
      useStaticSize: !1,
      useTranslate3d: !1
    });
  });
})(tg);
function tC(e, n) {
  if (e === n)
    return !0;
  if (!e || !n)
    return !1;
  var t = Object.keys(e), a = Object.keys(n), o = t.length;
  if (a.length !== o)
    return !1;
  for (var s = 0; s < o; s++) {
    var l = t[s];
    if (e[l] !== n[l] || !Object.prototype.hasOwnProperty.call(n, l))
      return !1;
  }
  return !0;
}
function nC(e, n) {
  if (e === n)
    return !0;
  if (!e || !n)
    return !1;
  var t = e.length;
  if (n.length !== t)
    return !1;
  for (var a = 0; a < t; a++)
    if (e[a] !== n[a])
      return !1;
  return !0;
}
const rC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  shallowEqualArrays: nC,
  shallowEqualObjects: tC
}, Symbol.toStringTag, { value: "Module" })), aC = /* @__PURE__ */ c0(rC);
var Wc = {}, Vc = {};
Vc.formatDistance = void 0;
const iC = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, oC = (e, n, t) => {
  let a;
  const o = iC[e];
  return typeof o == "string" ? a = o : n === 1 ? a = o.one : a = o.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + a : a + " ago" : a;
};
Vc.formatDistance = oC;
var $c = {}, ng = {};
ng.buildFormatLongFn = sC;
function sC(e) {
  return (n = {}) => {
    const t = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
$c.formatLong = void 0;
var vl = ng;
const uC = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, lC = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, cC = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
$c.formatLong = {
  date: (0, vl.buildFormatLongFn)({
    formats: uC,
    defaultWidth: "full"
  }),
  time: (0, vl.buildFormatLongFn)({
    formats: lC,
    defaultWidth: "full"
  }),
  dateTime: (0, vl.buildFormatLongFn)({
    formats: cC,
    defaultWidth: "full"
  })
};
var Yc = {};
Yc.formatRelative = void 0;
const fC = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, dC = (e, n, t, a) => fC[e];
Yc.formatRelative = dC;
var Bc = {}, rg = {};
rg.buildLocalizeFn = hC;
function hC(e) {
  return (n, t) => {
    const a = t != null && t.context ? String(t.context) : "standalone";
    let o;
    if (a === "formatting" && e.formattingValues) {
      const l = e.defaultFormattingWidth || e.defaultWidth, c = t != null && t.width ? String(t.width) : l;
      o = e.formattingValues[c] || e.formattingValues[l];
    } else {
      const l = e.defaultWidth, c = t != null && t.width ? String(t.width) : e.defaultWidth;
      o = e.values[c] || e.values[l];
    }
    const s = e.argumentCallback ? e.argumentCallback(n) : n;
    return o[s];
  };
}
Bc.localize = void 0;
var Za = rg;
const pC = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, mC = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, vC = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, gC = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, yC = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, wC = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, bC = (e, n) => {
  const t = Number(e), a = t % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
};
Bc.localize = {
  ordinalNumber: bC,
  era: (0, Za.buildLocalizeFn)({
    values: pC,
    defaultWidth: "wide"
  }),
  quarter: (0, Za.buildLocalizeFn)({
    values: mC,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: (0, Za.buildLocalizeFn)({
    values: vC,
    defaultWidth: "wide"
  }),
  day: (0, Za.buildLocalizeFn)({
    values: gC,
    defaultWidth: "wide"
  }),
  dayPeriod: (0, Za.buildLocalizeFn)({
    values: yC,
    defaultWidth: "wide",
    formattingValues: wC,
    defaultFormattingWidth: "wide"
  })
};
var Hc = {}, ag = {};
ag.buildMatchFn = _C;
function _C(e) {
  return (n, t = {}) => {
    const a = t.width, o = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], s = n.match(o);
    if (!s)
      return null;
    const l = s[0], c = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], d = Array.isArray(c) ? DC(c, (v) => v.test(l)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      xC(c, (v) => v.test(l))
    );
    let h;
    h = e.valueCallback ? e.valueCallback(d) : d, h = t.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      t.valueCallback(h)
    ) : h;
    const p = n.slice(l.length);
    return { value: h, rest: p };
  };
}
function xC(e, n) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && n(e[t]))
      return t;
}
function DC(e, n) {
  for (let t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
var ig = {};
ig.buildMatchPatternFn = SC;
function SC(e) {
  return (n, t = {}) => {
    const a = n.match(e.matchPattern);
    if (!a) return null;
    const o = a[0], s = n.match(e.parsePattern);
    if (!s) return null;
    let l = e.valueCallback ? e.valueCallback(s[0]) : s[0];
    l = t.valueCallback ? t.valueCallback(l) : l;
    const c = n.slice(o.length);
    return { value: l, rest: c };
  };
}
Hc.match = void 0;
var Qa = ag, OC = ig;
const MC = /^(\d+)(th|st|nd|rd)?/i, CC = /\d+/i, PC = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, TC = {
  any: [/^b/i, /^(a|c)/i]
}, EC = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, RC = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, AC = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, IC = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, LC = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, FC = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, NC = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, kC = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
Hc.match = {
  ordinalNumber: (0, OC.buildMatchPatternFn)({
    matchPattern: MC,
    parsePattern: CC,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: (0, Qa.buildMatchFn)({
    matchPatterns: PC,
    defaultMatchWidth: "wide",
    parsePatterns: TC,
    defaultParseWidth: "any"
  }),
  quarter: (0, Qa.buildMatchFn)({
    matchPatterns: EC,
    defaultMatchWidth: "wide",
    parsePatterns: RC,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: (0, Qa.buildMatchFn)({
    matchPatterns: AC,
    defaultMatchWidth: "wide",
    parsePatterns: IC,
    defaultParseWidth: "any"
  }),
  day: (0, Qa.buildMatchFn)({
    matchPatterns: LC,
    defaultMatchWidth: "wide",
    parsePatterns: FC,
    defaultParseWidth: "any"
  }),
  dayPeriod: (0, Qa.buildMatchFn)({
    matchPatterns: NC,
    defaultMatchWidth: "any",
    parsePatterns: kC,
    defaultParseWidth: "any"
  })
};
Wc.enUS = void 0;
var WC = Vc, VC = $c, $C = Yc, YC = Bc, BC = Hc;
Wc.enUS = {
  code: "en-US",
  formatDistance: WC.formatDistance,
  formatLong: VC.formatLong,
  formatRelative: $C.formatRelative,
  localize: YC.localize,
  match: BC.match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
var Ur = {};
Object.defineProperty(Ur, "__esModule", {
  value: !0
});
Ur.default = void 0;
Ur.default = {
  dateRangeWrapper: "rdrDateRangeWrapper",
  calendarWrapper: "rdrCalendarWrapper",
  dateDisplay: "rdrDateDisplay",
  dateDisplayItem: "rdrDateDisplayItem",
  dateDisplayItemActive: "rdrDateDisplayItemActive",
  monthAndYearWrapper: "rdrMonthAndYearWrapper",
  monthAndYearPickers: "rdrMonthAndYearPickers",
  nextPrevButton: "rdrNextPrevButton",
  month: "rdrMonth",
  weekDays: "rdrWeekDays",
  weekDay: "rdrWeekDay",
  days: "rdrDays",
  day: "rdrDay",
  dayNumber: "rdrDayNumber",
  dayPassive: "rdrDayPassive",
  dayToday: "rdrDayToday",
  dayStartOfWeek: "rdrDayStartOfWeek",
  dayEndOfWeek: "rdrDayEndOfWeek",
  daySelected: "rdrDaySelected",
  dayDisabled: "rdrDayDisabled",
  dayStartOfMonth: "rdrDayStartOfMonth",
  dayEndOfMonth: "rdrDayEndOfMonth",
  dayWeekend: "rdrDayWeekend",
  dayStartPreview: "rdrDayStartPreview",
  dayInPreview: "rdrDayInPreview",
  dayEndPreview: "rdrDayEndPreview",
  dayHovered: "rdrDayHovered",
  dayActive: "rdrDayActive",
  inRange: "rdrInRange",
  endEdge: "rdrEndEdge",
  startEdge: "rdrStartEdge",
  prevButton: "rdrPprevButton",
  nextButton: "rdrNextButton",
  selected: "rdrSelected",
  months: "rdrMonths",
  monthPicker: "rdrMonthPicker",
  yearPicker: "rdrYearPicker",
  dateDisplayWrapper: "rdrDateDisplayWrapper",
  definedRangesWrapper: "rdrDefinedRangesWrapper",
  staticRanges: "rdrStaticRanges",
  staticRange: "rdrStaticRange",
  inputRanges: "rdrInputRanges",
  inputRange: "rdrInputRange",
  inputRangeInput: "rdrInputRangeInput",
  dateRangePickerWrapper: "rdrDateRangePickerWrapper",
  staticRangeLabel: "rdrStaticRangeLabel",
  staticRangeSelected: "rdrStaticRangeSelected",
  monthName: "rdrMonthName",
  infiniteMonths: "rdrInfiniteMonths",
  monthsVertical: "rdrMonthsVertical",
  monthsHorizontal: "rdrMonthsHorizontal"
};
var Ds = {};
Object.defineProperty(Ds, "__esModule", {
  value: !0
});
Ds.ariaLabelsShape = void 0;
var Vn = HC(qn);
function HC(e) {
  return e && e.__esModule ? e : { default: e };
}
Ds.ariaLabelsShape = Vn.default.shape({
  dateInput: Vn.default.objectOf(Vn.default.shape({
    startDate: Vn.default.string,
    endDate: Vn.default.string
  })),
  monthPicker: Vn.default.string,
  yearPicker: Vn.default.string,
  prevButton: Vn.default.string,
  nextButton: Vn.default.string
});
Object.defineProperty(wi, "__esModule", {
  value: !0
});
wi.default = void 0;
var $e = XC(X), le = Ca(qn), UC = Un, Gp = Ca(_s), Kp = Ca(xs), Oo = Gn, Rr = Ca(Yr), jC = Ca(tg), zC = aC, Xe = Hr, qC = Wc, GC = Ca(Ur), KC = Ds;
function Ca(e) {
  return e && e.__esModule ? e : { default: e };
}
function og(e) {
  if (typeof WeakMap != "function") return null;
  var n = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  return (og = function(a) {
    return a ? t : n;
  })(e);
}
function XC(e, n) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var t = og(n);
  if (t && t.has(e)) return t.get(e);
  var a = { __proto__: null }, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in e) if (s !== "default" && Object.prototype.hasOwnProperty.call(e, s)) {
    var l = o ? Object.getOwnPropertyDescriptor(e, s) : null;
    l && (l.get || l.set) ? Object.defineProperty(a, s, l) : a[s] = e[s];
  }
  return a.default = e, t && t.set(e, a), a;
}
function ts() {
  return ts = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, ts.apply(this, arguments);
}
function en(e, n, t) {
  return n = ZC(n), n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function ZC(e) {
  var n = QC(e, "string");
  return typeof n == "symbol" ? n : String(n);
}
function QC(e, n) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, n);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
class Da extends $e.PureComponent {
  constructor(n, t) {
    var a;
    super(n, t), a = this, en(this, "focusToDate", function(o) {
      let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : a.props, l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
      if (!s.scroll.enabled) {
        if (l && s.preventSnapRefocus) {
          const h = (0, Xe.differenceInCalendarMonths)(o, a.state.focusedDate), p = s.calendarFocus === "forwards" && h >= 0, v = s.calendarFocus === "backwards" && h <= 0;
          if ((p || v) && Math.abs(h) < s.months)
            return;
        }
        a.setState({
          focusedDate: o
        });
        return;
      }
      const c = (0, Xe.differenceInCalendarMonths)(o, s.minDate, a.dateOptions), d = a.list.getVisibleRange();
      l && d.includes(c) || (a.isFirstRender = !0, a.list.scrollTo(c), a.setState({
        focusedDate: o
      }));
    }), en(this, "updateShownDate", function() {
      let o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : a.props;
      const s = o.scroll.enabled ? {
        ...o,
        months: a.list.getVisibleRange().length
      } : o, l = (0, Oo.calcFocusDate)(a.state.focusedDate, s);
      a.focusToDate(l, s);
    }), en(this, "updatePreview", (o) => {
      if (!o) {
        this.setState({
          preview: null
        });
        return;
      }
      const s = {
        startDate: o,
        endDate: o,
        color: this.props.color
      };
      this.setState({
        preview: s
      });
    }), en(this, "changeShownDate", function(o) {
      let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "set";
      const {
        focusedDate: l
      } = a.state, {
        onShownDateChange: c,
        minDate: d,
        maxDate: h
      } = a.props, p = {
        monthOffset: () => (0, Xe.addMonths)(l, o),
        setMonth: () => (0, Xe.setMonth)(l, o),
        setYear: () => (0, Xe.setYear)(l, o),
        set: () => o
      }, v = (0, Xe.min)([(0, Xe.max)([p[s](), d]), h]);
      a.focusToDate(v, a.props, !1), c && c(v);
    }), en(this, "handleRangeFocusChange", (o, s) => {
      this.props.onRangeFocusChange && this.props.onRangeFocusChange([o, s]);
    }), en(this, "handleScroll", () => {
      const {
        onShownDateChange: o,
        minDate: s
      } = this.props, {
        focusedDate: l
      } = this.state, {
        isFirstRender: c
      } = this, d = this.list.getVisibleRange();
      if (d[0] === void 0) return;
      const h = (0, Xe.addMonths)(s, d[0] || 0);
      !(0, Xe.isSameMonth)(h, l) && !c && (this.setState({
        focusedDate: h
      }), o && o(h)), this.isFirstRender = !1;
    }), en(this, "renderMonthAndYear", (o, s, l) => {
      const {
        showMonthArrow: c,
        minDate: d,
        maxDate: h,
        showMonthAndYearPickers: p,
        ariaLabels: v
      } = l, w = (h || Da.defaultProps.maxDate).getFullYear(), b = (d || Da.defaultProps.minDate).getFullYear(), _ = this.styles;
      return /* @__PURE__ */ $e.default.createElement("div", {
        onMouseUp: (D) => D.stopPropagation(),
        className: _.monthAndYearWrapper
      }, c ? /* @__PURE__ */ $e.default.createElement("button", {
        type: "button",
        className: (0, Rr.default)(_.nextPrevButton, _.prevButton),
        onClick: () => s(-1, "monthOffset"),
        "aria-label": v.prevButton
      }, /* @__PURE__ */ $e.default.createElement("i", null)) : null, p ? /* @__PURE__ */ $e.default.createElement("span", {
        className: _.monthAndYearPickers
      }, /* @__PURE__ */ $e.default.createElement("span", {
        className: _.monthPicker
      }, /* @__PURE__ */ $e.default.createElement("select", {
        value: o.getMonth(),
        onChange: (D) => s(D.target.value, "setMonth"),
        "aria-label": v.monthPicker
      }, this.state.monthNames.map((D, C) => /* @__PURE__ */ $e.default.createElement("option", {
        key: C,
        value: C
      }, D)))), /* @__PURE__ */ $e.default.createElement("span", {
        className: _.monthAndYearDivider
      }), /* @__PURE__ */ $e.default.createElement("span", {
        className: _.yearPicker
      }, /* @__PURE__ */ $e.default.createElement("select", {
        value: o.getFullYear(),
        onChange: (D) => s(D.target.value, "setYear"),
        "aria-label": v.yearPicker
      }, new Array(w - b + 1).fill(w).map((D, C) => {
        const N = D - C;
        return /* @__PURE__ */ $e.default.createElement("option", {
          key: N,
          value: N
        }, N);
      })))) : /* @__PURE__ */ $e.default.createElement("span", {
        className: _.monthAndYearPickers
      }, this.state.monthNames[o.getMonth()], " ", o.getFullYear()), c ? /* @__PURE__ */ $e.default.createElement("button", {
        type: "button",
        className: (0, Rr.default)(_.nextPrevButton, _.nextButton),
        onClick: () => s(1, "monthOffset"),
        "aria-label": v.nextButton
      }, /* @__PURE__ */ $e.default.createElement("i", null)) : null);
    }), en(this, "renderDateDisplay", () => {
      const {
        focusedRange: o,
        color: s,
        ranges: l,
        rangeColors: c,
        dateDisplayFormat: d,
        editableDateInputs: h,
        startDatePlaceholder: p,
        endDatePlaceholder: v,
        ariaLabels: w
      } = this.props, b = c[o[0]] || s, _ = this.styles;
      return /* @__PURE__ */ $e.default.createElement("div", {
        className: _.dateDisplayWrapper
      }, l.map((D, C) => D.showDateDisplay === !1 || D.disabled && !D.showDateDisplay ? null : /* @__PURE__ */ $e.default.createElement("div", {
        className: _.dateDisplay,
        key: C,
        style: {
          color: D.color || b
        }
      }, /* @__PURE__ */ $e.default.createElement(Kp.default, {
        className: (0, Rr.default)(_.dateDisplayItem, {
          [_.dateDisplayItemActive]: o[0] === C && o[1] === 0
        }),
        readOnly: !h,
        disabled: D.disabled,
        value: D.startDate,
        placeholder: p,
        dateOptions: this.dateOptions,
        dateDisplayFormat: d,
        ariaLabel: w.dateInput && w.dateInput[D.key] && w.dateInput[D.key].startDate,
        onChange: this.onDragSelectionEnd,
        onFocus: () => this.handleRangeFocusChange(C, 0)
      }), /* @__PURE__ */ $e.default.createElement(Kp.default, {
        className: (0, Rr.default)(_.dateDisplayItem, {
          [_.dateDisplayItemActive]: o[0] === C && o[1] === 1
        }),
        readOnly: !h,
        disabled: D.disabled,
        value: D.endDate,
        placeholder: v,
        dateOptions: this.dateOptions,
        dateDisplayFormat: d,
        ariaLabel: w.dateInput && w.dateInput[D.key] && w.dateInput[D.key].endDate,
        onChange: this.onDragSelectionEnd,
        onFocus: () => this.handleRangeFocusChange(C, 1)
      }))));
    }), en(this, "onDragSelectionStart", (o) => {
      const {
        onChange: s,
        dragSelectionEnabled: l
      } = this.props;
      l ? this.setState({
        drag: {
          status: !0,
          range: {
            startDate: o,
            endDate: o
          },
          disablePreview: !0
        }
      }) : s && s(o);
    }), en(this, "onDragSelectionEnd", (o) => {
      const {
        updateRange: s,
        displayMode: l,
        onChange: c,
        dragSelectionEnabled: d
      } = this.props;
      if (!d) return;
      if (l === "date" || !this.state.drag.status) {
        c && c(o);
        return;
      }
      const h = {
        startDate: this.state.drag.range.startDate,
        endDate: o
      };
      l !== "dateRange" || (0, Xe.isSameDay)(h.startDate, o) ? this.setState({
        drag: {
          status: !1,
          range: {}
        }
      }, () => c && c(o)) : this.setState({
        drag: {
          status: !1,
          range: {}
        }
      }, () => {
        s && s(h);
      });
    }), en(this, "onDragSelectionMove", (o) => {
      const {
        drag: s
      } = this.state;
      !s.status || !this.props.dragSelectionEnabled || this.setState({
        drag: {
          status: s.status,
          range: {
            startDate: s.range.startDate,
            endDate: o
          },
          disablePreview: !0
        }
      });
    }), en(this, "estimateMonthSize", (o, s) => {
      const {
        direction: l,
        minDate: c
      } = this.props, {
        scrollArea: d
      } = this.state;
      if (s && (this.listSizeCache = s, s[o]))
        return s[o];
      if (l === "horizontal") return d.monthWidth;
      const h = (0, Xe.addMonths)(c, o), {
        start: p,
        end: v
      } = (0, Oo.getMonthDisplayRange)(h, this.dateOptions);
      return (0, Xe.differenceInDays)(v, p, this.dateOptions) + 1 > 7 * 5 ? d.longMonthHeight : d.monthHeight;
    }), this.dateOptions = {
      locale: n.locale
    }, n.weekStartsOn !== void 0 && (this.dateOptions.weekStartsOn = n.weekStartsOn), this.styles = (0, Oo.generateStyles)([GC.default, n.classNames]), this.listSizeCache = {}, this.isFirstRender = !0, this.state = {
      monthNames: this.getMonthNames(),
      focusedDate: (0, Oo.calcFocusDate)(null, n),
      drag: {
        status: !1,
        range: {
          startDate: null,
          endDate: null
        },
        disablePreview: !1
      },
      scrollArea: this.calcScrollArea(n)
    };
  }
  getMonthNames() {
    return [...Array(12).keys()].map((n) => this.props.locale.localize.month(n));
  }
  calcScrollArea(n) {
    const {
      direction: t,
      months: a,
      scroll: o
    } = n;
    if (!o.enabled) return {
      enabled: !1
    };
    const s = o.longMonthHeight || o.monthHeight;
    return t === "vertical" ? {
      enabled: !0,
      monthHeight: o.monthHeight || 220,
      longMonthHeight: s || 260,
      calendarWidth: "auto",
      calendarHeight: (o.calendarHeight || s || 240) * a
    } : {
      enabled: !0,
      monthWidth: o.monthWidth || 332,
      calendarWidth: (o.calendarWidth || o.monthWidth || 332) * a,
      monthHeight: s || 300,
      calendarHeight: s || 300
    };
  }
  componentDidMount() {
    this.props.scroll.enabled && setTimeout(() => this.focusToDate(this.state.focusedDate));
  }
  componentDidUpdate(n) {
    const a = {
      dateRange: "ranges",
      date: "date"
    }[this.props.displayMode];
    this.props[a] !== n[a] && this.updateShownDate(this.props), (n.locale !== this.props.locale || n.weekStartsOn !== this.props.weekStartsOn) && (this.dateOptions = {
      locale: this.props.locale
    }, this.props.weekStartsOn !== void 0 && (this.dateOptions.weekStartsOn = this.props.weekStartsOn), this.setState({
      monthNames: this.getMonthNames()
    })), (0, zC.shallowEqualObjects)(n.scroll, this.props.scroll) || this.setState({
      scrollArea: this.calcScrollArea(this.props)
    });
  }
  renderWeekdays() {
    const n = /* @__PURE__ */ new Date();
    return /* @__PURE__ */ $e.default.createElement("div", {
      className: this.styles.weekDays
    }, (0, Xe.eachDayOfInterval)({
      start: (0, Xe.startOfWeek)(n, this.dateOptions),
      end: (0, Xe.endOfWeek)(n, this.dateOptions)
    }).map((t, a) => /* @__PURE__ */ $e.default.createElement("span", {
      className: this.styles.weekDay,
      key: a
    }, (0, Xe.format)(t, this.props.weekdayDisplayFormat, this.dateOptions))));
  }
  render() {
    const {
      showDateDisplay: n,
      onPreviewChange: t,
      scroll: a,
      direction: o,
      disabledDates: s,
      disabledDay: l,
      maxDate: c,
      minDate: d,
      rangeColors: h,
      color: p,
      navigatorRenderer: v,
      className: w,
      preview: b
    } = this.props, {
      scrollArea: _,
      focusedDate: D
    } = this.state, C = o === "vertical", N = v || this.renderMonthAndYear, $ = this.props.ranges.map((A, k) => ({
      ...A,
      color: A.color || h[k] || p
    }));
    return /* @__PURE__ */ $e.default.createElement("div", {
      className: (0, Rr.default)(this.styles.calendarWrapper, w),
      onMouseUp: () => this.setState({
        drag: {
          status: !1,
          range: {}
        }
      }),
      onMouseLeave: () => {
        this.setState({
          drag: {
            status: !1,
            range: {}
          }
        });
      }
    }, n && this.renderDateDisplay(), N(D, this.changeShownDate, this.props), a.enabled ? /* @__PURE__ */ $e.default.createElement("div", null, C && this.renderWeekdays(this.dateOptions), /* @__PURE__ */ $e.default.createElement("div", {
      className: (0, Rr.default)(this.styles.infiniteMonths, C ? this.styles.monthsVertical : this.styles.monthsHorizontal),
      onMouseLeave: () => t && t(),
      style: {
        width: _.calendarWidth + 11,
        height: _.calendarHeight + 11
      },
      onScroll: this.handleScroll
    }, /* @__PURE__ */ $e.default.createElement(jC.default, {
      length: (0, Xe.differenceInCalendarMonths)((0, Xe.endOfMonth)(c), (0, Xe.addDays)((0, Xe.startOfMonth)(d), -1), this.dateOptions),
      treshold: 500,
      type: "variable",
      ref: (A) => this.list = A,
      itemSizeEstimator: this.estimateMonthSize,
      axis: C ? "y" : "x",
      itemRenderer: (A, k) => {
        const R = (0, Xe.addMonths)(d, A);
        return /* @__PURE__ */ $e.default.createElement(Gp.default, ts({}, this.props, {
          onPreviewChange: t || this.updatePreview,
          preview: b || this.state.preview,
          ranges: $,
          key: k,
          drag: this.state.drag,
          dateOptions: this.dateOptions,
          disabledDates: s,
          disabledDay: l,
          month: R,
          onDragSelectionStart: this.onDragSelectionStart,
          onDragSelectionEnd: this.onDragSelectionEnd,
          onDragSelectionMove: this.onDragSelectionMove,
          onMouseLeave: () => t && t(),
          styles: this.styles,
          style: C ? {
            height: this.estimateMonthSize(A)
          } : {
            height: _.monthHeight,
            width: this.estimateMonthSize(A)
          },
          showMonthName: !0,
          showWeekDays: !C
        }));
      }
    }))) : /* @__PURE__ */ $e.default.createElement("div", {
      className: (0, Rr.default)(this.styles.months, C ? this.styles.monthsVertical : this.styles.monthsHorizontal)
    }, new Array(this.props.months).fill(null).map((A, k) => {
      let R = (0, Xe.addMonths)(this.state.focusedDate, k);
      return this.props.calendarFocus === "backwards" && (R = (0, Xe.subMonths)(this.state.focusedDate, this.props.months - 1 - k)), /* @__PURE__ */ $e.default.createElement(Gp.default, ts({}, this.props, {
        onPreviewChange: t || this.updatePreview,
        preview: b || this.state.preview,
        ranges: $,
        key: k,
        drag: this.state.drag,
        dateOptions: this.dateOptions,
        disabledDates: s,
        disabledDay: l,
        month: R,
        onDragSelectionStart: this.onDragSelectionStart,
        onDragSelectionEnd: this.onDragSelectionEnd,
        onDragSelectionMove: this.onDragSelectionMove,
        onMouseLeave: () => t && t(),
        styles: this.styles,
        showWeekDays: !C || k === 0,
        showMonthName: !C || k > 0
      }));
    })));
  }
}
Da.defaultProps = {
  showMonthArrow: !0,
  showMonthAndYearPickers: !0,
  disabledDates: [],
  disabledDay: () => {
  },
  classNames: {},
  locale: qC.enUS,
  ranges: [],
  focusedRange: [0, 0],
  dateDisplayFormat: "MMM d, yyyy",
  monthDisplayFormat: "MMM yyyy",
  weekdayDisplayFormat: "E",
  dayDisplayFormat: "d",
  showDateDisplay: !0,
  showPreview: !0,
  displayMode: "date",
  months: 1,
  color: "#3d91ff",
  scroll: {
    enabled: !1
  },
  direction: "vertical",
  maxDate: (0, Xe.addYears)(/* @__PURE__ */ new Date(), 20),
  minDate: (0, Xe.addYears)(/* @__PURE__ */ new Date(), -100),
  rangeColors: ["#3d91ff", "#3ecf8e", "#fed14c"],
  startDatePlaceholder: "Early",
  endDatePlaceholder: "Continuous",
  editableDateInputs: !1,
  dragSelectionEnabled: !0,
  fixedHeight: !1,
  calendarFocus: "forwards",
  preventSnapRefocus: !1,
  ariaLabels: {}
};
Da.propTypes = {
  showMonthArrow: le.default.bool,
  showMonthAndYearPickers: le.default.bool,
  disabledDates: le.default.array,
  disabledDay: le.default.func,
  minDate: le.default.object,
  maxDate: le.default.object,
  date: le.default.object,
  onChange: le.default.func,
  onPreviewChange: le.default.func,
  onRangeFocusChange: le.default.func,
  classNames: le.default.object,
  locale: le.default.object,
  shownDate: le.default.object,
  onShownDateChange: le.default.func,
  ranges: le.default.arrayOf(UC.rangeShape),
  preview: le.default.shape({
    startDate: le.default.object,
    endDate: le.default.object,
    color: le.default.string
  }),
  dateDisplayFormat: le.default.string,
  monthDisplayFormat: le.default.string,
  weekdayDisplayFormat: le.default.string,
  weekStartsOn: le.default.number,
  dayDisplayFormat: le.default.string,
  focusedRange: le.default.arrayOf(le.default.number),
  initialFocusedRange: le.default.arrayOf(le.default.number),
  months: le.default.number,
  className: le.default.string,
  showDateDisplay: le.default.bool,
  showPreview: le.default.bool,
  displayMode: le.default.oneOf(["dateRange", "date"]),
  color: le.default.string,
  updateRange: le.default.func,
  scroll: le.default.shape({
    enabled: le.default.bool,
    monthHeight: le.default.number,
    longMonthHeight: le.default.number,
    monthWidth: le.default.number,
    calendarWidth: le.default.number,
    calendarHeight: le.default.number
  }),
  direction: le.default.oneOf(["vertical", "horizontal"]),
  startDatePlaceholder: le.default.string,
  endDatePlaceholder: le.default.string,
  navigatorRenderer: le.default.func,
  rangeColors: le.default.arrayOf(le.default.string),
  editableDateInputs: le.default.bool,
  dragSelectionEnabled: le.default.bool,
  fixedHeight: le.default.bool,
  calendarFocus: le.default.string,
  preventSnapRefocus: le.default.bool,
  ariaLabels: KC.ariaLabelsShape
};
wi.default = Da;
Object.defineProperty(yi, "__esModule", {
  value: !0
});
yi.default = void 0;
var Xp = nP(X), la = Ss(qn), sg = Ss(wi), JC = Un, gl = Gn, gn = Hr, eP = Ss(Yr), tP = Ss(Ur);
function Ss(e) {
  return e && e.__esModule ? e : { default: e };
}
function ug(e) {
  if (typeof WeakMap != "function") return null;
  var n = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  return (ug = function(a) {
    return a ? t : n;
  })(e);
}
function nP(e, n) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var t = ug(n);
  if (t && t.has(e)) return t.get(e);
  var a = { __proto__: null }, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in e) if (s !== "default" && Object.prototype.hasOwnProperty.call(e, s)) {
    var l = o ? Object.getOwnPropertyDescriptor(e, s) : null;
    l && (l.get || l.set) ? Object.defineProperty(a, s, l) : a[s] = e[s];
  }
  return a.default = e, t && t.set(e, a), a;
}
function ql() {
  return ql = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, ql.apply(this, arguments);
}
function Mo(e, n, t) {
  return n = rP(n), n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function rP(e) {
  var n = aP(e, "string");
  return typeof n == "symbol" ? n : String(n);
}
function aP(e, n) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, n);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
class Uc extends Xp.Component {
  constructor(n, t) {
    var a;
    super(n, t), a = this, Mo(this, "calcNewSelection", function(o) {
      let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      const l = a.props.focusedRange || a.state.focusedRange, {
        ranges: c,
        onChange: d,
        maxDate: h,
        moveRangeOnFirstSelection: p,
        retainEndDateOnFirstSelection: v,
        disabledDates: w
      } = a.props, b = l[0], _ = c[b];
      if (!_ || !d) return {};
      let {
        startDate: D,
        endDate: C
      } = _;
      const N = /* @__PURE__ */ new Date();
      let $;
      if (!s)
        D = o.startDate, C = o.endDate;
      else if (l[1] === 0) {
        const R = (0, gn.differenceInCalendarDays)(C || N, D), ie = () => p ? (0, gn.addDays)(o, R) : v ? !C || (0, gn.isBefore)(o, C) ? C : o : o || N;
        D = o, C = ie(), h && (C = (0, gn.min)([C, h])), $ = [l[0], 1];
      } else
        C = o;
      let A = l[1] === 0;
      (0, gn.isBefore)(C, D) && (A = !A, [D, C] = [C, D]);
      const k = w.filter((R) => (0, gn.isWithinInterval)(R, {
        start: D,
        end: C
      }));
      return k.length > 0 && (A ? D = (0, gn.addDays)((0, gn.max)(k), 1) : C = (0, gn.addDays)((0, gn.min)(k), -1)), $ || ($ = [(0, gl.findNextRangeIndex)(a.props.ranges, l[0]), 0]), {
        wasValid: !(k.length > 0),
        range: {
          startDate: D,
          endDate: C
        },
        nextFocusRange: $
      };
    }), Mo(this, "setSelection", (o, s) => {
      const {
        onChange: l,
        ranges: c,
        onRangeFocusChange: d
      } = this.props, p = (this.props.focusedRange || this.state.focusedRange)[0], v = c[p];
      if (!v) return;
      const w = this.calcNewSelection(o, s);
      l({
        [v.key || `range${p + 1}`]: {
          ...v,
          ...w.range
        }
      }), this.setState({
        focusedRange: w.nextFocusRange,
        preview: null
      }), d && d(w.nextFocusRange);
    }), Mo(this, "handleRangeFocusChange", (o) => {
      this.setState({
        focusedRange: o
      }), this.props.onRangeFocusChange && this.props.onRangeFocusChange(o);
    }), Mo(this, "updatePreview", (o) => {
      var h;
      if (!o) {
        this.setState({
          preview: null
        });
        return;
      }
      const {
        rangeColors: s,
        ranges: l
      } = this.props, c = this.props.focusedRange || this.state.focusedRange, d = ((h = l[c[0]]) == null ? void 0 : h.color) || s[c[0]] || d;
      this.setState({
        preview: {
          ...o.range,
          color: d
        }
      });
    }), this.state = {
      focusedRange: n.initialFocusedRange || [(0, gl.findNextRangeIndex)(n.ranges), 0],
      preview: null
    }, this.styles = (0, gl.generateStyles)([tP.default, n.classNames]);
  }
  render() {
    return /* @__PURE__ */ Xp.default.createElement(sg.default, ql({
      focusedRange: this.state.focusedRange,
      onRangeFocusChange: this.handleRangeFocusChange,
      preview: this.state.preview,
      onPreviewChange: (n) => {
        this.updatePreview(n ? this.calcNewSelection(n) : null);
      }
    }, this.props, {
      displayMode: "dateRange",
      className: (0, eP.default)(this.styles.dateRangeWrapper, this.props.className),
      onChange: this.setSelection,
      updateRange: (n) => this.setSelection(n, !1),
      ref: (n) => {
        this.calendar = n;
      }
    }));
  }
}
Uc.defaultProps = {
  classNames: {},
  ranges: [],
  moveRangeOnFirstSelection: !1,
  retainEndDateOnFirstSelection: !1,
  rangeColors: ["#3d91ff", "#3ecf8e", "#fed14c"],
  disabledDates: []
};
Uc.propTypes = {
  ...sg.default.propTypes,
  onChange: la.default.func,
  onRangeFocusChange: la.default.func,
  className: la.default.string,
  ranges: la.default.arrayOf(JC.rangeShape),
  moveRangeOnFirstSelection: la.default.bool,
  retainEndDateOnFirstSelection: la.default.bool
};
yi.default = Uc;
var Os = {}, Si = {}, pr = {};
Object.defineProperty(pr, "__esModule", {
  value: !0
});
pr.createStaticRanges = lg;
pr.defaultStaticRanges = pr.defaultInputRanges = void 0;
var je = Hr;
const mt = {
  startOfWeek: (0, je.startOfWeek)(/* @__PURE__ */ new Date()),
  endOfWeek: (0, je.endOfWeek)(/* @__PURE__ */ new Date()),
  startOfLastWeek: (0, je.startOfWeek)((0, je.addDays)(/* @__PURE__ */ new Date(), -7)),
  endOfLastWeek: (0, je.endOfWeek)((0, je.addDays)(/* @__PURE__ */ new Date(), -7)),
  startOfToday: (0, je.startOfDay)(/* @__PURE__ */ new Date()),
  endOfToday: (0, je.endOfDay)(/* @__PURE__ */ new Date()),
  startOfYesterday: (0, je.startOfDay)((0, je.addDays)(/* @__PURE__ */ new Date(), -1)),
  endOfYesterday: (0, je.endOfDay)((0, je.addDays)(/* @__PURE__ */ new Date(), -1)),
  startOfMonth: (0, je.startOfMonth)(/* @__PURE__ */ new Date()),
  endOfMonth: (0, je.endOfMonth)(/* @__PURE__ */ new Date()),
  startOfLastMonth: (0, je.startOfMonth)((0, je.addMonths)(/* @__PURE__ */ new Date(), -1)),
  endOfLastMonth: (0, je.endOfMonth)((0, je.addMonths)(/* @__PURE__ */ new Date(), -1))
}, iP = {
  range: {},
  isSelected(e) {
    const n = this.range();
    return (0, je.isSameDay)(e.startDate, n.startDate) && (0, je.isSameDay)(e.endDate, n.endDate);
  }
};
function lg(e) {
  return e.map((n) => ({
    ...iP,
    ...n
  }));
}
pr.defaultStaticRanges = lg([{
  label: "Today",
  range: () => ({
    startDate: mt.startOfToday,
    endDate: mt.endOfToday
  })
}, {
  label: "Yesterday",
  range: () => ({
    startDate: mt.startOfYesterday,
    endDate: mt.endOfYesterday
  })
}, {
  label: "This Week",
  range: () => ({
    startDate: mt.startOfWeek,
    endDate: mt.endOfWeek
  })
}, {
  label: "Last Week",
  range: () => ({
    startDate: mt.startOfLastWeek,
    endDate: mt.endOfLastWeek
  })
}, {
  label: "This Month",
  range: () => ({
    startDate: mt.startOfMonth,
    endDate: mt.endOfMonth
  })
}, {
  label: "Last Month",
  range: () => ({
    startDate: mt.startOfLastMonth,
    endDate: mt.endOfLastMonth
  })
}]);
pr.defaultInputRanges = [{
  label: "days up to today",
  range(e) {
    return {
      startDate: (0, je.addDays)(mt.startOfToday, (Math.max(Number(e), 1) - 1) * -1),
      endDate: mt.endOfToday
    };
  },
  getCurrentValue(e) {
    return (0, je.isSameDay)(e.endDate, mt.endOfToday) ? e.startDate ? (0, je.differenceInCalendarDays)(mt.endOfToday, e.startDate) + 1 : "∞" : "-";
  }
}, {
  label: "days starting today",
  range(e) {
    const n = /* @__PURE__ */ new Date();
    return {
      startDate: n,
      endDate: (0, je.addDays)(n, Math.max(Number(e), 1) - 1)
    };
  },
  getCurrentValue(e) {
    return (0, je.isSameDay)(e.startDate, mt.startOfToday) ? e.endDate ? (0, je.differenceInCalendarDays)(e.endDate, mt.startOfToday) + 1 : "∞" : "-";
  }
}];
var Ms = {};
Object.defineProperty(Ms, "__esModule", {
  value: !0
});
Ms.default = void 0;
var Co = sP(X), Nt = oP(qn);
function oP(e) {
  return e && e.__esModule ? e : { default: e };
}
function cg(e) {
  if (typeof WeakMap != "function") return null;
  var n = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  return (cg = function(a) {
    return a ? t : n;
  })(e);
}
function sP(e, n) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var t = cg(n);
  if (t && t.has(e)) return t.get(e);
  var a = { __proto__: null }, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in e) if (s !== "default" && Object.prototype.hasOwnProperty.call(e, s)) {
    var l = o ? Object.getOwnPropertyDescriptor(e, s) : null;
    l && (l.get || l.set) ? Object.defineProperty(a, s, l) : a[s] = e[s];
  }
  return a.default = e, t && t.set(e, a), a;
}
function uP(e, n, t) {
  return n = lP(n), n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function lP(e) {
  var n = cP(e, "string");
  return typeof n == "symbol" ? n : String(n);
}
function cP(e, n) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, n);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
const Zp = 0, Qp = 99999;
class jc extends Co.Component {
  constructor(n, t) {
    super(n, t), uP(this, "onChange", (a) => {
      const {
        onChange: o
      } = this.props;
      let s = parseInt(a.target.value, 10);
      s = isNaN(s) ? 0 : Math.max(Math.min(Qp, s), Zp), o(s);
    });
  }
  shouldComponentUpdate(n) {
    const {
      value: t,
      label: a,
      placeholder: o
    } = this.props;
    return t !== n.value || a !== n.label || o !== n.placeholder;
  }
  render() {
    const {
      label: n,
      placeholder: t,
      value: a,
      styles: o,
      onBlur: s,
      onFocus: l
    } = this.props;
    return /* @__PURE__ */ Co.default.createElement("div", {
      className: o.inputRange
    }, /* @__PURE__ */ Co.default.createElement("input", {
      className: o.inputRangeInput,
      placeholder: t,
      value: a,
      min: Zp,
      max: Qp,
      onChange: this.onChange,
      onFocus: l,
      onBlur: s
    }), /* @__PURE__ */ Co.default.createElement("span", {
      className: o.inputRangeLabel
    }, n));
  }
}
jc.propTypes = {
  value: Nt.default.oneOfType([Nt.default.string, Nt.default.number]),
  label: Nt.default.oneOfType([Nt.default.element, Nt.default.node]).isRequired,
  placeholder: Nt.default.string,
  styles: Nt.default.shape({
    inputRange: Nt.default.string,
    inputRangeInput: Nt.default.string,
    inputRangeLabel: Nt.default.string
  }).isRequired,
  onBlur: Nt.default.func.isRequired,
  onFocus: Nt.default.func.isRequired,
  onChange: Nt.default.func.isRequired
};
jc.defaultProps = {
  value: "",
  placeholder: "-"
};
Ms.default = jc;
Object.defineProperty(Si, "__esModule", {
  value: !0
});
Si.default = void 0;
var Ar = hP(X), jt = Cs(qn), Ir = Cs(Ur), Jp = pr, fP = Un, dP = Cs(Ms), e0 = Cs(Yr);
function Cs(e) {
  return e && e.__esModule ? e : { default: e };
}
function fg(e) {
  if (typeof WeakMap != "function") return null;
  var n = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  return (fg = function(a) {
    return a ? t : n;
  })(e);
}
function hP(e, n) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var t = fg(n);
  if (t && t.has(e)) return t.get(e);
  var a = { __proto__: null }, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in e) if (s !== "default" && Object.prototype.hasOwnProperty.call(e, s)) {
    var l = o ? Object.getOwnPropertyDescriptor(e, s) : null;
    l && (l.get || l.set) ? Object.defineProperty(a, s, l) : a[s] = e[s];
  }
  return a.default = e, t && t.set(e, a), a;
}
function pP(e, n, t) {
  return n = mP(n), n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function mP(e) {
  var n = vP(e, "string");
  return typeof n == "symbol" ? n : String(n);
}
function vP(e, n) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, n);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
class zc extends Ar.Component {
  constructor(n) {
    super(n), pP(this, "handleRangeChange", (t) => {
      const {
        onChange: a,
        ranges: o,
        focusedRange: s
      } = this.props, l = o[s[0]];
      !a || !l || a({
        [l.key || `range${s[0] + 1}`]: {
          ...l,
          ...t
        }
      });
    }), this.state = {
      rangeOffset: 0,
      focusedInput: -1
    };
  }
  getRangeOptionValue(n) {
    const {
      ranges: t = [],
      focusedRange: a = []
    } = this.props;
    if (typeof n.getCurrentValue != "function")
      return "";
    const o = t[a[0]] || {};
    return n.getCurrentValue(o) || "";
  }
  getSelectedRange(n, t) {
    const a = n.findIndex((s) => !s.startDate || !s.endDate || s.disabled ? !1 : t.isSelected(s));
    return {
      selectedRange: n[a],
      focusedRangeIndex: a
    };
  }
  render() {
    const {
      headerContent: n,
      footerContent: t,
      onPreviewChange: a,
      inputRanges: o,
      staticRanges: s,
      ranges: l,
      renderStaticRangeLabel: c,
      rangeColors: d,
      className: h
    } = this.props;
    return /* @__PURE__ */ Ar.default.createElement("div", {
      className: (0, e0.default)(Ir.default.definedRangesWrapper, h)
    }, n, /* @__PURE__ */ Ar.default.createElement("div", {
      className: Ir.default.staticRanges
    }, s.map((p, v) => {
      const {
        selectedRange: w,
        focusedRangeIndex: b
      } = this.getSelectedRange(l, p);
      let _;
      return p.hasCustomRendering ? _ = c(p) : _ = p.label, /* @__PURE__ */ Ar.default.createElement("button", {
        type: "button",
        className: (0, e0.default)(Ir.default.staticRange, {
          [Ir.default.staticRangeSelected]: !!w
        }),
        style: {
          color: w ? w.color || d[b] : null
        },
        key: v,
        onClick: () => this.handleRangeChange(p.range(this.props)),
        onFocus: () => a && a(p.range(this.props)),
        onMouseOver: () => a && a(p.range(this.props)),
        onMouseLeave: () => {
          a && a();
        }
      }, /* @__PURE__ */ Ar.default.createElement("span", {
        tabIndex: -1,
        className: Ir.default.staticRangeLabel
      }, _));
    })), /* @__PURE__ */ Ar.default.createElement("div", {
      className: Ir.default.inputRanges
    }, o.map((p, v) => /* @__PURE__ */ Ar.default.createElement(dP.default, {
      key: v,
      styles: Ir.default,
      label: p.label,
      onFocus: () => this.setState({
        focusedInput: v,
        rangeOffset: 0
      }),
      onBlur: () => this.setState({
        rangeOffset: 0
      }),
      onChange: (w) => this.handleRangeChange(p.range(w, this.props)),
      value: this.getRangeOptionValue(p)
    }))), t);
  }
}
zc.propTypes = {
  inputRanges: jt.default.array,
  staticRanges: jt.default.array,
  ranges: jt.default.arrayOf(fP.rangeShape),
  focusedRange: jt.default.arrayOf(jt.default.number),
  onPreviewChange: jt.default.func,
  onChange: jt.default.func,
  footerContent: jt.default.any,
  headerContent: jt.default.any,
  rangeColors: jt.default.arrayOf(jt.default.string),
  className: jt.default.string,
  renderStaticRangeLabel: jt.default.func
};
zc.defaultProps = {
  inputRanges: Jp.defaultInputRanges,
  staticRanges: Jp.defaultStaticRanges,
  ranges: [],
  rangeColors: ["#3d91ff", "#3ecf8e", "#fed14c"],
  focusedRange: [0, 0]
};
Si.default = zc;
Object.defineProperty(Os, "__esModule", {
  value: !0
});
Os.default = void 0;
var Po = bP(X), gP = Oi(qn), dg = Oi(yi), hg = Oi(Si), t0 = Gn, yP = Oi(Yr), wP = Oi(Ur);
function Oi(e) {
  return e && e.__esModule ? e : { default: e };
}
function pg(e) {
  if (typeof WeakMap != "function") return null;
  var n = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  return (pg = function(a) {
    return a ? t : n;
  })(e);
}
function bP(e, n) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var t = pg(n);
  if (t && t.has(e)) return t.get(e);
  var a = { __proto__: null }, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in e) if (s !== "default" && Object.prototype.hasOwnProperty.call(e, s)) {
    var l = o ? Object.getOwnPropertyDescriptor(e, s) : null;
    l && (l.get || l.set) ? Object.defineProperty(a, s, l) : a[s] = e[s];
  }
  return a.default = e, t && t.set(e, a), a;
}
function ns() {
  return ns = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, ns.apply(this, arguments);
}
class qc extends Po.Component {
  constructor(n) {
    super(n), this.state = {
      focusedRange: [(0, t0.findNextRangeIndex)(n.ranges), 0]
    }, this.styles = (0, t0.generateStyles)([wP.default, n.classNames]);
  }
  render() {
    const {
      focusedRange: n
    } = this.state;
    return /* @__PURE__ */ Po.default.createElement("div", {
      className: (0, yP.default)(this.styles.dateRangePickerWrapper, this.props.className)
    }, /* @__PURE__ */ Po.default.createElement(hg.default, ns({
      focusedRange: n,
      onPreviewChange: (t) => this.dateRange.updatePreview(t ? this.dateRange.calcNewSelection(t, typeof t == "string") : null)
    }, this.props, {
      range: this.props.ranges[n[0]],
      className: void 0
    })), /* @__PURE__ */ Po.default.createElement(dg.default, ns({
      onRangeFocusChange: (t) => this.setState({
        focusedRange: t
      }),
      focusedRange: n
    }, this.props, {
      ref: (t) => this.dateRange = t,
      className: void 0
    })));
  }
}
qc.defaultProps = {};
qc.propTypes = {
  ...dg.default.propTypes,
  ...hg.default.propTypes,
  className: gP.default.string
};
Os.default = qc;
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "Calendar", {
    enumerable: !0,
    get: function() {
      return t.default;
    }
  }), Object.defineProperty(e, "DateRange", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  }), Object.defineProperty(e, "DateRangePicker", {
    enumerable: !0,
    get: function() {
      return a.default;
    }
  }), Object.defineProperty(e, "DefinedRange", {
    enumerable: !0,
    get: function() {
      return o.default;
    }
  }), Object.defineProperty(e, "createStaticRanges", {
    enumerable: !0,
    get: function() {
      return s.createStaticRanges;
    }
  }), Object.defineProperty(e, "defaultInputRanges", {
    enumerable: !0,
    get: function() {
      return s.defaultInputRanges;
    }
  }), Object.defineProperty(e, "defaultStaticRanges", {
    enumerable: !0,
    get: function() {
      return s.defaultStaticRanges;
    }
  });
  var n = l(yi), t = l(wi), a = l(Os), o = l(Si), s = pr;
  function l(c) {
    return c && c.__esModule ? c : { default: c };
  }
})(F4);
function jr(e, n) {
  if (e == null) return {};
  var t = {};
  for (var a in e) if ({}.hasOwnProperty.call(e, a)) {
    if (n.indexOf(a) >= 0) continue;
    t[a] = e[a];
  }
  return t;
}
var _P = ["version"], xP = function(n) {
  var t = n.version, a = t === void 0 ? "1" : t, o = jr(n, _P);
  switch (a) {
    case "1":
      return /* @__PURE__ */ X.createElement("svg", {
        width: "8",
        height: "13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /* @__PURE__ */ X.createElement("path", {
        d: "M6.727 0.546L1 6.273L6.727 12",
        stroke: "currentColor",
        strokeWidth: "1.273"
      }));
    case "2":
      return /* @__PURE__ */ X.createElement("svg", Object.assign({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: "#7370FF"
      }, o), /* @__PURE__ */ X.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.91693 6.24462C10.2789 6.58529 10.2961 7.15487 9.95548 7.51683L6.58308 11.1H19.5001C19.9972 11.1 20.4001 11.5029 20.4001 12C20.4001 12.4971 19.9972 12.9 19.5001 12.9H6.58308L9.95548 16.4832C10.2961 16.8451 10.2789 17.4147 9.91693 17.7554C9.55497 18.096 8.98538 18.0788 8.64472 17.7168L3.84472 12.6168C3.51856 12.2703 3.51856 11.7297 3.84472 11.3832L8.64472 6.28317C8.98538 5.92122 9.55497 5.90396 9.91693 6.24462Z",
        fill: "currentColor"
      }));
    default:
      return null;
  }
}, DP = function() {
  return /* @__PURE__ */ X.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ X.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1ZM7.28033 6.21967C6.98744 5.92678 6.51256 5.92678 6.21967 6.21967C5.92678 6.51256 5.92678 6.98744 6.21967 7.28033L8.93934 10L6.21967 12.7197C5.92678 13.0126 5.92678 13.4874 6.21967 13.7803C6.51256 14.0732 6.98744 14.0732 7.28033 13.7803L10 11.0607L12.7197 13.7803C13.0126 14.0732 13.4874 14.0732 13.7803 13.7803C14.0732 13.4874 14.0732 13.0126 13.7803 12.7197L11.0607 10L13.7803 7.28033C14.0732 6.98744 14.0732 6.51256 13.7803 6.21967C13.4874 5.92678 13.0126 5.92678 12.7197 6.21967L10 8.93934L7.28033 6.21967Z",
    fill: "#7370FF"
  }));
}, SP = ["version"], OP = function(n) {
  var t = n.version, a = t === void 0 ? "1" : t, o = jr(n, SP);
  switch (a) {
    case "1":
      return /* @__PURE__ */ X.createElement("svg", Object.assign({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, o), /* @__PURE__ */ X.createElement("path", {
        d: "M19.5509 4.27677C19.1818 3.90774 18.5835 3.90774 18.2145 4.27678L12 10.4913L5.78553 4.27678C5.4165 3.90774 4.81818 3.90774 4.44914 4.27677L4.27678 4.44914C3.90774 4.81817 3.90774 5.41649 4.27677 5.78553L10.4912 12L4.27678 18.2145C3.90774 18.5835 3.90774 19.1818 4.27678 19.5509L4.44914 19.7232C4.81818 20.0923 5.4165 20.0923 5.78553 19.7232L12 13.5088L18.2145 19.7232C18.5835 20.0923 19.1818 20.0923 19.5509 19.7232L19.7232 19.5509C20.0923 19.1818 20.0923 18.5835 19.7232 18.2145L13.5088 12L19.7232 5.78553C20.0923 5.41649 20.0923 4.81817 19.7232 4.44914L19.5509 4.27677Z",
        fill: "" + (o.fill ? o.fill : "#2A2354")
      }));
    case "2":
      return /* @__PURE__ */ X.createElement("svg", Object.assign({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: "#7370FF"
      }, o), /* @__PURE__ */ X.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.2636 6.2636C6.61508 5.91213 7.18492 5.91213 7.5364 6.2636L12 10.7272L16.4636 6.2636C16.8151 5.91213 17.3849 5.91213 17.7364 6.2636C18.0879 6.61508 18.0879 7.18492 17.7364 7.5364L13.2728 12L17.7364 16.4636C18.0879 16.8151 18.0879 17.3849 17.7364 17.7364C17.3849 18.0879 16.8151 18.0879 16.4636 17.7364L12 13.2728L7.5364 17.7364C7.18492 18.0879 6.61508 18.0879 6.2636 17.7364C5.91213 17.3849 5.91213 16.8151 6.2636 16.4636L10.7272 12L6.2636 7.5364C5.91213 7.18492 5.91213 6.61508 6.2636 6.2636Z",
        fill: "currentColor"
      }));
    default:
      return null;
  }
}, yl = function(n) {
  var t = n.fill;
  return /* @__PURE__ */ X.createElement("svg", {
    width: "7",
    height: "7",
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ X.createElement("path", {
    d: "M.135 1.455C-.212.905.15.156.762.156h5.476c.612 0 .974.75.627 1.3l-2.738 4.34a.726.726 0 0 1-1.254 0L.135 1.457Z",
    fill: t || "#205a4d"
  }));
}, MP = ["version"], CP = function(n) {
  var t = n.version, a = t === void 0 ? "1" : t, o = jr(n, MP);
  switch (a) {
    case "1":
      return /* @__PURE__ */ X.createElement("svg", Object.assign({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, o), /* @__PURE__ */ X.createElement("path", {
        d: "M21.003 21.027c.55-.545.55-1.433 0-1.977l-4.215-4.183a8.025 8.025 0 0 0 1.56-4.759C18.348 5.638 14.68 2 10.173 2 5.667 2 2 5.638 2 10.108c0 4.472 3.667 8.109 8.173 8.109a8.176 8.176 0 0 0 4.61-1.415l4.259 4.225a1.393 1.393 0 0 0 1.961 0ZM4.397 10.108c0-3.16 2.592-5.73 5.777-5.73 3.186 0 5.777 2.57 5.777 5.73 0 3.16-2.591 5.731-5.777 5.731s-5.777-2.57-5.777-5.73Z",
        fill: "#000"
      }));
    case "2":
      return /* @__PURE__ */ X.createElement("svg", Object.assign({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: "#7370FF"
      }, o), /* @__PURE__ */ X.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.2 2.99995C6.22356 2.99995 3.00001 6.2235 3.00001 10.2C3.00001 14.1764 6.22356 17.4 10.2 17.4C14.1765 17.4 17.4 14.1764 17.4 10.2C17.4 6.2235 14.1765 2.99995 10.2 2.99995ZM1.20001 10.2C1.20001 5.22939 5.22945 1.19995 10.2 1.19995C15.1706 1.19995 19.2 5.22939 19.2 10.2C19.2 12.3611 18.4383 14.3443 17.1687 15.8958L22.5364 21.2636C22.8879 21.615 22.8879 22.1849 22.5364 22.5363C22.1849 22.8878 21.6151 22.8878 21.2636 22.5363L15.8959 17.1686C14.3444 18.4382 12.3612 19.2 10.2 19.2C5.22945 19.2 1.20001 15.1705 1.20001 10.2Z",
        fill: "currentColor"
      }));
    default:
      return null;
  }
}, PP = ["version"], TP = function(n) {
  var t = n.version, a = t === void 0 ? "1" : t, o = jr(n, PP), s = o.className, l = s === void 0 ? "" : s, c = o.size, d = c === void 0 ? "md" : c, h = o.testId, p = o.text, v = o.color, w = {
    sm: {
      width: 16,
      height: 16
    },
    md: {
      width: 24,
      height: 24
    },
    lg: {
      width: 48,
      height: 48
    }
  }, b = w[d] || w.md, _ = b.width, D = b.height;
  switch (a) {
    case "1":
      return /* @__PURE__ */ X.createElement("div", {
        className: "flex flex-col justify-center items-center"
      }, /* @__PURE__ */ X.createElement("svg", {
        className: l || "",
        width: _,
        height: D,
        viewBox: "0 0 38 38",
        xmlns: "http://www.w3.org/2000/svg",
        stroke: v || "var(--c-purple)",
        "data-testid": h,
        "data-loader": !0
      }, /* @__PURE__ */ X.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, /* @__PURE__ */ X.createElement("g", {
        transform: "translate(1 1)",
        strokeWidth: "2"
      }, /* @__PURE__ */ X.createElement("circle", {
        strokeOpacity: ".5",
        cx: "18",
        cy: "18",
        r: "18"
      }), /* @__PURE__ */ X.createElement("path", {
        d: "M36 18c0-9.94-8.06-18-18-18"
      }, /* @__PURE__ */ X.createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 18 18",
        to: "360 18 18",
        dur: "1s",
        repeatCount: "indefinite"
      }))))), p ? /* @__PURE__ */ X.createElement("p", {
        className: "m-0 mt-[5px] text-sm"
      }, p) : null);
    case "2":
      return /* @__PURE__ */ X.createElement("div", {
        className: "flex flex-col justify-center items-center"
      }, /* @__PURE__ */ X.createElement("svg", {
        className: l || "",
        width: _,
        height: D,
        viewBox: "0 0 18 18",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": h,
        "data-loader": !0
      }, /* @__PURE__ */ X.createElement("path", {
        d: "M12.9868 2.23105C13.2966 1.74238 13.1537 1.08848 12.6306 0.84113C11.3744 0.247081 9.98627 -0.0319713 8.58764 0.0360179C6.83872 0.121035 5.15882 0.744534 3.77794 1.82115C2.39706 2.89777 1.38269 4.37489 0.873715 6.05026C0.364738 7.72564 0.386032 9.51739 0.934681 11.1802C1.48333 12.843 2.53251 14.2956 3.93859 15.3391C5.34467 16.3826 7.03891 16.966 8.78935 17.0094C10.5398 17.0528 12.2609 16.5542 13.717 15.5817C14.8814 14.804 15.8309 13.7536 16.487 12.5286C16.7601 12.0185 16.4858 11.408 15.946 11.1997C15.4062 10.9913 14.8068 11.2661 14.5132 11.7647C14.0267 12.5911 13.3581 13.3016 12.5532 13.8392C11.4564 14.5718 10.1599 14.9474 8.84132 14.9147C7.52274 14.882 6.2465 14.4425 5.18732 13.6565C4.12815 12.8704 3.33781 11.7762 2.92453 10.5236C2.51124 9.27107 2.4952 7.92138 2.8786 6.65935C3.26201 5.39731 4.02611 4.28463 5.06631 3.47362C6.1065 2.66262 7.37194 2.19295 8.68937 2.12891C9.65615 2.08191 10.6163 2.25504 11.4991 2.62964C12.0317 2.85566 12.677 2.71973 12.9868 2.23105Z",
        fill: "url(#paint0_linear_3592_2796)"
      }, /* @__PURE__ */ X.createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 9 9",
        to: "360 9 9",
        dur: "1s",
        repeatCount: "indefinite"
      })), /* @__PURE__ */ X.createElement("defs", null, /* @__PURE__ */ X.createElement("linearGradient", {
        id: "paint0_linear_3592_2796",
        x1: "12.351",
        y1: "1.52817",
        x2: "14.0843",
        y2: "15.9721",
        gradientUnits: "userSpaceOnUse"
      }, /* @__PURE__ */ X.createElement("stop", {
        stopColor: "white"
      }), /* @__PURE__ */ X.createElement("stop", {
        offset: "1",
        stopColor: v || "var(--c-purple)"
      })))), p ? /* @__PURE__ */ X.createElement("p", {
        className: "m-0 mt-[5px] text-sm"
      }, p) : null);
  }
}, ln = { input: "input__7896566e", "input-container": "input-container__11c84656", "input-label": "input-label__4a4cf7a9", "required-asterisk": "required-asterisk__8199627f", "helper-text-container": "helper-text-container__82bd89c5", "helper-text": "helper-text__1bc98dd9", "error-text": "error-text__e8734e2c", "elem-before-input": "elem-before-input__7c809ea4", "elem-after-input": "elem-after-input__1841d9c5" }, EP = ["isDisabled", "isError", "isRequired", "isReadOnly", "isFetching", "isClearable", "className", "label", "helperText", "errorText", "elemAfterInput", "elemBeforeInput", "testId", "maxNumberOfChars", "showCharsCounter", "onChange"], RP = /* @__PURE__ */ o0(function(e, n) {
  var t = e.isDisabled, a = t === void 0 ? !1 : t, o = e.isError, s = o === void 0 ? !1 : o, l = e.isRequired, c = l === void 0 ? !1 : l, d = e.isReadOnly, h = d === void 0 ? !1 : d, p = e.isFetching, v = p === void 0 ? !1 : p, w = e.isClearable, b = w === void 0 ? !1 : w, _ = e.className, D = _ === void 0 ? "" : _, C = e.label, N = C === void 0 ? "" : C, $ = e.helperText, A = $ === void 0 ? "" : $, k = e.errorText, R = k === void 0 ? "" : k, ie = e.elemAfterInput, Y = e.elemBeforeInput, z = e.testId, oe = e.maxNumberOfChars, xe = oe === void 0 ? 100 : oe, Ne = e.showCharsCounter, Ae = Ne === void 0 ? !1 : Ne, Te = e.onChange, ke = jr(e, EP), et = Sa(0), He = et[0], Pe = et[1], qe = He > xe, lt = Ae && qe, U = !Ae && qe ? "Character limit exceeded. Please shorten your input." : void 0, Z = X.useRef(null);
  n9(n, function() {
    return Z.current;
  });
  var V = b && e.value && !a && !h;
  function I() {
    var M;
    if (!(a || h)) {
      var S = (M = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")) == null ? void 0 : M.set;
      if (!(!S || Z.current === null)) {
        S.call(Z.current, "");
        var F = new Event("input", {
          bubbles: !0
        });
        Z.current.dispatchEvent(F);
      }
    }
  }
  return /* @__PURE__ */ X.createElement("div", null, N !== "" ? /* @__PURE__ */ X.createElement("label", {
    htmlFor: e.id,
    className: ln["input-label"] + " ",
    "data-readonly": h || void 0
  }, N, c ? /* @__PURE__ */ X.createElement("span", {
    className: ln["required-asterisk"],
    "aria-hidden": "true",
    title: "required"
  }, "*") : null) : null, /* @__PURE__ */ X.createElement("div", {
    "data-disabled": a || void 0,
    "data-invalid": s || lt ? s || lt : void 0,
    "data-readonly": h || void 0,
    "data-testid": z && z + "-container",
    className: ln["input-container"] + " " + D,
    onClick: function() {
      var S;
      Z.current && ((S = Z.current) == null || S.focus());
    }
  }, Y ? /* @__PURE__ */ X.createElement("div", {
    className: ln["elem-before-input"]
  }, Y) : null, /* @__PURE__ */ X.createElement("input", Object.assign({}, ke, {
    id: e.id,
    "data-testid": z,
    "aria-invalid": s || lt ? s || lt : void 0,
    disabled: a,
    readOnly: h,
    required: c,
    className: ln.input + " " + (lt ? "mr-9" : ""),
    ref: Z,
    onChange: function(S) {
      Pe(S.target.value.length), Te == null || Te(S);
    }
  })), v ? /* @__PURE__ */ X.createElement("div", {
    className: ln["elem-after-input"]
  }, /* @__PURE__ */ X.createElement(TP, {
    testId: z && z + "-loader"
  })) : V ? /* @__PURE__ */ X.createElement("div", {
    className: ln["elem-after-input"],
    onClick: I,
    "data-clear": !0,
    "data-testid": z && z + "-clear"
  }, /* @__PURE__ */ X.createElement(DP, null)) : ie ? /* @__PURE__ */ X.createElement("div", {
    className: ln["elem-after-input"]
  }, ie) : null, Ae && xe ? /* @__PURE__ */ X.createElement("span", {
    className: "absolute bottom-3 right-2 text-xs  " + (qe ? "text-error" : "text-gray-3")
  }, He, "/", xe) : null), A !== "" || R !== "" || U ? /* @__PURE__ */ X.createElement("div", {
    className: ln["helper-text-container"]
  }, A !== "" ? /* @__PURE__ */ X.createElement("span", {
    className: ln["helper-text"]
  }, A) : null, R !== "" || U ? /* @__PURE__ */ X.createElement("span", {
    className: ln["error-text"]
  }, U ?? R) : null) : null);
});
RP.displayName = "TextField";
var n0 = { "back-link": "back-link__bd03c98e", "back-link__link": "back-link__link__46c89c60" }, AP = function(n) {
  var t = n.text, a = n.onClick, o = n.className;
  return /* @__PURE__ */ X.createElement("div", {
    className: n0["back-link"]
  }, /* @__PURE__ */ X.createElement("a", {
    className: [n0["back-link__link"], o].filter(Boolean).join(" "),
    onClick: a,
    "data-testid": "back-link"
  }, /* @__PURE__ */ X.createElement(xP, {
    version: "2"
  }), t));
}, IP = ["className"], LP = function(n) {
  var t = n.className, a = jr(n, IP);
  return /* @__PURE__ */ X.createElement("svg", Object.assign({
    width: "152",
    height: "103",
    viewBox: "0 0 152 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "focal-loader " + t
  }, a), /* @__PURE__ */ X.createElement("path", {
    className: "left_icon",
    d: "M58.3776 23.6968C54.9128 21.7169 50.623 24.1918 50.623 28.1515V74.6828C50.623 78.6426 54.9128 81.1174 58.3776 79.1376L98.8042 55.874C102.269 53.8941 102.269 48.9444 98.8042 46.9645L58.3776 23.6968Z",
    fill: "#00FFA3"
  }), /* @__PURE__ */ X.createElement("path", {
    className: "right_icon",
    d: "M93.5252 23.6968C96.99 21.7169 101.28 24.1918 101.28 28.1515V74.8478C101.28 78.8076 96.99 81.2824 93.5252 79.3025L53.0986 56.0348C49.6338 54.055 49.6338 49.1053 53.0986 47.1254L93.5252 23.6968Z",
    fill: "url(#paint0_linear_710_20549)"
  }), /* @__PURE__ */ X.createElement("defs", null, /* @__PURE__ */ X.createElement("linearGradient", {
    id: "paint0_linear_710_20549",
    x1: "101.259",
    y1: "19.2792",
    x2: "73.3676",
    y2: "67.5883",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ X.createElement("stop", {
    stopColor: "#F106F5",
    stopOpacity: "0.97"
  }), /* @__PURE__ */ X.createElement("stop", {
    offset: "1",
    stopColor: "#032BFF",
    stopOpacity: "0.4"
  }))));
};
Ym.div;
var r0;
(function(e) {
  e.OPEN_SIDEBAR = "OPEN_SIDEBAR", e.CLOSE_SIDEBAR = "CLOSE_SIDEBAR", e.TEMPORARILY_OPEN_SIDEBAR = "TEMPORARILY_OPEN_SIDEBAR";
})(r0 || (r0 = {}));
var Gl = function(n) {
  var t = n.title, a = n.backButton;
  return /* @__PURE__ */ X.createElement(X.Fragment, null, a ? /* @__PURE__ */ X.createElement("div", {
    style: {
      marginBottom: "var(--s-30)"
    }
  }, /* @__PURE__ */ X.createElement(AP, {
    onClick: a,
    text: t,
    className: "back-link-h1 main-heading"
  })) : t ? /* @__PURE__ */ X.createElement("h1", {
    className: "main-heading"
  }, t) : /* @__PURE__ */ X.createElement("div", {
    className: "mt-8"
  }));
}, FP = function(n) {
  var t = n.children;
  return /* @__PURE__ */ X.createElement(Ym.div, {
    className: "banner",
    initial: {
      opacity: 1
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  }, t);
}, NP = function(n) {
  var t = n.children, a = n.className, o, s, l = [];
  return X.Children.forEach(t, function(c) {
    /* @__PURE__ */ X.isValidElement(c) && (c.type === Gl ? o = c : c.type === FP ? s = c : l.push(c));
  }), a ? /* @__PURE__ */ X.createElement("div", {
    className: a
  }, !!o && /* @__PURE__ */ X.createElement(X.Fragment, null, o), !!s && /* @__PURE__ */ X.createElement(X.Fragment, null, s), l) : /* @__PURE__ */ X.createElement(X.Fragment, null, !!o && /* @__PURE__ */ X.createElement(X.Fragment, null, o), !!s && /* @__PURE__ */ X.createElement(X.Fragment, null, s), l);
}, kP = ["className"], WP = function(n) {
  var t = n.className, a = jr(n, kP);
  return /* @__PURE__ */ X.createElement("div", Object.assign({
    className: "block" + (t ? " " + t : "")
  }, a));
};
const hT = ({
  children: e,
  title: n = "",
  backBtn: t = !1,
  state: a,
  route: o,
  className: s,
  withBackground: l = !1,
  blockClassName: c = ""
}) => {
  const d = Q3();
  return /* @__PURE__ */ Ve(NP, { className: s, children: [
    t ? /* @__PURE__ */ ee(Gl, { title: n, backButton: () => {
      o && a ? d(o, { state: a }) : d(o || -1);
    } }) : /* @__PURE__ */ ee(Gl, { title: n }),
    /* @__PURE__ */ ee(
      WP,
      {
        className: fn(c, { block_list: l }),
        children: e
      }
    )
  ] });
}, VP = ({ ...e }) => {
  const [n, t] = Sa(!1), a = n ? "text" : "password";
  return /* @__PURE__ */ Ve("div", { className: "input-container", children: [
    /* @__PURE__ */ ee(
      "input",
      {
        className: fn("input input--has-toggle-btn", {
          "input--error": e.error
        }),
        ...e,
        type: a
      }
    ),
    /* @__PURE__ */ ee(
      "span",
      {
        className: "input__toggle-button",
        onClick: () => t(!n),
        children: n ? "HIDE" : "SHOW"
      }
    )
  ] });
}, $P = ({ isFetching: e, ...n }) => /* @__PURE__ */ Ve("div", { className: "input-container", children: [
  /* @__PURE__ */ ee(
    "input",
    {
      className: fn("input", {
        "input--with-loader": e,
        "input--error": n.error
      }),
      ...n
    }
  ),
  e && /* @__PURE__ */ ee(i9, { className: "input__loader" })
] }), a0 = ({
  Icon: e,
  className: n = "",
  ...t
}) => /* @__PURE__ */ Ve("div", { className: `input-container input-container--with-icon ${n}`, children: [
  /* @__PURE__ */ ee(
    "input",
    {
      className: fn("input input--with-icon", {
        "input--error": t.error
      }),
      ...t
    }
  ),
  /* @__PURE__ */ ee(e, { version: "2" })
] }), YP = ({
  hasToggleButton: e,
  hasLoader: n,
  isFetching: t,
  error: a,
  icon: o,
  isSearch: s,
  ...l
}) => {
  if (l.type === "password" && e)
    return /* @__PURE__ */ ee(VP, { ...l });
  if (n)
    return /* @__PURE__ */ ee($P, { isFetching: t, ...l });
  if (s)
    return /* @__PURE__ */ ee(a0, { ...l, Icon: () => /* @__PURE__ */ ee(CP, { version: "2" }) });
  if (o)
    return /* @__PURE__ */ ee(a0, { ...l, Icon: o });
  const { className: c = "", ...d } = l;
  return /* @__PURE__ */ ee(
    "input",
    {
      ...d,
      className: fn(
        "input",
        {
          "input--error": a,
          "input--fetching": t
        },
        c
      )
    }
  );
}, pT = ({
  onSearch: e,
  placeholder: n,
  initialValue: t = ""
}) => {
  const [a, o] = Sa(t);
  return St(() => {
    o(t);
  }, [t]), /* @__PURE__ */ ee("div", { className: "search-container", children: /* @__PURE__ */ ee(
    YP,
    {
      className: "search-input",
      isSearch: !0,
      placeholder: n,
      name: "text",
      autoComplete: "off",
      onChange: (c) => {
        o(c.currentTarget.value);
      },
      onKeyDown: (c) => {
        c.key === "Enter" && e(c.currentTarget.value);
      },
      value: a
    }
  ) });
};
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function i0(e, n) {
  return e ? BP(e) ? /* @__PURE__ */ Lo.createElement(e, n) : e : null;
}
function BP(e) {
  return HP(e) || typeof e == "function" || UP(e);
}
function HP(e) {
  return typeof e == "function" && (() => {
    const n = Object.getPrototypeOf(e);
    return n.prototype && n.prototype.isReactComponent;
  })();
}
function UP(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function mT({
  className: e = "",
  stickyHeader: n = !1,
  table: t,
  emptyTableText: a = "No data available",
  isLoading: o = !1,
  loadingText: s = "Loading",
  isError: l = !1,
  errorText: c = "Error",
  isClickable: d = !1,
  rowTestId: h = "",
  rowTestCy: p = "",
  expandable: v = !1,
  enableMultiExpand: w = !1,
  expandedRows: b = {},
  resetExpanded: _ = !1,
  getRowClassName: D = () => "",
  onRowClick: C = () => null,
  selectedRow: N = () => !1,
  expandedRowData: $ = () => null,
  ...A
}) {
  const k = "isSelecting" in A && A.isSelecting, [R, ie] = Sa(
    b
  );
  return St(() => {
    ie(b);
  }, [o, _]), /* @__PURE__ */ ee("div", { className: n ? void 0 : "table-wrapper", children: /* @__PURE__ */ Ve(
    "table",
    {
      className: `generator-table${n ? "-sticky" : ""} ${e}`,
      "data-testid": "tid-table-generator",
      children: [
        /* @__PURE__ */ ee("thead", { "data-testid": "tid-table-generator-header", children: t.getHeaderGroups().map((Y) => /* @__PURE__ */ Ve(
          "tr",
          {
            "data-testid": `tid-table-generator-header-${Y.id}`,
            children: [
              k ? /* @__PURE__ */ ee(
                "th",
                {
                  className: "checkbox-col",
                  "data-testid": "tid-table-generator-header-checkbox",
                  children: /* @__PURE__ */ ee(
                    Mh,
                    {
                      isPartiallySelected: !1,
                      "data-testid": "tid-col-checkbox",
                      checked: A.isAllSelected,
                      onChange: A.onAllSelected
                    }
                  )
                }
              ) : null,
              v ? /* @__PURE__ */ ee("th", { "data-testid": "tid-table-generator-header-expandable" }) : null,
              Y.headers.map((z) => /* @__PURE__ */ ee(
                "th",
                {
                  colSpan: z.colSpan,
                  style: {
                    width: z.column.getSize(),
                    minWidth: z.column.columnDef.minSize,
                    maxWidth: z.column.columnDef.maxSize
                  },
                  "data-testid": `tid-table-generator-header-th-${z.id}`,
                  children: z.isPlaceholder ? null : /* @__PURE__ */ Ve(
                    "div",
                    {
                      "data-testid": `sortby-${z.column.id}`,
                      className: z.column.getCanSort() ? "sortable-th" : "unsortable-th",
                      onClick: z.column.getToggleSortingHandler(),
                      children: [
                        i0(
                          z.column.columnDef.header,
                          z.getContext()
                        ),
                        z.column.getCanSort() && /* @__PURE__ */ Ve("div", { className: "sortable-th__icons-container", children: [
                          /* @__PURE__ */ ee(
                            "div",
                            {
                              className: `sortable-th__asc-icon ${z.column.getIsSorted() === "asc" ? "sortable-th__asc-icon--active" : ""}`,
                              "data-testid": "tid-asc-arrow",
                              children: /* @__PURE__ */ ee(
                                yl,
                                {
                                  fill: z.column.getIsSorted() === "asc" ? "#7370FF" : "#bfbfbf"
                                }
                              )
                            }
                          ),
                          /* @__PURE__ */ ee(
                            "div",
                            {
                              className: `sortable-th__desc-icon ${z.column.getIsSorted() === "desc" ? "sortable-th__desc-icon--active" : ""}`,
                              "data-testid": "tid-desc-arrow",
                              children: /* @__PURE__ */ ee(
                                yl,
                                {
                                  fill: z.column.getIsSorted() === "desc" ? "#7370FF" : "#bfbfbf"
                                }
                              )
                            }
                          )
                        ] })
                      ]
                    }
                  )
                },
                z.id
              ))
            ]
          },
          Y.id
        )) }),
        /* @__PURE__ */ ee("tbody", { "data-testid": "tid-table-generator-body", children: o ? /* @__PURE__ */ ee("tr", { "data-testid": "tid-table-generator-body-loading", children: /* @__PURE__ */ ee(
          "td",
          {
            colSpan: 100,
            className: "u-text-center",
            "data-testid": "focal-loader",
            children: /* @__PURE__ */ Ve("div", { className: "loader-container loader-container--with-text", children: [
              /* @__PURE__ */ ee(LP, {}),
              /* @__PURE__ */ ee("p", { children: s })
            ] })
          }
        ) }) : l ? /* @__PURE__ */ ee("tr", { "data-testid": "tid-table-generator-body-error", children: /* @__PURE__ */ ee(
          "td",
          {
            colSpan: 100,
            className: "u-text-center",
            "data-testid": "tid-table-generator-body-error-data",
            children: /* @__PURE__ */ Ve("div", { className: "error-container", children: [
              /* @__PURE__ */ ee(OP, {}),
              /* @__PURE__ */ ee("span", { children: c })
            ] })
          }
        ) }) : t.getRowModel().rows.length === 0 ? /* @__PURE__ */ ee("tr", { "data-testid": "tid-table-generator-body-empty", children: /* @__PURE__ */ ee(
          "td",
          {
            colSpan: 100,
            "data-testid": "tid-table-generator-body-empty-data",
            children: /* @__PURE__ */ ee("div", { className: "u-text-center", children: a })
          }
        ) }) : t.getRowModel().rows.map((Y) => /* @__PURE__ */ Ve(s0, { children: [
          /* @__PURE__ */ Ve(
            "tr",
            {
              onClick: () => {
                d ? C(Y.original, Y.index) : v && ie(w ? (z) => ({
                  ...z,
                  [Y.id]: !R[Y.id]
                }) : {
                  [Y.id]: !R[Y.id]
                });
              },
              className: `generator-table ${d || v ? "generator-table--clickable-row" : "generator-table--row"} ${N(Y.original) ? "generator-table--selected" : ""} ${D(Y.original)}`,
              "data-testid": typeof h == "string" ? h : h(Y.original),
              "data-cy": typeof p == "string" ? p : p(Y.original),
              children: [
                k ? /* @__PURE__ */ ee(
                  "td",
                  {
                    className: `checkbox-col ${R[Y.id] ? "expanded-row" : ""}`,
                    "data-testid": "tid-selected-row-data",
                    children: /* @__PURE__ */ ee(
                      Mh,
                      {
                        isPartiallySelected: !1,
                        checked: A.isRowSelected(Y.original),
                        "data-testid": "tid-row-checkbox",
                        onChange: () => A.onRowSelected(Y.original)
                      }
                    )
                  }
                ) : null,
                v ? /* @__PURE__ */ ee(
                  "td",
                  {
                    className: `expand-col ${R[Y.id] ? "expanded-row" : ""}`,
                    onClick: (z) => z.stopPropagation(),
                    "data-testid": "tid-expandable-row-data",
                    children: /* @__PURE__ */ ee(
                      "button",
                      {
                        "data-testid": "tid-collapse-button",
                        onClick: () => {
                          ie(w ? (z) => ({
                            ...z,
                            [Y.id]: !R[Y.id]
                          }) : {
                            [Y.id]: !R[Y.id]
                          });
                        },
                        className: `expand-button ${R[Y.id] ? "expanded" : ""}`,
                        children: /* @__PURE__ */ ee(yl, {})
                      }
                    )
                  }
                ) : null,
                Y.getVisibleCells().map((z) => /* @__PURE__ */ ee(
                  "td",
                  {
                    style: {
                      width: z.column.getSize(),
                      minWidth: z.column.columnDef.minSize,
                      maxWidth: z.column.columnDef.maxSize
                    },
                    className: `${R[Y.id] ? "expanded-row" : ""}`,
                    "data-testid": `tid-row-data-${z.id}`,
                    children: /* @__PURE__ */ ee("div", { className: "generator-table--row-data", children: i0(
                      z.column.columnDef.cell,
                      z.getContext()
                    ) })
                  },
                  z.id
                ))
              ]
            },
            Y.id
          ),
          v && R[Y.id] && /* @__PURE__ */ Ve(
            "tr",
            {
              className: "generator-table--expand-row",
              "data-testid": "tid-expandable-row",
              children: [
                k && /* @__PURE__ */ ee(
                  "td",
                  {
                    className: "checkbox-col colored-border",
                    "data-testid": "tid-selected-expandable-row"
                  }
                ),
                v && /* @__PURE__ */ ee(
                  "td",
                  {
                    className: "expand-col colored-border",
                    "data-testid": "tid-expanded-expandable-row"
                  }
                ),
                /* @__PURE__ */ ee(
                  "td",
                  {
                    colSpan: Y.getVisibleCells().length || 100,
                    "data-testid": "tid-expanded-row-data",
                    children: $(Y.original)
                  }
                )
              ]
            }
          )
        ] }, Y.id)) })
      ]
    }
  ) });
}
const vT = ({ options: e, row: n, onOptionClick: t }) => {
  const a = r9(() => {
    t();
  });
  return /* @__PURE__ */ ee("div", { className: "table__row__options", ref: a, children: e.map((o, s) => /* @__PURE__ */ Ve(s0, { children: [
    /* @__PURE__ */ ee(
      "p",
      {
        onClick: () => {
          t(), o.onClick(n);
        },
        className: "table__row__options__option",
        children: o.changeBasedOnKey ? n[o.changeBasedOnKey] === o.changeBasedOnValue ? /* @__PURE__ */ Ve(Ku, { children: [
          o.otherIcon,
          o.otherLabel
        ] }) : /* @__PURE__ */ Ve(Ku, { children: [
          o.icon,
          o.label
        ] }) : /* @__PURE__ */ Ve(Ku, { children: [
          o.icon,
          o.label
        ] })
      }
    ),
    e.length - 1 !== s && /* @__PURE__ */ ee("p", { className: "table__row__options__separator" })
  ] }, `${o.label}-${s}`)) });
}, jP = "_toast_6ppby_1", zP = "_toast__inner_6ppby_19", qP = "_toast__close_6ppby_23", GP = "_toast__heading_6ppby_43", KP = "_toast__message_6ppby_35", ur = {
  "toast-container": "_toast-container_6ppby_1",
  toast: jP,
  toast__inner: zP,
  toast__close: qP,
  "toast__message-container": "_toast__message-container_6ppby_35",
  toast__heading: GP,
  toast__message: KP,
  "toast--info": "_toast--info_6ppby_47",
  "toast--error": "_toast--error_6ppby_50",
  "toast--warning": "_toast--warning_6ppby_53",
  "toast--success": "_toast--success_6ppby_56"
}, XP = {
  Info: {
    base: "toast--info",
    name: "Info"
  },
  Error: {
    base: "toast--error",
    name: "Error"
  },
  Warning: {
    base: "toast--warning",
    name: "Warning"
  },
  Success: {
    base: "toast--success",
    name: "Success"
  }
}, ZP = ({
  id: e,
  header: n,
  message: t,
  lifetime: a,
  onRemove: o,
  type: s
}) => {
  const l = s ? XP[s] : {
    base: "",
    name: n
  };
  return St(() => {
    a && o && setTimeout(() => {
      o(e);
    }, a);
  }, [a, e, o]), /* @__PURE__ */ ee("div", { className: `${ur.toast} ${ur[l.base]}`, children: /* @__PURE__ */ Ve("div", { className: `${ur.toast__inner}`, children: [
    /* @__PURE__ */ Ve("div", { className: `${ur["toast__message-container"]}`, children: [
      /* @__PURE__ */ ee("h4", { "data-cy": "toast-title", className: `${ur.toast__heading}`, children: n || l.name }),
      t && /* @__PURE__ */ ee("p", { className: `${ur.toast__message}`, children: t })
    ] }),
    /* @__PURE__ */ ee(
      "div",
      {
        onClick: () => o == null ? void 0 : o(e),
        className: `${ur.toast__close}`
      }
    )
  ] }) });
}, Gc = Vr(
  {}
), To = 5e3, gT = ({ children: e }) => {
  const n = Wr(!0);
  St(() => () => {
    n.current = !1;
  }, []);
  const [t, a] = Sa([]), o = ca(
    (h, p, v, w) => {
      const b = {
        id: QP(),
        message: h,
        type: p,
        header: v,
        lifetime: w || To
      };
      n.current && a((_) => [..._, b]);
    },
    [a, t]
  ), s = ca(
    (h, p, v) => o(h, "Error", p || "", v || To),
    [o]
  ), l = ca(
    (h, p, v) => o(h, "Warning", p || "", v || To),
    [o]
  ), c = ca(
    (h, p, v) => o(h, "Success", p || "", v || To),
    [o]
  ), d = ca(() => ({
    data: t,
    pushError: s,
    pushWarning: l,
    pushSuccess: c,
    push: o,
    async remove(h) {
      n.current && a((p) => p.filter((v) => v.id !== h));
    }
  }), [t, a, s, l, c, o]);
  return /* @__PURE__ */ Ve(Gc.Provider, { value: d(), children: [
    /* @__PURE__ */ ee(JP, {}),
    e
  ] });
}, QP = () => "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (e) => {
  const n = Math.random() * 16 | 0;
  return (e === "x" ? n : n & 3 | 8).toString(16);
}), yT = () => u0(Gc), JP = () => {
  const e = u0(Gc);
  function n(t) {
    var a;
    (a = e.remove) == null || a.call(e, t);
  }
  return /* @__PURE__ */ ee("div", { className: `${ur["toast-container"]}`, children: /* @__PURE__ */ ee("div", { children: e.data.map((t) => /* @__PURE__ */ ee(
    ZP,
    {
      id: t.id,
      message: t.message,
      type: t.type,
      header: t.header,
      icon: t.icon,
      onRemove: n,
      lifetime: t.lifetime
    },
    t.id
  )) }) });
};
export {
  uT as A,
  oT as B,
  Mh as C,
  sT as I,
  lT as L,
  hT as P,
  cT as R,
  fT as S,
  mT as T,
  dT as a,
  i9 as b,
  pT as c,
  vT as d,
  YP as e,
  JP as f,
  ZP as g,
  Gc as h,
  gT as i,
  r0 as j,
  yT as u
};
//# sourceMappingURL=toast-container-B09_bbj7.js.map
